import { HELP_FAZ8_TR } from './entries.faz8.tr';
import { AI_HELP_TR } from './entries.ai';
/**
 * Yönetim panelindeki her sayfa, buton ve alanın Türkçe açıklaması (spesifikasyon §26).
 * Her kayıt: ne işe yarar, ne zaman kullanılır, hangi veriyi değiştirir, hangi yetki gerekir,
 * geri alınabilir mi, olası hatalar ve çözümleri, rehber bağlantısı.
 * Panelden düzenlenen metinler veritabanında sürümlü saklanır; buradaki metin onların üzerine yazmaz.
 */
export interface HelpContent {
  kind: 'page' | 'action' | 'field' | 'menu';
  title: string;
  short: string;
  whatItDoes?: string;
  whenToUse?: string;
  dataChanged?: string;
  requiredPermission?: string;
  reversible?: string;
  commonErrors?: Array<{ problem: string; solution: string }>;
  guideUrl?: string;
}

const G = 'docs/ADMIN_GUIDE_TR.md';

export const HELP_TR = {
  ...HELP_FAZ8_TR,
  // Faz 9 (yapay zekâ) kayıtları ayrı dosyada (entries.ai.ts).
  ...AI_HELP_TR,
  // ------------------------------------------------------------------ Sayfalar
  'page.dashboard': {
    kind: 'page',
    title: 'Ana Panel',
    short: 'İşletmenizin genel durumunu tek bakışta gösterir.',
    whatItDoes:
      'Kurulum ilerlemesini, sistem durumunu ve dikkat isteyen uyarıları (ör. hatalı entegrasyon, süresi yaklaşan SSL) listeler. Bekleyen iade talepleri ve incelemedeki ödemeler de burada uyarı olarak çıkar. Satış raporları yetkisi olan kullanıcı bugünün ve son 30 günün satış özetini ve günlük satış grafiğini görür. Veri yoksa "henüz veri yok" yazar; tahmini veya örnek rakam gösterilmez.',
    whenToUse: 'Her girişte ilk bakılacak yer.',
    dataChanged: 'Hiçbir veriyi değiştirmez; yalnızca gösterir.',
    guideUrl: `${G}#ana-panel`,
  },
  'page.setup': {
    kind: 'page',
    title: 'Kurulum Sihirbazı',
    short: 'Mağazanın canlıya çıkması için gereken 24 adımı sırayla gösterir.',
    whatItDoes:
      'Her adımın durumu gerçek verilere bakılarak hesaplanır: örneğin bir marka eklediğinizde "Marka ekle" adımı kendiliğinden tamamlanır; Google adımları bağlı mülk veya girilen etiket kimliğiyle, SEO adımı site haritası Search Console\'a gönderilince tamamlanır. Henüz geliştirilmemiş modüllere ait adımlar "Kilitli" görünür ve hangi fazda açılacağı yazar.',
    whenToUse: 'İlk kurulumda ve canlıya çıkmadan önce eksikleri görmek için.',
    dataChanged: 'Sayfa yalnızca gösterir; "Atla" butonu adımı atlandı olarak işaretler.',
    guideUrl: `${G}#kurulum-sihirbazi`,
  },
  'page.organization': {
    kind: 'page',
    title: 'İşletme Bilgileri',
    short: 'Şirket unvanı, vergi bilgileri ve iletişim bilgileri.',
    whatItDoes:
      'Buradaki bilgiler sitenin alt kısmındaki satıcı bilgilerinde (künye), faturalarda, sözleşmelerde ve ödeme kuruluşu (POS) başvurusunda kullanılır. Vergi numarası veritabanında şifreli saklanır.',
    whenToUse: 'İlk kurulumda ve şirket bilgileri değiştiğinde.',
    dataChanged: 'İşletme kaydını günceller. Her değişiklik denetim kaydına eski ve yeni değeriyle yazılır.',
    requiredPermission:
      'Görüntüleme: İşletme ayarlarını görüntüleme. Değiştirme: İşletme bilgilerini ve ayarlarını değiştirme.',
    guideUrl: `${G}#isletme-bilgileri`,
  },
  'page.brands': {
    kind: 'page',
    title: 'Markalar',
    short: 'Satış yaptığınız markalar (ör. Zootopia Global, VITATOPIA).',
    whatItDoes:
      'Her markanın adı, kısa adı, logosu ve renkleri burada tutulur. Ürünler (Faz 2) bir markaya bağlanır; mağaza hangi markaları satacağını buradan seçer.',
    whenToUse: 'Yeni bir marka eklerken veya logosunu/rengini değiştirirken.',
    guideUrl: `${G}#markalar`,
  },
  'page.stores': {
    kind: 'page',
    title: 'Mağazalar',
    short: 'Satış kanallarınız: alan adları, ülke/dil/para birimi pazarları.',
    whatItDoes:
      'Bir mağaza; bir veya birkaç alan adı (ör. zootopia.com.tr), satılan markalar ve en az bir pazardan (ör. Türkiye – Türkçe – TL) oluşur. İleride yurt dışı için ayrı mağaza veya pazar eklenebilir.',
    whenToUse: 'İlk kurulumda ve yeni alan adı/ülke eklerken.',
    guideUrl: `${G}#magazalar`,
  },
  'page.users': {
    kind: 'page',
    title: 'Kullanıcılar',
    short: 'Panele erişen personeliniz ve rolleri.',
    whatItDoes:
      'Personeli e-posta ile davet eder, rollerini ve hangi mağazalara erişebileceklerini belirlersiniz. Her kullanıcı ilk girişte iki adımlı doğrulama kurmak zorundadır.',
    whenToUse: 'Yeni personel başladığında, görev değiştiğinde veya ayrıldığında.',
    requiredPermission:
      'Görüntüleme: Kullanıcıları görüntüleme. Değiştirme: Kullanıcı davet etme, rol değiştirme, askıya alma.',
    guideUrl: `${G}#kullanicilar`,
  },
  'page.roles': {
    kind: 'page',
    title: 'Roller ve Yetkiler',
    short: 'Hangi rolün neleri yapabildiğini gösterir; özel rol oluşturursunuz.',
    whatItDoes:
      '14 hazır rol vardır ve değiştirilemez (güncellemelerde bozulmasınlar diye). İhtiyacınıza tam uyan rol yoksa yetkileri tek tek seçerek özel rol oluşturabilirsiniz. Kendinizde olmayan bir yetkiyi başkasına veremezsiniz.',
    whenToUse: 'Personele uygun rolü seçmeden önce veya özel bir görev tanımı gerektiğinde.',
    guideUrl: `${G}#roller`,
  },
  'page.api_keys': {
    kind: 'page',
    title: 'API Anahtarları',
    short: 'Muhasebe, ERP, n8n gibi dış programların mağazanıza bağlanması için anahtarlar.',
    whatItDoes:
      'Her anahtar yalnızca seçtiğiniz yetkilerle (kapsam) çalışır. Kullanıcı yönetimi gibi hassas yetkiler anahtarlara verilemez. Anahtarın gizli kısmı yalnızca oluşturulduğu anda bir kez gösterilir.',
    whenToUse: 'Bir yazılımı mağazayla entegre ederken.',
    requiredPermission: 'API anahtarı oluşturma ve iptal etme (Sahip, Yönetici).',
    guideUrl: `${G}#api-anahtarlari`,
  },
  'page.webhooks': {
    kind: 'page',
    title: 'Webhook (Olay Bildirimleri)',
    short: 'Mağazada bir şey olduğunda (ör. marka eklendi) başka bir programa anında haber verir.',
    whatItDoes:
      'Seçtiğiniz olaylar gerçekleştiğinde verdiğiniz adrese imzalı bir istek gönderilir. Karşı taraf yanıt vermezse yaklaşık 22 saat boyunca tekrar denenir. Her gönderimin sonucu "Teslimat geçmişi"nde görünür.',
    whenToUse: 'Muhasebe/ERP/otomasyon araçlarının mağaza olaylarına tepki vermesi gerektiğinde.',
    guideUrl: `${G}#webhooklar`,
  },
  'organization.system_name': {
    kind: 'field',
    title: 'Panel adı (sistem adı)',
    short:
      'Yönetim panelinin sol üstünde, tarayıcı sekmesinde ve giriş ekranında görünen ad. Boş bırakılırsa "Zootopia Panel" kullanılır; Android uygulamasının adı değişmez.',
    whatItDoes:
      'İşletme bazındadır: birden çok işletmeye üye kullanıcı, seçtiği işletmenin adını görür. Giriş ekranı oturumdan önce açıldığı için bu tarayıcıda son görülen adı gösterir. Vitrindeki mağaza ve marka adları bundan etkilenmez (onlar Markalar ve Mağazalar ekranında).',
    dataChanged: 'İşletme kaydındaki panel adı; denetim kaydına eski ve yeni değeriyle yazılır.',
    requiredPermission: 'İşletme ayarlarını değiştirme',
    reversible: 'Evet, adı değiştirip veya alanı boşaltıp yeniden kaydedebilirsiniz.',
    guideUrl: `${G}#isletme-bilgileri`,
  },
  'integrations.verify_all': {
    kind: 'action',
    title: 'Tüm bağlantıları doğrula',
    short:
      'Kayıtlı bütün bağlantıları hemen dener ve sonucu tabloda gösterir. Yalnızca ileti göndermeyen, ödeme açmayan ve ücret doğurmayan testler çalışır; bağlantının durumu değişmez.',
    whatItDoes:
      'Aynı denetim 6 saatte bir kendiliğinden yapılır; art arda iki hata Sistem Durumu’nda uyarı olur ve uyarı alıcılarına e-posta gider. Nesne depolama ve hata takibi gibi deneme kaydı veya olay gönderen testler "Tek tek deneyin" olarak listelenir. Çalışmayan bağlantıda bağlantının kendi "Bağlantıyı test et" düğmesini kullanın.',
    requiredPermission: 'Entegrasyonları yönetme',
    guideUrl: `${G}#baglanti-denetimi`,
  },
  'page.integrations': {
    kind: 'page',
    title: 'Entegrasyonlar',
    short: 'Dış hizmetlerin (ödeme, Google, e-posta, kargo…) gerçek bağlantı durumları.',
    whatItDoes:
      'Her hizmetin durumu gerçektir: bilgileri girilmemiş veya test edilmemiş bir hizmet "Kurulum Gerekli" görünür, asla "bağlı" gösterilmez. Henüz yazılmamış entegrasyonlar hangi fazda ekleneceğini gösterir. Şifreler ve anahtarlar şifreli saklanır ve bir daha ekranda gösterilmez.',
    whenToUse: 'Bir hizmeti bağlarken, test ederken veya hata uyarısı aldığınızda.',
    guideUrl: `${G}#entegrasyonlar`,
  },
  'page.audit': {
    kind: 'page',
    title: 'Denetim Kayıtları',
    short: 'Kim, ne zaman, neyi değiştirdi — eski ve yeni değerleriyle.',
    whatItDoes:
      'Panelde ve API üzerinden yapılan her değişiklik buraya kaydedilir. Kayıtlar kimse tarafından silinemez veya değiştirilemez. Şifre ve anahtar gibi gizli değerler "[gizli]" olarak görünür.',
    whenToUse: 'Bir değişikliğin kaynağını araştırırken.',
    requiredPermission: 'Denetim kayıtlarını görüntüleme.',
    guideUrl: `${G}#denetim-kayitlari`,
  },
  'page.system': {
    kind: 'page',
    title: 'Sistem Durumu',
    short: 'Veritabanı, kuyruklar, e-posta, SSL ve yedeklerin durumu.',
    whatItDoes:
      'Sistemin sağlığını gerçek ölçümlerle gösterir: kuyrukta bekleyen/başarısız işler, alan adlarının SSL bitiş tarihleri, son yedek ve son geri yükleme testi. Bir değer ölçülemiyorsa "bilinmiyor" yazar.',
    whenToUse: 'Bir şeyin yolunda gitmediğinden şüphelendiğinizde ve ayda bir rutin kontrol için.',
    guideUrl: `${G}#sistem-durumu`,
  },
  'page.migration': {
    kind: 'page',
    title: 'Taşıma paketi',
    short: "Staging'de hazırlanan mağazayı canlıya (veya ikinci bir mağazaya) tek dosyayla taşır.",
    whatItDoes:
      'Dışa aktar: mağazanın ürünleri, kategorileri, fiyatları, stok bakiyeleri, yasal metinleri, sayfaları, blogu, menüleri, bannerları, teması, kargo yöntemleri, banka hesapları, yönlendirmeleri ve görselleri tek ZIP dosyasına yazılır. İçe aktar: önce önizlenir, sonra tek işlemde uygulanır. Müşteri, bayi, sipariş, ödeme, kullanıcı ve hiçbir anahtar/şifre taşınmaz.',
    whenToUse: 'Canlıya geçiş günü (staging → canlı) ve ikinci mağaza kurulumunda.',
    requiredPermission: 'Yalnızca işletme sahibi (iki adımlı doğrulama).',
    reversible:
      'İçe aktarma tek tıkla geri alınmaz; önce önizlemeyi kontrol edin. Aynı paketi tekrar yüklemek kopya oluşturmaz.',
    guideUrl: 'docs/GO_LIVE_TR.md#tasima-paketi',
  },
  'page.privacy': {
    kind: 'page',
    title: 'KVKK başvuruları',
    short:
      'Kişisel veriyle ilgili başvuruları (KVKK m.11) 30 günlük yasal süre içinde kaydeder, izler ve sonuçlandırır.',
    whatItDoes:
      'Vitrinden gelen "Verilerimi indir" ve "Hesabımı sil" başvuruları ile e-posta/KEP/posta ile gelenler burada listelenir; süresi en yakın olan en üsttedir. Başvurunun kişisi için sistemdeki kayıtlar sayılır, verilerin kopyası indirilir; silme başvurusunda önce etki önizlenir, sonra başvuranın e-postası yazılarak kişisel veriler anonimleştirilir. Sonuç başvurana e-postayla bildirilir.',
    whenToUse: 'Başvuru geldiğinde ve ana panel "KVKK başvurusu yanıt bekliyor" uyarısı verdiğinde.',
    dataChanged: 'Başvuru kaydı; anonimleştirmede müşteri, sipariş iletişim bilgileri ve ilgili kayıtlar.',
    requiredPermission:
      'Görmek: KVKK başvurularını görüntüleme. Kaydetmek/sonuçlandırmak: KVKK başvurusu kaydetme. Kopya ve anonimleştirme: sahip ve yönetici (iki adımlı doğrulama).',
    reversible: 'Anonimleştirme geri alınamaz. Diğer işlemler kayıt altındadır.',
    guideUrl: 'docs/PRIVACY_COMPLIANCE_TR.md#basvurular',
  },
  'page.account': {
    kind: 'page',
    title: 'Hesabım',
    short: 'Profiliniz, şifreniz, dil ve açık oturumlarınız.',
    whatItDoes:
      'Kendi bilgilerinizi, panel dilini ve kullanım modunu değiştirir; hangi cihazlarda oturumunuzun açık olduğunu gösterip kapatmanızı sağlar.',
    guideUrl: `${G}#hesabim`,
  },
  'page.help_editor': {
    kind: 'page',
    title: 'Yardım Metinleri',
    short: 'Paneldeki açıklamaları düzenlersiniz.',
    whatItDoes:
      'Her buton ve alanın yanında çıkan açıklamayı kendi ekibiniz için değiştirebilirsiniz. Her değişiklik sürüm olarak saklanır; eski hâli geçmişte görünür.',
    requiredPermission: 'Yardım metinlerini düzenleme.',
    guideUrl: `${G}#yardim-metinleri`,
  },

  // ------------------------------------------------------------------ Giriş ve güvenlik
  'auth.sign_in': {
    kind: 'action',
    title: 'Giriş Yap',
    short: 'E-posta ve şifrenizle oturum açar; ardından doğrulama kodu istenir.',
    whatItDoes:
      'Şifre doğruysa iki adımlı doğrulama ekranına geçer. 10 hatalı denemede hesap 15 dakika kilitlenir.',
    commonErrors: [
      {
        problem: '"E-posta veya şifre hatalı"',
        solution:
          'Büyük/küçük harf ve klavye dilini kontrol edin; hatırlamıyorsanız "Şifremi unuttum"u kullanın.',
      },
      { problem: '"Hesap kilitlendi"', solution: '15 dakika bekleyin veya şifrenizi sıfırlayın.' },
    ],
    guideUrl: `${G}#giris`,
  },
  'auth.mfa_enroll': {
    kind: 'action',
    title: 'İki Adımlı Doğrulamayı Kur',
    short: 'Telefonunuzdaki doğrulama uygulamasını hesabınıza bağlar.',
    whatItDoes:
      'Google Authenticator, Microsoft Authenticator veya benzeri bir uygulamayla ekrandaki karekodu okutun ve uygulamanın verdiği 6 haneli kodu girin. Kurulum bitince 10 adet yedek kod gösterilir.',
    whenToUse: 'İlk girişte zorunludur; panel bu adım olmadan açılmaz.',
    reversible: 'Telefonu kaybederseniz yedek kodlarla giriş yapabilirsiniz.',
    commonErrors: [
      {
        problem: 'Kod kabul edilmiyor',
        solution:
          'Telefonunuzun saatinin otomatik ayarlı olduğundan emin olun; kodu 30 saniyelik süre dolmadan girin.',
      },
    ],
    guideUrl: `${G}#iki-adimli-dogrulama`,
  },
  'auth.mfa_verify': {
    kind: 'action',
    title: 'Doğrulama Kodu',
    short: 'Doğrulama uygulamanızdaki 6 haneli kodu girin.',
    whatItDoes:
      'Kod doğruysa panel açılır. Hassas işlemlerde (kullanıcı davet etme, anahtar oluşturma gibi) son 15 dakika içinde kod girilmemişse kod yeniden istenir.',
    commonErrors: [
      {
        problem: 'Telefonum yanımda değil',
        solution:
          '"Yedek kod kullan"a tıklayıp size verilen yedek kodlardan birini girin. Her yedek kod bir kez çalışır.',
      },
    ],
    guideUrl: `${G}#iki-adimli-dogrulama`,
  },
  'auth.backup_codes': {
    kind: 'field',
    title: 'Yedek Kodlar',
    short: 'Telefonunuza erişemezseniz giriş yapmanızı sağlayan 10 tek kullanımlık kod.',
    whatItDoes:
      'Bu kodlar yalnızca şimdi gösterilir. Yazdırın veya güvenli bir yerde (şifre yöneticisi) saklayın.',
    reversible: 'Bu sayfadan çıktıktan sonra kodlar bir daha gösterilemez.',
  },
  'auth.forgot_password': {
    kind: 'action',
    title: 'Şifremi Unuttum',
    short: 'E-posta adresinize 1 saat geçerli bir sıfırlama bağlantısı gönderir.',
    whatItDoes:
      'Güvenlik gereği, adres kayıtlı olmasa da aynı mesaj gösterilir. Şifre sıfırlanınca tüm cihazlardaki oturumlar kapanır.',
    commonErrors: [
      {
        problem: 'E-posta gelmedi',
        solution:
          'Gereksiz/spam klasörüne bakın. E-posta servisi kurulmamışsa (Entegrasyonlar → SMTP) e-posta gönderilemez; yöneticinize başvurun.',
      },
    ],
  },

  // ------------------------------------------------------------------ İşletme
  'organization.save': {
    kind: 'action',
    title: 'İşletme Bilgilerini Kaydet',
    short: 'Yaptığınız değişiklikleri kaydeder.',
    dataChanged: 'İşletme kaydı. Eski ve yeni değerler denetim kaydına yazılır.',
    requiredPermission: 'İşletme bilgilerini ve ayarlarını değiştirme.',
    reversible: 'Evet, eski değeri tekrar girerek. Denetim kaydında eski değer görünür.',
    commonErrors: [
      {
        problem: '"Bu kayıt başka biri tarafından değiştirildi"',
        solution: 'Sayfayı yenileyin, güncel bilgileri görün ve değişikliğinizi yeniden yapın.',
      },
    ],
  },
  'organization.tax_number': {
    kind: 'field',
    title: 'Vergi Numarası / TCKN',
    short: 'Şirketler için 10 haneli vergi no, şahıs şirketleri için 11 haneli TCKN.',
    whatItDoes: 'Faturalarda ve POS başvurusunda kullanılır. Veritabanında şifreli saklanır.',
  },
  'organization.mersis': {
    kind: 'field',
    title: 'MERSİS Numarası',
    short: '16 haneli merkezi sicil numarası. Sitede satıcı bilgilerinde gösterilmesi gerekir.',
  },
  'organization.kep': {
    kind: 'field',
    title: 'KEP Adresi',
    short: 'Kayıtlı elektronik posta adresiniz (varsa).',
  },
  'organization.etbis': {
    kind: 'field',
    title: 'ETBİS doğrulama bağlantısı',
    short:
      'Ticaret Bakanlığı Elektronik Ticaret Bilgi Sistemi (ETBİS) kaydından sonra verilen karekodun açtığı adres (ör. https://etbis.eticaret.gov.tr/sitedogrulama/…). Doluysa vitrinin alt bilgisinde "ETBİS\'e kayıtlıdır" bağlantısı ve karekod görünür.',
    whatItDoes:
      'Yalnızca ETBİS alan adlarındaki https adresler kabul edilir. Karekod vitrinde bu adresten üretilir; ayrıca görsel yüklemeniz gerekmez.',
    commonErrors: [
      {
        problem: 'Kayıt yapıldı ama bağlantı nerede bilinmiyor.',
        solution:
          'ETBİS\'te (e-Devlet ile giriş) kaydınızın ayrıntısında karekod ve kod parçacığı verilir; parçacıktaki "sitedogrulama" ile başlayan adresi buraya yapıştırın.',
      },
    ],
    guideUrl: 'docs/GO_LIVE_TR.md#etbis',
  },

  // ------------------------------------------------------------------ Markalar
  'brands.create': {
    kind: 'action',
    title: 'Marka Ekle',
    short: 'Yeni bir marka oluşturur.',
    dataChanged: 'Yeni marka kaydı. "Marka ekle" kurulum adımı tamamlanır.',
    requiredPermission: 'Marka ekleme ve düzenleme.',
    reversible: 'Marka silinmez, "Arşivle" ile gizlenir.',
    commonErrors: [
      {
        problem: '"Bu kısa ad zaten kullanılıyor"',
        solution: 'Kısa ad (URL\'de görünen ad) her marka için farklı olmalı; örn. "zootopia-global".',
      },
    ],
  },
  'brands.edit': {
    kind: 'action',
    title: 'Markayı Düzenle',
    short: 'Markanın adını, açıklamasını, rengini veya logosunu değiştirir.',
    requiredPermission: 'Marka ekleme ve düzenleme.',
  },
  'brands.archive': {
    kind: 'action',
    title: 'Arşivle',
    short: 'Markayı aktif listeden kaldırır ama silmez.',
    reversible: 'Evet, "Aktif yap" ile geri alınır.',
  },
  'brands.logo_upload': {
    kind: 'action',
    title: 'Logo Yükle',
    short: 'PNG, JPEG, WebP, AVIF veya GIF; en fazla 5 MB.',
    whatItDoes:
      'Görsel güvenlik için yeniden işlenir (gizli meta veriler silinir) ve en fazla 1024 piksele küçültülerek WebP olarak saklanır.',
    commonErrors: [
      {
        problem: '"Bu dosya türü yüklenemez"',
        solution: 'SVG ve PDF kabul edilmez; logoyu PNG olarak dışa aktarın.',
      },
      { problem: '"Dosya çok büyük"', solution: '5 MB altına küçültün.' },
    ],
  },
  'brands.slug': {
    kind: 'field',
    title: 'Kısa Ad',
    short: 'Adreslerde görünen ad: küçük harf, rakam ve tire. Örn. "zootopia-global".',
  },
  'brands.primary_color': {
    kind: 'field',
    title: 'Ana Renk',
    short: 'Markanın ana rengi (ör. #0F766E). Vitrin teması ve e-postalarda kullanılır.',
  },

  // ------------------------------------------------------------------ Mağazalar
  'stores.create': {
    kind: 'action',
    title: 'Mağaza Ekle',
    short: 'Yeni bir satış kanalı oluşturur (ör. zootopia.com.tr).',
    requiredPermission: 'Mağaza, alan adı ve pazar yönetimi.',
  },
  'stores.edit': {
    kind: 'action',
    title: 'Mağazayı Düzenle',
    short: 'Mağazanın adını, kanal türünü ve markalarını değiştirir.',
  },
  'stores.channel_type': {
    kind: 'field',
    title: 'Kanal Türü',
    short: 'B2C: yalnızca son tüketici. B2B: yalnızca bayiler. Karma: ikisi birden.',
    whatItDoes:
      'Karma modda giriş yapmayan ziyaretçiler ve normal üyeler perakende fiyatı, onaylı bayiler kendi bayi fiyatını görür.',
  },
  'stores.status': {
    kind: 'field',
    title: 'Yayın Durumu',
    short:
      'Önizleme (vitrin "önizleme" uyarısıyla açık, arama motorlarına kapalı), Yayında veya Bakımda. Yayına alma hazırlık listesi tamamlanınca açık onay ve iki adımlı doğrulamayla yapılır.',
    whatItDoes:
      'Durum yalnızca bu bölümden değişir; her değişiklik denetim kaydına yazılır. Yayındaki mağazada test ortamıyla kart ödemesi sunulmaz.',
    requiredPermission: 'Mağazayı yayına alma (hassas; sahip ve yönetici).',
    guideUrl: 'docs/GO_LIVE_TR.md#yayina-alma',
  },
  'stores.go_live': {
    kind: 'action',
    title: 'Mağazayı Yayına Al',
    short: 'Vitrini gerçek müşterilere açar: önizleme uyarısı kalkar, sipariş ve ödemeler gerçek olur.',
    whatItDoes:
      'Şart olan hazırlık maddeleri (satıcı bilgileri, alan adı, yayında ürün, kargo, ödeme yöntemi, yasal metinlerin yayımlanması ve avukat incelemesi) tamam olmalıdır. Kartla ödemenin canlıda olması şart değildir. Arama motorlarına açılma ayrıca sunucu ayarıyla (SITE_INDEXING) yapılır.',
    whenToUse: 'Eski siteden geçiş günü, DNS yeni sunucuya yönlendirilmeden hemen önce veya sonra.',
    dataChanged:
      'Mağazanın durumu "yayında" olur; onay anındaki hazırlık listesi sonucu denetim kaydına yazılır ve "mağaza yayına alındı" olayı oluşur.',
    requiredPermission: 'Mağazayı yayına alma (hassas; iki adımlı doğrulama).',
    reversible: 'Evet. Bakıma alınabilir veya önizlemeye döndürülebilir; verilmiş siparişler etkilenmez.',
    commonErrors: [
      {
        problem: '"Hazırlık listesinde eksik şart maddeler var"',
        solution: 'Hazırlık listesindeki kırmızı maddeleri tamamlayıp tekrar deneyin.',
      },
      {
        problem: '"Mağaza arşivde"',
        solution: 'Önce arşivden çıkarın (mağaza önizlemeye döner), sonra yayına alın.',
      },
      {
        problem: 'Onay kutusu "zorunlu" uyarısı',
        solution: 'Mağazanın gerçek müşterilere açılacağını onaylayan kutuyu işaretleyin.',
      },
    ],
    guideUrl: 'docs/GO_LIVE_TR.md#yayina-alma',
  },
  'stores.maintenance': {
    kind: 'action',
    title: 'Bakıma Al',
    short:
      'Vitrin kısa süreliğine kapanır: ziyaretçi bakım sayfası görür (arama motorlarına "geçici olarak kapalı" yanıtı, 503).',
    whatItDoes:
      'Panel, sipariş işlemleri ve ödeme bildirimleri çalışmaya devam eder. Değişiklik vitrinde en geç bir dakikada geçerli olur.',
    whenToUse:
      'Fiyat güncellemesi, büyük içerik değişikliği veya taşıma sırasında vitrini kısa süre kapatmanız gerektiğinde.',
    dataChanged:
      'Mağazanın durumu "bakımda" olur; vitrin bakım sayfası gösterir. Eski ve yeni durum denetim kaydına yazılır.',
    requiredPermission:
      'Mağazayı yayına alma, bakıma alma, yayından kaldırma (hassas; iki adımlı doğrulama).',
    reversible: 'Evet. "Mağazayı yayına al" ile geri açılır.',
    commonErrors: [
      { problem: '"Mağaza arşivde"', solution: 'Arşivdeki mağaza bakıma alınamaz; önce arşivden çıkarın.' },
      {
        problem: '"Bu işlem için doğrulama kodunuzu yeniden girmeniz gerekiyor"',
        solution: 'Doğrulama uygulamanızdaki kodu girip tekrar deneyin.',
      },
    ],
  },
  'stores.to_draft': {
    kind: 'action',
    title: 'Önizlemeye Döndür',
    short: 'Mağazayı yayından kaldırır; vitrin "önizleme" uyarısıyla açılır ve arama motorlarına kapanır.',
    whenToUse:
      'Yayındaki mağazayı uzun süreli düzenleme için gerçek müşterilere kapatmak veya yanlışlıkla yayına alınan mağazayı geri çekmek istediğinizde.',
    dataChanged:
      'Mağazanın durumu "önizleme" olur; vitrin önizleme uyarısıyla açılır ve arama motorlarına kapanır. Eski ve yeni durum denetim kaydına yazılır.',
    requiredPermission:
      'Mağazayı yayına alma, bakıma alma, yayından kaldırma (hassas; iki adımlı doğrulama).',
    reversible: 'Evet. Hazırlık listesiyle yeniden yayına alınabilir.',
    commonErrors: [
      {
        problem: '"Mağaza yayındayken kart ödemesi test ortamına alınamaz"',
        solution: 'Kart ödemesini teste döndürmek istiyorsanız önce bu düğmeyle mağazayı önizlemeye alın.',
      },
      {
        problem: '"Bu işlem için doğrulama kodunuzu yeniden girmeniz gerekiyor"',
        solution: 'Doğrulama uygulamanızdaki kodu girip tekrar deneyin.',
      },
    ],
  },
  'stores.go_live_confirm': {
    kind: 'field',
    title: 'Yayına Alma Onayı',
    short:
      'Fiyatları, ödeme yöntemlerini ve yasal metinleri kontrol ettiğinizi ve mağazanın gerçek müşterilere açılacağını onaylarsınız.',
  },
  'stores.status_note': {
    kind: 'field',
    title: 'Not',
    short: 'Değişikliğin nedeni (ör. "DNS geçişi", "stok sayımı"). Denetim kaydına yazılır.',
  },
  'stores.add_domain': {
    kind: 'action',
    title: 'Alan Adı Ekle',
    short: 'Mağazaya bir alan adı bağlar (ör. zootopia.com.tr).',
    whatItDoes:
      'Kayıt eklenir; alan adının DNS kaydının sunucuyu göstermesi gerekir. DNS ayarı alan adını aldığınız firmanın panelinden yapılır.',
    commonErrors: [
      { problem: '"Bu alan adı başka bir mağazada kayıtlı"', solution: 'Önce diğer mağazadan kaldırın.' },
    ],
  },
  'stores.remove_domain': {
    kind: 'action',
    title: 'Alan Adını Kaldır',
    short: 'Alan adını mağazadan ayırır.',
    reversible: 'Evet, yeniden eklenebilir.',
  },
  'stores.default_market': {
    kind: 'action',
    title: 'Varsayılan yap',
    short:
      'Vitrin bu pazarın dili ve para birimiyle açılır; fiyatlar bu para birimindeki listelerden gelir (kurdan türetilebilir).',
    whatItDoes:
      'Bu para biriminde fiyatı olmayan ürün satılamaz. Kargo yöntemleri ve kapıda ödeme para birimine göre sunulur; kart yalnızca sağlayıcının desteklediği ve ödeme ayarlarında açılan dövizde.',
    guideUrl: 'docs/PRICING_ENGINE_TR.md#doviz-kurlari',
  },
  'stores.add_market': {
    kind: 'action',
    title: 'Pazar Ekle',
    short: 'Ülke + dil + para birimi kombinasyonu ekler (ör. Türkiye – Türkçe – TL).',
    whatItDoes: 'Fiyat listeleri ve vergiler (Faz 2) pazara göre çalışır. İlk eklenen pazar varsayılan olur.',
  },
  'stores.return_policy': {
    kind: 'field',
    title: 'İade politikası (arama motorları için)',
    short:
      "Google'ın ürün sonuçlarında gösterdiği iade bilgisi (süre, yöntem, iade kargo ücreti). Yasal metinlerinizdeki cayma/iade koşullarıyla aynı olmalıdır; açmadıkça hiçbir iade bilgisi bildirilmez.",
    whatItDoes:
      "Açıksa ürün sayfalarının yapılandırılmış verisine (schema.org MerchantReturnPolicy) ve ileride Merchant Center feed'ine yazılır. Yasal metnin yerine geçmez.",
    requiredPermission: 'Mağaza yönetimi',
    guideUrl: 'docs/SEO_GUIDE_TR.md#yapilandirilmis-veri',
  },
  'stores.return_days': {
    kind: 'field',
    title: 'İade süresi (gün)',
    short:
      'Teslimden itibaren iade/cayma süresi. Mesafeli satışta en az 14 gündür; daha uzun süre veriyorsanız yazın.',
  },
  'stores.return_method': {
    kind: 'field',
    title: 'İade yöntemi',
    short: 'Müşteri ürünü kargoyla mı, mağazaya getirerek mi iade eder.',
  },
  'stores.return_fees': {
    kind: 'field',
    title: 'İade kargo ücreti',
    short:
      '"Ücretsiz" yalnızca iade kargosunu siz karşılıyorsanız (ör. anlaşmalı kargo kodu) seçilmelidir; aksi hâlde "Müşteri öder".',
  },
  'stores.remove_market': {
    kind: 'action',
    title: 'Pazarı Kaldır',
    short: 'Pazarı siler. Varsayılan pazar silinemez.',
  },

  // ------------------------------------------------------------------ Kullanıcılar ve roller
  'users.copy_invite_link': {
    kind: 'action',
    title: 'Bağlantıyı Kopyala',
    short: 'Davet bağlantısını panoya kopyalar; kişiye WhatsApp, SMS veya yüz yüze iletebilirsiniz.',
    whatItDoes:
      'E-posta servisi kurulu olmadığında davet yalnızca bu bağlantıyla kabul edilebilir. Bağlantı tek kullanımlıktır ve 7 gün geçerlidir; yanlış kişiye giderse "Daveti iptal et" ile geçersiz kılın.',
    dataChanged: 'Hiçbir veriyi değiştirmez.',
  },
  'users.invite': {
    kind: 'action',
    title: 'Kullanıcı Davet Et',
    short: 'Kişiye 7 gün geçerli bir davet bağlantısı oluşturur; e-posta kuruluysa e-postayla gönderir.',
    whatItDoes:
      'Davet edilen kişi bağlantıya tıklayıp şifresini belirler ve iki adımlı doğrulamayı kurar. E-posta servisi kurulu değilse e-posta gönderilmez; bağlantı ekranda gösterilir ve kişiye sizin iletmeniz gerekir.',
    whenToUse:
      'Ekibinize yeni bir çalışan, muhasebeci veya ajans gibi panele girmesi gereken birini eklemek istediğinizde.',
    dataChanged: 'Davet kaydı oluşur; kabul edilince üyelik oluşur.',
    requiredPermission:
      'Kullanıcı davet etme, rol değiştirme, askıya alma (hassas işlem: doğrulama kodu istenebilir).',
    reversible: 'Kabul edilmeden önce "Daveti iptal et" ile geri alınır.',
    commonErrors: [
      {
        problem: '"Bu rolü veremezsiniz"',
        solution:
          'Kendinizde olmayan yetkileri içeren bir rolü başkasına veremezsiniz; sahip rolünü yalnızca sahip verebilir.',
      },
      {
        problem: 'E-posta gitmedi',
        solution: 'Entegrasyonlar → SMTP bağlantısının "Canlı" olduğunu kontrol edin.',
      },
    ],
  },
  'users.change_role': {
    kind: 'action',
    title: 'Rolü Değiştir',
    short: 'Kullanıcının yetkilerini belirleyen rolü değiştirir.',
    whenToUse:
      'Bir çalışanın görevi değiştiğinde (ör. depodan muhasebeye geçti) veya yetkilerinin daraltılması/genişletilmesi gerektiğinde.',
    dataChanged:
      'Kullanıcının bu işletmedeki rolü değişir; yeni yetkiler kişinin bir sonraki işleminden itibaren geçerli olur. Eski ve yeni rol denetim kaydına yazılır.',
    requiredPermission: 'Kullanıcı davet etme, rol değiştirme, askıya alma (hassas; iki adımlı doğrulama).',
    reversible: 'Evet, eski rol yeniden seçilebilir.',
    commonErrors: [
      {
        problem: '"En az bir aktif sahip kalmalıdır"',
        solution: 'Önce başka birini sahip yapın, sonra bu kişinin rolünü değiştirin.',
      },
    ],
  },
  'users.store_scope': {
    kind: 'field',
    title: 'Mağaza Kısıtı',
    short: 'Boş bırakılırsa kullanıcı tüm mağazalara erişir; seçilirse yalnızca seçilenlere.',
  },
  'users.dealer_scope': {
    kind: 'field',
    title: 'Bayi kapsamı',
    short:
      '"Yalnızca atanan bayiler": kullanıcı temsilcisi olduğu ve sorumlusu olduğu bölgedeki bayileri, onların kullanıcılarını, siparişlerini, tekliflerini ve cari hesabını görür; perakende müşteri ve diğer bayiler görünmez.',
    whatItDoes:
      'Bayi temsilcisi rolünde varsayılan budur. Yalnızca bayi verisiyle sınırlı rollerle verilebilir; destek talepleri, pazarlama veya denetim kaydı gibi tüm müşterileri açan yetkileri olan rolde kullanılamaz. Bayiyi temsilciye veya bölgeye atamak Bayiler → bayi → Satış temsilcisi ve bölge bölümündedir.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#temsilci',
  },
  'users.suspend': {
    kind: 'action',
    title: 'Askıya Al',
    short: 'Kullanıcının panele girişini durdurur; kayıtları silinmez.',
    whenToUse:
      'Bir çalışanın panele erişimini geçici olarak durdurmak istediğinizde (izin, inceleme, şüpheli giriş).',
    dataChanged:
      'Üyeliğin durumu "askıda" olur; kişi bir sonraki işleminden itibaren bu işletmenin paneline erişemez. Kayıtları ve geçmiş işlemleri silinmez; değişiklik denetim kaydına yazılır.',
    requiredPermission: 'Kullanıcı davet etme, rol değiştirme, askıya alma (hassas; iki adımlı doğrulama).',
    reversible: 'Evet, "Aktif yap" ile geri alınır.',
    commonErrors: [
      {
        problem: '"İşletmede en az bir aktif sahip kalmalıdır"',
        solution: 'Son sahibi askıya almadan önce başka birini sahip yapın.',
      },
      {
        problem:
          '"Kendi rolünüzü ve mağaza/bayi kapsamınızı değiştiremezsiniz" veya "Bu işlem için yetkiniz yok"',
        solution:
          'Sahip rolündeki kişiyi yalnızca başka bir sahip askıya alabilir; yetkiniz yetmiyorsa yöneticinize başvurun.',
      },
    ],
  },
  'users.remove': {
    kind: 'action',
    title: 'Üyelikten Çıkar',
    short: 'Kişinin bu işletmeyle bağını kaldırır.',
    whatItDoes: 'Kişinin geçmişte yaptığı değişiklikler denetim kayıtlarında kalır.',
    whenToUse:
      'İşten ayrılan veya artık panele erişmemesi gereken kişinin bu işletmeyle bağını tamamen kesmek için.',
    dataChanged:
      'Kişinin bu işletmedeki üyeliği silinir ve panele erişemez; üyeliğin önceki bilgileri denetim kaydına yazılır.',
    requiredPermission: 'Kullanıcı davet etme, rol değiştirme, askıya alma (hassas; iki adımlı doğrulama).',
    reversible: 'Yeniden davet edilerek.',
    commonErrors: [
      {
        problem: '"İşletmede en az bir aktif sahip kalmalıdır"',
        solution: 'Son sahibi çıkarmadan önce başka bir kişiye sahip rolü verin.',
      },
      {
        problem: '"Bu işlem için yetkiniz yok"',
        solution:
          'Sahip rolündeki kişiyi yalnızca başka bir sahip çıkarabilir; mağaza kapsamınızdan geniş yetkili üyeyi de çıkaramazsınız.',
      },
    ],
  },
  'users.revoke_invitation': {
    kind: 'action',
    title: 'Daveti İptal Et',
    short: 'Henüz kabul edilmemiş daveti geçersiz kılar.',
    whenToUse:
      'Yanlış kişiye veya yanlış rolle davet gönderdiğinizde ya da kişinin artık panele girmemesi gerektiğinde, davet kabul edilmeden önce.',
    dataChanged: 'Davet geçersiz olur; bağlantıyla artık hesap açılamaz. İşlem denetim kaydına yazılır.',
    requiredPermission: 'Kullanıcı davet etme, rol değiştirme, askıya alma (hassas; iki adımlı doğrulama).',
    reversible: 'Hayır, iptal edilen davet yeniden açılmaz; gerekirse kişiyi yeniden davet edin.',
    commonErrors: [
      {
        problem: '"Bu işlem için doğrulama kodunuzu yeniden girmeniz gerekiyor"',
        solution: 'Hassas işlemdir; doğrulama uygulamanızdaki kodu girip tekrar deneyin.',
      },
    ],
  },
  'roles.create_custom': {
    kind: 'action',
    title: 'Özel Rol Oluştur',
    short: 'Yetkileri tek tek seçerek yeni bir rol tanımlar.',
    whatItDoes:
      'Bir hazır rolü temel alıp yetki ekleyip çıkarabilirsiniz. Kendinizde olmayan yetkiyi ekleyemezsiniz.',
    requiredPermission: 'Özel rol oluşturma ve düzenleme.',
  },
  'roles.edit_custom': {
    kind: 'action',
    title: 'Özel Rolü Düzenle',
    short: 'Rolün yetkilerini değiştirir; bu rolü kullanan herkesi etkiler.',
    whenToUse: 'Özel rolü kullanan kişilerin yetkilerini topluca artırmak veya azaltmak istediğinizde.',
    dataChanged:
      'Rolün yetki listesi güncellenir ve bu rolü kullanan herkesin yetkisi bir sonraki işleminden itibaren değişir. Değişiklik denetim kaydına yazılır.',
    requiredPermission: 'Özel rol oluşturma ve düzenleme (hassas; iki adımlı doğrulama).',
    reversible:
      'Evet, yetkiler yeniden düzenlenerek eski hâline getirilir; denetim kaydında önceki liste görünür.',
    commonErrors: [
      {
        problem: '"Bu işlem için yetkiniz yok"',
        solution: 'Kendinizde olmayan bir yetkiyi role ekleyemezsiniz.',
      },
      {
        problem: '"Yalnızca atanan bayiler kapsamı bu rolle verilemez"',
        solution:
          'Bayi kapsamı sınırlı kullanıcıların rolüne destek, pazarlama veya denetim kaydı gibi bayi dışı yetkiler eklemeyin ya da kullanıcıların kapsamını değiştirin.',
      },
    ],
  },
  'roles.delete_custom': {
    kind: 'action',
    title: 'Özel Rolü Sil',
    short: 'Rolü siler.',
    whenToUse: 'Artık kullanılmayan bir özel rolü listeden kaldırmak istediğinizde.',
    dataChanged: 'Özel rol ve yetki listesi silinir; işlem denetim kaydına yazılır.',
    requiredPermission: 'Özel rol oluşturma ve düzenleme (hassas; iki adımlı doğrulama).',
    reversible: 'Hayır, silinen rol aynı yetkilerle yeniden oluşturulmalıdır.',
    commonErrors: [
      { problem: '"Bu rol kullanıcılara atanmış"', solution: 'Önce o kullanıcılara başka bir rol verin.' },
    ],
  },

  // ------------------------------------------------------------------ API anahtarları ve webhook
  'api_keys.create': {
    kind: 'action',
    title: 'API Anahtarı Oluştur',
    short: 'Dış bir programın (muhasebe, n8n vb.) mağazanıza bağlanması için anahtar üretir.',
    whenToUse: 'Bir yazılımı mağazayla entegre ederken.',
    dataChanged: 'Yeni bir anahtar kaydı oluşturur; mevcut veriler değişmez.',
    requiredPermission: 'API anahtarı oluşturma ve iptal etme (Sahip, Yönetici).',
    reversible: 'Anahtar istendiği an iptal edilebilir; iptal edilen anahtar bir daha çalışmaz.',
    commonErrors: [
      {
        problem: 'Gizli anahtarı kaybettim',
        solution: 'Gizli kısım yalnızca bir kez gösterilir; yeni anahtar oluşturup eskisini iptal edin.',
      },
    ],
    guideUrl: `${G}#api-anahtarlari`,
  },
  'api_keys.scopes': {
    kind: 'field',
    title: 'Kapsam (Yetkiler)',
    short: 'Anahtarın yapabileceği işlemler. Yalnızca gerekenleri seçin.',
    whatItDoes:
      'Örneğin muhasebe programı için yalnızca "Siparişleri görüntüleme" yeterlidir. Kullanıcı yönetimi gibi hassas yetkiler listede yoktur.',
  },
  'api_keys.revoke': {
    kind: 'action',
    title: 'İptal Et',
    short: 'Anahtarı hemen geçersiz kılar.',
    whenToUse:
      'Anahtarı kullanan programı artık kullanmadığınızda veya anahtarın sızdığından şüphelendiğinizde.',
    dataChanged:
      'Anahtara iptal tarihi yazılır ve anahtarla gelen istekler hemen reddedilir; işlem denetim kaydına yazılır.',
    requiredPermission: 'API anahtarı oluşturma ve iptal etme (hassas; iki adımlı doğrulama).',
    reversible: 'Hayır. Gerekirse yeni anahtar oluşturun.',
    commonErrors: [
      {
        problem: '"Bu işlem için doğrulama kodunuzu yeniden girmeniz gerekiyor"',
        solution: 'Hassas işlemdir; doğrulama uygulamanızdaki kodu girip tekrar deneyin.',
      },
      { problem: '"Kayıt bulunamadı"', solution: 'Anahtar zaten iptal edilmiş; sayfayı yenileyin.' },
    ],
  },
  'webhooks.create': {
    kind: 'action',
    title: 'Webhook Ekle',
    short: 'Seçilen olaylar olduğunda bildirim gönderilecek adresi kaydeder.',
    whatItDoes:
      'Adres "https://" ile başlamalı ve iç ağa (ör. 192.168.x.x) yönlenmemelidir. İmza sırrı yalnızca bir kez gösterilir; karşı program bu sırla isteğin gerçekten bizden geldiğini doğrular.',
    commonErrors: [
      {
        problem: '"https_required" veya "private_address"',
        solution: 'Herkese açık, HTTPS bir adres girin.',
      },
    ],
  },
  'webhooks.events': {
    kind: 'field',
    title: 'Olaylar',
    short: 'Hangi olaylarda bildirim gönderileceği. "*" tüm olaylar demektir.',
  },
  'webhooks.test': {
    kind: 'action',
    title: 'Test Olayı Gönder',
    short: 'Tüm aktif webhook\'lara "webhook.test" olayı gönderir; teslimat geçmişinden sonucu görürsünüz.',
  },
  'webhooks.rotate_secret': {
    kind: 'action',
    title: 'Sırrı Yenile',
    short: 'Yeni bir imza sırrı üretir; eski sır hemen geçersiz olur.',
    whenToUse: 'İmza sırrının ele geçirildiğinden şüphelendiğinizde veya karşı programı yeniden kurarken.',
    dataChanged:
      'Webhook için yeni bir imza sırrı üretilir ve şifreli saklanır; yeni sır yalnızca bu yanıtta bir kez gösterilir. İşlem denetim kaydına yazılır.',
    requiredPermission: 'Webhook (olay bildirimi) yönetimi (hassas; iki adımlı doğrulama).',
    reversible: 'Hayır. Karşı programdaki sırrı da güncellemeniz gerekir.',
    commonErrors: [
      {
        problem: '"Bu işlem için doğrulama kodunuzu yeniden girmeniz gerekiyor"',
        solution: 'Hassas işlemdir; doğrulama uygulamanızdaki kodu girip tekrar deneyin.',
      },
      {
        problem: 'Yenilemeden sonra karşı program bildirimleri reddediyor',
        solution: 'Eski sır hemen geçersiz olur; ekranda bir kez gösterilen yeni sırrı karşı programa girin.',
      },
    ],
  },
  'webhooks.redeliver': {
    kind: 'action',
    title: 'Yeniden Gönder',
    short: 'Başarısız bir teslimatı hemen tekrar dener.',
  },
  'webhooks.delete': {
    kind: 'action',
    title: 'Webhook Sil',
    short: 'Bu adrese bildirim gönderimini durdurur ve kaydı siler.',
    whenToUse: 'Bildirim gönderilen dış programı (ör. muhasebe, n8n) artık kullanmadığınızda.',
    dataChanged:
      'Webhook adresi kaydı silinir ve bu adrese bildirim gönderimi durur; silinen kayıt denetim kaydına yazılır.',
    requiredPermission: 'Webhook (olay bildirimi) yönetimi (hassas; iki adımlı doğrulama).',
    reversible:
      'Hayır, silinen webhook geri gelmez; aynı adres yeniden eklenirse yeni bir imza sırrı üretilir.',
    commonErrors: [
      {
        problem: '"Bu işlem için doğrulama kodunuzu yeniden girmeniz gerekiyor"',
        solution: 'Hassas işlemdir; doğrulama uygulamanızdaki kodu girip tekrar deneyin.',
      },
    ],
  },

  // ------------------------------------------------------------------ Entegrasyonlar
  'integrations.save_credentials': {
    kind: 'action',
    title: 'Bilgileri Kaydet',
    short: 'Girdiğiniz bilgileri şifreleyerek saklar.',
    whatItDoes:
      'Kaydetmek bağlantıyı açmaz: durum "Kurulum Gerekli" kalır. Bağlantı ancak "Bağlantıyı Test Et" başarılı olunca aktifleşir.',
    whenToUse:
      'Bir hizmetin (ödeme, kargo, e-posta, SMS vb.) anahtarlarını ilk kez girerken veya anahtarlar değiştiğinde.',
    dataChanged:
      'Seçilen ortamın (test veya canlı) bağlantı bilgileri şifrelenerek kaydedilir; bağlantının durumu "Kurulum Gerekli"ye döner ve son test sonucu silinir. Girilen alanların adları (gizli değerler değil) denetim kaydına yazılır.',
    requiredPermission:
      'Entegrasyon bilgilerini girme ve test etme. Canlı ortam için ayrıca: Entegrasyonu canlı ortama alma.',
    reversible:
      'Kısmen: eski bilgiler yeniden girilerek düzeltilir; ama kayıttan sonra bağlantı yeniden test edilene kadar çalışmaz.',
    commonErrors: [
      {
        problem: '"Bu entegrasyon … fazda eklenecek"',
        solution: 'Bu hizmet henüz kullanıma açılmadı; şu an anahtar girilemez.',
      },
      {
        problem: 'Kaydettikten sonra entegrasyon çalışmıyor',
        solution:
          'Kayıt bağlantıyı yeniden "Kurulum Gerekli"ye alır; "Bağlantıyı Test Et" ile yeniden etkinleştirin.',
      },
      {
        problem: '"Bu işlem için yetkiniz yok" (canlı ortam)',
        solution:
          'Canlı anahtar girmek için "Entegrasyonu canlı ortama alma" yetkisi gerekir; sahibe veya yöneticiye başvurun.',
      },
    ],
  },
  'integrations.test': {
    kind: 'action',
    title: 'Bağlantıyı Test Et',
    short: 'Kayıtlı bilgilerle gerçek servise bağlanmayı dener.',
    whatItDoes:
      'Başarılıysa durum "Canlı" (veya test ortamında "Sandbox") olur; başarısızsa "Hata" olur ve nedeni günlükte görünür. Gerçek ödeme veya gönderim yapmaz.',
    commonErrors: [
      {
        problem: 'SMTP: kimlik doğrulama hatası',
        solution: 'Kullanıcı adı/şifreyi kontrol edin; bazı sağlayıcılar "uygulama şifresi" ister.',
      },
      { problem: 'SMTP: zaman aşımı', solution: 'Port numarasını kontrol edin (genelde 587, SSL için 465).' },
    ],
  },
  'integrations.disconnect': {
    kind: 'action',
    title: 'Bağlantıyı Kaldır',
    short: 'Kayıtlı bilgileri siler ve entegrasyonu kapatır.',
    whenToUse:
      'Bir hizmeti artık kullanmayacağınızda veya anahtarlarının ele geçirildiğinden şüphelendiğinizde.',
    dataChanged:
      'Bu entegrasyonun seçilen ortamdaki (test veya canlı) şifreli bağlantı bilgileri silinir ve entegrasyon kapanır; işlem denetim kaydına yazılır.',
    requiredPermission: 'Entegrasyon bilgilerini girme ve test etme (hassas; iki adımlı doğrulama).',
    reversible: 'Bilgileri yeniden girerek.',
    commonErrors: [
      {
        problem: '"Kayıt bulunamadı"',
        solution: 'Bu ortam için kayıtlı bağlantı yok; sayfayı yenileyip doğru ortamı (test/canlı) seçin.',
      },
    ],
  },
  'integrations.environment': {
    kind: 'field',
    title: 'Ortam',
    short: 'Sandbox: gerçek para hareketi olmayan test ortamı. Canlı: gerçek işlemler.',
  },

  // ------------------------------------------------------------------ Diğer
  'audit.filter': {
    kind: 'action',
    title: 'Filtrele',
    short: 'Kayıtları türüne göre süzer (ör. yalnızca mağaza değişiklikleri).',
  },
  'system.refresh': { kind: 'action', title: 'Yenile', short: 'Durum bilgilerini yeniden ölçer.' },
  'setup.skip_step': {
    kind: 'action',
    title: 'Adımı Atla',
    short: 'Bu adımı şimdilik gerekli görmediğinizi işaretler.',
    reversible: 'Evet, "Geri al" ile.',
  },
  'account.change_password': {
    kind: 'action',
    title: 'Şifreyi Değiştir',
    short: 'Yeni şifre en az 12 karakter olmalı. Diğer cihazlardaki oturumlar kapanır.',
  },
  'account.sessions_revoke': {
    kind: 'action',
    title: 'Oturumu Kapat',
    short: 'Seçilen cihazdaki oturumu sonlandırır.',
  },
  'account.ui_mode': {
    kind: 'field',
    title: 'Kullanım Modu',
    short: 'Başlangıç modunda açıklamalar açık gelir; gelişmiş modda ekran sadeleşir.',
  },
  'account.language': { kind: 'field', title: 'Panel Dili', short: 'Türkçe, English, Deutsch veya العربية.' },
  'help.edit': {
    kind: 'action',
    title: 'Açıklamayı Düzenle',
    short: 'Bu yardım metnini değiştirir; eski hâli sürüm geçmişinde saklanır.',
  },
  // ------------------------------------------------------------------ Faz 2: katalog, fiyat, stok, müşteri, bayi, sipariş
  'page.products': {
    kind: 'page',
    title: 'Ürünler',
    short: 'Satılan tüm ürünler: varyantlar, stok, veteriner onayı ve yayın durumu.',
    whatItDoes:
      'Ürünleri ad, SKU veya barkodla arar; duruma, markaya ve veteriner onayına göre süzer. Her satırda toplam stok ve onay durumu görünür. Yeni ürün her zaman TASLAK olarak açılır; vitrinde görünmesi için ürünün etkin olması, sağlık içeriği varsa veteriner onayı alması, temel fiyatının girilmesi ve mağazada yayınlanması gerekir.',
    whenToUse: 'Ürün eklerken, düzenlerken veya hangi ürünlerin onay beklediğine bakarken.',
    dataChanged: 'Liste yalnızca gösterir.',
    requiredPermission: 'Ürünleri görüntüleme.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md',
  },
  'page.product_editor': {
    kind: 'page',
    title: 'Ürün Düzenleme',
    short: 'Ürün bilgileri, içerik, varyantlar, görseller, fiyatlar ve yayın.',
    whatItDoes:
      'Başlık, açıklama, içerik (bileşim), kullanım ve uyarılar "sağlık içeriği"dir: bu alanlardan biri değişirse veteriner onayı yeniden istenir ve ürün onaylanana kadar vitrinden kalkar. Metinde "tedavi eder, önler, iyileştirir" gibi ifadeler bulunursa sayfanın üstünde uyarı çıkar. Varyantlar (ör. 60 / 120 tablet) seçeneklerle tanımlanır; her varyantın SKU\'su tekildir.',
    whenToUse: 'Yeni ürün eklerken veya mevcut ürünü değiştirirken.',
    dataChanged:
      'Ürün, varyant, seçenek ve kategori kayıtlarını günceller. Her kayıt denetim kaydına eski/yeni değerle yazılır.',
    requiredPermission: 'Ürün ekleme ve düzenleme.',
    reversible:
      'Varyantlar silinmez, arşivlenir (sipariş geçmişi korunur). Değişiklikler denetim kaydından izlenebilir.',
    commonErrors: [
      {
        problem: '"Bu SKU başka bir varyantta kullanılıyor"',
        solution: 'SKU tüm işletmede tekil olmalı; farklı bir kod girin.',
      },
      {
        problem: '"Bu kayıt siz düzenlerken değiştirildi"',
        solution: 'Sayfayı yenileyin; başka biri aynı ürünü kaydetmiş.',
      },
    ],
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md',
  },
  'page.categories': {
    kind: 'page',
    title: 'Kategoriler',
    short: 'Vitrindeki ürün grupları (ör. Kedi Takviyeleri > Eklem).',
    whatItDoes:
      'Kategoriler ağaç yapısındadır; üst kategori sayfası alt kategorilerin ürünlerini de listeler. Gizlenen kategori vitrinde görünmez ama ürünler etkilenmez.',
    whenToUse: 'Mağaza menüsünü kurarken veya yeni ürün grubu açarken.',
    dataChanged: 'Kategori kayıtlarını değiştirir.',
    requiredPermission: 'Ürün ekleme ve düzenleme.',
    reversible: 'Gizleme geri alınabilir; silme yalnızca alt kategorisi olmayan kategoride yapılabilir.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#kategoriler',
  },
  'page.pricing': {
    kind: 'page',
    title: 'Fiyatlar',
    short: 'Müşteri grupları, fiyat listeleri, KDV sınıfları ve toplu fiyat değişikliği.',
    whatItDoes:
      'Temel (perakende) liste herkesin gördüğü fiyattır. Bir bayi grubuna bağlı liste yalnızca o grubun onaylı bayileri giriş yaptığında kullanılır: bayi fiyatı bu listede yoksa bayi de temel fiyatı görür. Toplu fiyat önce önizlenir, sonra uygulanır ve geri alınabilir. Vitrindeki "önceki fiyat" son 30 günde gerçekten uygulanmış en düşük fiyattan hesaplanır (uydurma üstü çizili fiyat yoktur).',
    whenToUse: 'Fiyat listesi kurarken, bayi iskontosu tanımlarken veya zam/indirim uygularken.',
    requiredPermission:
      'Görüntüleme: Fiyatları görüntüleme. Değiştirme: Fiyat düzenleme. Toplu uygulama: Toplu fiyat değişikliği uygulama (iki adımlı doğrulama).',
    guideUrl: 'docs/PRICING_ENGINE_TR.md',
  },
  'page.discounts': {
    kind: 'page',
    title: 'Kuponlar',
    short: 'Sepette kodla uygulanan yüzde veya tutar indirimleri.',
    whatItDoes:
      "Her kuponun kodu, türü (yüzde / sabit tutar), alt sepet tutarı, kullanım sınırı, bitiş tarihi ve geçerli olduğu müşteri grupları vardır. Sepette tek kupon kullanılır. İndirim KDV'den önce satırlara dağıtılır.",
    whenToUse: 'Kampanya veya müşteriye özel indirim verirken.',
    requiredPermission: 'Fiyat düzenleme.',
    reversible: 'Kupon pasifleştirilebilir; kullanılmış siparişler etkilenmez.',
    guideUrl: 'docs/PRICING_ENGINE_TR.md#kuponlar',
  },
  'page.stock': {
    kind: 'page',
    title: 'Stok',
    short: 'Depolar, varyant stokları, lot / son kullanma tarihi ve stok hareketleri.',
    whatItDoes:
      'Stok bir hareket defteriyle tutulur: mal kabul, düzeltme, hasar, sayım ve transfer birer hareket olarak eklenir; geçmiş silinemez. Sipariş verildiğinde stok "ayrılır", sevk edilince düşülür. Satışta son kullanma tarihi en yakın lot önce kullanılır; tarihi geçmiş lot satılmaz.',
    whenToUse: 'Mal geldiğinde, sayımda, fire/hasarda veya depolar arası aktarımda.',
    requiredPermission: 'Görüntüleme: Stokları görüntüleme. Hareket: Stok hareketi ve sayım.',
    reversible: 'Hareket silinmez; yanlış girişi ters yönlü bir düzeltmeyle dengeleyin.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#stok',
  },
  'page.customers': {
    kind: 'page',
    title: 'Müşteriler',
    short: 'Vitrin üyeleri ve bayi kullanıcıları.',
    whatItDoes:
      'Müşterileri ada göre arar; bayi / bireysel ayrımını gösterir. Kişisel verileri maskesiz görme yetkiniz yoksa e-posta ve telefon maskeli görünür ve e-postayla arama yapılamaz.',
    whenToUse: 'Müşteri bilgisine bakarken, hesabını etkinleştirirken veya kilidini açarken.',
    requiredPermission: 'Müşterileri görüntüleme.',
    guideUrl: 'docs/CUSTOMER_GUIDE_TR.md',
  },
  'page.customer_detail': {
    kind: 'page',
    title: 'Müşteri Ayrıntısı',
    short:
      'Profil, bağlı bayi firmaları, ileti izinleri, etiketler, sipariş özeti (RFM), adresler ve siparişler.',
    whatItDoes:
      'Hesap etkinleştirme / şifre sıfırlama bağlantısı üretir (e-posta kurulu değilse bağlantı ekranda gösterilir), kilitli hesabı açar, hesabı devre dışı bırakır, ileti izinlerinin geçmişini gösterir; müşteriye etiket verilir ve sipariş özeti ile RFM grubu görülür.',
    requiredPermission: 'Müşterileri görüntüleme; işlemler için Müşteri düzenleme.',
    guideUrl: 'docs/CUSTOMER_GUIDE_TR.md',
  },
  'page.dealers': {
    kind: 'page',
    title: 'Bayiler',
    short: 'Bayi firmaları, durumları ve fiyat grupları.',
    whatItDoes:
      'Onaylı bayinin kullanıcıları vitrine giriş yaptığında firmanın bayi grubuna ait fiyatları görür; askıya alınan veya reddedilen firmanın kullanıcıları normal (perakende) fiyatı görür. Bayi listesi Excel/CSV ile toplu yüklenebilir. Vergi numarası şifreli saklanır; tam numarayla arama yapılabilir.',
    whenToUse: 'Bayi eklerken, onaylarken veya askıya alırken.',
    requiredPermission:
      'Bayileri görüntüleme; ekleme/düzenleme: Bayi bilgilerini düzenleme; onay: Bayi başvurusu onaylama.',
    guideUrl: 'docs/CUSTOMER_GUIDE_TR.md#bayiler',
  },
  'page.dealer_detail': {
    kind: 'page',
    title: 'Bayi Ayrıntısı',
    short: 'Firma bilgileri, durum işlemleri, kullanıcılar ve başvuru geçmişi.',
    whatItDoes:
      'Firmaya kullanıcı eklediğinizde kişiye şifre belirleme (etkinleştirme) bağlantısı gider; e-posta kurulu değilse bağlantı ekranda gösterilir ve elle iletilir. Durum değişikliği fiyat görünürlüğünü hemen etkiler.',
    guideUrl: 'docs/CUSTOMER_GUIDE_TR.md#bayiler',
  },
  'page.dealer_applications': {
    kind: 'page',
    title: 'Bayilik Başvuruları',
    short: 'Vitrinden gelen bayilik başvuruları ve belgeleri.',
    whatItDoes:
      'Başvuruyu açıp firma bilgilerini ve belgeleri (vergi levhası vb.) inceleyin; onaylarken bir bayi grubu seçin. Onayla başvuran kişi firma yetkilisi olur ve bayi fiyatlarını görür. Belgeler yalnızca yetkili panel kullanıcılarınca indirilebilir.',
    requiredPermission: 'Görüntüleme: Bayileri görüntüleme. Karar: Bayi başvurusu onaylama.',
    guideUrl: 'docs/CUSTOMER_GUIDE_TR.md#basvurular',
  },
  'page.imports': {
    kind: 'page',
    title: 'İçe / Dışa Aktarma',
    short: 'Ürün ve bayi listelerini Excel/CSV ile toplu yükleme ve indirme.',
    whatItDoes:
      'Dosya önce ÖNİZLENİR: hangi satırların ekleneceği, güncelleneceği ve hangi satırlarda hata olduğu gösterilir; hiçbir veri değişmez. "Uygula" ile yazılır. Aynı dosyayı tekrar yüklemek kopya oluşturmaz (ürünlerde ürün kodu/SKU, bayilerde bayi kodu/vergi no ile eşleşir). Boş hücre mevcut değeri silmez. Shopify ürün CSV\'si doğrudan desteklenir.',
    whenToUse: 'İlk kurulumda mevcut ürün/bayi listesini taşırken veya toplu güncellemede.',
    requiredPermission:
      'Ürünler: Ürün içe aktarma. Bayiler: Bayi bilgilerini düzenleme (onaylı bayi için onay yetkisi).',
    reversible: 'Uygulanan içe aktarma tek tıkla geri alınmaz; dışa aktarma ile önce yedek almanız önerilir.',
    guideUrl: 'docs/BULK_IMPORT_EXPORT_TR.md',
  },
  'page.orders': {
    kind: 'page',
    title: 'Siparişler',
    short: 'Vitrinden, bayilerden ve panelden gelen siparişler.',
    whatItDoes:
      'Kartla ödenen siparişler ödeme kuruluşunun doğrulamasıyla kendiliğinden "Ödendi" olur. Havale/EFT siparişleri "Ödeme bekliyor" olarak gelir; para hesabınıza geçince sipariş ayrıntısında "Ödeme alındı" ile işaretleyin. Kapıda ödeme ve bayi açık hesabı siparişleri doğrudan "Hazırlanıyor" olarak gelir. Kargoya verdiğinizde stok defterden düşülür ve müşteriye takip numarasıyla e-posta gider.',
    whenToUse: 'Günlük sipariş takibi ve telefonla gelen bayi siparişlerini girmek için.',
    requiredPermission: 'Siparişleri görüntüleme; işlemler: Sipariş düzenleme.',
    guideUrl: 'docs/CUSTOMER_GUIDE_TR.md#siparisler',
  },
  'page.order_detail': {
    kind: 'page',
    title: 'Sipariş Ayrıntısı',
    short: 'Satırlar, tutarlar, adresler, zaman çizelgesi ve durum işlemleri.',
    whatItDoes:
      'Satırlar ve tutarlar sipariş anındaki hâliyle saklanır; fiyat sonradan değişse de bozulmaz. Ödemeler, iadeler, gönderiler, faturalar ve müşterinin onayladığı sözleşme metinleri bu sayfadadır. Durum yalnızca izin verilen yönde değişir; "Ödendi" yalnızca ödeme kaydıyla olur; ödenmiş sipariş önce tam iade yapılmadan iptal edilemez.',
    guideUrl: 'docs/CUSTOMER_GUIDE_TR.md#siparisler',
  },
  'products.create': {
    kind: 'action',
    title: 'Yeni Ürün',
    short: 'Taslak ürün açar; vitrinde görünmesi için yayın kuralları ayrıca sağlanmalıdır.',
    requiredPermission: 'Ürün ekleme ve düzenleme.',
  },
  'products.slug': {
    kind: 'field',
    title: 'Kısa Ad (adres)',
    short: 'Ürün sayfasının adresi: zootopia.com.tr/urun/<kısa-ad>. Boş bırakılırsa başlıktan üretilir.',
    whatItDoes:
      'Yalnızca küçük harf, rakam ve tire. Kısa ad değiştirilirse eski adres yeni adrese kalıcı olarak (301) yönlendirilir; yine de yayındaki ürünün adresini sık değiştirmeyin.',
  },
  'products.species': {
    kind: 'field',
    title: 'Tür',
    short:
      'Ürünün uygun olduğu hayvanlar: kedi, köpek, kuş, kemirgen (hamster, kobay vb.), tavşan, sürüngen ve kaplumbağa, diğer egzotik. Birden çoğu seçilebilir. Vitrindeki "Tür" süzgecinde (yalnızca ürünü olan türler görünür), karşılaştırmada ve ürün sayfasında kullanılır.',
    whenToUse:
      'Exotic serisi gibi birden çok türe uygun ürünlerde hepsini işaretleyin; içe aktarmada "hepsi" tüm türleri seçer.',
  },
  'products.tax_class': {
    kind: 'field',
    title: 'KDV Sınıfı',
    short: 'Boşsa varsayılan KDV sınıfı kullanılır. KDV sınıfı olmayan ürün satılamaz.',
  },
  'products.status': {
    kind: 'field',
    title: 'Ürün Durumu',
    short: 'Taslak: hazırlanıyor · Etkin: satılabilir · Arşiv: satıştan kalktı (kayıtlar korunur).',
  },
  'products.dealer_min_quantity': {
    kind: 'field',
    title: 'Bayi için en az adet',
    short:
      'Bayi bu ürünün bir seçeneğinden en az bu kadar alabilir (perakendeye uygulanmaz). Koli adedi de girildiyse en az adet koli katına yukarı yuvarlanır. Boş: kural yok.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#minimum-siparis',
  },
  'products.dealer_pack_size': {
    kind: 'field',
    title: 'Bayi koli adedi',
    short:
      'Bayi bu ürünü yalnızca bu adedin katları halinde alabilir (ör. 12, 24, 36). Ürün sayfasında ve sepette kural gösterilir; uymayan adet sepete eklenmez. Boş: kural yok.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#minimum-siparis',
  },
  'pricing.group_min_order': {
    kind: 'field',
    title: 'Minimum sipariş tutarı',
    short:
      'Bu gruptaki bayiler sepet tutarı (kargo hariç) bu tutara ulaşmadan sipariş veremez; sepette eksik tutar gösterilir. Firmaya özel tutar bayi kartında. Boş: yok.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#minimum-siparis',
  },
  'dealers.po_requirement': {
    kind: 'field',
    title: 'Satın alma emri (PO) zorunluluğu',
    short:
      'Vitrinden verilen siparişte PO numarası veya numara ve belge istenir. Panelden açtığınız siparişte zorunlu değildir.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#satin-alma-emri',
  },
  'dealers.min_order': {
    kind: 'field',
    title: 'Bayiye özel minimum sipariş',
    short:
      'Bu bayi için grubun tutarı yerine geçer. Boş bırakılırsa bayi grubunun minimum sipariş tutarı uygulanır.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#minimum-siparis',
  },
  'products.visibility': {
    kind: 'field',
    title: 'Kime Görünür',
    short:
      'Perakende: misafir ve bireysel müşteriler · Bayi: onaylı bayiler. Yalnızca bayiye açık ürünler (ör. koli) için perakendeyi kapatın.',
  },
  'products.health_content': {
    kind: 'field',
    title: 'Sağlık İçeriği',
    short:
      'Takviye/yem ürünlerinde açık bırakın: içerik Veteriner Uzman İnceleyici onaylamadan yayınlanamaz.',
    whatItDoes:
      'Açıkken başlık, açıklama, içerik, kullanım ve uyarılar onaylı içeriğin parçasıdır; biri değişirse onay düşer. Metinde hastalığı önleme/tedavi iddiası kullanılmamalıdır.',
  },
  'products.feed_registration_no': {
    kind: 'field',
    title: 'Yem Kayıt No',
    short: 'Tarım ve Orman Bakanlığı kayıt/onay numarası. Ürün sayfasında gösterilir.',
  },
  'products.variants': {
    kind: 'field',
    title: 'Seçenekler ve Varyantlar',
    short:
      'Seçenek (ör. Boyut: 60 tablet, 120 tablet) tanımlayın; her kombinasyon bir varyanttır ve kendi SKU, barkod ve stoğu vardır.',
    reversible: 'Varyant silinmez; arşivlenir.',
  },
  'products.sku': {
    kind: 'field',
    title: 'SKU (Stok Kodu)',
    short: 'İşletmede tekil kod. İçe aktarma ve entegrasyonlar ürünü bu kodla tanır.',
  },
  'products.cost': {
    kind: 'field',
    title: 'Maliyet',
    short:
      'Alış maliyeti; yalnızca "Maliyet ve kâr marjını görüntüleme" yetkisi olanlar görür. Vitrinde asla görünmez.',
  },
  'products.vet_review': {
    kind: 'action',
    title: 'Veteriner İncelemesi',
    short: 'Veteriner Uzman İnceleyici içeriği onaylar veya gerekçeyle reddeder.',
    whatItDoes:
      'Onay, ekrandaki içeriğin özetine bağlanır: siz incelerken başka biri içeriği değiştirdiyse onay reddedilir ve sayfayı yenilemeniz istenir. Otomatik uyarılar kesin karar değildir; karar inceleyicinindir.',
    requiredPermission: 'Ürün sağlık beyanını onaylama (yalnızca panel kullanıcısı).',
  },
  'products.media_upload': {
    kind: 'action',
    title: 'Görsel Ekle',
    short: "PNG/JPEG/WebP, en fazla 5 MB. Görsel WebP'ye dönüştürülür ve meta verileri (konum vb.) silinir.",
  },
  'products.prices': {
    kind: 'field',
    title: 'Ürün Fiyatları',
    short: 'Her fiyat listesindeki fiyat. Kutudan çıkınca kaydedilir; boş bırakmak fiyatı kaldırır.',
    whatItDoes: 'Her değişiklik fiyat geçmişine yazılır (önceki fiyat gösterimi buradan hesaplanır).',
  },
  'products.publish': {
    kind: 'action',
    title: 'Yayınla',
    short: 'Ürünü seçilen mağazanın vitrininde gösterir.',
    whatItDoes:
      'Şartlar: ürün etkin, sağlık içeriği varsa veteriner onaylı, mağazanın temel listesinde fiyatı var. Eksik şartlar listelenir.',
    whenToUse:
      'Ürünün açıklaması, görselleri, fiyatı ve (sağlık içeriği varsa) veteriner onayı tamamlandığında, ürünü bir mağazada satışa açmak için.',
    dataChanged:
      'Ürünün o mağazadaki yayın kaydı "yayında" olur ve ürün vitrinde, aramada ve site haritasında görünür; işlem denetim kaydına yazılır.',
    requiredPermission: 'Ürün yayınlama.',
    reversible: 'Evet, "Yayından kaldır".',
    commonErrors: [
      {
        problem: '"Ürün yayınlanamaz: …"',
        solution:
          'Mesajda yazan eksikleri giderin: ürün etkin olmalı, en az bir etkin varyant ve mağazanın temel fiyat listesinde fiyat bulunmalı, sağlık içeriği onaylı olmalı.',
      },
      {
        problem: '"Bu işlem için yetkiniz yok"',
        solution: 'Bu mağaza yetki alanınızda değil veya ürün yayınlama yetkiniz yok; yöneticinize başvurun.',
      },
    ],
  },
  'categories.parent': {
    kind: 'field',
    title: 'Üst Kategori',
    short: 'Boşsa ana menüde görünür. Bir kategori kendi alt kategorisinin altına taşınamaz.',
  },
  'pricing.group_kind': {
    kind: 'field',
    title: 'Grup Türü',
    short:
      'Bayi: onaylı bayi firmaları bu gruba bağlanır · Perakende: kupon kısıtlamalarında "bayi olmayanlar" anlamına gelir.',
  },
  'pricing.list_group': {
    kind: 'field',
    title: 'Listenin Grubu',
    short:
      'Boş: temel liste (herkes). Bir bayi grubu seçilirse liste yalnızca o grubun onaylı bayilerine uygulanır.',
  },
  'pricing.tax_inclusive': {
    kind: 'field',
    title: 'Fiyatlar KDV Dahil',
    short:
      'Perakende listeler genelde KDV dahildir; bayi listelerini KDV hariç girebilirsiniz (sepette KDV eklenir).',
  },
  'pricing.priority': {
    kind: 'field',
    title: 'Öncelik',
    short: 'Aynı türde birden çok liste geçerliyse önceliği yüksek olan kullanılır; eşitse düşük fiyat.',
  },
  'pricing.tax_class': {
    kind: 'field',
    title: 'KDV Sınıfları',
    short: 'Ürünlere atanan KDV oranları (ör. %20, %10). İlk eklenen varsayılan olur.',
  },
  'pricing.bulk_preview': {
    kind: 'action',
    title: 'Toplu Fiyat Önizleme',
    short:
      'Seçilen listedeki fiyatları yüzde/tutar ile veya başka listeden türeterek hesaplar; önizleme hiçbir fiyatı değiştirmez.',
    whatItDoes:
      'Önizleme 30 dakika geçerlidir. Bu sürede fiyatlar başka şekilde değişirse uygulama reddedilir.',
  },
  'pricing.bulk_apply': {
    kind: 'action',
    title: 'Toplu Fiyatı Uygula',
    short: 'Önizlenen fiyatları yazar; her değişiklik geçmişe kaydedilir.',
    whenToUse:
      'Toplu fiyat önizlemesindeki yeni fiyatları (ör. yüzde zam veya indirim) kontrol ettikten sonra, önizleme süresi dolmadan.',
    dataChanged:
      'Seçilen fiyat listesindeki fiyatlar önizlemedeki değerlerle değişir; her değişiklik fiyat geçmişine yazılır ve toplu işlem "uygulandı" olur. İşlem denetim kaydına yazılır.',
    requiredPermission: 'Toplu fiyat değişikliği uygulama (son 15 dakikada iki adımlı doğrulama).',
    reversible: 'Evet, geçmişten "Geri al" (sonradan elle değiştirilen fiyatlar korunur).',
    commonErrors: [
      { problem: '"Önizleme süresi doldu (30 dk)"', solution: 'Yeniden önizleyip hemen uygulayın.' },
      {
        problem: '"Önizlemeden sonra fiyatlar değişti"',
        solution: 'Biri bu sırada fiyat değiştirmiş; yeniden önizleyin.',
      },
      {
        problem: '"Bu işlem için doğrulama kodunuzu yeniden girmeniz gerekiyor"',
        solution: 'Doğrulama uygulamanızdaki kodu girip tekrar deneyin.',
      },
    ],
  },
  'pricing.bulk_revert': {
    kind: 'action',
    title: 'Toplu Fiyatı Geri Al',
    short:
      'Uygulanan toplu değişikliği eski fiyatlara döndürür; o tarihten sonra elle değişmiş fiyatlara dokunmaz.',
    whenToUse:
      'Uygulanan toplu fiyat değişikliğinin hatalı olduğunu fark ettiğinizde (yanlış yüzde, yanlış liste).',
    dataChanged:
      'Toplu işlemle değişen fiyatlar eski değerlerine döner ve fiyat geçmişine yazılır; uygulamadan sonra elle değiştirilmiş fiyatlar "atlandı" olarak raporlanır. Toplu işlem "geri alındı" olur ve denetim kaydına yazılır.',
    requiredPermission: 'Toplu fiyat değişikliği uygulama (hassas; iki adımlı doğrulama).',
    reversible:
      'Hayır, geri alınan toplu işlem yeniden uygulanamaz; gerekirse yeni bir toplu fiyat önizlemesi yapılır.',
    commonErrors: [
      {
        problem: '"Bu toplu işlem uygulanmamış; geri alınamaz"',
        solution: 'Yalnızca uygulanmış ve daha önce geri alınmamış işlem geri alınır.',
      },
    ],
  },
  'pricing.price_ending': {
    kind: 'field',
    title: 'Fiyat Sonu',
    short: 'Sonuç fiyatı yukarı yuvarlar: tam lira, ,90 veya ,99.',
  },
  'discounts.code': {
    kind: 'field',
    title: 'Kupon Kodu',
    short: '3–32 karakter; harf, rakam, - ve _. Büyük harfe çevrilir.',
  },
  'discounts.min_subtotal': {
    kind: 'field',
    title: 'En Az Sepet Tutarı',
    short: 'Sepet ara toplamı bu tutarın altındaysa kupon uygulanmaz.',
  },
  'discounts.usage_limit': {
    kind: 'field',
    title: 'Kullanım Sınırı',
    short:
      'Toplam kaç siparişte kullanılabilir. Aynı anda iki sipariş sınırı aşamaz; iptal edilen sipariş hakkı geri verir.',
  },
  'discounts.companies': {
    kind: 'field',
    title: 'Bayi firmaları',
    short:
      'Bayiye özel kupon: kodu yalnızca seçtiğiniz onaylı bayi firmalarının kullanıcıları kullanabilir (vitrinde ve panelden verilen siparişte).',
    guideUrl: 'docs/B2B_GUIDE_TR.md#bayi-kampanyalari',
  },
  'discounts.groups': {
    kind: 'field',
    title: 'Geçerli Gruplar',
    short:
      'Boş: herkes. Perakende grubu seçilirse misafir ve bayi olmayan müşteriler; bayi grubu seçilirse o grubun bayileri.',
  },
  'stock.change_type': {
    kind: 'field',
    title: 'Hareket Türü',
    short:
      'Mal kabul (+) · Düzeltme (± açıklama zorunlu) · Hasar/fire (−) · Sayım (girilen sayı yeni toplam olur).',
    whatItDoes: 'Ayrılmış (siparişe bağlı) stoğun altına düşürecek hareket reddedilir.',
  },
  'stock.lot': {
    kind: 'field',
    title: 'Lot ve SKT',
    short:
      "Takviyelerde parti numarası ve son kullanma tarihi girin; satışta SKT'si en yakın lot önce çıkar, tarihi geçen satılmaz.",
  },
  'stock.transfer': {
    kind: 'action',
    title: 'Depolar Arası Transfer',
    short: 'Bir depodan çıkış ve diğerine giriş hareketini birlikte kaydeder.',
    whenToUse:
      'Ürünleri bir depodan diğerine (ör. ana depodan mağaza deposuna) fiziksel olarak taşıdığınızda.',
    dataChanged:
      'Kaynak depoda "transfer çıkışı", hedef depoda "transfer girişi" hareketi aynı anda yazılır (lot seçildiyse o lottan). Toplam stok değişmez; işlem denetim kaydına yazılır.',
    requiredPermission: 'Stok hareketi ve sayım.',
    reversible: 'Kısmen: hareketler silinmez; ürünler ters yönde yeni bir transferle geri taşınır.',
    commonErrors: [
      {
        problem: '"Kaynak depoda bu ürünün taşınabilir stoğu yok"',
        solution: 'İlk stok girişini "Mal kabul" ile yapın; siparişlere ayrılmış adetler taşınamaz.',
      },
      { problem: '"Bu depodaki stok lotlarda"', solution: 'Kaynak olarak taşımak istediğiniz lotu seçin.' },
      { problem: '"Stokta yeterli ürün yok"', solution: 'Adedi mesajda yazan en fazla adede indirin.' },
    ],
  },
  'stock.expiring': {
    kind: 'field',
    title: 'SKT Yaklaşanlar',
    short: 'Seçilen gün içinde son kullanma tarihi dolacak, elde stoğu olan lotlar.',
  },
  'customers.pii_masked': {
    kind: 'field',
    title: 'Maskeli Kişisel Veri',
    short:
      'Yetkiniz olmadığı için e-posta, telefon ve adres maskeli. Tam görmek için "Müşteri kişisel verilerini maskesiz görme" yetkisi gerekir.',
  },
  'customers.access_link': {
    kind: 'action',
    title: 'Giriş Bağlantısı',
    short: 'Şifresi olmayan müşteriye etkinleştirme, olana şifre sıfırlama bağlantısı üretir.',
    whatItDoes:
      'E-posta altyapısı kuruluysa e-postayla gider. Kurulu değilse "gönderildi" denmez; bağlantı ekranda gösterilir ve müşteriye elle (ör. WhatsApp) iletirsiniz. Yeni bağlantı eskisini geçersiz kılar.',
    requiredPermission: 'Müşteri düzenleme.',
  },
  'customers.unlock': {
    kind: 'action',
    title: 'Kilidi Aç',
    short: '10 hatalı girişten sonra 15 dk kilitlenen hesabı hemen açar.',
  },
  'customers.consents': {
    kind: 'field',
    title: 'İleti İzinleri',
    short: 'E-posta/SMS kampanya izinleri; geçmiş silinmez, her değişiklik yeni kayıttır.',
    whatItDoes:
      'Sipariş ve kargo bildirimleri izin gerektirmez. Panelden izin VERMEK için ispat (imzalı form vb.) referansı gerekir; geri almak (müşteri talebi) her zaman yapılabilir. İYS entegrasyonu Faz 6.',
  },
  'dealers.tax_number': {
    kind: 'field',
    title: 'Vergi No / TCKN',
    short:
      'Şirketler 10 haneli VKN, şahıs işletmeleri 11 haneli TCKN. Şifreli saklanır; aynı numarayla iki firma açılamaz.',
  },
  'dealers.external_code': {
    kind: 'field',
    title: 'Bayi Kodu',
    short: 'Eski sistemdeki / muhasebedeki cari kod. İçe aktarmada eşleştirme anahtarıdır.',
  },
  'dealers.group': {
    kind: 'field',
    title: 'Bayi Grubu',
    short: 'Bayinin göreceği fiyat listesini belirler. Değiştirmek onay yetkisi ister.',
  },
  'dealers.status_action': {
    kind: 'action',
    title: 'Bayi Durumu',
    short: 'Onayla: bayi fiyatları açılır · Askıya al: perakende fiyata döner · Reddet: gerekçe zorunlu.',
    whenToUse:
      'Bayilik başvurusunu karara bağlarken, ödeme veya sözleşme sorunu olan bayiyi geçici olarak durdururken ya da askıdaki bayiyi yeniden açarken.',
    dataChanged:
      'Firmanın durumu (onaylı, askıda, reddedildi) ve bayi grubu güncellenir; bekleyen başvuru aynı kararla kapanır. Onayda bayi fiyatları bu gruptan gelir; değişiklik eski ve yeni değerle denetim kaydına yazılır.',
    requiredPermission: 'Bayi başvurusu onaylama.',
    reversible: 'Evet; askıdaki veya reddedilen bayi yeniden onaylanabilir.',
    commonErrors: [
      {
        problem: '"Onaylı bayi için bir bayi grubu seçilmeli"',
        solution: 'Onaylamadan önce bayi grubunu seçin.',
      },
      { problem: '"Açıklama yazılmalı"', solution: 'Reddederken gerekçeyi yazın.' },
      {
        problem: '"Bu durumdan bu duruma geçilemez"',
        solution: 'Örneğin onaylı bayi doğrudan reddedilemez; önce askıya alın.',
      },
    ],
  },
  'dealers.add_member': {
    kind: 'action',
    title: 'Kullanıcı Ekle',
    short: 'Bayi çalışanını firmaya bağlar; hesabı yoksa oluşturulur ve şifre belirleme bağlantısı üretilir.',
  },
  'applications.documents': {
    kind: 'field',
    title: 'Başvuru Belgeleri',
    short:
      'Başvuranın yüklediği vergi levhası vb. Yalnızca yetkili panel kullanıcıları indirebilir; dosya herkese açık adreste sunulmaz.',
  },
  'applications.decision': {
    kind: 'action',
    title: 'Başvuru Kararı',
    short:
      'Onaylarken bayi grubu seçin; reddederken gerekçe yazın. Başvurana e-posta gider (e-posta kuruluysa).',
    whenToUse: 'Bayilik başvurusundaki firma bilgilerini ve vergi kaydını kontrol ettikten sonra.',
    dataChanged:
      'Onayda firma onaylanıp seçilen bayi grubuna bağlanır ve başvuran firma yetkilisi olur; ret durumunda başvuru gerekçesiyle kapanır. E-posta kuruluysa başvurana sonuç e-postası gider ve karar denetim kaydına yazılır.',
    requiredPermission: 'Bayi başvurusu onaylama/reddetme.',
    reversible:
      'Kısmen: başvuru kararı değiştirilemez; onaylanan bayi sonradan "Bayi Durumu"ndan askıya alınabilir.',
    commonErrors: [
      {
        problem: '"Bu başvuru zaten sonuçlandı"',
        solution: 'Sayfayı yenileyin; başvuru başka biri tarafından karara bağlanmış.',
      },
    ],
  },
  'imports.products_file': {
    kind: 'action',
    title: 'Ürün Dosyası Yükle',
    short:
      "Kendi şablonumuz (Excel/CSV), Shopify ürün CSV'si veya ürün JSON/XML belgesi (şema: docs/schemas). Önce önizleme gösterilir; tanınmayan sütunlar elle eşleştirilebilir.",
    commonErrors: [
      {
        problem: 'Eski Excel (.xls) reddedildi',
        solution: 'Dosyayı Excel\'de "Farklı kaydet → Excel Çalışma Kitabı (.xlsx)" ile kaydedin.',
      },
      {
        problem: 'Türkçe karakterler bozuk',
        solution: 'CSV\'yi "UTF-8" olarak kaydedin veya .xlsx kullanın.',
      },
    ],
  },
  'imports.dealers_file': {
    kind: 'action',
    title: 'Bayi Listesi Yükle',
    short: 'Excel/CSV; zorunlu sütunlar: Firma Unvanı ve Bayi Kodu veya Vergi No.',
    whatItDoes:
      'Yetkili e-postası olan satırlar için şifresiz müşteri hesabı açılır ve firmaya bağlanır. Bayiler hesaplarını e-postayla gelen bağlantıdan veya "Şifremi unuttum" ile etkinleştirir.',
  },
  'imports.products_apply': {
    kind: 'action',
    title: 'Ürünleri içe aktar',
    short:
      'Önizlemedeki yeni ürünleri ekler, mevcutları günceller. 50 ürüne kadar hemen, fazlası arka planda işlenir.',
    whatItDoes:
      'Her ürün ayrı yazılır; hatalı bir satır diğerlerini durdurmaz, sonuç tablosunda hata nedeniyle gösterilir. Yeni ürünler yayına alınmaz. Elle yaptığınız sütun eşleştirmesi sonraki dosyalar için hatırlanır. Arka planda işlenirken sayfadan ayrılabilirsiniz.',
    whenToUse: 'Önizlemede eklenecek ve güncellenecek ürünleri, sorunlu satırları kontrol ettikten sonra.',
    dataChanged:
      'Ürünler, varyantlar ve seçtiğiniz fiyat listesindeki fiyatlar yazılır; depo seçildiyse stok sayım olarak girilir. İçe aktarma kaydı ve denetim kaydı oluşur.',
    requiredPermission: 'Ürün içe aktarma.',
    reversible:
      'Tek tıkla geri alınmaz. Güncellemeden önce "Dışa aktar" ile yedek alın; yeni eklenen taslak ürünler silinebilir.',
    commonErrors: [
      { problem: '"Önizleme süresi doldu (1 saat)"', solution: 'Dosyayı yeniden yükleyip önizleyin.' },
      {
        problem: '"Bu içe aktarma zaten uygulandı"',
        solution: 'Aynı önizleme ikinci kez uygulanmaz; sonucu sayfadaki tabloda görün.',
      },
    ],
    guideUrl: 'docs/BULK_IMPORT_EXPORT_TR.md#urun-ice-aktarma',
  },
  'imports.dealers_apply': {
    kind: 'action',
    title: 'Bayileri içe aktar',
    short: 'Önizlemedeki bayileri ekler veya günceller ve yetkili kullanıcıları firmaya bağlar.',
    whatItDoes:
      'Tüm satırlar tek işlemde yazılır (hepsi ya da hiçbiri). "Etkinleştirme e-postası" seçildiyse şifresi olmayan kullanıcılara şifre belirleme bağlantısı gider; e-posta kurulu değilse gönderilmez ve sonuçta yazar.',
    whenToUse: 'Önizlemede eklenecek ve güncellenecek bayileri kontrol ettikten sonra.',
    dataChanged:
      'Bayi firmaları, durumları ve müşteri grupları yazılır; yetkili e-postası olan satırlar için şifresiz müşteri hesabı açılıp firmaya bağlanır. Denetim kaydına düşer.',
    requiredPermission:
      'Bayi bilgilerini düzenleme; dosyada onaylı/askıda durum veya müşteri grubu varsa ayrıca bayi başvurusu onaylama. Bayi kapsamı sınırlı kullanıcılar uygulayamaz.',
    reversible:
      'Tek tıkla geri alınmaz; bayi durumu ve grubu bayi kartından tek tek düzeltilir. Gönderilen e-postalar geri alınmaz.',
    commonErrors: [
      { problem: '"Önizleme süresi doldu (1 saat)"', solution: 'Dosyayı yeniden yükleyip önizleyin.' },
      {
        problem: '"Bu içe aktarma zaten uygulandı"',
        solution: 'Aynı önizleme ikinci kez uygulanmaz; değişiklik için dosyayı yeniden yükleyin.',
      },
    ],
    guideUrl: 'docs/BULK_IMPORT_EXPORT_TR.md#bayi-ice-aktarma',
  },
  'imports.price_list': {
    kind: 'field',
    title: 'Fiyatların Yazılacağı Liste',
    short: 'Dosyadaki "Fiyat" sütunu bu listeye yazılır. Seçmezseniz fiyatlar alınmaz.',
  },
  'imports.warehouse': {
    kind: 'field',
    title: 'Stokların Yazılacağı Depo',
    short: 'Dosyadaki "Stok" sütunu bu depoya SAYIM olarak yazılır (lotsuz stok). Seçmezseniz stok alınmaz.',
  },
  'imports.default_brand': {
    kind: 'field',
    title: 'Varsayılan marka',
    short:
      '"Marka" sütunu boş olan satırlardaki yeni ürünler bu markaya eklenir. Sütunda yazan marka her zaman önceliklidir.',
  },
  'imports.default_status': {
    kind: 'field',
    title: 'Varsayılan Durum',
    short: '"Durum" sütunu boşsa: Onaylı (hemen bayi fiyatı görür) veya Başvuru (onay bekler).',
  },
  'imports.send_links': {
    kind: 'field',
    title: 'Etkinleştirme E-postası',
    short:
      'Şifresi olmayan bayi kullanıcılarına şifre belirleme bağlantısı gönderilir. E-posta kurulu değilse gönderilmez ve sonuçta belirtilir.',
  },
  'imports.download_issues': {
    kind: 'action',
    title: 'Hata Listesini İndir',
    short:
      'Önizlemede bulunan sorunları satır numarasıyla CSV olarak indirir; düzeltip dosyayı yeniden yükleyin.',
    whatItDoes:
      "Dosya bilgisayarınızda oluşturulur, sunucuya bir şey gönderilmez. Dosyadaki değerler Excel'de formül olarak çalışmasın diye gerektiğinde başına kesme işareti eklenir.",
  },
  'imports.export': {
    kind: 'action',
    title: 'Dışa Aktar',
    short:
      'Aynı sütunlarla Excel dosyası indirir; düzenleyip geri yükleyebilirsiniz. JSON ve XML ürün belgesi de indirilebilir (tutarlar kuruş; şema docs/schemas). Maliyet yalnızca maliyet görme yetkisiyle yazılır.',
    guideUrl: 'docs/BULK_IMPORT_EXPORT_TR.md#json-xml',
  },
  'orders.manual_create': {
    kind: 'action',
    title: 'Panelden Sipariş',
    short: "Telefonla/WhatsApp'tan gelen siparişi müşterinin fiyatıyla (bayiyse bayi fiyatı) oluşturur.",
    whatItDoes:
      '"Kesinleştir" seçilirse stok hemen ayrılır; "Taslak" stok ayırmaz. Açık hesap ve kapıda ödeme siparişi doğrudan hazırlanır; elle/havale siparişi ödeme alınınca "Ödeme alındı" ile işaretlenir. Elle fiyat girmek Fiyat düzenleme yetkisi ister ve denetim kaydına işlenir.',
  },
  'orders.ledger_settled': {
    kind: 'field',
    title: 'Cari ile Kapandı',
    short:
      'Açık hesap siparişinin borcu, bayinin cari hesabına girilen tahsilatlarla (en eski vadeli borçtan başlayarak) tamamen kapandı.',
    whatItDoes:
      'Yalnızca bilgi işaretidir: siparişin ödeme durumu değişmez. Siparişe ayrıca "Ödeme alındı" girmeyin; aynı para cari hesapta iki kez alacak olur.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-ile-kapandi',
  },
  'orders.status_change': {
    kind: 'action',
    title: 'Durum Değiştir',
    short:
      'Hazırlanıyor → (Kargoya ver) → Teslim edildi → Tamamlandı. İptal stok ve kupon hakkını geri verir.',
    whatItDoes:
      '"Kargoda" durumuna Kargoya ver ile (takip numarasıyla) geçilir; ayrılan stok defterde "satış" hareketiyle düşülür. Kargoya verilmiş sipariş iptal edilemez; iade için Para İadesi kullanılır.',
    whenToUse:
      'Siparişi hazırlamaya başladığınızda, teslim edildiğini öğrendiğinizde, işi kapattığınızda veya ödenmemiş bir siparişi iptal ederken.',
    dataChanged:
      'Siparişin durumu değişir, geçmişine ve denetim kaydına yazılır. Taslak kesinleşirken stok ayrılır ve kupon kullanımı sayılır; iptalde ayrılan stok, kupon hakkı ve hediye kartı/kredi bakiyesi geri verilir, müşteriye iptal e-postası gider.',
    requiredPermission: 'Sipariş düzenleme.',
    reversible:
      'Kısmen: durumlar yalnızca izin verilen sırayla ilerler, iptal edilen sipariş yeniden açılamaz.',
    commonErrors: [
      {
        problem: '"Ödenmiş sipariş, para iadesi yapılmadan iptal edilemez"',
        solution: 'Önce Para İadesi ile tam iade yapın, sonra iptal edin.',
      },
      {
        problem: '"Bu siparişte kartta bloke var"',
        solution: 'Provizyonlu siparişi "Provizyonu bırak" ile iptal edin.',
      },
      {
        problem: '"Bu kuponun kullanım hakkı dolmuş"',
        solution: 'Taslağı kesinleştirmeden önce kuponu kaldırın veya kuponun kullanım sınırını artırın.',
      },
    ],
  },
  'orders.payment_note': {
    kind: 'field',
    title: 'Ödeme Açıklaması',
    short: 'Ödemenin nasıl alındığını yazın (ör. havale dekont no, kapıda ödeme tahsilatı, cari mahsup).',
  },
  'orders.notes': { kind: 'field', title: 'İç Not', short: 'Yalnızca panelde görünür; müşteri görmez.' },
  'orders.po': {
    kind: 'field',
    title: 'Satın alma emri ve firma onayı',
    short:
      'Bayinin satın alma emri (PO) numarası ve belgesi; Satın alma kullanıcısının eşiği aşan siparişini kimin onayladığı.',
    whatItDoes:
      'Bayi ödeme adımında PO numarasını ve belgesini ekler; firmada zorunlu tutulabilir (Bayi ayrıntısı → Sipariş koşulları). Numara her aşamada düzeltilebilir; belge eklenir veya değiştirilir. Firma onayı bilgisi Satın alma kullanıcısının eşiğini aşan siparişte görünür ve değiştirilemez.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#satin-alma-emri',
  },
  'orders.po_number': {
    kind: 'field',
    title: 'PO numarası',
    short:
      'Bayinin kendi satın alma emri numarası (en çok 50 karakter). Sipariş listesinde PO numarasıyla aranır.',
  },
  'orders.po_document': {
    kind: 'action',
    title: 'PO belgesi ekle veya değiştir',
    short:
      'PDF, JPEG veya PNG (en çok 10 MB). Özel dosya olarak saklanır; yalnızca sipariş görme yetkisi olan panel kullanıcıları indirir.',
  },
  'orders.company_approval': {
    kind: 'field',
    title: 'Firma içi onay',
    short:
      'Satın alma kullanıcısının eşiği aşan sepetini firma Yetkilisi vitrinde onayladı; onaylanan tutar ve not burada.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#firma-onayi',
  },
  'page.order_print': {
    kind: 'page',
    title: 'Sipariş Yazdır',
    short: 'Seçilen siparişlerin özeti veya sevk listesi; her sipariş ayrı sayfada.',
    whatItDoes:
      'Sipariş özeti ürünleri, fiyatları, KDV ve toplamları; sevk listesi fiyatsız olarak ürünleri, adetleri, lot ve son kullanma tarihlerini ve kontrol kutularını içerir. "Yazdır / PDF kaydet" tarayıcının yazdırma penceresini açar; PDF için hedef olarak "PDF olarak kaydet"i seçin. Kişisel verileri görme yetkiniz yoksa adresler gizli basılır. Sevk listesi e-İrsaliye yerine geçmez.',
    requiredPermission: 'Siparişleri görüntüleme.',
    guideUrl: 'docs/CUSTOMER_GUIDE_TR.md#toplu-siparis',
  },
  'orders.guest': {
    kind: 'field',
    title: 'Müşteri Türü',
    short:
      'Kayıtlı müşteride fiyatlar müşterinin grubuna göre (bayiyse bayi fiyatı) hesaplanır. Misafir siparişte perakende fiyat kullanılır; e-posta zorunludur.',
    guideUrl: 'docs/CUSTOMER_GUIDE_TR.md#taslak-siparis',
  },
  'orders.shipping_fee': {
    kind: 'field',
    title: 'Kargo',
    short:
      'Kargo yöntemi seçilirse ücret vitrindeki kuralla hesaplanır (ağırlık kademesi, ücretsiz kargo sınırı). Elle ücret girmek Fiyat düzenleme yetkisi ister.',
    guideUrl: 'docs/CUSTOMER_GUIDE_TR.md#taslak-siparis',
  },
  'orders.manual_discount': {
    kind: 'field',
    title: 'İndirim',
    short:
      'Kupon kodu kuponun kurallarıyla uygulanır (kullanımı sipariş kesinleşince sayılır). Elle tutar Fiyat düzenleme yetkisi ister ve denetim kaydına yazılır. İkisi birlikte kullanılamaz.',
    guideUrl: 'docs/CUSTOMER_GUIDE_TR.md#taslak-siparis',
  },
  'orders.edit_draft': {
    kind: 'action',
    title: 'Taslağı Düzenle',
    short:
      'Taslakta müşteri, ürünler, kargo, indirim, ödeme yöntemi, adres ve not değişebilir. Fiyatlar güncel liste fiyatıyla yeniden hesaplanır (elle fiyatlar korunur). Taslak stok ayırmaz; "Siparişi kesinleştir" ile siparişe dönüşür.',
    guideUrl: 'docs/CUSTOMER_GUIDE_TR.md#siparis-duzenleme',
  },
  'orders.edit_lines': {
    kind: 'action',
    title: 'Ürünleri Düzenle',
    short:
      'Ödeme alınmadan önce ürün ve adet değişebilir. Siparişteki ürünlerin fiyatı korunur, yeni ürün güncel fiyatla eklenir; stok yeniden ayrılır. Ödeme alındıktan, fatura kesildikten veya müşteri kartla öderken değiştirilemez.',
    guideUrl: 'docs/CUSTOMER_GUIDE_TR.md#siparis-duzenleme',
  },
  'orders.edit_address': {
    kind: 'action',
    title: 'Adres ve Notu Düzenle',
    short:
      'Gönderi oluşturulana kadar teslimat adresi ve not değişebilir (ödeme alınmış olsa da). Fatura kesildiyse fatura adresi değişmez.',
    guideUrl: 'docs/CUSTOMER_GUIDE_TR.md#siparis-duzenleme',
  },
  'orders.payment_link': {
    kind: 'action',
    title: 'Ödeme Linki',
    short:
      'Ödeme bekleyen siparişe süreli bağlantı oluşturur; müşteri siparişi ve sözleşmeleri görüp kartla öder. Bağlantı yalnızca oluşturulurken gösterilir; yenisi öncekini iptal eder. Sipariş tutarı değişirse bağlantı ödeme almaz.',
    whatItDoes:
      'Taslak sipariş bağlantı oluşturulunca kesinleşir (stok ayrılır). Ödeme alınınca sipariş "Ödendi" olur ve müşteriye onay ile sözleşme e-postası gider. Kart ödemesi kurulu değilse bağlantı oluşturulamaz (Kurulum Gerekli).',
    whenToUse:
      "Telefonla veya WhatsApp'tan alınan peşin ödemeli siparişte müşterinin kartla uzaktan ödeme yapması gerektiğinde.",
    dataChanged:
      'Siparişe süreli yeni bir ödeme bağlantısı eklenir ve önceki etkin bağlantılar iptal edilir; taslak sipariş "Ödeme bekleniyor" olur ve stok ayrılır. "E-postayla gönder" seçiliyse bağlantı müşteriye e-postayla gider.',
    requiredPermission: 'Sipariş düzenleme.',
    reversible:
      'Evet, bağlantı Ödeme Linkleri sayfasından iptal edilir. Taslağın kesinleşmesi ve gönderilen e-posta geri alınmaz.',
    commonErrors: [
      {
        problem: '"Kartla ödeme kurulu değil"',
        solution: 'Ödemeler → Ödeme ayarlarından ödeme kuruluşunu bağlayın.',
      },
      {
        problem: '"Ön bilgilendirme formu ve mesafeli satış sözleşmesi yayımlanmadan sipariş alınamaz"',
        solution: 'Yasal Metinler sayfasında bu iki metni yayımlayın.',
      },
      {
        problem: '"Ödeme linki yalnızca peşin ödenecek … siparişte oluşturulabilir"',
        solution:
          'Açık hesap veya kapıda ödemeli siparişte, tutarı sıfır olan ya da kısmen ödenmiş siparişte bağlantı oluşturulamaz.',
      },
    ],
    guideUrl: 'docs/PAYMENTS_TR.md#odeme-linki',
  },
  'orders.payment_link_hours': {
    kind: 'field',
    title: 'Geçerlilik Süresi',
    short: 'Bu süreden sonra bağlantı ödeme almaz; sipariş kendiliğinden iptal edilmez, stok ayrılı kalır.',
    guideUrl: 'docs/PAYMENTS_TR.md#odeme-linki',
  },
  'orders.payment_link_email': {
    kind: 'field',
    title: 'E-postayla Gönder',
    short:
      'Bağlantı siparişteki e-posta adresine gönderilir (e-posta altyapısı kuruluysa). İşaretlemezseniz bağlantıyı kopyalayıp kendiniz iletin.',
    guideUrl: 'docs/PAYMENTS_TR.md#odeme-linki',
  },
  'orders.bulk_status': {
    kind: 'action',
    title: 'Toplu Durum Değişikliği',
    short:
      'Seçili siparişler (en çok 100) tek tek kendi kurallarıyla değişir; uygun olmayanlar nedeniyle listelenir. Kargoya verme gönderi oluşturarak, "Ödendi" ödeme kaydıyla yapılır.',
    whenToUse:
      'Aynı aşamadaki çok sayıda siparişi (ör. teslim edilenleri "Tamamlandı") tek seferde ilerletmek istediğinizde.',
    dataChanged:
      'Her sipariş tek tek "Durum Değiştir" kurallarıyla değişir (iptalde stok ve kupon geri verilir, e-posta gider). Toplu işlemin özeti (istenen, başarılı, başarısız sayısı) denetim kaydına yazılır.',
    requiredPermission: 'Sipariş düzenleme.',
    reversible:
      'Kısmen: her sipariş ayrı ayrı izin verilen sırayla ilerler; iptal edilen siparişler yeniden açılamaz.',
    commonErrors: [
      {
        problem: 'Bazı siparişler "uygun değil" olarak listelendi',
        solution:
          'Listede her siparişin nedeni yazar (ör. ödenmemiş, bölünmüş); o siparişleri tek tek düzeltin.',
      },
    ],
    guideUrl: 'docs/CUSTOMER_GUIDE_TR.md#toplu-siparis',
  },
  'orders.bulk_print': {
    kind: 'action',
    title: 'Yazdır',
    short:
      "Seçili siparişlerin özetini (fiyatlı) veya sevk listesini (fiyatsız, lot/SKT'li) yazdırma sayfasında açar.",
    guideUrl: 'docs/CUSTOMER_GUIDE_TR.md#toplu-siparis',
  },
  'orders.bulk_export': {
    kind: 'action',
    title: 'Excel Olarak İndir',
    short:
      'Seçili siparişleri Dışa Aktarma ekranındaki sütunlarla indirir; kişisel veriler maskelidir. Taslaklar dosyaya girmez.',
    guideUrl: 'docs/BULK_IMPORT_EXPORT_TR.md#operasyon-disa-aktarma',
  },
  'orders.print': {
    kind: 'action',
    title: 'Yazdır / PDF Kaydet',
    short:
      'Tarayıcının yazdırma penceresini açar; her sipariş ayrı sayfaya basılır. PDF için "PDF olarak kaydet"i seçin.',
  },
  'page.payment_settings': {
    kind: 'page',
    title: 'Ödeme Ayarları (POS Kurulum Merkezi)',
    short:
      'Kartla ödeme (iyzico/PayTR), havale/EFT, kapıda ödeme ve bayi açık hesabı; canlıya hazırlık listesi.',
    whatItDoes:
      'Mağazanın hangi ödeme yöntemlerini sunacağını belirler. Kartla ödeme için önce Entegrasyonlar ekranında iyzico veya PayTR anahtarlarını girip bağlantı testini geçirmeniz gerekir; test (sandbox) ortamında gerçek para çekilmez. Canlıya geçiş ayrı bir onaydır: canlı bağlantı testi ve test ortamında en az bir başarılı ödeme olmadan açılmaz. Sayfanın başındaki liste, mağazanın canlıya çıkması için eksik olanları gerçek verilerden gösterir.',
    whenToUse: 'İlk kurulumda, ödeme kuruluşu başvurunuz onaylandığında ve canlıya geçerken.',
    dataChanged:
      'Mağazanın ödeme ayarlarını ve banka hesaplarını değiştirir; her değişiklik denetim kaydına eski ve yeni değeriyle yazılır.',
    requiredPermission:
      'Görüntüleme: Ödemeleri görüntüleme. Değiştirme: Ödeme sağlayıcısı yönetimi (hassas; iki adımlı doğrulama ister).',
    reversible:
      'Evet. Canlıdan teste dönmek kartla ödemeyi kapatır; yeniden açmak için sağlayıcıyı tekrar seçin.',
    guideUrl: 'docs/PAYMENTS_TR.md#odeme-ayarlari',
  },
  'page.payments': {
    kind: 'page',
    title: 'Ödemeler',
    short: 'Tüm ödeme denemeleri, tahsilatlar, iadeler ve sağlayıcı mutabakatı.',
    whatItDoes:
      'Kart, havale/EFT, kapıda ödeme ve açık hesap kayıtlarını durumlarıyla listeler. Kart ödemelerinde sağlayıcıdan gelen her bildirim ve sorgu, imzanın geçerli olup olmadığıyla birlikte saklanır. Mutabakat, sağlayıcının işlem dökümünü sizdeki kayıtlarla karşılaştırır ve farkları gösterir.',
    whenToUse:
      'Günlük ödeme kontrolü, müşteri "param çekildi ama sipariş görünmüyor" dediğinde ve gün sonu mutabakatında.',
    dataChanged:
      'Liste yalnızca gösterir. Mutabakat çalıştırmak bir kayıt oluşturur; farkı açıklamayla kapatmak denetim kaydına yazılır.',
    requiredPermission: 'Ödemeleri görüntüleme; farkı kapatma: Ödeme alma.',
    guideUrl: 'docs/PAYMENTS_TR.md#odemeler-ve-mutabakat',
  },
  'page.invoices': {
    kind: 'page',
    title: 'Faturalar',
    short: "Siparişlerin fatura kayıtları: BizimHesap'a gönderilenler ve elle girilenler.",
    whatItDoes:
      'Fatura sipariş ekranından oluşturulur. BizimHesap bağlıysa fatura oraya kayıt olarak gönderilir; e-Arşiv/e-Fatura\'ya dönüştürme BizimHesap panelinden yapılır. Bağlantı zaman aşımına uğrarsa fatura "belirsiz" olur ve kendiliğinden yeniden gönderilmez (çift fatura riskine karşı); BizimHesap\'ta kontrol edip işaretlemeniz gerekir.',
    whenToUse: 'Gün sonunda gönderilmemiş, başarısız veya belirsiz faturaları kontrol etmek için.',
    requiredPermission: 'Faturaları görüntüleme; işlemler: Fatura oluşturma ve gönderme.',
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#faturalar',
  },
  'page.redirects': {
    kind: 'page',
    title: 'Yönlendirmeler',
    short: 'Eski adresleri yeni adreslere bağlar (301 kalıcı, 302 geçici).',
    whatItDoes:
      'Eski siteden geçişte eski sayfa adresleri (ör. /sayfa/kvkk-metni, /uyeol) yeni karşılıklarına yönlendirilir; böylece Google sıralaması ve müşterilerin kayıtlı bağlantıları kaybolmaz. Eski alan adına (ör. zootopiaglobal.com) gelen her istek de bu listeye göre tek adımda 301 ile yönlenir; listede olmayan eski adresin karşılığını sistem bulur ve emin olduğunu "Eşleştirme" olarak ekler (Derma ile Exotic Derma gibi ayırt edici kelimeler karıştırılmaz). Ürün veya kategori adresi değiştirildiğinde eski adres yenisine kendiliğinden yönlendirilir. Her kaydın kaç kez kullanıldığı görünür; mağazanın kendi sayfalarını gölgeleyen kurallar üstte uyarılır.',
    whenToUse: 'Eski siteden geçişten önce (liste dosyadan içe aktarılır) ve bir sayfa kaldırıldığında.',
    dataChanged:
      'Yalnızca yönlendirme listesini değiştirir. Değişiklik vitrinde en geç bir dakikada geçerli olur.',
    requiredPermission: 'Görüntüleme: SEO görüntüleme. Değiştirme: SEO düzenleme.',
    guideUrl: 'docs/GO_LIVE_TR.md#yonlendirmeler',
  },
  'redirects.add': {
    kind: 'action',
    title: 'Yönlendirme Ekle',
    short: 'Tek bir eski adresi yeni adrese bağlar.',
    reversible: 'Evet. Kayıt düzenlenebilir veya silinebilir.',
  },
  'redirects.import': {
    kind: 'action',
    title: 'Dosyadan İçe Aktar',
    short: 'Eski site adres listesini (CSV/Excel) toplu yükler; önce önizlenir.',
    whatItDoes:
      'Sütunlar: eski adres, yeni adres, isteğe bağlı kod (301/302), not ve kaynak alan adı. Eski adres tam adres olarak yazılırsa (https://www.eski-alan-adi.com/shop) kural yalnızca o alan adına uygulanır; mağazanın kendi alan adıysa tüm alan adlarına. Hatalı satır varsa hiçbir satır kaydedilmez; aynı eski adres zaten varsa güncellenir. En fazla 5.000 satır.',
    whenToUse:
      'Eski siteden (ör. Wix, Shopify) geçerken eski sayfa adreslerini yeni adreslere toplu bağlamak için.',
    dataChanged:
      'Dosyadaki her satır için yönlendirme kuralı eklenir veya aynı eski adres varsa güncellenir; bu adreslerdeki "bulunamadı" kayıtları çözülmüş sayılır. İşlem denetim kaydına yazılır.',
    requiredPermission: 'SEO ayarlarını düzenleme.',
    reversible: 'Kısmen. Eklenen kayıtlar tek tek silinebilir.',
    commonErrors: [
      {
        problem: '"Dosyada eski adres ve yeni adres sütunları bulunamadı"',
        solution: '"Şablonu İndir" ile gelen sütun başlıklarını kullanın.',
      },
      {
        problem: '"Dosyada … hatalı satır var; hiçbir satır kaydedilmedi"',
        solution: 'Önizlemedeki hatalı satırları düzeltip dosyayı yeniden yükleyin.',
      },
      {
        problem: '"Dosyada en fazla … satır olabilir"',
        solution: 'Dosyayı parçalara bölüp ayrı ayrı yükleyin.',
      },
    ],
  },
  'redirects.search': {
    kind: 'field',
    title: 'Adreslerde Ara',
    short: 'Eski veya yeni adreste geçen bir parçayı yazın (ör. "kvkk").',
  },
  'redirects.from': {
    kind: 'field',
    title: 'Eski Adres',
    short: 'Yönlendirilecek yol, "/" ile başlar (ör. /sayfa/iptal-ve-iade-sartlari).',
    whatItDoes:
      'Büyük/küçük harf ve sondaki "/" fark etmez; sorgu (?...) dikkate alınmaz. Tam adres yazarsanız (https://zootopia.com.tr/uyeol/) yalnızca yolu alınır. Ana sayfa ve sistem yolları (/v1, /_next) yönlendirilemez.',
  },
  'redirects.to': {
    kind: 'field',
    title: 'Yeni Adres',
    short: 'Ziyaretçinin gideceği yol (ör. /yasal/iade-ve-cayma) veya https:// ile başlayan tam adres.',
  },
  'redirects.code': {
    kind: 'field',
    title: 'Yönlendirme Türü',
    short:
      '301 kalıcıdır ve arama motorlarına "sayfa taşındı" der (geçişte bunu kullanın). 302 geçicidir. 410 "kalıcı olarak kaldırıldı" demektir: yönlendirme yapılmaz, adres arama motoru dizininden çıkar (benzer bir sayfa varsa 301 tercih edin).',
  },
  'redirects.note': {
    kind: 'field',
    title: 'Not',
    short: 'Kendiniz için açıklama (ör. "eski site, Ekim 2026").',
  },
  'redirects.template': {
    kind: 'action',
    title: 'Şablonu İndir',
    short: 'Doğru sütun başlıklarıyla boş CSV şablonu.',
  },
  'page.shipping': {
    kind: 'page',
    title: 'Kargo Yöntemleri',
    short: 'Ödeme adımında müşterinin seçtiği kargo seçenekleri ve ücretleri.',
    whatItDoes:
      'Her yöntem için sabit ücret veya ağırlık kademesi, ücretsiz kargo sınırı, kapıda ödeme uygunluğu ve hangi müşterilere (herkes, perakende, bayi) gösterileceği belirlenir. Ağırlığa göre ücretlendirmede ürünlerin ağırlığı girilmiş olmalıdır; ağırlığı bilinmeyen ürün olan sepette bu yöntem gösterilmez. Kargo firması API bağlantısı olmadan da çalışır: gönderi oluştururken takip numarasını siz girersiniz.',
    whenToUse: 'İlk kurulumda ve kargo anlaşmanız değiştiğinde.',
    dataChanged: 'Kargo yöntemlerini değiştirir. Verilmiş siparişlerin kargo ücreti değişmez.',
    requiredPermission: 'Görüntüleme: Mağazaları görüntüleme. Değiştirme: Kargo yöntemi yönetimi.',
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#kargo-yontemleri',
  },
  'page.legal': {
    kind: 'page',
    title: 'Yasal Metinler',
    short:
      'KVKK aydınlatma metni, üyelik ve mesafeli satış sözleşmesi, ön bilgilendirme formu, iade/cayma, gizlilik ve çerez politikası.',
    whatItDoes:
      'Metinler taslak olarak yazılır ve yayımlanınca yeni sürüm olur; yayımlanmış sürüm değiştirilemez ve silinemez. Ön bilgilendirme formu ve mesafeli satış sözleşmesi siparişte satıcı, alıcı, ürün ve tutar bilgileriyle doldurulur; müşteri onayladığı metin, metnin kendisiyle birlikte saklanır ve e-postasına gönderilir. Bu ekrandaki metinler hukuki danışmanlık yerine geçmez; yayımlamadan önce avukatınıza inceletin.',
    whenToUse: 'Canlıya çıkmadan önce ve mevzuat ya da iş kuralları değiştiğinde.',
    dataChanged:
      'Yeni sürüm yayımlar; önceki sürüm arşivlenir ama silinmez (geçmiş siparişler eski sürüme bağlı kalır).',
    requiredPermission:
      'Görüntüleme: Yasal metinleri görüntüleme. Taslak: Yasal metin düzenleme. Yayın: Yasal metin yayımlama (hassas).',
    reversible: 'Yayın geri alınamaz; düzeltme için yeni sürüm yayımlanır.',
    guideUrl: 'docs/LEGAL_TEXTS_TR.md#yasal-metinler',
  },
  'payments.card_provider': {
    kind: 'field',
    title: 'Kartla Ödeme Sağlayıcısı',
    short:
      'iyzico, PayTR veya Sipay. Seçilebilmesi için seçili ortamda (test/canlı) bağlantı testinin başarılı olması gerekir.',
    whatItDoes:
      'Müşteri kart bilgisini sağlayıcının güvenli sayfasında girer (iyzico ve Sipay: yönlendirme, PayTR: sayfa içi güvenli form); mağaza kart bilgisi görmez ve saklamaz. Ödemenin sonucu tarayıcıdan gelen bilgiye değil, sağlayıcıya yapılan sunucu sorgusuna ve imzalı bildirime göre kesinleşir.',
    commonErrors: [
      {
        problem: '"Kart sağlayıcısının bu ortam için bağlantı testi başarılı olmalı"',
        solution: 'Entegrasyonlar ekranında anahtarları girip "Bağlantıyı test et"e basın.',
      },
    ],
    guideUrl: 'docs/PAYMENTS_TR.md#kart-saglayicisi',
  },
  'payments.environment': {
    kind: 'field',
    title: 'Ortam (Test / Canlı)',
    short: 'Test (sandbox) ortamında gerçek para çekilmez. Canlıya geçiş ayrı onay ister.',
    whatItDoes:
      'Canlıya geçmek için: canlı anahtarların bağlantı testi geçmiş olmalı, test ortamında en az bir başarılı ödeme alınmış olmalı ve "gerçek kartlardan para çekilecek" onayı verilmelidir. İşlem iki adımlı doğrulama ister ve denetim kaydına "canlıya geçiş" olarak yazılır.',
    guideUrl: 'docs/PAYMENTS_TR.md#canliya-gecis',
  },
  'payments.max_installments': {
    kind: 'field',
    title: 'Taksit Sayısı',
    short: 'Müşteriye sunulacak en fazla taksit. Taksit komisyonu ödeme kuruluşu sözleşmenize göredir.',
  },
  'payments.card_capture': {
    kind: 'field',
    title: 'Tahsilat Zamanı',
    short:
      '"Önce provizyon": ödeme sırasında tutar kartta bloke edilir, sipariş kargoya verilirken çekilir. Gönderilemeyen ürün varsa önce sipariş ürünlerini düzenleyin; yalnızca kalan tutar çekilir. Yalnızca iyzico.',
    whatItDoes:
      'Provizyon 25 gün içinde tahsil edilmelidir; 20. günden itibaren sipariş ayrıntısında ve sistem uyarısında görünür. Provizyonlu siparişi iptal etmek için "Provizyonu bırak" kullanılır. Tek çekimdir; banka kartlarıyla (debit) provizyon yapılamaz.',
    guideUrl: 'docs/PAYMENTS_TR.md#on-provizyon',
  },
  'orders.preauth_capture': {
    kind: 'action',
    title: 'Tahsil Et',
    short:
      'Karttaki provizyondan siparişin güncel toplamını çeker. Toplam provizyondan düşükse (ürün çıkarıldıysa) kalan bloke bankaca kaldırılır. Kargoya verirken kendiliğinden de yapılır.',
    whenToUse:
      'Ödeme ayarında "önce provizyon" seçiliyken, sipariş hazırlanıp tutarı kesinleştiğinde ve kargoya vermeden önce parayı çekmek istediğinizde.',
    dataChanged:
      'Karttaki provizyon tahsil edilmiş ödemeye dönüşür; siparişin ödeme durumu "Ödendi" olur. İşlem sipariş geçmişine ve denetim kaydına yazılır.',
    requiredPermission: 'Ödeme alma.',
    reversible: 'Hayır, tahsilat geri alınamaz. Fazla çekilen tutar "Para İadesi" ile iade edilir.',
    commonErrors: [
      {
        problem: '"Yeni toplam, kartta bloke edilen provizyon tutarını aşıyor"',
        solution:
          'Provizyondan fazla para çekilemez; siparişi provizyon tutarına indirin veya müşteriden ayrıca ödeme alın.',
      },
      {
        problem: '"Provizyon tahsil edilemedi"',
        solution:
          'Ödeme kuruluşu panelinden provizyonu kontrol edin; gerekirse provizyonu bırakıp müşteriden yeniden ödeme alın.',
      },
      {
        problem: '"Bu siparişte tahsil edilmemiş ön provizyon yok"',
        solution:
          'Sayfayı yenileyin; provizyon daha önce (ör. kargoya verirken) tahsil edilmiş veya bırakılmış olabilir.',
      },
    ],
    guideUrl: 'docs/PAYMENTS_TR.md#on-provizyon',
  },
  'orders.preauth_release': {
    kind: 'action',
    title: 'Provizyonu Bırak',
    short:
      'Karttaki blokeyi kaldırır ve siparişi iptal eder; stok ve kupon hakkı geri verilir, müşteriye iptal e-postası gider. Kargoya verilmiş siparişte kullanılamaz.',
    whenToUse:
      'Provizyonlu sipariş hiç gönderilmeyecekse (stok yok, müşteri vazgeçti) ve karttaki blokenin kaldırılması gerektiğinde.',
    dataChanged:
      'Provizyon iptal edilir, sipariş "İptal edildi" olur; ayrılan stok, kupon hakkı ve hediye kartı/kredi bakiyesi geri verilir. BizimHesap\'a gönderilmiş fatura "iptal edilmeli" olarak işaretlenir; müşteriye iptal e-postası gider.',
    requiredPermission: 'İade onaylama.',
    reversible:
      'Hayır, geri alınamaz: bloke kalkar ve sipariş iptal olur. Gerekirse yeni sipariş açılıp yeniden ödeme alınır.',
    commonErrors: [
      {
        problem: '"Sipariş kargoya verildi"',
        solution:
          'Kargoya verilmiş siparişte provizyon bırakılamaz; önce gönderiyi iptal edin veya tahsil edip iade yapın.',
      },
      {
        problem: '"Provizyon bırakılamadı"',
        solution: 'Ödeme kuruluşu panelinden provizyonun durumunu kontrol edip tekrar deneyin.',
      },
    ],
    guideUrl: 'docs/PAYMENTS_TR.md#on-provizyon',
  },
  'payments.card_timeout': {
    kind: 'field',
    title: 'Kart Ödemesi Süresi (dakika)',
    short:
      'Bu süre içinde tamamlanmayan kart ödemesinde sipariş iptal edilir, stok ve kupon hakkı geri verilir.',
    whatItDoes: 'İptal etmeden önce sağlayıcıya sorulur: ödeme geç tamamlanmışsa sipariş "ödendi" olur.',
  },
  'payments.bank_transfer_hold': {
    kind: 'field',
    title: 'Havale Ödeme Süresi (saat)',
    short:
      'Havale/EFT ile verilen siparişin ödemesi bu süre içinde gelmezse sipariş kendiliğinden iptal edilir, stok serbest kalır.',
    whatItDoes:
      'Müşteriye sipariş e-postasında son tarih yazılır; sürenin son 24 saatinde (kısa sürelerde son yarısında) bir kez hatırlatma e-postası gider. Süre dolunca müşteriye iptal bildirilir. Ödeme sonradan gelirse siparişi yeniden oluşturun veya parayı iade edin. 1–720 saat.',
    guideUrl: 'docs/PAYMENTS_TR.md#havale',
  },
  'payments.notify_urls': {
    kind: 'field',
    title: 'Bildirim Adresleri',
    short: 'iyzico ve PayTR panelinde "bildirim / callback URL" alanına yazılacak adresler.',
    whatItDoes:
      "PayTR'de Bildirim URL zorunludur. iyzico'da imzalı bildirim (webhook) özelliği için iyzico'ya başvurmanız gerekebilir; açık değilse ödeme sonucu yine sunucu sorgusuyla kesinleşir.",
    guideUrl: 'docs/PAYMENTS_TR.md#bildirim-adresleri',
  },
  'payments.other_methods': {
    kind: 'action',
    title: 'Diğer Ödeme Yöntemleri',
    short: 'Havale/EFT, kapıda ödeme, bayi açık hesabı ve üye olmadan sipariş.',
  },
  'payments.cod_fee': {
    kind: 'field',
    title: 'Kapıda Ödeme Bedeli',
    short: 'Siparişe eklenen hizmet bedeli (KDV dahil). 0 girerseniz ücretsizdir.',
  },
  'payments.cod_max': {
    kind: 'field',
    title: 'Kapıda Ödeme Üst Sınırı',
    short: 'Bu tutarın üzerindeki siparişlerde kapıda ödeme sunulmaz. Boş: sınır yok.',
  },
  'payments.bank_account': {
    kind: 'action',
    title: 'Banka Hesabı',
    short:
      "Havale/EFT seçen müşteriye gösterilen IBAN'lar. Değişiklik hassas işlemdir ve denetim kaydına yazılır.",
    whatItDoes:
      'IBAN kontrol hanesiyle doğrulanır. Dolandırıcılık riskine karşı yalnızca tüm mağazalara yetkili, iki adımlı doğrulamalı kullanıcı değiştirebilir.',
    whenToUse:
      'Havale/EFT ile ödeme almaya başlarken veya hesap bilgileriniz (banka, IBAN, hesap sahibi) değiştiğinde.',
    dataChanged:
      "Banka hesabı kaydı eklenir, değiştirilir veya silinir; ödeme adımında ve sipariş e-postalarında bu IBAN'lar gösterilir. Değişiklik eski ve yeni değeriyle denetim kaydına yazılır.",
    requiredPermission:
      'Ödeme ayarları, banka hesapları ve sağlayıcı anahtarları (hassas; iki adımlı doğrulama; tüm mağazalara yetki gerekir).',
    reversible:
      'Kısmen: hesap yeniden düzenlenebilir, ama silinen hesap kalıcı olarak silinir ve yeniden girilmesi gerekir.',
    commonErrors: [
      {
        problem: '"IBAN geçersiz"',
        solution: "TR ile başlayan 26 karakterli IBAN'ı boşluksuz ve eksiksiz girin.",
      },
      {
        problem: '"Bu IBAN zaten kayıtlı"',
        solution: 'Aynı IBAN ikinci kez eklenemez; mevcut kaydı düzenleyin.',
      },
      {
        problem: '"Bu işlem için yetkiniz yok"',
        solution:
          'Yalnızca tüm mağazalara yetkili kullanıcı banka hesabını değiştirebilir; yöneticinize başvurun.',
      },
    ],
  },
  'payments.iban': {
    kind: 'field',
    title: 'IBAN',
    short: 'TR ile başlayan 26 karakter; boşluklu veya boşluksuz yazabilirsiniz.',
  },
  'payments.reconcile': {
    kind: 'action',
    title: 'Mutabakat',
    short: 'Sağlayıcının o günkü işlem dökümünü sizdeki ödemelerle karşılaştırır.',
    whatItDoes:
      'Canlı bağlantısı olan sağlayıcılar için önceki günün mutabakatı her gün kendiliğinden çalışır. Farklar (sizde olmayan işlem, sağlayıcıda olmayan ödeme, tutar farkı) listelenir; inceledikten sonra açıklamayla kapatılır.',
    guideUrl: 'docs/PAYMENTS_TR.md#odemeler-ve-mutabakat',
  },
  'shipping.method': {
    kind: 'action',
    title: 'Kargo Yöntemi',
    short: 'Ödeme adımında gösterilecek kargo seçeneği ekler veya değiştirir.',
  },
  'shipping.handling_days': {
    kind: 'field',
    title: 'Hazırlık süresi (iş günü)',
    short:
      'Siparişten kargoya teslime kadar geçen süre (en az – en çok). Kargoda geçen süreyle birlikte girilirse Google ürün sonuçlarında tahmini teslim süresi olarak kullanılır.',
    guideUrl: 'docs/SEO_GUIDE_TR.md#yapilandirilmis-veri',
  },
  'shipping.transit_days': {
    kind: 'field',
    title: 'Kargoda geçen süre (iş günü)',
    short:
      'Kargo firmasının teslim süresi (en az – en çok). Gerçek ortalamanızı yazın; olduğundan kısa göstermeyin.',
    guideUrl: 'docs/SEO_GUIDE_TR.md#yapilandirilmis-veri',
  },
  'shipping.carrier': {
    kind: 'field',
    title: 'Kargo Firması',
    short: 'Takip bağlantısı ve müşteriye giden e-postada görünür. API bağlantısı gerekmez.',
  },
  'shipping.audience': {
    kind: 'field',
    title: 'Kimlere Gösterilir',
    short: 'Herkes, yalnızca perakende müşteriler veya yalnızca onaylı bayiler.',
  },
  'shipping.rate_type': {
    kind: 'field',
    title: 'Ücret Türü',
    short: 'Sabit ücret veya sepet ağırlığına göre kademeli ücret.',
  },
  'shipping.free_over': {
    kind: 'field',
    title: 'Ücretsiz Kargo Sınırı',
    short: 'İndirim sonrası ürün toplamı (KDV dahil) bu tutara ulaşınca kargo ücretsiz olur.',
  },
  'legal.variables': {
    kind: 'field',
    title: 'Değişkenler',
    short: 'Metne yazılan {{alan}} ifadeleri gösterimde gerçek bilgilerle doldurulur (ör. satıcı unvanı).',
    whatItDoes:
      'Satıcı bilgileri İşletme Bilgileri ekranından gelir. Ön bilgilendirme ve mesafeli satış metninde sipariş değişkenleri (alıcı, ürünler, toplam) de kullanılır; bu metinlerde zorunlu değişkenler yoksa metin yayımlanamaz.',
    guideUrl: 'docs/LEGAL_TEXTS_TR.md#degiskenler',
  },
  'legal.languages': {
    kind: 'field',
    title: 'Dil sürümleri',
    short: 'Her metnin dil başına ayrı taslağı, yayımı ve hukuki inceleme beyanı vardır. Türkçe esastır.',
    whatItDoes:
      'Vitrin ziyaretçinin dilinde yayımlanmış sürümü, yoksa Türkçeyi gösterir; siparişte ve üyelikte gösterilen sürüm kabul kaydına yazılır. Canlıya alma yalnızca Türkçeyi zorunlu tutar; açık pazarlarınızın dilinde eksik metinler burada ve canlıya hazırlık listesinde uyarı olarak görünür.',
    guideUrl: 'docs/LEGAL_TEXTS_TR.md#dil-surumleri',
  },
  'legal.language': {
    kind: 'field',
    title: 'Metnin dili',
    short: 'Düzenlediğiniz dil. Her dil ayrı kaydedilir ve ayrı yayımlanır.',
    whatItDoes:
      'Türkçe dışındaki diller çeviridir: çeviriyi de avukatınıza inceletin ve hukuki inceleme beyanını o dil için ayrıca verin. Ön bilgilendirme ve mesafeli satış çevirisinde de aynı değişkenler ({{alici.ad}} gibi) kullanılmalıdır.',
  },
  'legal.copy_tr': {
    kind: 'action',
    title: 'Türkçe metinden başla',
    short: 'Türkçe metni (değişkenleriyle) bu dilin taslağına kopyalar; çeviriyi üzerine yazarsınız.',
  },
  'legal.reviewed': {
    kind: 'field',
    title: 'Hukuki İnceleme',
    short: 'Metnin avukatınızca incelendiğini beyan eder. Canlıya hazırlık listesinde ayrıca kontrol edilir.',
  },
  'legal.publish': {
    kind: 'action',
    title: 'Yasal metni yayımla',
    short: 'Seçili dilin kaydedilmiş taslağını yeni sürüm olarak vitrine ve yeni siparişlere uygular.',
    whatItDoes:
      'Taslak yayımlanır; aynı dilin önceki yayımlanmış sürümü arşive alınır ve silinmez. Daha önce verilen siparişler kendi sürümüyle kalır, yeni siparişlerde bu sürüm kullanılır. Kaydedilmemiş değişiklik varsa düğme kapalıdır; önce "Taslağı kaydet".',
    whenToUse:
      'Avukatınız metni inceledikten sonra veya işletme bilgisi, iade süresi gibi bir koşul değiştiğinde.',
    dataChanged:
      'Taslak "yayımlandı" olur, aynı dilin önceki sürümü "arşiv" olur; hukuki inceleme beyanı sürümle saklanır. İşlem denetim kaydına sürüm numarası ve içerik özetiyle yazılır.',
    requiredPermission: 'Yasal metin yayımlama (hassas işlem: doğrulama kodu istenebilir).',
    reversible:
      'Tek tıkla geri alınmaz. Eski sürümün metni geçmişte durur; düzeltme için o metinle yeni taslak açıp yeniden yayımlayın.',
    commonErrors: [
      {
        problem: '"Yayımlanacak taslak yok"',
        solution: 'Önce metni düzenleyip "Taslağı kaydet" ile kaydedin.',
      },
      {
        problem: '"Metinde zorunlu değişkenler eksik" veya "tanımlı olmayan bir değişken var"',
        solution: 'Değişkenler listesinden zorunlu alanları ekleyin; yazım hatalı değişkeni düzeltin.',
      },
      {
        problem: '"Bu kayıt siz düzenlerken başka biri tarafından değiştirildi"',
        solution: 'Sayfayı yenileyip taslağın son hâlini kontrol edin, sonra yayımlayın.',
      },
    ],
    guideUrl: 'docs/LEGAL_TEXTS_TR.md#yasal-metinler',
  },
  'invoices.send': {
    kind: 'action',
    title: "BizimHesap'a Gönder",
    short: 'Faturayı BizimHesap\'a kayıt olarak gönderir. Zaman aşımında "belirsiz" olur.',
    whenToUse:
      'Taslak fatura hazır olduğunda veya daha önce gönderimi başarısız olan faturayı yeniden göndermek istediğinizde.',
    dataChanged:
      'Fatura BizimHesap\'a gönderilir; başarılıysa fatura numarası ve bağlantısı kaydedilir ve durum "gönderildi" olur, başarısızsa "başarısız", bağlantı koparsa "belirsiz" olur. Her deneme denetim kaydına yazılır.',
    requiredPermission: 'Fatura oluşturma ve gönderme.',
    reversible:
      'Hayır, BizimHesap\'ta oluşan fatura buradan geri alınamaz; iptal BizimHesap tarafında (veya "BizimHesap iptali" ile) yapılır.',
    commonErrors: [
      {
        problem: '"Yalnızca taslak veya başarısız fatura gönderilebilir"',
        solution:
          "Gönderilmiş veya belirsiz faturayı yeniden göndermeyin; belirsizse önce BizimHesap'ta kontrol edip sonucu işaretleyin.",
      },
      {
        problem: '"Önce bağlantı bilgilerini kaydedin"',
        solution: "Entegrasyonlar → BizimHesap'ta bağlantı bilgilerini girip test edin.",
      },
      {
        problem: '"Bayi BizimHesap carisine bağlı değil"',
        solution: 'Entegrasyonlar → BizimHesap → Carileri içe aktar ile bayiyi cariye bağlayın.',
      },
    ],
  },
  'invoices.uncertain': {
    kind: 'action',
    title: 'Belirsiz Fatura',
    short:
      "Bağlantı kesildiği için faturanın oluşup oluşmadığı bilinmiyor. BizimHesap'ta kontrol edip sonucu işaretleyin.",
    whatItDoes:
      'Çift fatura oluşmasın diye sistem belirsiz faturayı kendiliğinden yeniden göndermez. BizimHesap\'ta fatura varsa "oluşturuldu", yoksa "oluşmadı" seçin; oluşmadıysa yeniden gönderebilirsiniz.',
    whenToUse:
      'Fatura gönderimi sırasında bağlantı koptuğunda, BizimHesap panelinde faturanın oluşup oluşmadığını kontrol ettikten sonra.',
    dataChanged:
      '"Oluşturuldu" seçilirse fatura "gönderildi" olur (fatura numarasıyla); "oluşmadı" seçilirse "başarısız" olur ve yeniden gönderilebilir. Seçim ve açıklama denetim kaydına yazılır.',
    requiredPermission: 'Fatura oluşturma ve gönderme.',
    reversible:
      'Hayır, işaretlenen sonuç geri alınamaz; yanlışlıkla "oluşmadı" seçip yeniden göndermek çift faturaya yol açabilir.',
    commonErrors: [
      {
        problem: '"Fatura belirsiz durumda değil"',
        solution: 'Sayfayı yenileyin; faturanın sonucu zaten belirlenmiş olabilir.',
      },
    ],
  },
  'invoices.create': {
    kind: 'action',
    title: 'Fatura Oluştur',
    short: "BizimHesap'a gönderilecek taslak fatura veya başka yerde kesilmiş faturanın kaydı.",
    whatItDoes:
      'Fatura kalemleri ve toplamları sipariş anındaki tutarlarla birebir oluşturulur (kargo ve kapıda ödeme bedeli dahil). Bir siparişin aynı anda yalnızca bir geçerli faturası olabilir.',
    whenToUse:
      "Sipariş ödendikten veya kesinleştikten sonra faturasını BizimHesap'a göndermek için taslak hazırlarken ya da faturayı başka bir programda kestiyseniz kaydını tutmak için.",
    dataChanged:
      "Siparişe bağlı yeni bir fatura kaydı (kalemler ve toplamlar sipariş tutarlarıyla) oluşur; işlem denetim kaydına yazılır. BizimHesap'a henüz bir şey gönderilmez.",
    requiredPermission: 'Fatura oluşturma ve gönderme.',
    reversible:
      'Evet, fatura sistemde "iptal edildi" olarak işaretlenebilir; BizimHesap\'a gönderilmişse oradaki kaydın iptali ayrıca yapılır.',
    commonErrors: [
      {
        problem: '"Bu siparişin geçerli bir faturası zaten var"',
        solution: 'Bir siparişin aynı anda tek geçerli faturası olur; yenisi için öncekini iptal edin.',
      },
      {
        problem: '"Bu sipariş için fatura oluşturulamaz"',
        solution: 'Taslak veya iptal edilmiş siparişe fatura kesilmez; önce siparişi kesinleştirin.',
      },
    ],
  },
  'orders.capture': {
    kind: 'action',
    title: 'Ödeme Alındı',
    short: 'Havale/EFT, kapıda ödeme veya açık hesap tahsilatını açıklamayla kaydeder.',
    whatItDoes:
      'Ödeme bekleyen sipariş "Ödendi" olur ve müşteriye e-posta gider. Kartla ödenen siparişte kullanılamaz: kart ödemesi yalnızca sağlayıcının doğrulamasıyla kesinleşir.',
    whenToUse:
      'Havale/EFT parası hesabınıza geçtiğinde, kapıda ödeme tahsil edildiğinde veya bayi açık hesap borcunu ödediğinde.',
    dataChanged:
      'Siparişe tahsil edilmiş bir ödeme kaydı eklenir ve ödeme durumu "Ödendi" olur; ödeme bekleyen sipariş "Ödendi" durumuna geçer. Açık hesap siparişinde bayinin cari hesabına tahsilat yazılır; işlem denetim kaydına düşer.',
    requiredPermission: 'Ödeme alma.',
    reversible:
      'Hayır, "ödeme alındı" işareti geri alınamaz. Yanlış kayıtta "Para İadesi" ile iade kaydı girilir.',
    commonErrors: [
      {
        problem: '"Kartla ödenen siparişte ödeme yalnızca sağlayıcı doğrulamasıyla kesinleşir"',
        solution:
          'Kart veya PayPal siparişinde bu düğme kullanılmaz; ödeme sonucu ödeme kuruluşundan kendiliğinden gelir.',
      },
      {
        problem: '"Bu siparişin ödemesi zaten alınmış"',
        solution: 'Siparişin ödeme bölümüne bakın; ödeme daha önce kaydedilmiş, ikinci kez girmeyin.',
      },
      {
        problem: '"Bu durumdan bu duruma geçilemez"',
        solution: 'Taslak veya iptal edilmiş siparişe ödeme kaydedilemez; taslağı önce kesinleştirin.',
      },
    ],
  },
  'orders.refund': {
    kind: 'action',
    title: 'Para İadesi',
    short:
      'Kartla ödemede iade sağlayıcı üzerinden yapılır; havale/kapıda ödemede elle yaptığınız iadenin kaydıdır.',
    whatItDoes:
      "Kısmi veya tam iade yapılabilir; iade edilebilir tutardan fazlası reddedilir. iyzico'da aynı gün yapılan tam iade, iptal olarak işlenir. Başarısız iade de kayda geçer ve hata mesajı gösterilir. Hediye kartı veya mağaza kredisiyle ödenen tutarın iadesi bakiyeye geri yüklenir; müşterinin açık onayıyla iade mağaza kredisi olarak da verilebilir (cayma iadesinde değil). Hassas işlemdir (iki adımlı doğrulama).",
    whenToUse:
      'Müşteri cayma hakkını kullandığında, ürün hasarlı geldiğinde, stok olmadığı için ürün gönderilemediğinde veya mükerrer ödeme alındığında.',
    dataChanged:
      'Siparişe iade kaydı eklenir; ödemenin iade edilen tutarı artar ve siparişin ödeme durumu "Kısmen iade edildi" veya "İade edildi" olur. "Stoğa geri al" seçildiyse kargolanmış ürünler stoğa döner; müşteriye iade e-postası gider.',
    requiredPermission: 'İade onaylama (hassas).',
    reversible: 'Hayır. İade edilen tutar geri alınamaz.',
    commonErrors: [
      {
        problem: '"İade tutarı, iade edilebilir tutarı aşıyor"',
        solution: 'Daha önce yapılan iadeleri düşün; en fazla kalan iade edilebilir tutarı girin.',
      },
      {
        problem: '"Bu ödeme için sürmekte olan bir iade var"',
        solution:
          'Önceki iadenin sonucunu bekleyin; 10 dakikada sonuçlanmazsa "İade Sonucunu Belirle" ile kapatın.',
      },
      {
        problem: '"Elle yapılan iade için açıklama girin"',
        solution: "Havale/kapıda ödeme iadesinde parayı gönderdiğiniz IBAN'ı ve tarihi açıklamaya yazın.",
      },
    ],
    guideUrl: 'docs/PAYMENTS_TR.md#iade',
  },
  'orders.resolve_refund': {
    kind: 'action',
    title: 'İade Sonucunu Belirle',
    short:
      'Yarıda kalan (sonucu bilinmeyen) iadeyi, sağlayıcı panelinde kontrol ettikten sonra "yapılmış" veya "yapılmamış" olarak kapatır.',
    whatItDoes:
      'İade başlatıldıktan 10 dakika sonra görünür. Sağlayıcıya yeni istek gönderilmez (çift iade olmaz). "Yapılmış" seçilirse tutar iade toplamına eklenir ve müşteriye iade e-postası gider; "yapılmamış" seçilirse yeniden iade yapılabilir.',
    whenToUse:
      'Bir iade bağlantı kesintisi nedeniyle "sonucu bilinmiyor" durumunda kaldığında, ödeme kuruluşu panelinde iadenin yapılıp yapılmadığını gördükten sonra.',
    dataChanged:
      'Bekleyen iade kaydı "yapıldı" veya "yapılmadı" olarak kapanır. "Yapıldı" seçilirse iade toplamı ve siparişin ödeme durumu güncellenir; işlem denetim kaydına yazılır.',
    requiredPermission: 'İade onaylama (hassas).',
    reversible: 'Hayır. Kaydedilen sonuç değiştirilemez.',
    commonErrors: [
      {
        problem: '"İade işlemi sürüyor olabilir"',
        solution: 'İade başlatıldıktan sonra mesajda yazan süre kadar bekleyip tekrar deneyin.',
      },
      {
        problem: '"Bu iade zaten sonuçlanmış"',
        solution:
          'Sayfayı yenileyin; iade sonucu başka biri tarafından ya da sağlayıcıdan gelen bildirimle kaydedilmiş.',
      },
    ],
    guideUrl: 'docs/PAYMENTS_TR.md#iade',
  },
  'orders.resolve_refund_outcome': {
    kind: 'field',
    title: 'Sağlayıcı Panelindeki Sonuç',
    short: 'iyzico veya PayTR panelinde bu iadenin işlem listesinde görünüp görünmediği.',
  },
  'orders.resolve_refund_note': {
    kind: 'field',
    title: 'Açıklama',
    short:
      'Neye bakarak karar verdiğiniz (ör. "iyzico panelinde 13.10 iade kaydı var"). Denetim kaydına yazılır.',
  },
  'orders.returns': {
    kind: 'page',
    title: 'İade / Cayma Talepleri',
    short: 'Müşterinin sipariş sayfasından açtığı iade/cayma ve değişim talepleri.',
    whatItDoes:
      'Talep para iadesi yapmaz. Onaylayın (ürünü nasıl göndereceğini yazın) veya gerekçeyle reddedin; müşteriye e-posta gider. Ürün gelince para iadesini Ödeme bölümünden yapın ve talebi "Tamamlandı" işaretleyin. Değişim talebinde onay, istenen seçeneği stokta ayırır; iade edilen ürün gelince "Değişimi kargoya ver" ile yeni ürünü gönderirsiniz (ücret alınmaz). Cayma hakkının kapsamı (14 gün, hijyen nedeniyle ambalajı açılmış ürün istisnası vb.) yasal metinlerinizde yazar; kararı siz verirsiniz.',
    requiredPermission: 'Sipariş düzenleme.',
    guideUrl: 'docs/PAYMENTS_TR.md#iade-talepleri',
  },
  'orders.address_place': {
    kind: 'field',
    title: 'İl ve İlçe',
    short:
      'Türkiye adreslerinde il ve ilçe listeden seçilir (81 il, 973 ilçe; PTT posta kodu listesi). Posta kodu girilirse ilk iki rakamı ilin plaka kodu olmalıdır.',
    whatItDoes:
      'Eski bir adreste listede olmayan değer "(listede yok)" olarak görünür; adresi kaydetmek için listeden seçin. Kayıtlı eski adresler ve siparişler değişmez.',
    guideUrl: 'docs/CUSTOMER_GUIDE_TR.md#adres-dogrulama',
  },
  'orders.cancel_items': {
    kind: 'action',
    title: 'Kalan Ürünleri İptal Et',
    short:
      'Bölünmüş siparişte gönderilemeyecek ürünleri iptal eder; ayrılan stok serbest kalır, müşteriye e-posta gider.',
    whatItDoes:
      'Sipariş tutarı ve alınmış ödeme değişmez: iptal edilen ürünlerin tutarı (satır tutarından adede göre pay) siparişte ayrıca gösterilir ve Ödeme bölümünde iade önerisi çıkar; iadeyi "İade et" ile yapın. Açık hesapta "Ödeme alındı" bu tutar düşülerek kaydedilir; fatura iptal edilen adetleri içermez. Gönderilecek ürün kalmazsa sipariş "Kargoda" (paketlerin hepsi teslim edildiyse "Teslim edildi") olur.',
    whenToUse:
      'Siparişin bir bölümü kargoya verildikten sonra kalan ürünler artık gönderilemeyecekse (ör. stok bitti).',
    dataChanged:
      'Kalan satırların iptal edilen adedi kaydedilir, ayrılan stok serbest kalır; açık hesap siparişinde cari hesap güncellenir. Müşteriye e-posta gider ve işlem denetim kaydına yazılır.',
    requiredPermission: 'Sipariş düzenleme.',
    reversible: 'Geri alınamaz: iptal edilen adet yeniden gönderilemez (gerekirse yeni sipariş açılır).',
    commonErrors: [
      {
        problem: '"Kısmi iptal yalnızca bir bölümü kargoya verilmiş siparişte yapılır"',
        solution: 'Hiç gönderilmemiş siparişi "Durum Değiştir" ile tamamen iptal edin.',
      },
      {
        problem: '"İptal edilecek ürün yok"',
        solution: 'Gönderilmeyi bekleyen ürün kalmamış; sayfayı yenileyin.',
      },
    ],
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#kismi-iptal',
  },
  'orders.exchange_ship': {
    kind: 'action',
    title: 'Değişimi Kargoya Ver',
    short:
      'İade edilen ürün geldiyse yeni ürünü takip numarasıyla gönderir; ayrılan ürün stoktan düşer, talep tamamlanır, müşteriye e-posta gider.',
    whatItDoes:
      'Değişim aynı fiyatlı seçenekle yapıldığı için para hareketi olmaz. "Stoğa geri al" seçiliyse iade gelen ürün siparişte çıktığı lota satılabilir stok olarak geri eklenir; kusurlu veya açılmış ürün için seçmeyin.',
    whenToUse: 'Onaylanmış bir değişim talebinde müşterinin iade ettiği ürün depoya ulaştığında.',
    dataChanged:
      'Yeni ürün için ayrılan stok "satış" hareketiyle düşer; "Stoğa geri al" seçiliyse iade gelen ürün stoğa eklenir. Değişim talebi "Tamamlandı" olur, müşteriye takip numarasıyla e-posta gider.',
    requiredPermission: 'Gönderi oluşturma.',
    reversible: 'Hayır, geri alınamaz: talep tamamlanır, stok hareketleri ve giden e-posta kalır.',
    commonErrors: [
      {
        problem: '"Değişim ürünü yalnızca onaylanmış değişim talebinde kargoya verilir"',
        solution: 'Önce talebi İadeler bölümünde onaylayın.',
      },
      {
        problem: '"Bu kayıt siz düzenlerken başka biri tarafından değiştirildi"',
        solution: 'Sayfayı yenileyip tekrar deneyin.',
      },
    ],
    guideUrl: 'docs/PAYMENTS_TR.md#degisim',
  },
  'orders.return_note': {
    kind: 'field',
    title: 'Not / Gerekçe',
    short: 'Müşteriye e-postayla gider ve sipariş sayfasında görünür. Ret ve iptalde zorunludur.',
  },
  'orders.restock': {
    kind: 'field',
    title: 'Stoğa Geri Al',
    short: 'Kargolanmış siparişte iade gelen ürünleri aynı lota stoğa geri ekler.',
  },
  'orders.ship': {
    kind: 'action',
    title: 'Kargoya Ver',
    short:
      'Takip numarasıyla gönderi oluşturur; paketteki adetler stoktan düşer, müşteriye e-posta gider. Kalan ürün yoksa sipariş "Kargoda" olur.',
    whatItDoes:
      'Ödemesi alınmamış sipariş kargoya verilemez (kapıda ödeme ve bayi açık hesabı hariç). Sipariş birden çok pakete bölünebilir: her pakete giren ürünleri ve adetleri seçersiniz. Takip adresi boşsa firmanın genel takip sayfası kullanılır; firmalar bağlantı biçimini belgelemediği için adresi kontrol edin.',
    whenToUse: 'Paket hazırlanıp kargo firmasına teslim edildiğinde ve takip numarası elinizdeyken.',
    dataChanged:
      'Siparişe gönderi kaydı eklenir; paketteki adetler stoktan "satış" hareketiyle düşer. Provizyonlu siparişte tutar karttan kendiliğinden tahsil edilir; sipariş "Kargoda" olur (kalan ürün varsa "kısmen gönderildi") ve müşteriye takip numarasıyla e-posta gider.',
    requiredPermission: 'Kargo işlemleri.',
    reversible:
      'Kısmen: gönderinin durumu "İptal" yapılırsa paketteki ürünler stoğa döner ve sipariş yeniden hazırlanıyor olur. Gönderilen e-posta ve yapılan tahsilat geri alınmaz.',
    commonErrors: [
      {
        problem: '"Ödemesi alınmamış sipariş kargoya verilemez"',
        solution:
          'Önce ödemeyi alın ("Ödeme Alındı" veya kart ödemesi); kapıda ödeme ve açık hesap bu kurala tabi değildir.',
      },
      {
        problem: '"Kapıda ödemeli sipariş bölünemez"',
        solution: 'Kapıda ödemeli siparişin tüm ürünlerini tek pakette gönderin.',
      },
      {
        problem: '"Adet, gönderilmeyi bekleyen adetten fazla olamaz"',
        solution: 'Pakete giren adetleri kalan adetlere göre düzeltin.',
      },
    ],
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#gonderi',
  },
  'orders.ship_lines': {
    kind: 'field',
    title: 'Paketteki Ürünler',
    short:
      'Bu pakette gönderilecek adetler. Varsayılan, henüz gönderilmemiş adetlerin tamamıdır; pakete girmeyen ürünün adetini 0 yapın.',
    whatItDoes:
      'Bir bölümü gönderilen sipariş "Hazırlanıyor · Kısmen gönderildi" kalır ve kalan ürünler sonraki gönderiyle yollanır. Müşteriye her paketin içeriği ve takip numarası ayrı e-postayla bildirilir. Kapıda ödemeli sipariş bölünemez; provizyonlu siparişte tutarın tamamı ilk pakette tahsil edilir. Fatura sipariş başına tektir.',
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#parcali-gonderi',
  },
  'orders.manual_payment_method': {
    kind: 'field',
    title: 'Ödeme Yöntemi',
    short:
      'Elle / havale: ödeme alınınca "Ödeme alındı" ile işaretlenir. Açık hesap ve kapıda ödeme: sipariş doğrudan hazırlanır.',
  },
  'page.page_designs': {
    kind: 'page',
    title: 'Sayfa tasarımları',
    short: 'Vitrinin üst menüsü ve Makaleler sayfası için üç tasarım seçeneğinden birini seçer.',
    whatItDoes:
      'Her deneyim için üç seçenek vardır; hepsi aynı içeriği, adresleri ve arama motoru etiketlerini kullanır, yalnızca görünüm değişir. Kartlardaki görseller gerçek vitrin sayfasından alınmış ekran görüntüleridir. "Önizle" seçeneği yalnızca sizin tarayıcınızda, yayına almadan 30 dakika gösterir. "Yayına al" anında geçer; istediğiniz zaman başka seçeneğe dönebilirsiniz. Her geçiş denetim kaydına yazılır.',
    whenToUse:
      'Vitrinin görünümünü değiştirmek veya seçenekleri karşılaştırmak istediğinizde. Renk ve yazı tipleri Tasarım (tema) sayfasından değişir ve üç seçeneğe de uygulanır.',
    guideUrl: 'docs/STOREFRONT_DESIGN_VARIANTS_TR.md',
  },
  'page_designs.header': {
    kind: 'field',
    title: 'Üst menü tasarımı',
    short: 'Logonun, menü öğelerinin, aramanın ve sepetin başlıktaki yerleşimi.',
    whatItDoes:
      'Menü öğeleri Menüler sayfasından gelir; seçenek yalnızca yerleşimi değiştirir. Mobilde üç seçenekte de aynı sırada çekmece menü vardır.',
    guideUrl: 'docs/STOREFRONT_DESIGN_VARIANTS_TR.md#ust-menu',
  },
  'page_designs.articles': {
    kind: 'field',
    title: 'Makaleler tasarımı',
    short: 'Blog listesinin, kategori ve arşiv sayfalarının görünümü.',
    whatItDoes:
      'Öne çıkan yazıyı blog düzenleyicisindeki "Öne çıkar" düğmesiyle seçersiniz; seçilmemişse en yeni yazı gösterilir. Yazı sayfasının kendisi her seçenekte aynıdır.',
    guideUrl: 'docs/STOREFRONT_DESIGN_VARIANTS_TR.md#makaleler',
  },
  'page_designs.preview': {
    kind: 'action',
    title: 'Önizle',
    short: 'Seçeneği yayına almadan vitrinde, yalnızca sizin tarayıcınızda açar.',
    whatItDoes:
      'İmzalı, 30 dakika geçerli bir bağlantı açılır. Önizlemedeki sayfa arama motorlarına kapalıdır ve üstte önizleme şeridi görünür; ziyaretçiler yayındaki seçeneği görmeye devam eder.',
    requiredPermission: 'Tema düzenleme',
    guideUrl: 'docs/STOREFRONT_DESIGN_VARIANTS_TR.md#onizleme',
  },
  'page_designs.publish': {
    kind: 'action',
    title: 'Yayına al',
    short: 'Seçeneği hemen tüm ziyaretçilere açar.',
    whatItDoes:
      'Geçiş anında olur ve geri alınabilir: başka bir seçeneği yayına almanız yeterlidir. Kim, ne zaman, hangi seçenekten hangisine geçti denetim kaydına yazılır.',
    whenToUse:
      'Üst menü, makaleler, satış noktaları veya ihtiyaç bulucu sayfası için önizlediğiniz tasarım seçeneğini (A, B, C) tüm ziyaretçilere açmak istediğinizde.',
    dataChanged:
      'Mağazanın o sayfa için seçili tasarım seçeneği değişir ve vitrine hemen yansır; eski ve yeni seçenek denetim kaydına yazılır.',
    requiredPermission: 'Tema yayımlama (iki adımlı doğrulama)',
    reversible: 'Evet, önceki seçeneği yeniden yayına alarak geri dönülür.',
    commonErrors: [
      {
        problem: '"Bu işlem için doğrulama kodunuzu yeniden girmeniz gerekiyor"',
        solution: 'Hassas işlemdir; doğrulama uygulamanızdaki kodu girip tekrar deneyin.',
      },
    ],
    guideUrl: 'docs/STOREFRONT_DESIGN_VARIANTS_TR.md#onizleme',
  },
  'page_designs.history': {
    kind: 'field',
    title: 'Geçiş geçmişi',
    short: 'Son 30 seçenek değişikliği: tarih, kişi, deneyim ve değişiklik.',
    guideUrl: 'docs/STOREFRONT_DESIGN_VARIANTS_TR.md#onizleme',
  },
  'page.sales_points': {
    kind: 'page',
    title: 'Satış noktaları',
    short: 'Vitrindeki Satış Noktaları sayfasında listelenen bayileri yönetir.',
    whatItDoes:
      'Onaylı bayilerin işletme bilgileri (görünen ad, adres, harita pini, vitrin telefonu, çalışma saatleri, not) vitrinde il, ilçe ve mahalleye göre listelenir. Yetkili adı ve cep telefonu hiçbir zaman kendiliğinden gösterilmez. Bayi askıya alınınca noktaları vitrinde kendiliğinden gizlenir, yeniden onaylanınca geri gelir.',
    whenToUse:
      'Yeni bayileri vitrinde göstermek, toplu göster/gizle yapmak veya eksikleri (pin, telefon, kişi adı uyarısı) görmek istediğinizde. Nokta bilgileri bayi kartında düzenlenir.',
    requiredPermission: 'Bayi yönetimi',
    guideUrl: 'docs/STORE_LOCATOR_TR.md',
  },
  'dealers.sales_points': {
    kind: 'field',
    title: 'Satış noktası',
    short: 'Bu bayinin vitrinde Satış Noktaları sayfasında görünen işletme bilgisi.',
    whatItDoes:
      'Lokasyondan eklerken ad, il, ilçe ve adres önerilir; yetkili adı ve telefonu önerilmez. Bayi onaylı değilse nokta vitrinde görünmez.',
    guideUrl: 'docs/STORE_LOCATOR_TR.md#panelde-duzenleme',
  },
  'sales_points.auto_add': {
    kind: 'field',
    title: 'Otomatik ekleme',
    short: 'Yeni onaylanan bayi lokasyonlarından satış noktası olarak eklenir (varsayılan açık).',
    whatItDoes:
      'Bayi onaylandığında, satış noktası yoksa lokasyonlarından nokta oluşturulur. Unvanı bir kişinin adı olabilecek bayi (şahıs firması) gizli eklenir; görünen adı düzeltip açmanız gerekir. Kapalıyken noktaları bayi kartından elle eklersiniz.',
    guideUrl: 'docs/STORE_LOCATOR_TR.md#otomatik-ekleme',
  },
  'sales_points.visible': {
    kind: 'field',
    title: 'Vitrinde göster',
    short: 'Kapalıysa nokta vitrinde görünmez; kayıt silinmez.',
    guideUrl: 'docs/STORE_LOCATOR_TR.md#gorunurluk',
  },
  'sales_points.name': {
    kind: 'field',
    title: 'Görünen ad',
    short: 'Vitrinde görünen tabela veya işletme adı.',
    whatItDoes:
      'Kişisel veriyi korumak için bir kişinin adını yazmayın; şahıs firmalarında tabela adını kullanın.',
    guideUrl: 'docs/STORE_LOCATOR_TR.md#panelde-duzenleme',
  },
  'sales_points.neighbourhood': {
    kind: 'field',
    title: 'Mahalle',
    short: 'PTT listesindeki mahalleler; ziyaretçi mahalleye göre süzebilir.',
    guideUrl: 'docs/STORE_LOCATOR_TR.md#panelde-duzenleme',
  },
  'sales_points.pin': {
    kind: 'field',
    title: 'Konum (harita pini)',
    short: "Google Haritalar'dan kopyalanan koordinat veya bağlantı.",
    whatItDoes:
      'Yapıştırdığınız metin bu tarayıcıda çözülür, hiçbir yere gönderilmez. Pin olan nokta haritada işaretlenir ve "Konumumu kullan" ile mesafeye göre sıralanır; pinsiz nokta listede yine görünür.',
    guideUrl: 'docs/STORE_LOCATOR_TR.md#panelde-duzenleme',
  },
  'sales_points.phone': {
    kind: 'field',
    title: 'Vitrin telefonu',
    short: 'Ziyaretçilerin arayacağı işletme numarası.',
    whatItDoes:
      'Bayi kaydındaki yetkili telefonu buraya kendiliğinden yazılmaz. Cep telefonunu yalnızca sahibi onay verdiyse yazın.',
    guideUrl: 'docs/STORE_LOCATOR_TR.md#panelde-duzenleme',
  },
  'sales_points.hours': {
    kind: 'field',
    title: 'Çalışma saatleri',
    short: 'Her gün için açık/kapalı ve saat aralığı; belirtilmeyen gün vitrinde gösterilmez.',
    guideUrl: 'docs/STORE_LOCATOR_TR.md#panelde-duzenleme',
  },
  'sales_points.note': {
    kind: 'field',
    title: 'Not',
    short: 'Vitrinde kartın altında görünen kısa not (ör. "Otopark var").',
    guideUrl: 'docs/STORE_LOCATOR_TR.md#panelde-duzenleme',
  },
  'sales_points.bulk': {
    kind: 'action',
    title: 'Toplu göster/gizle',
    short: 'Seçilen noktaları vitrinde gösterir veya gizler; denetim kaydına yazılır.',
    guideUrl: 'docs/STORE_LOCATOR_TR.md#panelde-duzenleme',
  },
  'sales_points.from_location': {
    kind: 'action',
    title: 'Lokasyondan ekle',
    short: 'Bayinin şube/teslimat lokasyonundan adres bilgisiyle yeni satış noktası açar.',
    guideUrl: 'docs/STORE_LOCATOR_TR.md#panelde-duzenleme',
  },
  'sales_points.geocode': {
    kind: 'field',
    title: 'Konumu adresten bul',
    short: 'Elle pin girilmemiş noktaların konumu adresinden OpenStreetMap ile bulunur (varsayılan açık).',
    whatItDoes:
      'Her on dakikada bir konumu olmayan veya adresi değişen noktalar aranır. Bulunan konum vitrinde "Konumumu kullan" ile en yakın noktaların sıralanmasında kullanılır. Adres başka bir il/ilçeyi gösteriyorsa veya bulunamazsa bayi kartında uyarı çıkar. Elle girdiğiniz pin hiçbir zaman değiştirilmez.',
    whenToUse: 'Kapatırsanız yalnızca elle girdiğiniz pinler kullanılır.',
    guideUrl: 'docs/STORE_LOCATOR_TR.md#konum',
  },
  'sales_points.backfill': {
    kind: 'action',
    title: 'Onaylı bayilerden oluştur',
    short:
      'Satış noktası olmayan her onaylı bayi için lokasyonlarından (yoksa firma adresinden) görünür nokta ekler.',
    whatItDoes:
      'Var olan noktalara dokunulmaz. Adresi il/ilçe listesinde olmayan bayiler listelenir; bayi kartında adresi düzeltip tekrar çalıştırabilirsiniz. Unvanı kişi adı olabilecek bayiler de eklenir ve "Kişi adı olabilir" uyarısı gösterilir.',
    requiredPermission: 'Bayi yönetimi',
    guideUrl: 'docs/STORE_LOCATOR_TR.md#otomatik-ekleme',
  },
  'sales_points.geocode_now': {
    kind: 'action',
    title: 'Konumları şimdi bul',
    short: 'Konumu bekleyen en çok 10 noktanın adresini hemen arar (saniyede bir istek).',
    whatItDoes:
      'Sistem bunu zaten on dakikada bir 50 nokta için yapar; düğme beklemeden sonucu görmek içindir. Sonuçlar listede ve bayi kartında uyarı olarak görünür.',
    requiredPermission: 'Bayi yönetimi',
    guideUrl: 'docs/STORE_LOCATOR_TR.md#konum',
  },
  'sales_points.geocode_one': {
    kind: 'action',
    title: 'Adresten konum bul',
    short: "Bu noktanın adresini OpenStreetMap'te arar ve bulunan konumu pin olarak yazar.",
    whatItDoes:
      "Adres başka bir yeri gösterirse pin yazılmaz ve bulunan yer uyarıda gösterilir; adresi düzeltin ya da Google Haritalar'dan koordinatı elle girin. Elle girilen pin varsa düğme görünmez.",
    requiredPermission: 'Bayi yönetimi',
    guideUrl: 'docs/STORE_LOCATOR_TR.md#adres-uyarilari',
  },
  'page_designs.store_locator': {
    kind: 'field',
    title: 'Satış Noktaları tasarımı',
    short: 'Satış Noktaları sayfasının ve il/ilçe sayfalarının görünümü.',
    whatItDoes:
      'Üç seçenek aynı listeyi, süzgeci ve adresleri kullanır. Harita kendi sunucumuzdan gelir; ziyaretçinin konumu dışarı gönderilmez.',
    guideUrl: 'docs/STOREFRONT_DESIGN_VARIANTS_TR.md#satis-noktalari',
  },
  'page.design': {
    kind: 'page',
    title: 'Tasarım',
    short: 'Vitrinin renklerini, yazı tiplerini ve düzenini kod yazmadan değiştirir.',
    whatItDoes:
      'Değişiklikler önce taslakta kalır ve sağdaki canlı önizlemede anında görünür. "Vitrinde önizle" taslağı yalnızca size, gerçek vitrinde gösterir. "Yayımla" taslağı ziyaretçilere açar ve değişmez bir sürüm olarak kaydeder; istediğiniz zaman önceki bir sürüme dönebilirsiniz. Okunmayan renk çiftleri (WCAG AA kontrastı) düzeltilmeden yayımlanamaz.',
    whenToUse:
      'İlk kurulumda mağazanın görünümünü belirlemek, kampanya veya mevsim için renkleri değiştirmek için.',
    dataChanged: 'Yalnızca mağazanın tema ayarlarını değiştirir; ürün, sipariş ve içerik etkilenmez.',
    requiredPermission:
      'Görüntüleme: Temayı görüntüleme. Düzenleme: Tema düzenleme. Yayımlama ve geri alma: Temayı canlıya alma (iki adımlı doğrulama).',
    reversible: 'Evet. Her yayım sürüm geçmişinde durur; önceki bir sürüme dönülebilir.',
    guideUrl: 'docs/THEME_EDITOR_TR.md#tema-editoru',
  },
  'design.preview': {
    kind: 'action',
    title: 'Vitrinde Önizle',
    short: 'Taslağı gerçek vitrinde yalnızca size gösterir (2 saat geçerli bağlantı).',
    whatItDoes:
      'Kaydedilmemiş değişiklik varsa önce kaydeder, sonra mağazanın alan adında yeni sekme açar. Üstte "Tema önizlemesi" şeridi görünür; ziyaretçiler etkilenmez. "Önizlemeden çık" ile normal görünüme dönülür.',
    commonErrors: [
      {
        problem: '"Mağazanın vitrin alan adı tanımlı değil"',
        solution: 'Mağazalar ekranında mağazaya vitrin alan adı ekleyin.',
      },
    ],
    guideUrl: 'docs/THEME_EDITOR_TR.md#onizleme',
  },
  'design.save': {
    kind: 'action',
    title: 'Taslağı Kaydet',
    short: 'Değişiklikleri taslak olarak saklar; vitrin değişmez.',
    reversible: 'Evet. Taslak yeniden değiştirilebilir veya yayındaki temaya döndürülebilir.',
  },
  'design.publish': {
    kind: 'action',
    title: 'Yayımla',
    short: 'Taslağı ziyaretçilere açar ve yeni sürüm olarak kaydeder.',
    whatItDoes:
      'Okunabilirlik denetiminden geçmeyen tema yayımlanamaz. Yeni görünüm vitrinde en geç bir dakika içinde görünür. İşlem denetim kaydına yazılır.',
    whenToUse:
      'Tema taslağında renk, yazı tipi veya düzen değişikliklerini kaydedip vitrinde önizledikten sonra.',
    dataChanged:
      'Taslak, değiştirilemez yeni bir tema sürümü olarak yayımlanır ve vitrinin görünümü değişir; işlem denetim kaydına yazılır.',
    requiredPermission: 'Temayı canlıya alma (iki adımlı doğrulama).',
    reversible: 'Evet. Sürüm geçmişinden önceki sürüme dönülebilir.',
    commonErrors: [
      {
        problem: '"Tema yayımlanamaz: … renk çifti yeterince okunaklı değil"',
        solution: 'Editördeki okunabilirlik uyarılarını düzeltip taslağı kaydedin.',
      },
      {
        problem: '"Yayımlanacak bir tema taslağı yok" veya "Bu tema zaten yayında"',
        solution: 'Önce değişiklik yapıp taslağı kaydedin.',
      },
    ],
    guideUrl: 'docs/THEME_EDITOR_TR.md#yayimlama',
  },
  'design.revert_local': {
    kind: 'action',
    title: 'Değişikliklerden Vazgeç',
    short: 'Kaydetmediğiniz değişiklikleri atar; ekran kayıtlı taslağa döner.',
  },
  'design.discard': {
    kind: 'action',
    title: 'Yayındaki Temaya Döndür',
    short: 'Taslaktaki yayımlanmamış değişiklikleri siler; taslak yayındaki sürümle aynı olur.',
    reversible: 'Hayır. Atılan taslak değişiklikleri geri gelmez.',
  },
  'design.templates': {
    kind: 'field',
    title: 'Şablonlar',
    short: 'Renk, yazı tipi ve düzeni birlikte değiştiren hazır başlangıç noktaları.',
    whatItDoes: 'Şablon uygulanınca tüm tema ayarları değişir; kaydedene kadar yalnızca önizlemede görünür.',
  },
  'design.palettes': {
    kind: 'field',
    title: 'Hazır Paletler',
    short: 'Okunabilirliği denetlenmiş renk takımları; yazı tipi ve düzen korunur.',
    whatItDoes:
      'Koyu görünüm açıksa paletin koyu renkleri de uygulanır. Her palet WCAG AA kontrastından geçer.',
  },
  'design.color.background': {
    kind: 'field',
    title: 'Arka Plan',
    short: 'Sayfanın genel zemin rengi.',
  },
  'design.color.surface': {
    kind: 'field',
    title: 'Kart ve Alan Zemini',
    short: 'Ürün kartları, üst bilgi, özet kutuları ve form alanlarının zemini.',
  },
  'design.color.text': {
    kind: 'field',
    title: 'Yazı',
    short: 'Gövde metni ve başlıkların rengi. Arka plan ve kart zemininde en az 4,5:1 kontrast gerekir.',
  },
  'design.color.muted_text': {
    kind: 'field',
    title: 'İkincil Yazı',
    short: 'Açıklamalar, marka adı, tarih gibi ikincil metinler. Yine en az 4,5:1 kontrast gerekir.',
  },
  'design.color.border': {
    kind: 'field',
    title: 'Çizgi ve Çerçeve',
    short: 'Kart çerçeveleri ve ayırıcı çizgiler.',
  },
  'design.color.primary': {
    kind: 'field',
    title: 'Ana Renk',
    short:
      'Bağlantılar, seçili sekmeler, logo zemini ve vurgulu öğeler. Bağlantı metni olduğu için en az 4,5:1 kontrast gerekir.',
  },
  'design.color.secondary': {
    kind: 'field',
    title: 'İkincil Renk',
    short: 'İkincil etiketler ve rozetler. Üzerindeki yazı rengi kendiliğinden seçilir.',
  },
  'design.color.accent': {
    kind: 'field',
    title: 'Vurgu Rengi',
    short:
      'Kampanya ve indirim etiketleri gibi dikkat çekmesi gereken öğeler. Üzerindeki yazı rengi kendiliğinden seçilir.',
  },
  'design.color.button': {
    kind: 'field',
    title: 'Düğme',
    short: '"Sepete ekle", "Siparişi onayla" gibi ana düğmelerin rengi.',
  },
  'design.color.button_text': {
    kind: 'field',
    title: 'Düğme Yazısı',
    short: 'Ana düğmelerin yazı rengi. Düğme ve üzerine gelince renkleriyle en az 4,5:1 kontrast gerekir.',
  },
  'design.color.button_hover': {
    kind: 'field',
    title: 'Düğme (Üzerine Gelince)',
    short: 'Fare düğmenin üzerindeyken kullanılan renk.',
  },
  'design.dark_mode': {
    kind: 'field',
    title: 'Koyu Görünüm',
    short: 'Ziyaretçinin cihazı koyu moddaysa ayrı tanımlanan koyu renkler kullanılır.',
    whatItDoes: 'Açınca koyu renk alanları görünür. Kapalıyken vitrin her cihazda açık görünür.',
    guideUrl: 'docs/THEME_EDITOR_TR.md#renkler',
  },
  'design.font_body': {
    kind: 'field',
    title: 'Gövde Yazı Tipi',
    short: 'Metinler, fiyatlar ve formlar için yazı tipi.',
    whatItDoes: 'Yazı tipleri vitrinle birlikte sunulur; Google Fonts gibi dış hizmetlere istek gitmez.',
  },
  'design.font_heading': {
    kind: 'field',
    title: 'Başlık Yazı Tipi',
    short: 'Sayfa ve ürün başlıkları için yazı tipi.',
  },
  'design.base_size': {
    kind: 'field',
    title: 'Gövde Yazı Boyutu',
    short: 'Metinlerin temel boyutu; başlıklar buna göre ölçeklenir.',
  },
  'design.heading_scale': {
    kind: 'field',
    title: 'Başlık Boyutları',
    short: 'Başlıkların gövde metnine göre ne kadar büyük olacağı.',
  },
  'design.heading_weight': {
    kind: 'field',
    title: 'Başlık Kalınlığı',
    short: 'Başlıkların yazı kalınlığı.',
  },
  'design.radius': {
    kind: 'field',
    title: 'Köşe Yuvarlaklığı',
    short: 'Kart, alan ve görsellerin köşeleri (0 = köşeli).',
  },
  'design.button_shape': {
    kind: 'field',
    title: 'Düğme Biçimi',
    short: 'Köşeli, yuvarlatılmış veya hap biçimli düğmeler.',
  },
  'design.shadow': {
    kind: 'field',
    title: 'Gölge',
    short: 'Gölgeli kartlarda ve özet kutularında kullanılan gölge.',
  },
  'design.card_style': {
    kind: 'field',
    title: 'Ürün Kartı',
    short: 'Ürün kartlarının çerçeveli, düz veya gölgeli görünmesi.',
  },
  'design.image_ratio': {
    kind: 'field',
    title: 'Ürün Görseli Oranı',
    short: 'Ürün listelerinde görsel alanının biçimi; görseller bu alana kırpılarak sığdırılır.',
  },
  'design.grid_desktop': {
    kind: 'field',
    title: 'Masaüstünde Sütun',
    short: 'Geniş ekranda yan yana kaç ürün gösterileceği. Tablette en fazla 3 sütun kullanılır.',
  },
  'design.grid_mobile': {
    kind: 'field',
    title: 'Telefonda Sütun',
    short: 'Telefonda yan yana bir veya iki ürün.',
  },
  'design.header_layout': {
    kind: 'field',
    title: 'Logo Konumu',
    short: 'Üst bilgide logonun solda veya ortada durması.',
  },
  'design.header_style': {
    kind: 'field',
    title: 'Üst Bilgi Zemini',
    short:
      'Üst bilginin açık zeminde mi, ana renkte mi görüneceği. Ana renkte yazı rengi kendiliğinden seçilir.',
  },
  'design.header_sticky': {
    kind: 'field',
    title: 'Sabit Üst Bilgi',
    short: 'Sayfa aşağı kaydırıldığında üst bilgi ekranın üstünde kalır.',
  },
  'design.footer_style': {
    kind: 'field',
    title: 'Alt Bilgi Zemini',
    short: 'Alt bilginin açık, koyu veya ana renkte görünmesi.',
  },
  'design.gallery': {
    kind: 'field',
    title: 'Ürün Sayfasında Görsel',
    short: 'Geniş ekranda ürün görselinin solda veya sağda durması.',
  },
  'design.blog_layout': {
    kind: 'field',
    title: 'Blog Sayfası',
    short: 'Blog yazılarının ızgara veya liste olarak dizilmesi.',
  },
  'design.input_style': {
    kind: 'field',
    title: 'Form Alanları',
    short: 'Form alanlarının çerçeveli veya dolgulu görünmesi.',
  },
  'design.live_preview': {
    kind: 'field',
    title: 'Canlı Önizleme',
    short: 'Kaydetmeden önce değişikliklerin örnek bir vitrin sayfasında nasıl görüneceği.',
    whatItDoes:
      'Önizlemedeki ürünler kataloğunuzdaki ürünlerdir; fiyat yerine "Fiyat" yazar. Sayfanın tamamını gerçek vitrinde görmek için "Vitrinde önizle"yi kullanın.',
    guideUrl: 'docs/THEME_EDITOR_TR.md#onizleme',
  },
  'design.device': {
    kind: 'field',
    title: 'Cihaz',
    short: 'Önizlemeyi telefon, tablet veya masaüstü genişliğinde gösterir.',
  },
  'design.contrast': {
    kind: 'field',
    title: 'Okunabilirlik Denetimi',
    short: 'Yazı ve zemin renklerinin WCAG AA kontrast oranını (en az 4,5:1) denetler.',
    whatItDoes:
      'Oran düşükse metin zor okunur (özellikle güneş altında ve görme güçlüğü olanlar için). Sorun varsa tema kaydedilebilir ama yayımlanamaz.',
    guideUrl: 'docs/THEME_EDITOR_TR.md#renkler',
  },
  'design.versions': {
    kind: 'field',
    title: 'Sürüm Geçmişi',
    short: 'Yayımlanan her tema hâli, tarihi ve yayımlayan kişi.',
    guideUrl: 'docs/THEME_EDITOR_TR.md#surumler',
  },
  'design.rollback': {
    kind: 'action',
    title: 'Bu Sürüme Dön',
    short: 'Seçilen sürümü yeniden yayımlar ve taslağı o hâle getirir.',
    whenToUse:
      'Yeni yayımlanan tema beklenmedik bir sorun çıkardığında veya önceki görünüme dönmek istediğinizde.',
    dataChanged:
      'Seçilen sürümün ayarları yeni bir sürüm olarak yayımlanır ve taslak da o hâle getirilir; geçmiş sürümler silinmez. İşlem denetim kaydına yazılır.',
    requiredPermission: 'Temayı canlıya alma (iki adımlı doğrulama).',
    reversible: 'Evet. Geri alma da yeni sürümdür; geçmiş silinmez.',
    commonErrors: [
      {
        problem: '"Bu tema zaten yayında; değişiklik yok"',
        solution: 'Seçtiğiniz sürüm şu an yayındakiyle aynı; başka bir sürüm seçin.',
      },
      { problem: '"Tema taslağı okunamadı"', solution: 'Editörde taslağı yeniden kaydedip tekrar deneyin.' },
    ],
  },
  'design.note': {
    kind: 'field',
    title: 'Sürüm Notu',
    short: 'Bu yayımın nedeni (ör. "Kasım kampanyası renkleri"); sürüm geçmişinde görünür.',
  },
  'page.menus': {
    kind: 'page',
    title: 'Menüler',
    short: 'Vitrinin üst menüsünü (mega menü) ve alt bilgi menüsünü düzenler.',
    whatItDoes:
      'Üst menüde en fazla 3 seviye: üst öğe, sütun başlığı, bağlantı. Alt bilgi menüsünde 2 seviye: sütun başlığı ve bağlantılar. Kategori ve ürün bağlantıları kimlikle saklanır; kısa ad değişse de menü doğru adrese gider. Gizlenen kategori veya vitrinde görünmeyen ürün menüden kendiliğinden düşer.',
    whenToUse: 'Vitrinin gezinmesini kurarken, yeni kategori veya kampanya sayfası eklendiğinde.',
    dataChanged:
      'Yalnızca seçili mağazanın menüsünü değiştirir. Kayıt vitrinde en geç bir dakika içinde görünür.',
    requiredPermission: 'Görüntüleme: İçerikleri görüntüleme. Kaydetme: İçerik yayınlama.',
    reversible: 'Evet. Menü yeniden düzenlenebilir; her kayıt denetim kaydına yazılır.',
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#menuler',
  },
  'menus.location': {
    kind: 'field',
    title: 'Menü Konumu',
    short: 'Üst menü veya alt bilgi menüsü; her biri ayrı kaydedilir.',
  },
  'menus.add': {
    kind: 'action',
    title: 'Öğe Ekle',
    short: 'Menünün sonuna yeni bir birinci seviye öğe ekler.',
  },
  'menus.add_child': {
    kind: 'action',
    title: 'Alt Öğe Ekle',
    short: 'Bu öğenin altına öğe ekler (üst menüde sütun ve bağlantı, alt bilgide bağlantı).',
  },
  'menus.label': {
    kind: 'field',
    title: 'Menüde Görünen Ad',
    short: 'Ziyaretçinin gördüğü metin (en fazla 60 karakter).',
  },
  'menus.link': {
    kind: 'field',
    title: 'Bağlantı',
    short:
      'Öğenin nereye gideceği: kategori, ürün, tüm ürünler, sayfa, blog, blog yazısı, bir adres veya bağlantısız başlık.',
    whatItDoes:
      'Bağlantısız başlık yalnızca alt öğesi varsa kullanılabilir (ör. mega menüde "Bağışıklık" sütunu).',
  },
  'menus.category': {
    kind: 'field',
    title: 'Kategori',
    short: 'Bağlantı verilecek kategori. Gizli kategori vitrinde gösterilmez.',
  },
  'menus.product': {
    kind: 'field',
    title: 'Ürün',
    short: "Ada, SKU'ya veya barkoda göre arayıp seçin. Vitrinde görünmeyen ürün menüde gösterilmez.",
  },
  'menus.url': {
    kind: 'field',
    title: 'Adres',
    short: 'Site içi yol (ör. /iletisim, /yasal/kvkk-aydinlatma-metni) veya https:// ile başlayan tam adres.',
  },
  'menus.new_tab': {
    kind: 'field',
    title: 'Yeni Sekmede Aç',
    short: 'Dış sitelere giden bağlantılar için; ziyaretçi mağazadan ayrılmaz.',
  },
  'menus.move': {
    kind: 'action',
    title: 'Sırayı Değiştir',
    short: 'Öğeyi aynı seviyede bir yukarı veya aşağı taşır.',
  },
  'menus.remove': {
    kind: 'action',
    title: 'Kaldır',
    short: 'Öğeyi ve alt öğelerini menüden çıkarır (kaydedene kadar vitrin değişmez).',
  },
  'menus.save': {
    kind: 'action',
    title: 'Menüyü Kaydet',
    short: 'Seçili konumdaki menüyü kaydeder; vitrinde en geç bir dakika içinde görünür.',
    requiredPermission: 'İçerik yayınlama.',
  },
  'menus.page': {
    kind: 'field',
    title: 'Sayfa',
    short:
      'Bağlanacak kurumsal veya kampanya sayfası (Vitrin → Sayfalar). Sayfa yalnızca yayındayken menüde görünür; kısa adı değişse de bağlantı doğru adrese gider.',
  },
  'menus.unavailable': {
    kind: 'field',
    title: 'Hedef Vitrinde Görünmüyor',
    short: 'Kategori gizli, ürün veya sayfa vitrinde yayında değil; öğe vitrinde gösterilmez.',
  },
  // ------------------------------------------------------------------ Sayfalar (Faz 4)
  'page.pages': {
    kind: 'page',
    title: 'Sayfalar',
    short: 'Ana sayfa düzenini, kurumsal sayfaları ve kampanya sayfalarını bölüm bölüm oluşturur.',
    whatItDoes:
      'Her sayfa bölümlerden oluşur: büyük başlık (hero), metin, görsel + metin, ürün ızgarası, kategori kutuları, sıkça sorulan sorular. Taslak kaydedilir, imzalı bağlantıyla vitrinde önizlenir, sonra yayımlanır. Her yayın değiştirilemez bir sürüm olarak saklanır. Ana sayfa düzeni yayımlanmamışsa vitrin varsayılan ana sayfayı gösterir.',
    whenToUse:
      'Ana sayfayı düzenlerken; Hakkımızda, İletişim gibi kurumsal sayfalar veya kampanya sayfası açarken.',
    dataChanged: 'Yalnızca seçili mağazanın sayfalarını değiştirir. Taslak kaydı vitrini değiştirmez.',
    requiredPermission:
      'Görüntüleme: İçerikleri görüntüleme. Taslak: İçerik düzenleme. Yayın, yayından kaldırma ve silme: İçerik yayınlama. Sağlık içeriği onayı: Uzman (veteriner) onayı.',
    reversible:
      'Evet. Sayfa yayından kaldırılabilir; yayımlanan her sürüm saklanır ve denetim kaydına yazılır.',
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#sayfalar',
  },
  'page.page_editor': {
    kind: 'page',
    title: 'Sayfa Düzenleyici',
    short: 'Sayfanın başlığını, adresini, SEO bilgilerini ve bölümlerini düzenler.',
    whatItDoes:
      'Bölüm ekler, sıralar, gizler veya kaldırırsınız. "Taslağı kaydet" vitrini değiştirmez. "Önizle" taslağı vitrinin görünümüyle yeni sekmede açar. "Yayımla" taslağı yeni bir sürüm olarak vitrine çıkarır; isterseniz yayın ve kaldırma tarihi verirsiniz. Metinde hastalığı önleme veya tedavi gibi bir ifade bulunursa ya da sayfa "sağlık içeriği" işaretliyse, yayın için Veteriner Uzman İnceleyici onayı gerekir.',
    whenToUse: 'Bir sayfanın içeriğini hazırlarken veya güncellerken.',
    dataChanged: 'Sayfanın taslağını; yayımladığınızda vitrindeki sayfayı değiştirir.',
    requiredPermission: 'Taslak: İçerik düzenleme. Yayın: İçerik yayınlama.',
    reversible: 'Evet. Yayımlanan sürümler listelenir; sayfa yayından kaldırılabilir.',
    commonErrors: [
      {
        problem:
          '"Sağlık içeriği veya sağlık beyanı var: yayımlamak için Veteriner Uzman İnceleyici onayı gerekir."',
        solution:
          'Sayfa sağlık içeriği olarak işaretli ya da metinde sağlık beyanı bulundu. Veteriner Uzman İnceleyici "Uzman incelemesi" bölümünden onaylamalıdır. İçerik değişirse onay düşer ve yeniden istenir.',
      },
      {
        problem: '"Seçilen kategori veya ürün bulunamadı; başka bir seçim yapın."',
        solution:
          'Bölümde seçili kategori ya da ürün silinmiş olabilir. Bölümdeki seçimi güncelleyip yeniden kaydedin.',
      },
      {
        problem: '"Bu kısa ad zaten kullanılıyor."',
        solution: 'Aynı kısa adla başka bir sayfa var. Farklı bir kısa ad yazın.',
      },
    ],
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#sayfalar',
  },
  'pages.create': {
    kind: 'action',
    title: 'Yeni Sayfa',
    short: 'Taslak bir sayfa oluşturur ve düzenleyiciyi açar; vitrin yayımlayana kadar değişmez.',
    requiredPermission: 'İçerik düzenleme',
  },
  'pages.kind': {
    kind: 'field',
    title: 'Sayfa Türü',
    short:
      'Ana sayfa düzeni (mağaza başına bir tane, adresi "/"), kurumsal sayfa (Hakkımızda gibi) veya kampanya sayfası. Kurumsal ve kampanya sayfaları /sayfa/kisa-ad adresinde açılır.',
  },
  'pages.title': {
    kind: 'field',
    title: 'Sayfa Başlığı',
    short:
      'Panelde ve vitrinde görünen ad (en fazla 120 karakter). SEO başlığı boşsa tarayıcı başlığı da budur.',
  },
  'pages.slug': {
    kind: 'field',
    title: 'Kısa Ad (adres)',
    short:
      'Sayfanın adresi: küçük harf, rakam ve tire (ör. hakkimizda). Yayındaki sayfanın kısa adı kayıtla hemen değişir ve eski adres yeni adrese kalıcı olarak yönlendirilir; bunun için İçerik yayınlama yetkisi gerekir.',
  },
  'pages.seo_title': {
    kind: 'field',
    title: 'SEO Başlığı',
    short:
      'Arama sonuçlarında ve tarayıcı sekmesinde görünen başlık (en fazla 70 karakter). Boşsa sayfa başlığı kullanılır.',
  },
  'pages.seo_description': {
    kind: 'field',
    title: 'SEO Açıklaması',
    short: 'Arama sonuçlarında başlığın altında görünen kısa metin (en fazla 170 karakter).',
  },
  'pages.health_content': {
    kind: 'field',
    title: 'Sağlık İçeriği',
    short:
      'Sayfa evcil hayvan sağlığıyla ilgili bilgi içeriyorsa işaretleyin. İşaretli sayfalar Veteriner Uzman İnceleyici onayı olmadan yayımlanamaz. İşaretlemeseniz de metinde sağlık beyanı bulunursa onay istenir.',
  },
  'pages.preview': {
    kind: 'action',
    title: 'Önizle',
    short:
      'Kaydedilmemiş değişiklikleri kaydeder ve taslağı vitrinin görünümüyle yeni sekmede açar. Bağlantı imzalıdır, 2 saat geçerlidir ve arama motorlarına kapalıdır.',
    requiredPermission: 'İçerik düzenleme',
  },
  'pages.save': {
    kind: 'action',
    title: 'Taslağı Kaydet',
    short:
      'Değişiklikleri taslak olarak saklar; vitrindeki sayfa yayımlayana kadar değişmez (yayındaki sayfanın kısa adı hariç).',
    requiredPermission: 'İçerik düzenleme',
  },
  'pages.publish': {
    kind: 'action',
    title: 'Yayımla',
    short:
      'Taslağı yeni bir sürüm olarak vitrine çıkarır. Yayın tarihi verirseniz sayfa o zamana kadar görünmez; kaldırma tarihi verirseniz o zaman kendiliğinden kapanır.',
    whenToUse:
      'Sayfa taslağını önizleyip kontrol ettikten sonra ziyaretçilere açmak (veya ileri bir tarihte açılmasını planlamak) istediğinizde.',
    dataChanged:
      'Taslak içerik yeni bir sürüm olarak saklanır ve sayfa "yayında" olur; verdiyseniz yayın ve kaldırma tarihleri kaydedilir. İşlem denetim kaydına yazılır.',
    requiredPermission: 'İçerik yayınlama (sağlık içeriğinde ayrıca uzman onayı)',
    reversible: 'Evet. Sayfayı yayından kaldırabilir veya yeniden yayımlayabilirsiniz.',
    commonErrors: [
      {
        problem: '"Sağlık içeriği veya sağlık beyanı var: … uzman onayı gerekir"',
        solution: 'Veteriner Uzman İnceleyici onayını alın; içerik değişirse onay yeniden gerekir.',
      },
      {
        problem: '"Seçilen kategori veya ürün bulunamadı" veya "içerikteki bir görsel bulunamadı"',
        solution: 'Bölümlerdeki silinmiş ürün, kategori veya görseli değiştirip yeniden kaydedin.',
      },
      {
        problem: '"Yayından kaldırma tarihi yayın tarihinden sonra olmalı"',
        solution: 'Tarihleri düzeltin.',
      },
    ],
  },
  'pages.schedule': {
    kind: 'field',
    title: 'Yayın ve Kaldırma Tarihi',
    short:
      'Boş bırakılırsa sayfa hemen yayına girer ve süresiz kalır. Kampanya sayfaları için başlangıç ve bitiş zamanı verin; kaldırma tarihi yayın tarihinden sonra olmalıdır.',
  },
  'pages.unpublish': {
    kind: 'action',
    title: 'Yayından Kaldır',
    short:
      'Sayfa vitrinden hemen kalkar; taslak ve sürümler saklanır. Ana sayfa düzenini kaldırırsanız varsayılan ana sayfa görünür.',
    whenToUse:
      'Sayfa geçici olarak görünmemeli veya içeriği artık geçerli değilse (ör. biten kampanya sayfası).',
    dataChanged:
      'Sayfanın durumu "yayından kaldırıldı" olur ve vitrinden kalkar; taslak ve sürümler korunur. İşlem denetim kaydına yazılır.',
    requiredPermission: 'İçerik yayınlama',
    reversible: 'Evet. Yeniden yayımlayabilirsiniz.',
    commonErrors: [
      {
        problem: '"Bu kayıt siz düzenlerken başka biri tarafından değiştirildi"',
        solution: 'Sayfayı yenileyip tekrar deneyin.',
      },
    ],
  },
  'pages.delete': {
    kind: 'action',
    title: 'Sayfayı Sil',
    short:
      'Hiç yayımlanmamış taslak sayfayı kalıcı olarak siler. Yayımlanmış sayfalar silinmez, yayından kaldırılır.',
    whenToUse:
      'Yanlışlıkla açılmış veya artık gerekmeyen, hiç yayımlanmamış bir taslak sayfayı kaldırmak için.',
    dataChanged: 'Taslak sayfa kalıcı olarak silinir; işlem denetim kaydına yazılır.',
    requiredPermission: 'İçerik yayınlama',
    reversible: 'Hayır.',
    commonErrors: [
      {
        problem: '"Yayımlanmış sayfa silinemez"',
        solution: 'Yayımlanmış sayfayı "Yayından Kaldır" ile vitrinden kaldırın; geçmişi korunur.',
      },
    ],
  },
  'pages.review': {
    kind: 'action',
    title: 'Uzman İncelemesi',
    short:
      'Veteriner Uzman İnceleyici içeriği onaylar veya gerekçe yazarak reddeder. Onay o anki içeriğe bağlıdır: içerik değişirse onay düşer.',
    requiredPermission: 'Uzman (veteriner) onayı',
  },
  'pages.review_note': {
    kind: 'field',
    title: 'İnceleme Notu',
    short: 'Reddederken zorunludur: editöre neyin düzeltilmesi gerektiğini yazın.',
  },
  'pages.section_add': {
    kind: 'action',
    title: 'Bölüm Ekle',
    short: 'Seçtiğiniz türde bir bölümü sayfanın sonuna ekler (en fazla 40 bölüm).',
  },
  'pages.section_hide': {
    kind: 'field',
    title: 'Bölümü Gizle',
    short: 'Bölüm taslakta kalır ama vitrinde gösterilmez. Geçici olarak kapatmak için kullanın.',
  },
  'pages.section_move': {
    kind: 'action',
    title: 'Bölümü Taşı',
    short: 'Bölümü bir yukarı veya aşağı taşır; vitrinde bu sırayla görünür.',
  },
  'pages.section_remove': {
    kind: 'action',
    title: 'Bölümü Kaldır',
    short: 'Bölümü taslaktan çıkarır. Kaydedene kadar sayfayı yenileyerek geri alabilirsiniz.',
  },
  'pages.heading': {
    kind: 'field',
    title: 'Bölüm Başlığı',
    short: 'Bölümün üstünde görünen başlık. Sayfanın ilk büyük başlığı (hero) sayfanın ana başlığı olur.',
  },
  'pages.cta': {
    kind: 'field',
    title: 'Düğme',
    short:
      'Büyük başlığın altındaki düğmenin metni ve adresi (ör. /urunler veya https:// ile başlayan bir adres).',
  },
  'pages.rich_text': {
    kind: 'field',
    title: 'Metin Düzenleyici',
    short:
      'Paragraf, başlık, kalın, italik, liste, alıntı, ayırıcı, bağlantı ve görsel ekleyebilirsiniz. Yapıştırılan metin bu biçimlere indirgenir. Görsel eklerken alternatif metin zorunludur. Görsel ve videoyu sürükleyerek ya da seçip yukarı/aşağı ok düğmeleriyle taşıyabilirsiniz (paragraf ve tablolar için de çalışır).',
  },
  'pages.image': {
    kind: 'action',
    title: 'Görsel Yükle',
    short: 'PNG, JPEG, WebP, AVIF veya GIF görsel yükler. Görsel, alternatif metniyle birlikte kaydedilir.',
  },
  'pages.image_alt': {
    kind: 'field',
    title: 'Alternatif Metin',
    short:
      'Görseli göremeyen ziyaretçiler ve ekran okuyucular için görselin ne gösterdiğini kısaca yazın. Zorunludur.',
  },
  'pages.image_position': {
    kind: 'field',
    title: 'Görselin Yeri',
    short:
      'Masaüstünde görselin metnin solunda mı sağında mı duracağı. Mobilde görsel her zaman üstte görünür.',
  },
  'pages.grid_source': {
    kind: 'field',
    title: 'Ürün Kaynağı',
    short:
      'Izgarada hangi ürünlerin görüneceği: en yeniler; çok satanlar (son 30 günde ödemesi alınmış siparişlerde en çok satılanlar — satış yoksa bölüm gösterilmez); indirimli ürünler (fiyatı son 30 günün en düşük fiyatından düşük olanlar); bir kategori, koleksiyon veya markanın ürünleri; ya da tek tek seçtiğiniz ürünler.',
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#urun-izgarasi',
  },
  'pages.grid_collection': {
    kind: 'field',
    title: 'Koleksiyon',
    short:
      'Katalog → Koleksiyonlar ekranındaki koleksiyonlardan biri. Gizli koleksiyonun bölümü vitrinde görünmez.',
  },
  'pages.grid_brand': {
    kind: 'field',
    title: 'Marka',
    short: 'Markanın vitrinde yayında olan ürünleri. "Tümünü gör" bağlantısı marka sayfasına gider.',
  },
  'pages.grid_limit': {
    kind: 'field',
    title: 'Ürün Sayısı',
    short: 'Izgarada en fazla kaç ürün görüneceği (2–24). Vitrinde görünmeyen ürünler gösterilmez.',
  },
  'pages.products': {
    kind: 'field',
    title: 'Seçili Ürünler',
    short:
      'Ad, stok kodu veya barkodla arayıp ekleyin (en fazla 24). Vitrinde bu sırayla görünür; yayında olmayanlar atlanır.',
  },
  'pages.tiles': {
    kind: 'field',
    title: 'Kategori Kutuları',
    short: 'Vitrinde kutu olarak gösterilecek kategoriler. Gizli kategoriler gösterilmez.',
  },
  'pages.faq': {
    kind: 'field',
    title: 'Soru ve Cevap',
    short:
      'Sıkça sorulan sorular bölümündeki her soru ve cevabı. Vitrinde açılır kapanır liste olarak görünür.',
  },
  // ------------------------------------------------------------------ Bannerlar (Faz 4)
  'page.banners': {
    kind: 'page',
    title: 'Bannerlar',
    short:
      "Ana sayfa slider'ını, kampanya kutularını, kategori üstü bannerı, duyuru çubuğunu ve açılır pencereyi yönetir.",
    whatItDoes:
      'Bannerlar yerleşimlere göre listelenir. Ana sayfa slider\'ı birden çok bannerı sırayla gösterir (durdur düğmesi var, "hareketi azalt" tercihinde kendiliğinden dönmez); ikincil alan kutu ızgarasıdır; kategori üstü seçilen kategorilerin sayfasında, duyuru çubuğu ve açılır pencere tüm sitede görünür. Banner taslak olarak hazırlanır, etkinleştirilince başlangıç ve bitiş tarihleri arasında vitrinde görünür. Hedef kitle: herkes, bayi olmayanlar veya yalnızca bayiler.',
    whenToUse: 'Kampanya, duyuru ve öne çıkan ürünleri vitrinde göstermek için.',
    dataChanged: 'Yalnızca seçili mağazanın bannerlarını değiştirir. Taslak vitrini değiştirmez.',
    requiredPermission:
      'Görüntüleme: İçerikleri görüntüleme. Taslak: İçerik düzenleme. Etkinleştirme, durdurma, sıralama, etkin bannerı değiştirme ve silme: İçerik yayınlama. Sağlık beyanı onayı: Uzman (veteriner) onayı.',
    reversible: 'Evet. Banner durdurulabilir; her işlem denetim kaydına yazılır.',
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#bannerlar',
  },
  'page.banner_editor': {
    kind: 'page',
    title: 'Banner Düzenleyici',
    short: 'Bannerın yerleşimini, metnini, görsellerini, hedef kitlesini ve tarihlerini düzenler.',
    whatItDoes:
      'Metin görselin üstüne değil, tema renklerindeki düz bir panele yazılır; böylece her görselde okunur. Metinde hastalığı önleme veya tedavi gibi bir ifade bulunursa banner Veteriner Uzman İnceleyici onayı olmadan etkinleştirilemez; etkin bannerın metni değişirse onay gelene kadar vitrinde gösterilmez.',
    requiredPermission:
      'Taslak: İçerik düzenleme. Etkinleştirme ve etkin bannerı değiştirme: İçerik yayınlama.',
    reversible: 'Evet. Banner durdurulabilir veya yeniden düzenlenebilir.',
    commonErrors: [
      {
        problem: '"Bu yerleşim için masaüstü görseli yükleyin."',
        solution:
          "Ana sayfa slider'ı, ikincil alan ve kategori üstü bannerlarında masaüstü görseli zorunludur.",
      },
      {
        problem:
          '"Sağlık içeriği veya sağlık beyanı var: yayımlamak için Veteriner Uzman İnceleyici onayı gerekir."',
        solution: 'Metindeki ifadeyi düzeltin veya Veteriner Uzman İnceleyiciden onay isteyin.',
      },
    ],
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#bannerlar',
  },
  'banners.create': {
    kind: 'action',
    title: 'Yeni Banner',
    short: 'Taslak banner hazırlar; etkinleştirilene kadar vitrinde görünmez.',
    requiredPermission: 'İçerik düzenleme',
  },
  'banners.placement': {
    kind: 'field',
    title: 'Yerleşim',
    short:
      "Bannerın vitrinde nerede görüneceği: ana sayfa slider'ı, ana sayfa ikincil alanı, kategori üstü, duyuru çubuğu (sitenin en üstü) veya açılır pencere.",
  },
  'banners.name': {
    kind: 'field',
    title: 'İç Ad',
    short: 'Yalnızca panelde görünür; bannerı listede bulmak için (ör. "Kasım kampanyası slider").',
  },
  'banners.title': {
    kind: 'field',
    title: 'Başlık',
    short:
      'Bannerda büyük yazıyla görünen başlık (en fazla 120 karakter). Açılır pencerede başlık veya metin zorunludur.',
  },
  'banners.text': {
    kind: 'field',
    title: 'Metin',
    short:
      'Başlığın altındaki kısa metin (en fazla 300 karakter). Duyuru çubuğunda görünen yazı budur ve zorunludur.',
  },
  'banners.cta': {
    kind: 'field',
    title: 'Düğme Metni',
    short:
      'Düğmede yazan metin (ör. "Ürünleri gör"). Düğme metni yoksa ve adres varsa bannerın tamamı tıklanır.',
  },
  'banners.href': {
    kind: 'field',
    title: 'Bağlantı Adresi',
    short: 'Site içi yol (ör. /urunler) veya https:// ile başlayan adres. Tehlikeli adresler kabul edilmez.',
  },
  'banners.desktop_image': {
    kind: 'action',
    title: 'Masaüstü Görseli',
    short:
      'Geniş ekranda görünen görsel. Slider için yatay (16:9 veya daha geniş) görsel önerilir. Slider, ikincil alan ve kategori üstünde zorunludur.',
  },
  'banners.mobile_image': {
    kind: 'action',
    title: 'Mobil Görsel',
    short: 'Telefonda görünen görsel (isteğe bağlı). Yüklenmezse masaüstü görseli kullanılır.',
  },
  'banners.image_alt': {
    kind: 'field',
    title: 'Alternatif Metin',
    short: 'Görselin ne gösterdiğini kısaca yazın; ekran okuyucular bu metni okur. Görsel varsa zorunludur.',
  },
  'banners.audience': {
    kind: 'field',
    title: 'Hedef Kitle',
    short:
      'Herkes; bayi olmayan ziyaretçiler (misafir ve üye müşteriler); veya yalnızca giriş yapmış onaylı bayiler.',
  },
  'banners.dates': {
    kind: 'field',
    title: 'Başlangıç ve Bitiş',
    short:
      'Boş bırakılırsa banner etkinleştirildiği andan durdurulana kadar görünür. Bitiş, başlangıçtan sonra olmalıdır.',
  },
  'banners.dismiss_days': {
    kind: 'field',
    title: 'Kapatınca Gizleme Süresi',
    short:
      'Ziyaretçi açılır pencereyi kapattıktan sonra kaç gün aynı tarayıcıda gösterilmeyeceği (1–365). İçerik değişirse yeniden gösterilir.',
  },
  'banners.categories': {
    kind: 'field',
    title: 'Kategoriler',
    short:
      'Kategori üstü bannerın görüneceği kategoriler. Hiçbiri seçilmezse tüm kategori sayfalarında görünür.',
  },
  'banners.save': {
    kind: 'action',
    title: 'Kaydet',
    short:
      'Bannerı kaydeder. Etkin bannerda değişiklik vitrine hemen yansır; bunun için İçerik yayınlama yetkisi gerekir.',
  },
  'banners.activate': {
    kind: 'action',
    title: 'Etkinleştir',
    short: 'Banner başlangıç ve bitiş tarihleri arasında vitrinde görünmeye başlar.',
    whenToUse:
      'Bannerın görselleri, bağlantısı ve tarihleri hazır olduğunda vitrinde göstermeye başlamak için.',
    dataChanged:
      'Bannerın durumu "etkin" olur; başlangıç ve bitiş tarihleri arasında vitrindeki yerleşiminde görünür. İşlem denetim kaydına yazılır.',
    requiredPermission: 'İçerik yayınlama (sağlık beyanında ayrıca uzman onayı)',
    reversible: 'Evet. Durdurabilirsiniz.',
    commonErrors: [
      {
        problem: '"Sağlık içeriği veya sağlık beyanı var: … uzman onayı gerekir"',
        solution:
          'Banner metninde sağlık beyanı bulunduysa Veteriner Uzman İnceleyici onayından sonra etkinleştirin.',
      },
      {
        problem: '"İçerik uzman incelemesinde reddedildi"',
        solution: 'Metni düzeltip yeniden incelemeye gönderin.',
      },
    ],
  },
  'banners.deactivate': {
    kind: 'action',
    title: 'Durdur',
    short: 'Banner vitrinden hemen kalkar; bilgileri saklanır.',
    requiredPermission: 'İçerik yayınlama',
    reversible: 'Evet. Yeniden etkinleştirebilirsiniz.',
  },
  'banners.move': {
    kind: 'action',
    title: 'Sırala',
    short: 'Bannerı yerleşim içinde yukarı veya aşağı taşır; slider bu sırayla döner. Vitrine hemen yansır.',
    requiredPermission: 'İçerik yayınlama',
  },
  'banners.delete': {
    kind: 'action',
    title: 'Bannerı Sil',
    short: 'Etkin olmayan bannerı kalıcı olarak siler. Etkin banner önce durdurulmalıdır.',
    requiredPermission: 'İçerik yayınlama',
    reversible: 'Hayır.',
  },
  'pages.post_list': {
    kind: 'field',
    title: 'Blog Yazıları',
    short:
      'Bu bölüm seçilen kategorideki (veya tüm kategorilerdeki) en yeni yayındaki yazıları gösterir (1–12).',
  },
  'pages.banners': {
    kind: 'field',
    title: 'Banner Alanı',
    short:
      "Bu bölüm, Bannerlar ekranında seçilen alana (ana sayfa slider'ı veya ikincil alan) eklenen etkin bannerları gösterir.",
  },
  // ------------------------------------------------------------------ Blog (Faz 4)
  'products.media_alt': {
    kind: 'field',
    title: 'Görselin Alternatif Metni',
    short:
      'Görselin ne gösterdiğini kısaca yazın (ör. "Kutunun ön yüzü"); ekran okuyucular okur. Boşsa vitrinde ürün adı kullanılır. Alandan çıkınca kaydedilir.',
  },
  'products.media_order': {
    kind: 'action',
    title: 'Görsel Sırası',
    short:
      'Ok düğmeleriyle görselleri sıralayın; ilk görsel listede ve vitrinde kapaktır, galeri bu sırayla gösterilir.',
  },
  'page.blog': {
    kind: 'page',
    title: 'Blog',
    short: 'Makale ve rehber yazılarını, blog kategorilerini yönetir.',
    whatItDoes:
      'Yazı taslak olarak hazırlanır, imzalı bağlantıyla vitrinde önizlenir ve yayımlanır; her yayın değiştirilemez bir sürümdür ve vitrin yalnızca yayımlanan sürümü gösterir. Sağlık içeriği işaretli veya metinde hastalığı önleme/tedavi gibi bir ifade bulunan yazı, Veteriner Uzman İnceleyici onayı olmadan yayımlanmaz; içerik değişince onay düşer ve yazı yeniden incelemeye girer. Vitrin adresleri: /blog, /blog/kategori/<kısa-ad>, /blog/<kısa-ad>.',
    whenToUse: 'Beslenme, bakım ve ürün kullanımı üzerine bilgilendirici yazılar yayımlarken.',
    dataChanged: 'Yalnızca seçili mağazanın blogunu değiştirir. Taslak kaydı vitrini değiştirmez.',
    requiredPermission:
      'Görüntüleme: İçerikleri görüntüleme. Taslak ve kategori ekleme: İçerik düzenleme. Yayın, yayından kaldırma, silme ve kategori değişikliği: İçerik yayınlama. Sağlık içeriği onayı: Uzman (veteriner) onayı.',
    reversible:
      'Evet. Yazı yayından kaldırılabilir; yayımlanan her sürüm saklanır ve denetim kaydına yazılır.',
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#blog',
  },
  'page.post_editor': {
    kind: 'page',
    title: 'Yazı Düzenleyici',
    short:
      'Yazının başlığını, metnini, kapağını, kaynaklarını, ilgili ürünlerini ve SEO bilgilerini düzenler.',
    whatItDoes:
      'Metin, panelin metin düzenleyicisiyle yazılır (başlık, liste, alıntı, bağlantı, görsel). Kaydet vitrini değiştirmez; Önizle taslağı yeni sekmede vitrin görünümüyle açar; Yayımla yeni sürüm oluşturur. Sağlık içeriği işaretli yazıda vitrinde "bilgilendirme amaçlıdır, veteriner hekiminize danışın" notu gösterilir.',
    requiredPermission:
      'Taslak: İçerik düzenleme. Yayın: İçerik yayınlama (sağlık içeriğinde ayrıca uzman onayı).',
    reversible: 'Evet. Yazı yayından kaldırılabilir; sürümler listelenir.',
    commonErrors: [
      {
        problem:
          '"Sağlık içeriği veya sağlık beyanı var: yayımlamak için Veteriner Uzman İnceleyici onayı gerekir."',
        solution:
          'Veteriner Uzman İnceleyici "Uzman incelemesi" bölümünden onaylamalıdır. Onaydan sonra içerik değişirse onay düşer.',
      },
      {
        problem: '"Yayımlamak için yazının metnini girin."',
        solution: 'Metin alanı boş olan yazı yayımlanamaz.',
      },
    ],
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#blog',
  },
  'blog.create': {
    kind: 'action',
    title: 'Yeni Yazı',
    short: 'Başlıkla taslak yazı oluşturur ve düzenleyiciyi açar; yayımlanana kadar vitrinde görünmez.',
    requiredPermission: 'İçerik düzenleme',
  },
  'blog.filter': {
    kind: 'field',
    title: 'Süzgeç',
    short: 'Tüm yazılar, uzman onayı bekleyenler (incelemede), yayındakiler veya taslaklar.',
  },
  'page.content_calendar': {
    kind: 'page',
    title: 'İçerik takvimi',
    short: 'Seçilen ayın planlı ve gerçekleşen yayın olayları: yazılar, sayfalar ve bannerlar, gün gün.',
    whatItDoes:
      'Yazı ve sayfaların yayına giriş tarihleri (ileri tarihli olanlar "Planlı"), yayımlanmış içeriğin yeni sürümleri ("Güncellendi"), kampanya sayfalarının yayından kalkış tarihi ve bannerların başlangıç/bitiş tarihleri listelenir. Günler ve saatler Türkiye saatiyledir. Başlığa tıklayınca içeriğin düzenleyicisi açılır.',
    whenToUse: 'Kampanya ve yayın planını görmek, boş kalan günleri ve çakışmaları fark etmek için.',
    dataChanged: 'Hiçbir şeyi değiştirmez; yalnızca gösterir.',
    requiredPermission: 'İçerikleri görüntüleme',
    reversible: 'Değişiklik yapmaz.',
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#icerik-takvimi',
  },
  'content_calendar.month': {
    kind: 'action',
    title: 'Ay seçimi',
    short: 'Önceki veya sonraki aya geçer; "Bu ay" bugünün ayına döner. Ay sınırları Türkiye saatiyle.',
  },
  'content_calendar.kind': {
    kind: 'field',
    title: 'Tür',
    short: 'Takvimi yalnızca blog yazılarına, sayfalara veya bannerlara daraltır.',
  },
  'page.content_report': {
    kind: 'page',
    title: 'İçerik raporu',
    short:
      'Yazı, sayfa ve banner durumları; kategorilere ve aylara göre yayın; uzun süredir güncellenmeyen yazılar; Search Console tıklamaları.',
    whatItDoes:
      'Seçili mağaza ve dil için içerik envanterini çıkarır. "Güncellenmeyen yazılar" son yayımlanan sürümü bir yıldan eski olan yayındaki yazılardır; bilgilerin güncelliğini kontrol edip yeniden yayımlamanız önerilir. Search Console bağlıysa ve SEO raporlarını görme yetkiniz varsa her yazının son 28 gündeki tıklama ve gösterimleri eklenir; bağlı değilse "Kurulum gerekli" yazar.',
    whenToUse: 'Aylık içerik değerlendirmesi ve hangi yazıların yenilenmesi gerektiğine karar verirken.',
    dataChanged: 'Hiçbir şeyi değiştirmez; yalnızca gösterir.',
    requiredPermission: 'İçerikleri görüntüleme (Search Console tıklamaları için ayrıca SEO görüntüleme)',
    reversible: 'Değişiklik yapmaz.',
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#icerik-raporu',
  },
  'content_report.states': {
    kind: 'field',
    title: 'Durum özeti',
    short:
      'Yayında: vitrinde görünüyor. Planlı: ileri tarihli yayın. Taslak: hiç yayımlanmadı. Süresi doldu: bitiş tarihi geçti.',
  },
  'content_report.stale': {
    kind: 'field',
    title: 'Güncellenmeyen yazılar',
    short:
      'Son yayımlanan sürümü 365 günden eski olan yayındaki yazılar, en eskisi önce. Yazıyı açıp gözden geçirin ve yeniden yayımlayın.',
  },
  'content_report.search_console': {
    kind: 'field',
    title: 'Search Console tıklamaları',
    short:
      'Bağlı Search Console mülkünden son 28 gün: yazı adresine gelen tıklama, gösterim, tıklama oranı ve ortalama konum. Yalnızca vitrin dilindeki yazılar.',
    requiredPermission: 'SEO görüntüleme',
  },
  'page.forms': {
    kind: 'page',
    title: 'Formlar',
    short: 'İletişim formunun alanlarını ve bayilik başvurusunun ek alanlarını düzenler.',
    whatItDoes:
      'Alan türü (kısa/uzun metin, e-posta, telefon, sayı, seçim listesi, onay kutusu, tarih), etiket, yardım metni, zorunluluk, seçenekler ve sıra buradan belirlenir. "Formu kaydet" ile değişiklik vitrine hemen yansır. İletişim formu yalnızca açıkken ve KVKK aydınlatma metni yayımdayken İletişim sayfasında görünür; formun altında aydınlatma metnine bağlantı kendiliğinden gösterilir. İstenmeyen gönderime karşı IP başına 10 dakikada 5 gönderim sınırı ve görünmez bir tuzak alanı vardır.',
    whenToUse: 'Müşterilerden mesaj almak veya bayilik başvurusunda ek bilgi (ör. şube sayısı) istemek için.',
    dataChanged:
      'Seçili mağaza ve dil için form tanımını değiştirir. Daha önce gelen mesaj ve başvurular, gönderildikleri andaki alan adlarıyla kalır.',
    requiredPermission: 'Görüntüleme: İçerikleri görüntüleme. Kaydetme: İçerik yayınlama.',
    reversible: 'Evet. Alanlar yeniden düzenlenebilir; değişiklik denetim kaydına yazılır.',
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#formlar',
  },
  'forms.kind': {
    kind: 'field',
    title: 'Form',
    short:
      'İletişim formu: alanların tamamı düzenlenir. Bayilik başvurusu: firma ve vergi alanları sabittir, yalnızca ek alanlar eklenir.',
  },
  'forms.enabled': {
    kind: 'field',
    title: 'Formu İletişim sayfasında göster',
    short:
      'Açıkken vitrindeki İletişim sayfasında form çıkar. KVKK aydınlatma metni yayımlanmadan açılamaz (Yasal metinler).',
    requiredPermission: 'İçerik yayınlama',
  },
  'forms.notify': {
    kind: 'field',
    title: 'Yeni mesajda e-posta bildirimi',
    short:
      'Yeni mesaj gelince işletme sahibi ve yöneticilere (veya Bildirim ayarlarındaki adreslere) e-posta gider; e-postada mesajın içeriği yoktur, panele bağlantı vardır. 15 dakika içinde gelen diğer mesajlar için tekrar gönderilmez.',
  },
  'forms.fields': {
    kind: 'field',
    title: 'Form alanları',
    short:
      'Etiket, tür, yardım metni ve zorunluluk her alan için ayrı. Ok düğmeleriyle sıralanır. İletişim formundaki e-posta alanı yanıt verebilmek için zorunludur ve kaldırılamaz.',
  },
  'forms.add_field': {
    kind: 'action',
    title: 'Alan ekle',
    short: 'Listenin sonuna boş bir kısa metin alanı ekler (en fazla 20 alan).',
    requiredPermission: 'İçerik yayınlama',
  },
  'forms.save': {
    kind: 'action',
    title: 'Formu kaydet',
    short: 'Alanları ve ayarları kaydeder; vitrine hemen yansır.',
    requiredPermission: 'İçerik yayınlama',
  },
  'forms.label': {
    kind: 'field',
    title: 'Etiket',
    short:
      'Ziyaretçinin gördüğü alan adı (en fazla 80 karakter). Hazır alanlarda boş bırakılırsa varsayılan etiket (ör. "Adınız soyadınız") kullanılır.',
  },
  'forms.type': {
    kind: 'field',
    title: 'Alan türü',
    short:
      'Türe göre giriş denetlenir: e-posta biçimi, telefon, sayı, tarih; seçim listesinde yalnızca tanımlı seçenekler kabul edilir.',
  },
  'forms.help_text': {
    kind: 'field',
    title: 'Yardım metni',
    short: 'Alanın altında gösterilen kısa açıklama (en fazla 200 karakter).',
  },
  'forms.options': {
    kind: 'field',
    title: 'Seçenekler',
    short: 'Seçim listesinin seçenekleri, her satıra bir tane (2–30 seçenek, birbirinden farklı).',
  },
  'forms.required': {
    kind: 'field',
    title: 'Zorunlu alan',
    short: 'Açıksa ziyaretçi alanı doldurmadan gönderemez; onay kutusunda işaretlemesi gerekir.',
  },
  'page.contact_messages': {
    kind: 'page',
    title: 'İletişim mesajları',
    short: 'Vitrindeki iletişim formundan gelen mesajlar.',
    whatItDoes:
      'Mesajlar en yeniden eskiye listelenir; yanıtladığınız mesajı "İşlendi" olarak işaretleyin. Kişisel veri yetkisi olmayan kullanıcılar e-posta ve telefonu maskeli görür. Mesajlar 2 yıl sonra kendiliğinden silinir; KVKK silme başvurusunda başvuranın e-postasıyla eşleşen mesajlar da silinir.',
    whenToUse: 'Müşteri sorularını takip etmek ve yanıtlamak için.',
    dataChanged: 'İşaretleme ve silme yalnızca mesaj kaydını değiştirir.',
    requiredPermission:
      'Görüntüleme: Müşterileri görüntüleme (e-posta/telefonun açık hâli için Kişisel verileri görüntüleme). İşaretleme ve silme: Müşteri düzenleme.',
    reversible: 'İşaretleme geri alınabilir; silme geri alınamaz.',
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#iletisim-mesajlari',
  },
  'messages.filter': {
    kind: 'field',
    title: 'Göster',
    short: 'Yeni (işlenmemiş) mesajlar, işlenenler veya tümü.',
  },
  'messages.handle': {
    kind: 'action',
    title: 'İşlendi olarak işaretle',
    short: 'Mesajı yanıtladığınızı kaydeder; "Yeniye geri al" ile geri alınır.',
    requiredPermission: 'Müşteri düzenleme',
  },
  'messages.delete': {
    kind: 'action',
    title: 'Mesajı sil',
    short: 'Mesajı kalıcı olarak siler (geri alınamaz). Denetim kaydına mesajın içeriği yazılmaz.',
    whenToUse:
      'İletişim formundan gelen istenmeyen (spam) mesajları veya kişinin silinmesini istediği mesajı kaldırmak için.',
    dataChanged:
      'Form mesajı kalıcı olarak silinir; denetim kaydına yalnızca silme işlemi yazılır, mesajın içeriği yazılmaz.',
    requiredPermission: 'Müşteri düzenleme',
    reversible: 'Hayır, silinen mesaj geri getirilemez.',
    commonErrors: [
      {
        problem: '"Kayıt bulunamadı"',
        solution: 'Mesaj zaten silinmiş veya yetkili olduğunuz mağazaya ait değil; sayfayı yenileyin.',
      },
    ],
  },
  'topbar.store': {
    kind: 'field',
    title: 'Çalışılan mağaza',
    short:
      'Panel ekranlarında (sayfalar, blog, SEO, ödeme ayarları, panelden sipariş vb.) varsayılan olarak bu mağaza seçilir. Ekrandaki mağaza seçimini değiştirmek de bunu değiştirir; seçim bu tarayıcıda hatırlanır.',
  },
  'topbar.jobs': {
    kind: 'field',
    title: 'Arka plan işleri',
    short:
      'İçe aktarma, toplu ürün işlemi, site taraması ve sayfa hızı ölçümü gibi uzun işlerin ilerlemesi. Süren işler ve son 10 dakikada bitenler listelenir; işin adına tıklayınca ilgili ekran açılır. Yalnızca görme yetkiniz olan işler gösterilir.',
    requiredPermission: 'İşleri görüntüleme',
  },
  'system.offsite': {
    kind: 'field',
    title: 'Yedeklerin uzak kopyası',
    short:
      'Gece alınan veritabanı ve görsel yedeği şifrelenip nesne deposuna (S3 / R2) yüklenir; sunucu kaybolsa da geri yüklenebilir. Entegrasyonlar → Nesne depolama → "Yedeklerin uzak kopyası" ile açılır. Dosyalar uygulamanın şifreleme anahtarıyla şifrelenir; geri açmak için o anahtar gerekir.',
  },
  'page.marketing_audience': {
    kind: 'page',
    title: 'Aboneler ve izinler',
    short: "Bülten aboneleri, engel listesi ve İYS'ye bildirilecek izin/ret kayıtları.",
    whatItDoes:
      "Pazarlama iletisi yalnızca güncel izni olan, engel listesinde olmayan ve izni İYS'ye bildirilmiş kişiye gönderilir. Bülten aboneliği e-postadaki onay bağlantısıyla başlar; her pazarlama iletisinde tek tıkla çıkma bağlantısı vardır. Üyelerin izni müşteri kartında ve vitrindeki Hesabım sayfasındadır.",
    whenToUse:
      'Telefonla "bana ileti göndermeyin" diyen kişiyi engellemek, aboneleri görmek ve İYS bildirimlerini üç iş günü içinde tamamlamak için.',
    dataChanged:
      "Engelleme ve abonelik sonlandırma İYS'ye ret kaydı ekler; silme yalnızca abone kaydını siler (çıkma ve İYS kayıtları ispat için kalır).",
    requiredPermission:
      'Görüntüleme: Aboneleri, engel listesini ve İYS kayıtlarını görüntüleme (adreslerin açık hâli için Kişisel verileri görüntüleme). Değiştirme: Abonelik ve engel listesini yönetme.',
    reversible: 'Engel kaldırılabilir ama kişinin izni geri gelmez; abone silme geri alınamaz.',
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#izinler',
  },
  'audience.subscribers': {
    kind: 'field',
    title: 'Bülten aboneleri',
    short:
      'Vitrin formundan abone olanlar; "Onay bekliyor" kişiler e-postadaki bağlantıyı henüz açmadı ve onlara pazarlama iletisi gönderilmez.',
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#bulten',
  },
  'audience.status': { kind: 'field', title: 'Durum', short: 'Abone, onay bekleyen, çıkan veya tümü.' },
  'audience.search': {
    kind: 'field',
    title: 'E-postada ara',
    short: 'Adresin bir kısmıyla arar (yalnızca kişisel verileri görüntüleme yetkisiyle).',
  },
  'audience.subscriber_actions': {
    kind: 'action',
    title: 'Aboneliği sonlandır / Sil',
    short:
      'Sonlandırma adresi engel listesine "çıktı" olarak ekler ve İYS\'ye ret bildirir. Silme KVKK başvurusu içindir: abone kaydı silinir, ispat kayıtları kalır.',
    whenToUse:
      'Sonlandır: kişi e-posta almak istemediğini telefonla veya yazılı bildirdiğinde. Sil: kişi KVKK kapsamında abone kaydının silinmesini istediğinde.',
    dataChanged:
      'Sonlandırma: adres engel listesine "çıktı" olarak eklenir, abonelik sona erer ve İYS\'ye ret bildirimi sıraya alınır. Silme: abone kaydı silinir, engel listesi ve İYS kayıtları ispat için kalır; ikisi de denetim kaydına yazılır.',
    requiredPermission: 'Abonelik ve engel listesini yönetme, İYS kayıtlarını işaretleme.',
    reversible:
      'Hayır: kişiye yeniden ileti gönderilebilmesi için kendisinin yeniden izin vermesi gerekir; silinen abone kaydı geri gelmez.',
    commonErrors: [{ problem: '"Kayıt bulunamadı"', solution: 'Abone zaten silinmiş; sayfayı yenileyin.' }],
  },
  'audience.suppressions': {
    kind: 'field',
    title: 'Engel listesi',
    short:
      'Bu adreslere izin olsa bile pazarlama iletisi gönderilmez. Çıkma bağlantısı, geri dönen/şikâyet edilen e-postalar ve elle eklenenler.',
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#engel-listesi',
  },
  'audience.channel': { kind: 'field', title: 'Kanal', short: 'E-posta, SMS veya WhatsApp.' },
  'audience.address': {
    kind: 'field',
    title: 'Adres',
    short: 'E-posta adresi veya telefon (0532 123 45 67 ya da +90 ile).',
  },
  'audience.note': { kind: 'field', title: 'Not', short: 'Neden engellendiği (ör. "telefonla istedi").' },
  'audience.suppress': {
    kind: 'action',
    title: 'Engelle',
    short: "Adres engel listesine eklenir, aboneliği varsa sonlanır ve İYS'ye ret bildirilir.",
  },
  'audience.channel_filter': { kind: 'field', title: 'Kanal', short: 'Listeyi bir kanala göre süzer.' },
  'audience.unsuppress': {
    kind: 'action',
    title: 'Kaldır',
    short: 'Engeli kaldırır; kişiye tekrar ileti gitmesi için yeniden izin vermesi gerekir.',
  },
  'audience.iys': {
    kind: 'field',
    title: 'İYS kayıtları',
    short:
      'İzin ve retler üç iş günü içinde İYS\'ye bildirilmeli. İYS bağlıysa otomatik gider; değilse dosyayı indirip İYS panelinden yükleyin ve "bildirildi" işaretleyin.',
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#iys',
  },
  'audience.iys_filter': {
    kind: 'field',
    title: 'Göster',
    short: 'Bildirilecek (bekleyen ve reddedilen), gönderilen, elle bildirilen veya tümü.',
  },
  'audience.iys_download': {
    kind: 'action',
    title: 'Dosya indir (CSV)',
    short:
      'Bildirilecek kayıtları İYS alan adlarıyla indirir (alıcı, tür, kaynak, durum, tarih, alıcı türü).',
  },
  'audience.iys_mark': {
    kind: 'action',
    title: 'Bildirildi işaretle',
    short: 'İYS panelinden yüklediğiniz kayıtları işaretler; bundan sonra bu izinlerle ileti gönderilebilir.',
  },
  'page.segments': {
    kind: 'page',
    title: 'Segmentler',
    short: 'RFM grupları ve kurallarla tanımlanan müşteri segmentleri.',
    whatItDoes:
      'Müşterileri son alışveriş, sipariş sayısı ve harcamaya göre hazır gruplara (RFM) ayırır; etiket, şehir, tür, bayi, izin gibi koşullarla kendi segmentlerinizi tanımlamanızı sağlar. Segmentler kampanya ve otomasyonlarda kitle olarak kullanılır.',
    whenToUse:
      'Kime kampanya göndereceğinizi belirlemek, kaybetmek üzere olduğunuz müşterileri görmek veya bayilere özel bir duyuru hazırlamak için.',
    dataChanged:
      'Segment kaydı yalnızca kuralları saklar; müşteri kayıtları değişmez. "Şimdi yeniden hesapla" RFM puanlarını ve segment sayılarını günceller.',
    requiredPermission:
      'Görüntüleme: Aboneleri, engel listesini ve İYS kayıtlarını görüntüleme (e-postaların açık hâli için Kişisel verileri görüntüleme). Oluşturma ve hesaplama: Müşteri segmentlerini oluşturma.',
    reversible: 'Segment silinebilir; silmek müşterileri etkilemez.',
    guideUrl: 'docs/CRM_GUIDE_TR.md#segmentler',
  },
  'page.segment_editor': {
    kind: 'page',
    title: 'Segment',
    short: 'Segmentin adı, kuralları, önizlemesi ve üyeleri.',
    whatItDoes:
      'Koşulları seçip "Önizle" ile kaç müşterinin eşleştiğini kaydetmeden görürsünüz. Kayıttan sonra segmentteki müşteriler listelenir.',
    whenToUse: 'Yeni bir müşteri grubu tanımlarken veya mevcut segmentin kurallarını değiştirirken.',
    dataChanged: 'Yalnızca segment kaydı (ad, açıklama, kurallar) değişir.',
    requiredPermission:
      'Değiştirme: Müşteri segmentlerini oluşturma. Görüntüleme: Aboneleri, engel listesini ve İYS kayıtlarını görüntüleme.',
    reversible: 'Kurallar her zaman değiştirilebilir; segment silinebilir.',
    guideUrl: 'docs/CRM_GUIDE_TR.md#kurallar',
  },
  'segments.rfm': {
    kind: 'field',
    title: 'RFM grupları',
    short:
      'R yakınlık, F sıklık, M harcama: her biri 1–5 puan. Gruplar puanlardan çıkar (ör. Şampiyonlar: yakın zamanda, sık ve çok alışveriş yapanlar).',
    guideUrl: 'docs/CRM_GUIDE_TR.md#rfm',
  },
  'segments.recompute': {
    kind: 'action',
    title: 'Şimdi yeniden hesapla',
    short: 'RFM puanlarını ve segment sayılarını hemen günceller (her gece kendiliğinden yapılır).',
  },
  'segments.save_rfm': {
    kind: 'action',
    title: 'Segment olarak kaydet',
    short: 'Bu RFM grubunu kampanyalarda kullanılabilecek bir segment olarak kaydeder.',
  },
  'segments.list': {
    kind: 'field',
    title: 'Segmentler',
    short: 'Müşteri sayısı son sayımdır (kayıtta, yeniden hesaplamada ve her gece güncellenir).',
  },
  'segments.name': {
    kind: 'field',
    title: 'Ad',
    short: 'Kampanya seçerken göreceğiniz ad; işletmede tekil.',
  },
  'segments.description': {
    kind: 'field',
    title: 'Açıklama',
    short: 'Segmentin amacı (ör. "Son 3 ayda kedi ürünü alan İstanbullu müşteriler").',
  },
  'segments.match': {
    kind: 'field',
    title: 'Eşleşme',
    short: '"Tüm koşullar": hepsi sağlanmalı. "Koşullardan biri": en az biri yeterli.',
  },
  'segments.conditions': {
    kind: 'field',
    title: 'Koşullar',
    short:
      'En çok 10 koşul. Sayı alanlarında "en az / en çok", diğerlerinde "eşittir / eşit değildir". Tutar net harcamadır (iade ve iptaller düşülmüş).',
    guideUrl: 'docs/CRM_GUIDE_TR.md#kurallar',
  },
  'segments.preview': {
    kind: 'action',
    title: 'Önizle',
    short: 'Kaydetmeden kaç müşterinin eşleştiğini ve ilk 10 müşteriyi gösterir.',
  },
  'segments.save': { kind: 'action', title: 'Kaydet', short: 'Segmenti kaydeder ve üye sayısını günceller.' },
  'segments.delete': { kind: 'action', title: 'Sil', short: 'Segmenti siler; müşteriler etkilenmez.' },
  'segments.members': {
    kind: 'field',
    title: 'Segmentteki müşteriler',
    short: 'Kurallara şu an uyan müşteriler; e-postalar kişisel veri yetkisi yoksa maskeli.',
  },
  'customers.tags': {
    kind: 'field',
    title: 'Etiketler',
    short:
      'Müşteriye panelde verilen kısa etiketler (ör. vip, fuar 2026); listede süzgeç ve segment kuralı olarak kullanılır. Vitrinde görünmez ama KVKK veri kopyasında müşteriye verilir. En çok 30, küçük harfe çevrilir.',
    guideUrl: 'docs/CRM_GUIDE_TR.md#etiketler',
  },
  'customers.save_tags': {
    kind: 'action',
    title: 'Etiketleri kaydet',
    short: 'Yazılan etiketleri kaydeder.',
  },
  'customers.tag_filter': { kind: 'field', title: 'Etiket', short: 'Listeyi bir etikete göre süzer.' },
  'customers.summary': {
    kind: 'field',
    title: 'Müşteri özeti',
    short:
      'Geçerli siparişlerden anlık: bugüne kadarki ve son 12 aydaki net harcama (işletmenin para biriminde), sipariş sayısı, ortalama sepet, son sipariş, ortalama sipariş aralığı ve beklenen sonraki sipariş (tahmin), iade talepleri; RFM grubu gece hesaplanır.',
    guideUrl: 'docs/CRM_GUIDE_TR.md#musteri-360',
  },
  'customers.notes': {
    kind: 'field',
    title: 'İç notlar',
    short:
      'Müşteriyle ilgili ekibin bilmesi gerekenler (ör. "teslimatı akşam ister"). Vitrinde görünmez; KVKK veri kopyasında müşteriye verilir.',
  },
  'customers.save_notes': {
    kind: 'action',
    title: 'Notu kaydet',
    short: 'Notu kaydeder; değişiklik denetim kaydına düşer.',
  },
  'customers.timeline': {
    kind: 'field',
    title: 'Etkinlik geçmişi',
    short:
      'Siparişler, iade talepleri, değerlendirmeler, sorular, izin değişiklikleri, iletişim mesajları, bülten ve KVKK başvuruları tek listede. Yalnızca görme yetkiniz olan bölümler listelenir.',
    guideUrl: 'docs/CRM_GUIDE_TR.md#musteri-360',
  },
  'email_routing.transactional': {
    kind: 'field',
    title: 'İşlem e-postaları',
    short:
      "Sipariş, kargo, şifre ve davet e-postaları. Seçim yoksa işletmenin SMTP bağlantısı, o da yoksa platform SMTP'si kullanılır. Seçilen sağlayıcının bağlantısı kaldırılırsa yine SMTP'ye dönülür.",
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#saglayicilar',
  },
  'email_routing.marketing': {
    kind: 'field',
    title: 'Pazarlama e-postaları',
    short:
      'Bülten ve kampanya e-postaları. Ayrı bir sağlayıcı veya ayrı bir akış (ör. Postmark yayın akışı) itibarı korur: pazarlama şikâyetleri sipariş e-postalarının teslimini etkilemez.',
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#saglayicilar',
  },
  'email_routing.save': {
    kind: 'action',
    title: 'Gönderim seçimini kaydet',
    short: 'Seçim hemen geçerli olur.',
  },
  'email_routing.webhooks': {
    kind: 'field',
    title: 'Bildirim adresleri',
    short:
      'Sağlayıcının geri dönen, şikâyet ve çıkma bildirimlerini göndereceği adres. SendGrid için imzalı olay bildirimi açılmalı ve doğrulama anahtarı girilmeli; Amazon SES için SNS konusu girilmeli.',
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#saglayici-bildirimleri',
  },
  'email_routing.rotate': {
    kind: 'action',
    title: 'Adresleri yenile',
    short: 'Adres sızdığından şüpheleniyorsanız kullanın; eski adresler hemen geçersiz olur.',
    whenToUse:
      'E-posta sağlayıcınızın bildirim (teslim/geri dönme) adresinin başkalarının eline geçtiğinden şüphelendiğinizde.',
    dataChanged:
      'Bildirim adresindeki gizli jeton yenilenir; eski adres hemen çalışmaz. İşlem denetim kaydına yazılır.',
    requiredPermission: 'Entegrasyon bilgilerini girme ve test etme (hassas; iki adımlı doğrulama).',
    reversible:
      'Hayır, eski adres geri gelmez; yeni adresi e-posta sağlayıcınızın panelinde güncellemeniz gerekir.',
    commonErrors: [
      {
        problem: '"Bu işlem için doğrulama kodunuzu yeniden girmeniz gerekiyor"',
        solution: 'Hassas işlemdir; doğrulama uygulamanızdaki kodu girip tekrar deneyin.',
      },
      {
        problem: 'Yenilemeden sonra geri dönen e-posta ve çıkma bildirimleri gelmiyor',
        solution: 'Yeni bildirim adresini e-posta sağlayıcınızın panelinde güncelleyin.',
      },
    ],
  },
  'page.email_templates': {
    kind: 'page',
    title: 'E-posta şablonları',
    short: 'Bülten ve kampanya e-postalarının blok tabanlı şablonları.',
    whatItDoes:
      'Pazarlama e-postalarının içeriğini bloklarla (başlık, metin, görsel, düğme, ürün kartları, ayırıcı, boşluk, sepet, sipariş) hazırlarsınız. Renkler ve logo mağazanın yayındaki temasından, alt bilgideki unvan, adres, MERSİS ve çıkma bağlantısı işletme ayarlarından kendiliğinden gelir.',
    whenToUse:
      'Bir bülten veya kampanya e-postası hazırlarken; aynı tasarımı başka dilde kullanmak için çeviri eklerken.',
    dataChanged: 'Yalnızca şablon kaydı değişir. Bu ekrandan müşterilere e-posta gönderilmez.',
    requiredPermission:
      'Görüntüleme: Kampanyaları görüntüleme. Oluşturma, değiştirme, test gönderimi: Kampanya hazırlama. Sağlık beyanı onayı: Uzman (veteriner) onayı verme.',
    reversible: 'Şablon değiştirilebilir ve silinebilir; silmek gönderilmiş e-postaları etkilemez.',
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#sablonlar',
  },
  'page.email_template_editor': {
    kind: 'page',
    title: 'E-posta şablonu',
    short: 'Blokları ekleyin, sıralayın; önizleyin ve kendinize test gönderin.',
    whatItDoes:
      'Soldaki bloklar sağdaki önizlemede e-posta istemcilerine uygun tablo tabanlı HTML olarak görünür; düz metin sürümü de üretilir. Önizlemede kişisel alanların yerine [Ad] gibi yer tutucular, ürün bloklarında mağazanın gerçek ürünleri görünür.',
    whenToUse:
      'Şablonun içeriğini hazırlarken ve göndermeden önce farklı ekranlarda nasıl görüneceğini denetlerken.',
    dataChanged:
      'Kaydet yalnızca şablonu değiştirir. Test gönderimi yalnızca işletmenin panel kullanıcılarına gider ve denetim kaydına yazılır.',
    requiredPermission:
      'Değiştirme ve test: Kampanya hazırlama. Görüntüleme: Kampanyaları görüntüleme. Sağlık beyanı onayı: Uzman (veteriner) onayı verme.',
    reversible: 'Şablon her zaman değiştirilebilir. Gönderilmiş test e-postası geri alınamaz.',
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#sablonlar',
  },
  'email_templates.create': {
    kind: 'action',
    title: 'Yeni şablon',
    short: 'Seçili mağaza ve dilde boş bir şablon açar; ilk kayıtta oluşturulur.',
  },
  'email_templates.save': {
    kind: 'action',
    title: 'Kaydet',
    short:
      'Şablonu kaydeder. İçerik değişince sağlık beyanı yeniden denetlenir; bulgu varsa uzman onayı yeniden gerekir.',
  },
  'email_templates.name': {
    kind: 'field',
    title: 'Şablon adı',
    short: 'Kampanya seçerken göreceğiniz ad; alıcılar görmez.',
  },
  'email_templates.subject': {
    kind: 'field',
    title: 'Konu',
    short: 'Gelen kutusunda görünen konu (en çok 200 karakter). Kişiselleştirme alanları kullanılabilir.',
  },
  'email_templates.preheader': {
    kind: 'field',
    title: 'Ön metin',
    short:
      'Birçok e-posta uygulaması konunun yanında bu metni gösterir. Konuyu tamamlayan kısa bir cümle yazın.',
  },
  'email_templates.merge_fields': {
    kind: 'field',
    title: 'Kişiselleştirme alanları',
    short:
      'Konu, ön metin, başlık, metin ve düğme yazısında kullanılır. Alıcıda değer yoksa dikey çizgiden sonraki metin yazılır (ör. ad yoksa "dostumuz").',
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#sablonlar',
  },
  'email_templates.blocks': {
    kind: 'field',
    title: 'İçerik blokları',
    short: 'En çok 40 blok. Eksik görünen bloklar önizlemeye girmez ve kaydı engeller.',
  },
  'email_templates.move': {
    kind: 'action',
    title: 'Sıralama',
    short:
      'Bloğu tutamağından sürükleyip bırakın ya da ok düğmeleriyle bir yukarı/aşağı taşıyın; çöp kutusu bloğu kaldırır.',
  },
  'email_templates.add_block': {
    kind: 'action',
    title: 'Blok ekle',
    short: 'Seçilen bloğu şablonun sonuna ekler; sonra istediğiniz yere taşıyabilirsiniz.',
  },
  'email_templates.delete': {
    kind: 'action',
    title: 'Sil',
    short: 'Şablonu siler. Başka dillerdeki sürümleri ve gönderilmiş e-postalar etkilenmez.',
  },
  'email_templates.align': {
    kind: 'field',
    title: 'Hizalama',
    short: 'Yazının veya düğmenin sola ya da ortaya hizalanması.',
  },
  'email_templates.heading': { kind: 'field', title: 'Başlık', short: 'En çok 200 karakter.' },
  'email_templates.level': {
    kind: 'field',
    title: 'Boyut',
    short: 'Büyük başlık e-postanın ana başlığıdır; bölümler için ara başlık kullanın.',
  },
  'email_templates.text': {
    kind: 'field',
    title: 'Metin',
    short: 'Düz yazı; HTML kodu yazı olarak görünür. Boş satır paragraf, **iki yıldız** kalın yazı.',
  },
  'email_templates.image': {
    kind: 'action',
    title: 'Görsel',
    short:
      'PNG, JPEG, WebP veya GIF; sunucuda yeniden kodlanır. E-posta uygulamaları büyük görselleri yavaş yükler; 1200 piksel genişlik yeterlidir.',
  },
  'email_templates.image_alt': {
    kind: 'field',
    title: 'Görsel açıklaması',
    short:
      'Birçok e-posta uygulaması görselleri başta göstermez; açıklama yerinde görünür. Bağlantılı görselde zorunlu.',
  },
  'email_templates.link': {
    kind: 'field',
    title: 'Bağlantı',
    short:
      'Mağaza içi yol (/kampanya) mağaza adresine tamamlanır ya da http(s) ile başlayan tam adres yazılır. Diğer adres türleri kabul edilmez.',
  },
  'email_templates.width': {
    kind: 'field',
    title: 'Genişlik',
    short: 'Tam genişlik veya ortada yarım genişlik.',
  },
  'email_templates.button_label': {
    kind: 'field',
    title: 'Düğme yazısı',
    short: 'Kısa ve ne olacağını söyleyen bir yazı (ör. "Ürünleri incele").',
  },
  'email_templates.products_source': {
    kind: 'field',
    title: 'Ürün kaynağı',
    short: 'En yeni ürünler, bir koleksiyon, bir kategori veya elle seçilen ürünler (en çok 12).',
  },
  'email_templates.columns': {
    kind: 'field',
    title: 'Sütun',
    short: 'Masaüstünde yan yana kart sayısı; telefonda kartlar küçülerek aynı düzende kalır.',
  },
  'email_templates.limit': {
    kind: 'field',
    title: 'Ürün sayısı',
    short: 'Kaynaktan en çok kaç ürün gösterileceği (1–12).',
  },
  'email_templates.collection': {
    kind: 'field',
    title: 'Koleksiyon',
    short: 'Koleksiyonun kurallarına uyan ürünler ada göre sıralanır.',
  },
  'email_templates.category': {
    kind: 'field',
    title: 'Kategori',
    short: 'Kategorideki ürünler ada göre sıralanır.',
  },
  'email_templates.products_pick': {
    kind: 'field',
    title: 'Ürünler',
    short: 'Ad, SKU veya barkodla arayın; seçim sırası e-postadaki sıradır. Yayında olmayan ürün görünmez.',
  },
  'email_templates.show_price': {
    kind: 'field',
    title: 'Fiyatı göster',
    short: 'Varsayılan pazarın vergi dahil en düşük varyant fiyatı. Fiyat, gönderim anındaki fiyattır.',
  },
  'email_templates.spacer': { kind: 'field', title: 'Boşluk', short: 'Bloklar arasına dikey boşluk ekler.' },
  'email_templates.cart': {
    kind: 'field',
    title: 'Sepet bloğu',
    short: 'Sepet hatırlatma otomasyonunda müşterinin sepetiyle dolar. Kampanyada açıklama metni görünür.',
  },
  'email_templates.order': {
    kind: 'field',
    title: 'Sipariş bloğu',
    short: 'Sipariş sonrası otomasyonlarda siparişin ürünleriyle dolar. Kampanyada açıklama metni görünür.',
  },
  'email_templates.quote': {
    kind: 'field',
    title: 'Teklif bloğu',
    short:
      'Bayi teklif takibi otomasyonunda bayiye gönderilen teklif sürümünün ürünleri, toplamı ve geçerlilik tarihiyle dolar. Kampanyada açıklama metni görünür.',
  },
  'email_templates.preview': {
    kind: 'field',
    title: 'Önizleme',
    short:
      'Yazdıkça yarım saniye içinde güncellenir. Kişisel alanlar yer tutucudur; ürünler, fiyatlar, logo ve renkler gerçektir. Bağlantılar yeni sekmede açılır.',
  },
  'email_templates.device': {
    kind: 'field',
    title: 'Ekran ve biçim',
    short:
      'Masaüstü (600 piksel) ve telefon (375 piksel) görünümü; "Düz metin" HTML göstermeyen uygulamalara giden sürümdür.',
  },
  'email_templates.test_send': {
    kind: 'action',
    title: 'Test gönder',
    short:
      'Kaydedilmiş hâli yalnızca işletmenizin panel kullanıcılarına "[Test]" konusuyla gönderir. Dakikada en çok 10 test.',
  },
  'email_templates.test_to': {
    kind: 'field',
    title: 'Alıcılar',
    short: 'Panel kullanıcılarının e-postaları (en çok 5). Müşteri adresine test gönderilemez.',
  },
  'page.campaigns': {
    kind: 'page',
    title: 'E-posta kampanyaları',
    short: 'Şablonu seçilen kitleye gönderin; ilerlemeyi ve sonuçları izleyin.',
    whatItDoes:
      'Bir e-posta şablonunu segmentlerdeki müşterilere ve/veya bülten abonelerine gönderir. Gönderim arka planda, belirlediğiniz hızla yapılır; her alıcı gönderim anında engel listesi, izin ve İYS bakımından yeniden denetlenir. Raporda gönderilen, teslim, geri dönen, tıklama, çıkma, şikâyet ve kampanya bağlantısından gelen siparişler görünür.',
    whenToUse: 'Bülten, duyuru veya kampanya e-postası göndermek ve sonucunu ölçmek için.',
    dataChanged:
      'Gönder: alıcılara gerçek e-posta gider (geri alınamaz). Alıcı kayıtları (adres, teslim, tıklama) 180 gün saklanır, sonra silinir; toplamlar kalır.',
    requiredPermission:
      'Görüntüleme: Kampanyaları görüntüleme. Taslak: Kampanya hazırlama. Gönderme, zamanlama, durdurma: Kampanya gönderme (son 15 dakikada iki adımlı doğrulama ister).',
    reversible:
      'Gönderim durdurulabilir; gönderilmiş e-postalar geri alınamaz. Gönderimi başlamış kampanya silinmez.',
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#kampanyalar',
  },
  'page.campaign_editor': {
    kind: 'page',
    title: 'E-posta kampanyası',
    short: 'Şablon, konu, kitle, A/B testi ve hız; gönderim, ilerleme ve rapor.',
    whatItDoes:
      'Taslakta içerik, kitle ve gönderim ayarlarını yaparsınız. "Gönder…" penceresi kaç kişiye gideceğini ve kimlerin neden çıkarıldığını gösterir. Gönderim başladıktan sonra ekran ilerlemeyi ve raporu kendiliğinden yeniler.',
    whenToUse: 'Kampanya hazırlarken, göndermeden önce alıcıları denetlerken ve sonuçları incelerken.',
    dataChanged:
      'Kaydet yalnızca taslağı değiştirir. Gönder/zamanla kampanyayı sıraya alır; worker gönderir ve her adımı denetim kaydına yazar.',
    requiredPermission:
      'Taslak: Kampanya hazırlama. Gönderme ve durdurma: Kampanya gönderme (iki adımlı doğrulama).',
    reversible: 'Taslak her zaman değiştirilebilir. Gönderilmiş e-posta geri alınamaz.',
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#kampanyalar',
  },
  'campaigns.create': {
    kind: 'action',
    title: 'Yeni kampanya',
    short: 'Seçili mağaza için taslak kampanya açar.',
  },
  'campaigns.save': {
    kind: 'action',
    title: 'Kaydet',
    short: 'Taslağı kaydeder; hiçbir e-posta gönderilmez.',
  },
  'campaigns.name': {
    kind: 'field',
    title: 'Kampanya adı',
    short: 'Raporlarda ve bağlantılardaki kampanya kodunda kullanılır.',
  },
  'campaigns.template': {
    kind: 'field',
    title: 'E-posta şablonu',
    short:
      'Ana şablon. Aynı şablonun başka dillerdeki sürümleri, o dildeki alıcılara kendiliğinden gönderilir (uzman onayı gerekiyorsa onaylı olmalı).',
  },
  'campaigns.subject': {
    kind: 'field',
    title: 'Konu',
    short:
      'Şablonun konusunu bu kampanya için değiştirir (yalnızca ana dildeki alıcılarda). Kişiselleştirme alanları kullanılabilir.',
  },
  'campaigns.preheader': {
    kind: 'field',
    title: 'Ön metin',
    short: 'Şablonun ön metnini bu kampanya için değiştirir.',
  },
  'campaigns.audience': {
    kind: 'field',
    title: 'Kitle',
    short:
      'Segmentler gönderim başladığı anki kurallarla hesaplanır. Bayi firması üyelerine (tacir) izin gerekmez; İYS reddi yine geçerlidir.',
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#kampanyalar',
  },
  'campaigns.subscribers': {
    kind: 'field',
    title: 'Bülten aboneleri',
    short: 'Bu mağazanın vitrinde abone olup onay bağlantısına tıklamış ziyaretçileri.',
  },
  'campaigns.estimate': {
    kind: 'action',
    title: 'Alıcıları hesapla',
    short: 'Kaç kişiye gönderilebileceğini ve kimin neden çıkarıldığını gösterir; kişi listesi göstermez.',
  },
  'campaigns.ab': {
    kind: 'field',
    title: 'A/B testi',
    short:
      'Test grubu iki eşit parçaya ayrılır, A ve B konusu gider. Süre sonunda tıklama oranı yüksek konu kalanlara gider; eşitlikte A. En az 100 alıcı gerekir.',
  },
  'campaigns.subject_b': {
    kind: 'field',
    title: 'B konusu',
    short: 'A konusu kampanyanın (veya şablonun) konusudur.',
  },
  'campaigns.ab_percent': {
    kind: 'field',
    title: 'Test grubu',
    short: 'Alıcıların yüzde kaçının teste gireceği (%10–50).',
  },
  'campaigns.ab_wait': {
    kind: 'field',
    title: 'Bekleme süresi',
    short: 'Test grubuna gönderim bittikten sonra kazananı seçmek için beklenen süre.',
  },
  'campaigns.rate': {
    kind: 'field',
    title: 'Gönderim hızı',
    short: 'Dakikada en çok kaç e-posta gideceği (10–3000). Sağlayıcınızın sınırını aşmayın.',
  },
  'campaigns.delete': {
    kind: 'action',
    title: 'Sil',
    short: 'Yalnızca taslak (veya gönderimi başlamadan durdurulan) kampanya silinir.',
  },
  'campaigns.send': {
    kind: 'action',
    title: 'Gönder',
    short:
      'Kaç kişiye gideceğini gösterir, onayla kampanyayı hemen veya ileri bir tarihte gönderir. Şablon onaylı ve e-posta altyapısı kurulu olmalı.',
    whenToUse:
      'Kampanya taslağını, şablonunu ve alıcı kitlesini kontrol edip "Alıcıları hesapla" ile kaç kişiye gideceğini gördükten sonra.',
    dataChanged:
      'Kampanya "zamanlandı" durumuna geçer ve gönderim sırasına girer; e-postaları arka plan işi seçtiğiniz zamanda gönderir. Engel listesi, izin ve İYS denetiminden geçen alıcılar listelenir; işlem denetim kaydına yazılır.',
    requiredPermission: 'Kampanya gönderme (hassas; iki adımlı doğrulama).',
    reversible:
      'Kısmen: gönderim başlamadan veya sürerken "Gönderimi durdur" ile kalan alıcılar iptal edilir; gönderilmiş e-postalar geri alınamaz.',
    commonErrors: [
      {
        problem: '"E-posta gönderimi kurulu değil"',
        solution: 'Entegrasyonlar ekranından SMTP veya bir e-posta sağlayıcısı bağlayın.',
      },
      {
        problem: '"Şablonda sağlık beyanı var ve uzman onayı bekliyor"',
        solution: 'Veteriner Uzman İnceleyici şablonu onaylamadan gönderim yapılamaz.',
      },
      {
        problem: '"Bu kitlede gönderilebilir kimse yok"',
        solution:
          "Segment seçimini genişletin; izin vermemiş, engellenmiş veya İYS'de bildirilmemiş kişilere gönderilmez.",
      },
    ],
  },
  'campaigns.scheduled_at': {
    kind: 'field',
    title: 'Gönderim zamanı',
    short: 'En çok 90 gün ileri; Türkiye saati.',
  },
  'campaigns.status': {
    kind: 'field',
    title: 'Gönderim durumu',
    short: 'Ekran 5 saniyede bir yenilenir. Duraklatılan gönderim nedenini ve yapılacak işi gösterir.',
  },
  'campaigns.resume': {
    kind: 'action',
    title: 'Sürdür',
    short: 'Sorun giderildikten sonra gönderilmemiş alıcılara gönderime devam eder.',
    whenToUse:
      'Kampanya bir sorun yüzünden (ör. e-posta altyapısı yoktu, sağlayıcı anahtarı reddedildi) duraklatıldıysa ve sorunu giderdiyseniz.',
    dataChanged:
      'Duraklatılmış kampanya yeniden "gönderiliyor" (hiç başlamadıysa "zamanlandı") olur; yalnızca henüz gönderilmemiş alıcılara gönderilir. İşlem denetim kaydına yazılır.',
    requiredPermission: 'Kampanya gönderme (hassas; iki adımlı doğrulama).',
    reversible:
      'Kısmen: "Gönderimi durdur" ile kalan alıcılar iptal edilebilir; gönderilen e-postalar geri alınamaz.',
    commonErrors: [
      {
        problem: '"Kampanya duraklatılmış değil"',
        solution: 'Yalnızca duraklatılmış kampanya sürdürülür; durumunu sayfada kontrol edin.',
      },
      {
        problem: '"E-posta gönderimi kurulu değil"',
        solution: 'Önce Entegrasyonlar ekranından e-posta altyapısını bağlayın.',
      },
    ],
  },
  'campaigns.cancel': {
    kind: 'action',
    title: 'Gönderimi durdur',
    short: 'Henüz gönderilmemiş alıcılara gönderilmez; gönderilenler geri alınamaz.',
    whenToUse:
      'Zamanlanmış veya süren bir e-posta kampanyasında hata fark ettiğinizde (yanlış şablon, yanlış kitle, yanlış tarih).',
    dataChanged:
      'Kampanya "durduruldu" olur; henüz gönderilmemiş ve bekleyen alıcılar "iptal" işaretlenir. İptal edilen alıcı sayısı denetim kaydına yazılır.',
    requiredPermission: 'Kampanya gönderme (hassas; iki adımlı doğrulama).',
    reversible:
      'Hayır, durdurulan kampanya sürdürülemez; gerekirse yeni kampanya hazırlanır. Hiç başlamamışsa taslak gibi silinebilir.',
    commonErrors: [
      {
        problem: '"Bu kampanyanın gönderimi zaten bitti veya durduruldu"',
        solution: 'Sayfayı yenileyin; kampanyanın durumu değişmiş.',
      },
    ],
  },
  'campaigns.report': {
    kind: 'field',
    title: 'Rapor',
    short:
      'Tıklama, e-postadaki bağlantının mağaza adresindeki ölçüm adresinden geçmesiyle sayılır (bazı e-posta güvenlik yazılımları bağlantıları önceden açabilir). Açılma ölçülmez.',
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#kampanya-raporu',
  },
  'page.automations': {
    kind: 'page',
    title: 'Pazarlama otomasyonları',
    short: 'Olaylara göre kendiliğinden giden e-posta akışları ve gönderim kuralları.',
    whatItDoes:
      '9 hazır akışı (hoş geldin, sepet terk, ödeme bekleyen, satın alma sonrası, tekrar satın alma, geri kazanma, VIP, doğum günü, bayi karşılama) listeler; her birinin açık/kapalı durumunu ve son 30 gündeki sayılarını gösterir. Altta tüm akışlar için sıklık sınırı ve sessiz saatler ayarlanır.',
    whenToUse:
      'Hangi akışların çalıştığını görmek, bir akışı açmak veya gönderim kurallarını değiştirmek için.',
    dataChanged:
      'Bu ekranda yalnızca gönderim kuralları kaydedilir (denetim kaydına düşer). Akışlar kendi ekranlarında açılır.',
    requiredPermission:
      'Görüntüleme: Kampanyaları görüntüleme. Akışı açma/kapama ve kurallar: Otomasyon yönetimi (son 15 dakikada iki adımlı doğrulama ister).',
    reversible: 'Kurallar her zaman değiştirilebilir; gönderilmiş e-posta geri alınamaz.',
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#otomasyonlar',
  },
  'page.automation_editor': {
    kind: 'page',
    title: 'Otomasyon akışı',
    short: 'Akışı açın/kapatın; tetikleyici süresi, adımlar ve şablonlar; rapor.',
    whatItDoes:
      'Akışın hangi olayla başlayacağını (ör. sepetteki son değişiklikten kaç saat sonra), adımlarını (bekle, koşul, e-posta) ve her e-posta adımının şablonunu belirlersiniz. Akış açıkken her e-postadan önce izin, engel listesi, İYS, sıklık sınırı ve sessiz saat denetlenir. Rapor akışa girenleri, çıkış nedenlerini ve gönderimleri gösterir.',
    whenToUse: 'Bir akışı ilk kez kurarken, adımlarını değiştirirken veya sonuçlarına bakarken.',
    dataChanged:
      'Kaydet akışı değiştirir ve denetim kaydına yazar. Açınca bundan sonraki olaylar akışa girer ve kişilere gerçek e-posta gider. Kapatınca veya adımlar değişince akışta bekleyen kişiler akıştan çıkar.',
    requiredPermission:
      'Değiştirme: Otomasyon yönetimi (iki adımlı doğrulama). Görüntüleme: Kampanyaları görüntüleme.',
    reversible: 'Akış her zaman kapatılabilir; gönderilmiş e-posta geri alınamaz.',
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#otomasyonlar',
  },
  'automations.settings': {
    kind: 'field',
    title: 'Gönderim kuralları',
    short: 'Tüm otomasyon akışları için sıklık sınırı ve sessiz saatler.',
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#otomasyon-kurallari',
  },
  'automations.frequency_cap': {
    kind: 'field',
    title: 'Sıklık sınırı',
    short:
      'Kişi bu süre içinde bir kampanya veya başka bir akıştan e-posta aldıysa otomasyon e-postası atlanır (raporda "Sıklık sınırı"). Varsayılan 24 saat.',
  },
  'automations.quiet_hours': {
    kind: 'field',
    title: 'Sessiz saatler',
    short:
      'Türkiye saatiyle bu aralıkta otomasyon e-postası gönderilmez; bekleyen e-posta bitiş saatinde gider. Varsayılan 21:00–09:00.',
  },
  'automations.settings_save': {
    kind: 'action',
    title: 'Kuralları kaydet',
    short: 'Sıklık sınırı ve sessiz saatleri kaydeder; bir sonraki gönderimden itibaren geçerlidir.',
  },
  'automations.save': {
    kind: 'action',
    title: 'Kaydet',
    short:
      'Akışı kaydeder. Akışı açıyorsanız onay ister; açılınca bundan sonraki olaylar akışa girer (geçmiş olaylar için e-posta gitmez).',
    whenToUse:
      'Hazır otomatik e-posta akışını (ör. sepet hatırlatma, hoş geldin) düzenlediğinizde, açtığınızda veya kapattığınızda.',
    dataChanged:
      'Akışın adımları ve açık/kapalı durumu kaydedilir; açılınca bu andan sonraki olaylar akışa girer ve müşterilere e-posta gider. Kapatınca veya adımlar değişince süren kayıtlar akıştan çıkar; işlem denetim kaydına yazılır.',
    requiredPermission: 'Otomasyon yönetimi (hassas; iki adımlı doğrulama).',
    reversible:
      'Kısmen: akış yeniden kapatılabilir veya eski adımlarına döndürülebilir; gönderilmiş e-postalar geri alınamaz.',
    commonErrors: [
      {
        problem: '"Akışı açmak için bu e-posta adımına bir şablon seçin"',
        solution: 'Her e-posta adımına bu mağazanın onaylı bir şablonunu seçin.',
      },
      {
        problem: '"Akış bekleme adımıyla bitemez"',
        solution: 'Son bekleme adımını silin veya ardına bir e-posta adımı ekleyin.',
      },
      {
        problem: '"E-posta gönderimi kurulu değil"',
        solution: 'Akışı açmadan önce Entegrasyonlar ekranından e-posta altyapısını bağlayın.',
      },
    ],
  },
  'automations.enabled': {
    kind: 'field',
    title: 'Akış açık',
    short:
      'Açmak için her e-posta adımında şablon seçili olmalı ve e-posta altyapısı kurulu olmalı. Kapatınca akışta bekleyenler çıkar.',
  },
  'automations.trigger': {
    kind: 'field',
    title: 'Tetikleyici',
    short: 'Kişiyi akışa sokan olay. Her olay için bir kez kayıt açılır; tetikleyici dakikada bir taranır.',
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#otomasyonlar',
  },
  'automations.store': {
    kind: 'field',
    title: 'Mağaza',
    short:
      'E-postadaki marka, bağlantılar ve şablonlar bu mağazanındır. Sepet ve sipariş akışları yalnızca bu mağazadaki olaylarla tetiklenir.',
  },
  'automations.after_hours': {
    kind: 'field',
    title: 'Ne kadar sonra',
    short: 'Sepetteki son değişiklikten veya siparişin oluşturulmasından sonra beklenecek süre (1–72 saat).',
  },
  'automations.days': {
    kind: 'field',
    title: 'Gün',
    short:
      'Teslimattan, son siparişten veya teklifin gönderilmesinden sonra kaç gün geçince akışa girileceği (1–365).',
  },
  'automations.steps': {
    kind: 'field',
    title: 'Adımlar',
    short:
      'En çok 10 adım; en az bir e-posta olmalı ve akış beklemeyle bitemez. Bir e-posta 72 saat içinde gönderilemezse (ör. altyapı kurulu değil) kişi akıştan çıkar.',
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#otomasyonlar',
  },
  'automations.step_tools': {
    kind: 'action',
    title: 'Adımı taşı veya sil',
    short: 'Oklar adımın sırasını değiştirir, çöp kutusu adımı siler. Değişiklik "Kaydet" ile geçerli olur.',
  },
  'automations.add_step': {
    kind: 'action',
    title: 'Adım ekle',
    short: 'Akışın sonuna bekleme, koşul veya e-posta adımı ekler.',
  },
  'automations.reset': {
    kind: 'action',
    title: 'Varsayılan adımlara dön',
    short:
      'Adımları ve süreyi hazır akışın varsayılanına döndürür (şablon seçimleri boşalır). Kaydetmeden değişmez.',
  },
  'automations.report': {
    kind: 'field',
    title: 'Rapor',
    short:
      'Sipariş ve ciro, e-postadaki bağlantıya eklenen akış kodu (utm_campaign=oto-…) ile son temas kuralına göre sayılır. Kayıtlar 180 gün saklanır.',
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#otomasyon-raporu',
  },
  'page.product_alerts': {
    kind: 'page',
    title: 'Stok ve fiyat bildirimleri',
    short: '"Gelince haber ver" talepleri ve favorilerde fiyat düşüşü e-postası.',
    whatItDoes:
      'Vitrinde stoksuz ürüne bırakılan "Gelince haber ver" taleplerini varyant başına listeler (bekleyen, bildirilen, güncel stok). Stok gelince bekleyenlere talep sırasıyla bir kez e-posta gider. Ayrıca favorideki ürünün fiyatı düşünce pazarlama izni olan müşterilere günlük bildirim açılabilir.',
    whenToUse:
      'Stoğu biten ürünlere ilgiyi görmek, tedarik önceliğini belirlemek ve bildirimleri açıp kapatmak için.',
    dataChanged:
      'Ayarlar ve iptal denetim kaydına düşer. Açık olduğunda kişilere gerçek e-posta gider (stok bildirimi tek seferlik; fiyat düşüşü pazarlama iletisi).',
    requiredPermission:
      'Görüntüleme: Kampanyaları görüntüleme. Ayarlar ve iptal: Otomasyon yönetimi (iki adımlı doğrulama).',
    reversible: 'Ayarlar her zaman değiştirilebilir; gönderilmiş e-posta geri alınamaz.',
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#stok-ve-fiyat-bildirimleri',
  },
  'product_alerts.settings': {
    kind: 'field',
    title: 'Ayarlar',
    short: 'İkisi de varsayılan kapalı; açmak için e-posta altyapısı gerekir.',
  },
  'product_alerts.stock_toggle': {
    kind: 'field',
    title: 'Vitrinde "Gelince haber ver"',
    short:
      'Stoksuz seçenekte e-posta formu gösterir. Form ayrıca KVKK aydınlatma metni yayımdayken görünür. Kapatırsanız bekleyen taleplere bildirim gitmez.',
    guideUrl: 'docs/EMAIL_MARKETING_TR.md#stok-ve-fiyat-bildirimleri',
  },
  'product_alerts.price_drop': {
    kind: 'field',
    title: 'Fiyat düşüşü bildirimi',
    short:
      'Günde bir (10:05), favorideki ürünün müşteriye görünen fiyatı en düşük fiyattan belirtilen oranda düştüyse e-posta. İzin, İYS ve sıklık sınırı uygulanır.',
  },
  'product_alerts.store': {
    kind: 'field',
    title: 'Mağaza',
    short: 'Fiyatlar, ürün kartları, marka ve bağlantılar bu mağazadan alınır.',
  },
  'product_alerts.min_percent': {
    kind: 'field',
    title: 'En az düşüş',
    short:
      'Ör. %10: favoriye eklendiğinden (veya son bildirimden) beri görülen en düşük fiyattan en az %10 düşük.',
  },
  'product_alerts.save': {
    kind: 'action',
    title: 'Kaydet',
    short: 'Ayarları kaydeder; bir bildirimi açıyorsanız onay ister.',
    whenToUse:
      '"Stoğa gelince haber ver" veya "fiyat düşünce haber ver" e-postalarını açmak, kapatmak ya da ayarlarını değiştirmek istediğinizde.',
    dataChanged:
      'Ürün bildirimi ayarları kaydedilir; açık bildirimler için talep bırakan müşterilere koşul oluşunca e-posta gider. Değişiklik denetim kaydına yazılır.',
    requiredPermission: 'Otomasyon yönetimi (hassas; iki adımlı doğrulama).',
    reversible: 'Evet, bildirim yeniden kapatılabilir; gönderilmiş e-postalar geri alınamaz.',
    commonErrors: [
      {
        problem: '"E-posta gönderimi kurulu değil"',
        solution: 'Bildirimi açmadan önce Entegrasyonlar ekranından e-posta altyapısını bağlayın.',
      },
      {
        problem: '"Fiyat düşüşü bildirimi için … mağazayı seçin"',
        solution: 'Fiyat düşüşü bildirimi açıkken fiyatların alınacağı mağazayı seçin.',
      },
    ],
  },
  'product_alerts.requests': {
    kind: 'field',
    title: 'Talepler',
    short:
      'Bekleyen talep sayısı, stoğu biten ürüne olan ilgiyi gösterir. Stok gelince bir turda stok adedinin 3 katı (en az 5) kişiye bildirilir.',
  },
  'product_alerts.view': {
    kind: 'action',
    title: 'Talepler',
    short: 'Varyantın taleplerini sırasıyla gösterir (adres kişisel veri yetkisi yoksa maskeli).',
  },
  'product_alerts.cancel': {
    kind: 'action',
    title: 'İptal et',
    short: 'Talep kapanır, kişiye e-posta gitmez.',
  },
  'page.message_campaigns': {
    kind: 'page',
    title: 'SMS ve WhatsApp',
    short: 'SMS ve WhatsApp kampanyaları, kurulum durumu ve gönderim ayarları.',
    whatItDoes:
      "Segmentlerdeki müşterilere SMS (bağlı Netgsm, İleti Merkezi veya Verimor hesabıyla) ya da Meta'da onaylı WhatsApp şablonu gönderir. Kurulum bölümü eksikleri (sağlayıcı, MERSİS, ret metni, WhatsApp bağlantısı) gösterir. Her alıcı gönderim anında izin, engel listesi ve İYS bakımından yeniden denetlenir; sıklık sınırı ve sessiz saate uyulur.",
    whenToUse:
      'Kampanya duyurusunu SMS veya WhatsApp ile iletmek, gönderim ayarlarını yapmak ve sonuçları görmek için.',
    dataChanged:
      'Ayarlar denetim kaydına düşer. Gönderimde gerçek kişilere ücretli ileti gider (geri alınamaz). Alıcı kayıtları (telefon, durum) 180 gün saklanır, sonra silinir; toplamlar kalır.',
    requiredPermission:
      'Görüntüleme: Kampanyaları görüntüleme. Taslak: Kampanya hazırlama. Gönderme ve durdurma: Kampanya gönderme. Ayarlar: Otomasyon yönetimi (iki adımlı doğrulama).',
    reversible:
      'Ayarlar ve taslaklar değiştirilebilir. Gönderim durdurulabilir; gönderilmiş ileti geri alınamaz.',
    guideUrl: 'docs/MESSAGING_TR.md#kampanyalar',
  },
  'page.message_campaign_editor': {
    kind: 'page',
    title: 'SMS/WhatsApp kampanyası',
    short: 'Kanal, şablon, kitle, tahmini maliyet; gönderim, ilerleme ve rapor.',
    whatItDoes:
      'Taslakta kanalı (SMS veya WhatsApp), şablonu ve segmentleri seçersiniz. "Alıcıları ve maliyeti hesapla" kaç kişiye gideceğini, kimlerin neden çıkarıldığını, SMS boyunu ve tahmini maliyeti gösterir. Gönderim başlayınca ekran ilerlemeyi ve raporu kendiliğinden yeniler.',
    whenToUse:
      'Kampanya hazırlarken, göndermeden önce alıcıları ve maliyeti denetlerken ve sonuçları incelerken.',
    dataChanged:
      'Kaydet yalnızca taslağı değiştirir. Gönder/zamanla kampanyayı sıraya alır; worker gönderir. Her adım denetim kaydına yazılır.',
    requiredPermission:
      'Taslak: Kampanya hazırlama. Gönderme, durdurma, sürdürme: Kampanya gönderme (son 15 dakikada iki adımlı doğrulama).',
    reversible: 'Taslak her zaman değiştirilebilir. Gönderilmiş SMS veya WhatsApp iletisi geri alınamaz.',
    guideUrl: 'docs/MESSAGING_TR.md#kampanyalar',
  },
  'page.sms_templates': {
    kind: 'page',
    title: 'SMS şablonları',
    short: 'Kampanyalarda kullanılan SMS metinleri ve uzman onay durumları.',
    whatItDoes:
      'SMS metinlerini listeler. Metin kişiye özel alan içerebilir (ad, ad soyad, mağaza adı). Sağlık beyanı içeren metin Veteriner Uzman İnceleyici onayı olmadan kampanyada gönderilmez.',
    whenToUse: 'Yeni SMS metni hazırlamak veya mevcut metinleri gözden geçirmek için.',
    dataChanged: 'Oluşturma, değiştirme ve silme denetim kaydına düşer. Şablon kaydetmek SMS göndermez.',
    requiredPermission:
      'Görüntüleme: Kampanyaları görüntüleme. Değiştirme: Kampanya hazırlama. Onay: Uzman incelemesi.',
    reversible: 'Şablon değiştirilebilir; bekleyen kampanyada kullanılan şablon silinmez.',
    guideUrl: 'docs/MESSAGING_TR.md#sms-sablonlari',
  },
  'page.sms_template_editor': {
    kind: 'page',
    title: 'SMS şablonu',
    short: 'Metin, kişiye özel alanlar, canlı boy hesabı ve uzman onayı.',
    whatItDoes:
      'Yazdıkça gönderilecek hâli (MERSİS ve ret metni eklenmiş) gösterir; karakter kümesini, karakter sayısını ve SMS boyunu hesaplar. Türkçe karakter bir boyu 150, emoji 65 karaktere düşürür. Olası sağlık beyanları işaretlenir.',
    whenToUse: 'SMS metnini yazarken ve maliyeti etkileyen boyu kontrol ederken.',
    dataChanged: 'Kaydet şablonu değiştirir; metin değişirse uzman onayı yenilenmelidir. SMS gönderilmez.',
    requiredPermission: 'Değiştirme: Kampanya hazırlama. Onay/ret: Uzman incelemesi.',
    reversible: 'Metin her zaman değiştirilebilir.',
    guideUrl: 'docs/MESSAGING_TR.md#sms-sablonlari',
  },
  'messaging.create': {
    kind: 'action',
    title: 'Yeni SMS/WhatsApp kampanyası',
    short: 'Taslak oluşturur; taslak kaydetmek ileti göndermez.',
  },
  'messaging.setup': {
    kind: 'field',
    title: 'Kurulum durumu',
    short:
      'Eksik olan kanal "Kurulum Gerekli" görünür ve o kanaldan gönderim sunucuda reddedilir. Sağlayıcı hesabı ve başlık onayı sizin tarafınızdan açılır.',
    guideUrl: 'docs/MESSAGING_TR.md#kurulum',
  },
  'messaging.settings': {
    kind: 'field',
    title: 'Ayarlar',
    short: 'Tüm SMS/WhatsApp kampanyaları için geçerlidir. Değiştirmek iki adımlı doğrulama ister.',
    guideUrl: 'docs/MESSAGING_TR.md#ayarlar',
  },
  'messaging.sms_provider': {
    kind: 'field',
    title: 'SMS sağlayıcısı',
    short: 'Kampanya SMS’leri bu hesaptan gider. Önce Entegrasyonlar ekranında bağlayıp testi geçirin.',
  },
  'messaging.opt_out': {
    kind: 'field',
    title: 'Ret metni',
    short:
      "Ticari SMS'te zorunlu: alıcı aynı kanaldan nasıl ret bildireceğini görmeli. Sağlayıcınızın ret numarasını veya İYS kısa numarasını yazın.",
    guideUrl: 'docs/MESSAGING_TR.md#ayarlar',
  },
  'messaging.unit_cost_sms': {
    kind: 'field',
    title: 'SMS boyu başına maliyet',
    short: 'Sağlayıcı fiyatınız (TL, KDV dahil önerilir). Yalnızca tahmini maliyet için kullanılır.',
  },
  'messaging.unit_cost_whatsapp': {
    kind: 'field',
    title: 'WhatsApp iletisi başına maliyet',
    short: 'Meta’nın pazarlama iletisi fiyatı (TL). Yalnızca tahmini maliyet için kullanılır.',
  },
  'messaging.frequency_cap': {
    kind: 'field',
    title: 'Sıklık sınırı',
    short: 'Aynı numaraya bu süre içinde ikinci kampanya iletisi gitmez; alıcı raporda "atlandı" görünür.',
  },
  'messaging.staging_phones': {
    kind: 'field',
    title: 'Staging test numaraları',
    short: 'Deneme sunucusunda yalnızca bu numaralara gönderilir; diğerleri "atlandı" sayılır.',
  },
  'messaging.settings_save': {
    kind: 'action',
    title: 'Ayarları kaydet',
    short: 'Ayarları kaydeder; zamanlanmış ve süren gönderimlere de uygulanır.',
  },
  'messaging.save': {
    kind: 'action',
    title: 'Kaydet',
    short: 'Taslağı kaydeder; ileti göndermez.',
  },
  'messaging.channel': {
    kind: 'field',
    title: 'Kanal',
    short:
      'SMS: kendi şablonunuz. WhatsApp: yalnızca Meta’da onaylı pazarlama şablonu. Kanal sonradan değişmez.',
  },
  'messaging.name': {
    kind: 'field',
    title: 'Kampanya adı',
    short: 'Panelde ve müşteri geçmişinde görünür; alıcıya gitmez.',
  },
  'messaging.sms_template': {
    kind: 'field',
    title: 'SMS şablonu',
    short: 'Sağlık beyanı olan şablon uzman onayından sonra gönderilebilir.',
  },
  'messaging.whatsapp_template': {
    kind: 'field',
    title: 'WhatsApp şablonu',
    short:
      "Meta'da onaylı şablonlar listelenir. Gönderimde şablonun hâlâ onaylı olduğu ve değişken sayısı yeniden denetlenir.",
    guideUrl: 'docs/MESSAGING_TR.md#whatsapp',
  },
  'messaging.whatsapp_params': {
    kind: 'field',
    title: 'Şablon değişkenleri',
    short: 'Şablondaki {{1}}, {{2}}… yerine geçen metinler. Sağlık beyanı içeremez.',
  },
  'messaging.segments': {
    kind: 'field',
    title: 'Kitle',
    short: 'Segment üyeleri gönderim anında yeniden hesaplanır. Aynı numaraya bir kez gider.',
    guideUrl: 'docs/MESSAGING_TR.md#izin-ve-iys',
  },
  'messaging.estimate': {
    kind: 'action',
    title: 'Alıcıları ve maliyeti hesapla',
    short: 'Gönderilebilir kişi, çıkarılanların nedenleri, SMS boyu ve tahmini maliyet. İleti gönderilmez.',
  },
  'messaging.delete': {
    kind: 'action',
    title: 'Sil',
    short: 'Taslağı veya hiç başlamamış durdurulan kampanyayı siler.',
  },
  'messaging.send': {
    kind: 'action',
    title: 'Gönder',
    short:
      'Alıcı sayısını ve maliyeti gösterir, onayla kampanyayı hemen veya ileri bir tarihte gönderir. Sağlayıcı bağlı, şablon kullanılabilir ve (SMS için) MERSİS ile ret metni tam olmalı.',
    whenToUse:
      'SMS veya WhatsApp kampanyasının şablonunu ve kitlesini kontrol edip "Alıcıları ve maliyeti hesapla" ile alıcı sayısını ve tahmini maliyeti gördükten sonra.',
    dataChanged:
      'Kampanya hesaplanan alıcı sayısı ve tahmini maliyetle "zamanlandı" durumuna geçer; iletileri arka plan işi gönderir ve sağlayıcınız ücretlendirir. İşlem denetim kaydına yazılır.',
    requiredPermission: 'Kampanya gönderme (hassas; iki adımlı doğrulama).',
    reversible:
      'Kısmen: "Durdur" ile gönderilmemiş alıcılar iptal edilir; gönderilmiş iletiler ve ücretleri geri alınamaz.',
    commonErrors: [
      {
        problem: '"SMS sağlayıcısı bağlı değil" veya "WhatsApp Business bağlı değil"',
        solution: "Entegrasyonlar'dan sağlayıcıyı bağlayıp SMS ve WhatsApp ayarlarından seçin.",
      },
      {
        problem: '"Ticari SMS\'te MERSİS numarası zorunlu" veya "ret metni zorunlu"',
        solution: "MERSİS'i İşletme bilgilerinden, ret metnini SMS ve WhatsApp ayarlarından girin.",
      },
      {
        problem: '"Bu WhatsApp şablonu Meta\'da bulunamadı veya onaylı değil"',
        solution: "Şablonun Meta'da onaylandığını kontrol edin ve şablonu yeniden seçin.",
      },
    ],
    guideUrl: 'docs/MESSAGING_TR.md#kampanyalar',
  },
  'messaging.scheduled_at': {
    kind: 'field',
    title: 'Gönderim zamanı',
    short: 'En çok 90 gün ileri; Türkiye saati. Sessiz saate denk gelirse sabah başlar.',
  },
  'messaging.status': {
    kind: 'field',
    title: 'Gönderim durumu',
    short: 'Ekran 5 saniyede bir yenilenir. Duraklatılan gönderim nedenini ve yapılacak işi gösterir.',
  },
  'messaging.resume': {
    kind: 'action',
    title: 'Sürdür',
    short: 'Sorun giderildikten sonra gönderilmemiş alıcılara devam eder.',
  },
  'messaging.cancel': {
    kind: 'action',
    title: 'Durdur',
    short: 'Gönderilmemiş alıcılar iptal edilir; gönderilmiş iletiler geri alınamaz.',
    whenToUse:
      'Zamanlanmış veya süren SMS/WhatsApp kampanyasını yanlış metin, kitle veya zaman nedeniyle hemen durdurmanız gerektiğinde.',
    dataChanged:
      'Kampanya "durduruldu" olur ve bekleyen alıcılar "iptal" işaretlenir; işlem denetim kaydına yazılır.',
    requiredPermission: 'Kampanya gönderme (hassas; iki adımlı doğrulama).',
    reversible: 'Hayır, durdurulan kampanya sürdürülemez; gerekirse yeni kampanya hazırlanır.',
    commonErrors: [
      {
        problem: '"Bu kampanyanın gönderimi zaten bitti veya durduruldu"',
        solution: 'Sayfayı yenileyin; kampanyanın durumu değişmiş.',
      },
    ],
  },
  'messaging.report': {
    kind: 'field',
    title: 'Rapor',
    short: 'Gönderilen, teslim, gönderilemeyen ve atlanan alıcılar; nedenleri ve tahmini maliyet.',
    guideUrl: 'docs/MESSAGING_TR.md#rapor',
  },
  'sms_templates.create': {
    kind: 'action',
    title: 'Yeni SMS şablonu',
    short: 'Boş bir şablon açar.',
  },
  'sms_templates.save': {
    kind: 'action',
    title: 'Kaydet',
    short: 'Şablonu kaydeder. Metin değişirse uzman onayı yeniden gerekir.',
  },
  'sms_templates.name': {
    kind: 'field',
    title: 'Şablon adı',
    short: 'Kampanya ekranında şablonu seçerken görünür.',
  },
  'sms_templates.body': {
    kind: 'field',
    title: 'Metin',
    short:
      'Kısa tutun: Türkçe karakterli bir SMS boyu 150 karakter. MERSİS ve ret metni gönderimde eklenir. Hastalık önleme veya tedavi iddiası kullanmayın.',
    guideUrl: 'docs/MESSAGING_TR.md#sms-sablonlari',
  },
  'sms_templates.fields': {
    kind: 'field',
    title: 'Kişiye özel alanlar',
    short:
      'İmlecin olduğu yere alan ekler. Değer boşsa alan boş kalır; {{alan|yedek}} biçimiyle yedek yazılabilir.',
  },
  'sms_templates.preview': {
    kind: 'field',
    title: 'Önizleme',
    short:
      'Örnek kişiyle gönderilecek metin, karakter kümesi ve boy. Uyarılar maliyeti ve gönderilebilirliği etkiler.',
  },
  'sms_templates.delete': {
    kind: 'action',
    title: 'Sil',
    short: 'Bekleyen bir kampanyada kullanılmıyorsa şablonu siler.',
  },
  'page.push': {
    kind: 'page',
    title: 'Anlık bildirimler',
    short: 'Tarayıcı bildirimi kampanyaları, vitrin düğmesi ve kurulum durumu.',
    whatItDoes:
      'Vitrinde "Bildirimleri aç" düğmesine basıp tarayıcı iznini veren ziyaretçilere kısa bildirim gönderir. Kurulum bölümü anahtarı, iletişim adresini, aydınlatma metnini ve Android uygulaması için Firebase bağlantısını gösterir. Bildirim içeriği uçtan uca şifrelenir; kimin bildirimi gördüğü ölçülmez.',
    whenToUse: 'Kampanya veya yeni ürün duyurusunu tarayıcı bildirimiyle iletmek için.',
    dataChanged:
      'Ayarlar ve anahtar işlemleri denetim kaydına düşer. Gönderimde gerçek kişilerin tarayıcısına bildirim gider (geri alınamaz). Alıcı kayıtları 180 gün saklanır; sona eren abonelikler 30 gün sonra silinir.',
    requiredPermission:
      'Görüntüleme: Kampanyaları görüntüleme. Taslak: Kampanya hazırlama. Gönderme: Kampanya gönderme. Kurulum: Otomasyon yönetimi (iki adımlı doğrulama).',
    reversible:
      'Ayarlar değiştirilebilir. Anahtar yenilenirse abonelikler geri gelmez. Gönderilmiş bildirim geri alınamaz.',
    guideUrl: 'docs/PUSH_NOTIFICATIONS_TR.md#kurulum',
  },
  'page.push_editor': {
    kind: 'page',
    title: 'Bildirim kampanyası',
    short: 'Başlık, metin, açılacak sayfa, kitle; önizleme, gönderim ve rapor.',
    whatItDoes:
      'Taslakta bildirimin başlığını, metnini ve tıklanınca açılacak mağaza sayfasını yazarsınız. Sağdaki önizleme yaklaşık görünümü gösterir; olası sağlık beyanları işaretlenir. Gönderim başlayınca ilerleme ve rapor kendiliğinden yenilenir.',
    whenToUse: 'Bildirim hazırlarken, göndermeden önce kitleyi kontrol ederken ve sonuçları incelerken.',
    dataChanged:
      'Kaydet yalnızca taslağı değiştirir. Gönder/zamanla kampanyayı sıraya alır; worker gönderir.',
    requiredPermission:
      'Taslak: Kampanya hazırlama. Gönderme ve durdurma: Kampanya gönderme (iki adımlı doğrulama). Onay: Uzman incelemesi.',
    reversible: 'Taslak her zaman değiştirilebilir. Gönderilmiş bildirim geri alınamaz.',
    guideUrl: 'docs/PUSH_NOTIFICATIONS_TR.md#kampanyalar',
  },
  'push.create': {
    kind: 'action',
    title: 'Yeni bildirim kampanyası',
    short: 'Taslak açar; taslak kaydetmek bildirim göndermez.',
  },
  'push.setup': {
    kind: 'field',
    title: 'Kurulum',
    short:
      'Eksik olan madde "Kurulum Gerekli" veya "Eksik" görünür; vitrin düğmesi hepsi tamamlanınca çıkar.',
    guideUrl: 'docs/PUSH_NOTIFICATIONS_TR.md#kurulum',
  },
  'push.create_key': {
    kind: 'action',
    title: 'Anahtar oluştur',
    short:
      'Sunucuda bir anahtar çifti üretir; özel anahtar şifreli saklanır, hiçbir yere gönderilmez. İki adımlı doğrulama ister.',
  },
  'push.replace_key': {
    kind: 'action',
    title: 'Anahtarı yenile',
    short:
      'Yalnızca anahtar ele geçirildiyse kullanın: tüm abonelikler sona erer, ziyaretçilerin bildirimleri yeniden açması gerekir.',
    whenToUse: 'Yalnızca vitrin bildirim anahtarının ele geçirildiğinden şüphelendiğinizde.',
    dataChanged:
      'Eski anahtar silinir ve yeni anahtar çifti üretilir (özel anahtar şifreli saklanır); bütün etkin abonelikler "sona erdi" olur. Sona eren abonelik sayısı denetim kaydına yazılır.',
    requiredPermission: 'Otomasyon yönetimi (hassas; iki adımlı doğrulama).',
    reversible:
      'Hayır, geri alınamaz: eski anahtar ve abonelikler geri gelmez; ziyaretçilerin bildirimleri yeniden açması gerekir.',
    commonErrors: [
      {
        problem: '"Bu işlem için doğrulama kodunuzu yeniden girmeniz gerekiyor"',
        solution: 'Doğrulama uygulamanızdaki kodu girip tekrar deneyin.',
      },
    ],
  },
  'push.contact': {
    kind: 'field',
    title: 'İletişim adresi',
    short:
      'mailto:destek@alanadi veya https://alanadi. Bildirim hizmetleri (ör. Apple) bu adresi zorunlu tutar.',
  },
  'push.enabled': {
    kind: 'field',
    title: 'Vitrin düğmesi',
    short:
      'Açıkken vitrinin alt bilgisinde düğme görünür; izin yalnızca ziyaretçi düğmeye basınca istenir. Varsayılan kapalı.',
    guideUrl: 'docs/PUSH_NOTIFICATIONS_TR.md#vitrin',
  },
  'push.settings_save': {
    kind: 'action',
    title: 'Kaydet',
    short: 'Ayarları kaydeder; açmak anahtar ve iletişim adresi ister.',
  },
  'push.save': { kind: 'action', title: 'Kaydet', short: 'Taslağı kaydeder; bildirim göndermez.' },
  'push.name': { kind: 'field', title: 'Kampanya adı', short: 'Panelde ve raporda görünür; alıcıya gitmez.' },
  'push.title': {
    kind: 'field',
    title: 'Başlık',
    short: 'Kısa tutun: tarayıcılar yaklaşık 50 karakterden sonrasını kesebilir.',
  },
  'push.body': {
    kind: 'field',
    title: 'Metin',
    short:
      'En çok 180 karakter. Hastalık önleme veya tedavi iddiası kullanmayın; sağlık beyanı uzman onayı ister.',
  },
  'push.url': {
    kind: 'field',
    title: 'Açılacak sayfa',
    short: 'Mağaza içi adres (/ ile başlar). Başka siteye bağlantı verilemez; UTM kendiliğinden eklenir.',
  },
  'push.audience': {
    kind: 'field',
    title: 'Kitle',
    short: 'Boşsa tüm aboneler. Segment seçilirse yalnızca abone olurken giriş yapmış üyeler.',
    guideUrl: 'docs/PUSH_NOTIFICATIONS_TR.md#kampanyalar',
  },
  'push.estimate': {
    kind: 'action',
    title: 'Kaç tarayıcıya gideceğini hesapla',
    short: 'Etkin aboneliklerden bu kampanyanın gideceği sayı. Bildirim gönderilmez.',
  },
  'push.preview': {
    kind: 'field',
    title: 'Önizleme',
    short: 'Yaklaşık görünüm; tarayıcı ve işletim sistemine göre değişir.',
  },
  'push.delete': {
    kind: 'action',
    title: 'Sil',
    short: 'Taslağı veya hiç başlamamış durdurulan kampanyayı siler.',
  },
  'push.send': {
    kind: 'action',
    title: 'Gönder',
    short:
      'Kaç tarayıcıya gideceğini gösterir; onayla hemen veya ileri bir tarihte gönderir. Vitrin bildirimleri kurulu olmalı.',
    whenToUse:
      'Vitrin bildirimi (tarayıcı bildirimi) kampanyasının metnini ve kitlesini kontrol edip kaç tarayıcıya gideceğini gördükten sonra.',
    dataChanged:
      'Kampanya "zamanlandı" durumuna geçer; bildirimleri arka plan işi etkin aboneliği olan tarayıcılara gönderir. İşlem denetim kaydına yazılır.',
    requiredPermission: 'Kampanya gönderme (hassas; iki adımlı doğrulama).',
    reversible:
      'Kısmen: "Durdur" ile gönderilmemiş tarayıcılar iptal edilir; gönderilmiş bildirimler geri alınamaz.',
    commonErrors: [
      {
        problem: '"Vitrin bildirimleri kurulu değil"',
        solution: 'Bildirim ayarlarında anahtar oluşturup ayarı açın.',
      },
      {
        problem: '"Bu kitlede gönderilebilir kimse yok"',
        solution: 'Seçilen segmentlerde bildirime izin vermiş tarayıcı yok; kitleyi genişletin.',
      },
      {
        problem: '"Gönderim zamanı şimdiden sonra ve en çok 90 gün ileride olmalı"',
        solution: 'Gönderim tarihini düzeltin.',
      },
    ],
    guideUrl: 'docs/PUSH_NOTIFICATIONS_TR.md#kampanyalar',
  },
  'push.scheduled_at': {
    kind: 'field',
    title: 'Gönderim zamanı',
    short: 'En çok 90 gün ileri; sessiz saatte sabahı bekler.',
  },
  'push.status': {
    kind: 'field',
    title: 'Gönderim durumu',
    short: 'Ekran 5 saniyede bir yenilenir. Duraklatılan gönderim nedenini ve yapılacak işi gösterir.',
  },
  'push.resume': {
    kind: 'action',
    title: 'Sürdür',
    short: 'Sorun giderildikten sonra gönderilmemiş tarayıcılara devam eder.',
  },
  'push.cancel': {
    kind: 'action',
    title: 'Durdur',
    short: 'Gönderilmemiş tarayıcılar iptal edilir.',
    whenToUse: 'Zamanlanmış veya süren bildirim kampanyasını hemen durdurmanız gerektiğinde.',
    dataChanged:
      'Kampanya "durduruldu" olur ve bekleyen gönderimler "iptal" işaretlenir; işlem denetim kaydına yazılır.',
    requiredPermission: 'Kampanya gönderme (hassas; iki adımlı doğrulama).',
    reversible: 'Hayır, durdurulan kampanya sürdürülemez; gönderilmiş bildirimler geri alınamaz.',
    commonErrors: [
      {
        problem: '"Bu kampanyanın gönderimi zaten bitti veya durduruldu"',
        solution: 'Sayfayı yenileyin; kampanyanın durumu değişmiş.',
      },
    ],
  },
  'push.report': {
    kind: 'field',
    title: 'Rapor',
    short:
      'Hizmetin kabul ettiği gönderimler, sona eren abonelikler, nedenler ve bildirim bağlantısından gelen siparişler.',
  },
  'notifications.section': {
    kind: 'field',
    title: 'Mobil bildirimler',
    short: 'Android yönetim uygulamasındaki bildirimler: cihazlarınız ve hangi olayların bildirileceği.',
    guideUrl: 'docs/PUSH_NOTIFICATIONS_TR.md#android',
  },
  'notifications.events': {
    kind: 'field',
    title: 'Bildirim gelecek olaylar',
    short: 'Yalnızca yetkiniz olan olaylar seçilebilir; mağaza kapsamınız dışındaki siparişler bildirilmez.',
  },
  'notifications.quiet_hours': {
    kind: 'field',
    title: 'Sessiz saat',
    short: 'Bu aralıkta (Türkiye saati) bildirim gelmez; kaçan bildirim sonradan gönderilmez.',
  },
  'notifications.save': {
    kind: 'action',
    title: 'Tercihleri kaydet',
    short: 'Yalnızca sizin bildirimlerinizi etkiler.',
  },
  'notifications.test': {
    kind: 'action',
    title: 'Deneme bildirimi',
    short: 'Kayıtlı cihazlarınıza bir deneme bildirimi gönderir (Firebase bağlı olmalı).',
  },
  'notifications.device_remove': {
    kind: 'action',
    title: 'Cihazı kaldır',
    short: 'Bu cihaza artık bildirim gönderilmez. Yalnızca sizin cihazlarınızı etkiler.',
    whenToUse: 'Telefonu değiştirdiğinizde, kaybettiğinizde veya o cihazda bildirim istemediğinizde.',
    dataChanged: 'Cihaz kaydı silinir; işlem denetim kaydına düşer.',
    requiredPermission: 'Ayrı yetki gerekmez; herkes yalnızca kendi cihazlarını kaldırabilir.',
    reversible:
      'Uygulama o cihazda yeniden açıldığında (uygulamada bildirimler kapatılmadıysa) cihaz kendiliğinden tekrar kaydolur.',
    commonErrors: [
      {
        problem: 'Cihaz bulunamadı',
        solution: 'Cihaz başka bir oturumda zaten kaldırılmış olabilir; sayfayı yenileyin.',
      },
    ],
    guideUrl: 'docs/PUSH_NOTIFICATIONS_TR.md#android',
  },
  'page.promotions': {
    kind: 'page',
    title: 'Otomatik indirimler',
    short: 'Kupon gerektirmeyen kampanyalar: ürün indirimi, sepet kademesi, X al Y öde, ücretsiz kargo.',
    whatItDoes:
      'Mağaza başına kampanyaları, durumlarını (taslak, yayında, duraklatıldı, sona erdi) ve kullanımlarını (sipariş sayısı, toplam indirim) listeler. Kampanya indirimi sepette ve ödeme adımında ayrı satır olarak görünür; ürün sayfasında kampanya adı ve koşulu yazar, üstü çizili fiyat gösterilmez.',
    whenToUse: 'Sezon indirimi, sepet tutarına göre indirim veya ücretsiz kargo kampanyası açarken.',
    dataChanged:
      'Kampanya oluşturma, değiştirme, yayına alma ve duraklatma denetim kaydına düşer. Yayındaki kampanya tüm uygun sepetlerin tutarını değiştirir.',
    requiredPermission:
      'Görüntüleme: Fiyatları görüntüleme. Oluşturma ve yayına alma: Fiyatları düzenleme (yayına almada iki adımlı doğrulama). Sağlık beyanı onayı: Uzman incelemesi.',
    reversible: 'Kampanya duraklatılabilir. Verilmiş siparişlerdeki indirim değişmez.',
    guideUrl: 'docs/PROMOTIONS_TR.md#turler',
  },
  'page.promotion_editor': {
    kind: 'page',
    title: 'Otomatik kampanya',
    short: 'Tür, kural, hedef ürünler, kitle, öncelik, birleşme ve tarih; müşterinin göreceği metin.',
    whatItDoes:
      'Taslakta kampanyanın türünü ve kuralını, hangi ürünlere ve kimlere uygulanacağını seçersiniz. Sağdaki önizleme müşterinin ürün sayfasında göreceği metni gösterir. Yayındaki kampanyada, fiyatı kampanyadan önceki 10 günde artırıldığı için indirim almayan ürünler ve kullanım raporu görünür.',
    whenToUse: 'Kampanya hazırlarken, yayına alırken ve sonuçlarını izlerken.',
    dataChanged:
      'Kaydet yalnızca kampanya tanımını değiştirir. Yayına al, uygun bütün sepetlere indirimi hemen uygular.',
    requiredPermission: 'Fiyatları düzenleme (yayına almada iki adımlı doğrulama). Onay: Uzman incelemesi.',
    reversible:
      'Duraklatıp değiştirebilir, yeniden yayına alabilirsiniz. Taslak hiç yayına alınmadıysa silinir.',
    commonErrors: [
      {
        problem: '"Yayındaki kampanya değiştirilemez"',
        solution: 'Önce Duraklat, sonra değiştirip yeniden Yayına al.',
      },
      {
        problem: 'Bir ürün indirim almıyor',
        solution:
          'Ürünün fiyatı kampanya başlangıcından önceki 10 günde artırılmış olabilir: "İndirim almayan ürünler" bölümüne bakın. Ayrıca ürün hedef seçimine uymuyor veya müşteri kitle dışında olabilir.',
      },
    ],
    guideUrl: 'docs/PROMOTIONS_TR.md#yayina-alma',
  },
  'promotions.create': {
    kind: 'action',
    title: 'Yeni kampanya',
    short: 'Taslak açar; taslak müşteriye görünmez.',
    guideUrl: 'docs/PROMOTIONS_TR.md#turler',
  },
  'promotions.save': {
    kind: 'action',
    title: 'Kaydet',
    short: 'Taslağı veya duraklatılmış kampanyayı kaydeder.',
  },
  'promotions.activate': {
    kind: 'action',
    title: 'Yayına al',
    short:
      'Kampanyayı başlatır (başlangıç tarihi ileride ise o tarihte). İki adımlı doğrulama ister; sağlık beyanı varsa önce uzman onayı gerekir.',
    whenToUse:
      'Kampanyanın koşullarını, indirim kademelerini ve tarihlerini kontrol ettikten sonra sepetlerde uygulanmaya başlaması için.',
    dataChanged:
      'Kampanyanın durumu "etkin" olur ve yayın dönemi kaydedilir; başlangıç tarihinden itibaren uygun sepetlerin fiyatına uygulanır. İşlem denetim kaydına yazılır.',
    requiredPermission: 'Fiyat düzenleme (son 15 dakikada iki adımlı doğrulama).',
    reversible:
      'Evet, "Duraklat" ile sepetlere uygulanması hemen durur; daha önce verilen siparişler değişmez.',
    commonErrors: [
      {
        problem: '"Kampanyanın bitiş tarihi geçmiş"',
        solution: 'Bitiş tarihini ileri bir tarihe güncelleyin.',
      },
      {
        problem: '"Sağlık içeriği veya sağlık beyanı var: … uzman onayı gerekir"',
        solution: 'Kampanya metni Veteriner Uzman İnceleyici tarafından onaylanmalı.',
      },
      {
        problem: '"Bu işlem için doğrulama kodunuzu yeniden girmeniz gerekiyor"',
        solution: 'Doğrulama uygulamanızdaki kodu girip tekrar deneyin.',
      },
    ],
    guideUrl: 'docs/PROMOTIONS_TR.md#yayina-alma',
  },
  'promotions.pause': {
    kind: 'action',
    title: 'Duraklat',
    short: 'Kampanya sepetlere hemen uygulanmaz; değiştirip yeniden yayına alabilirsiniz.',
  },
  'promotions.delete': {
    kind: 'action',
    title: 'Taslağı sil',
    short:
      'Yalnızca hiç yayına alınmamış taslak silinir; yayına alınmış kampanya fiyat geçmişi ve rapor için kalır.',
  },
  'promotions.name': { kind: 'field', title: 'Kampanya adı', short: 'Yalnızca panelde ve raporda görünür.' },
  'promotions.label': {
    kind: 'field',
    title: 'Müşteriye görünen ad',
    short:
      'Sepette, ödeme adımında ve ürün sayfasında görünür (en çok 80 karakter). Hastalık önleme/tedavi iddiası kullanmayın; olası sağlık beyanı uzman onayı ister.',
  },
  'promotions.kind': {
    kind: 'field',
    title: 'Kampanya türü',
    short: 'Ürün indirimi, sepet kademesi, X al Y öde veya ücretsiz kargo.',
    guideUrl: 'docs/PROMOTIONS_TR.md#turler',
  },
  'promotions.percent': {
    kind: 'field',
    title: 'İndirim yüzdesi',
    short: 'Ör. 20 veya 7,5. İndirim aşağı yuvarlanır; ilan edilen oranı aşmaz.',
  },
  'promotions.buy': { kind: 'field', title: 'Al', short: 'Kaç üründe bir grup oluşur (2–20).' },
  'promotions.pay': {
    kind: 'field',
    title: 'Öde',
    short: 'Grubun kaç ürünü ücretli (al adedinden az). Her grupta en düşük fiyatlı ürünler bedava.',
  },
  'promotions.min_subtotal': {
    kind: 'field',
    title: 'En az sepet tutarı',
    short: 'Ürün indirimlerinden sonra kalan tutar. Boşsa her siparişte kargo bedava.',
  },
  'promotions.basis': {
    kind: 'field',
    title: 'Eşik türü',
    short: 'Sepet tutarı (indirimlerden sonra) veya uygun ürün adedi.',
  },
  'promotions.tier_type': { kind: 'field', title: 'İndirim türü', short: 'Yüzde veya sabit tutar.' },
  'promotions.tiers': {
    kind: 'field',
    title: 'Kademeler',
    short: 'En çok 5 kademe; sepete uyan en yüksek kademe uygulanır. Eşikler farklı olmalı.',
  },
  'promotions.add_tier': {
    kind: 'action',
    title: 'Kademe ekle',
    short: 'Yeni bir eşik ve indirim satırı ekler.',
  },
  'promotions.remove_tier': {
    kind: 'action',
    title: 'Kademeyi kaldır',
    short: 'Bu kademeyi taslaktan çıkarır.',
  },
  'promotions.currency': {
    kind: 'field',
    title: 'Para birimi',
    short: 'Tutar içeren kampanya yalnızca bu para birimindeki sepetlere uygulanır.',
  },
  'promotions.targets': {
    kind: 'field',
    title: 'Hedef ürünler',
    short: 'Hiçbiri seçilmezse tüm ürünler. Seçimlerden herhangi birine uyan ürün dahildir.',
    guideUrl: 'docs/PROMOTIONS_TR.md#hedef-ve-kitle',
  },
  'promotions.categories': {
    kind: 'field',
    title: 'Kategoriler',
    short: 'Alt kategorilerdeki ürünler de dahildir.',
  },
  'promotions.brands': { kind: 'field', title: 'Markalar', short: 'Seçilen markaların ürünleri.' },
  'promotions.collections': {
    kind: 'field',
    title: 'Koleksiyonlar',
    short: 'Elle seçilmiş veya kurallı koleksiyonun o anki ürünleri.',
  },
  'promotions.products': {
    kind: 'field',
    title: 'Ürünler',
    short: 'Ad, SKU veya barkodla arayıp tek tek seçin.',
  },
  'promotions.audience': {
    kind: 'field',
    title: 'Kitle',
    short:
      'Herkes, yalnızca perakende veya yalnızca bayiler; isteğe bağlı müşteri grubu ve segment (segment yalnızca giriş yapmış üyeler).',
    guideUrl: 'docs/PROMOTIONS_TR.md#hedef-ve-kitle',
  },
  'page.dealer_reports': {
    kind: 'page',
    title: 'Bayi raporları',
    short:
      'Bayi satışları, ürün ve kategori kırılımı, vade dağılımı ve tahsilatlar; bayi, temsilci veya bölge bazında.',
    whatItDoes:
      'Satış, ürün ve kategori raporları dönemde verilen bayi siparişlerinden (taslak ve iptal hariç) hesaplanır. Vade dağılımı bugün itibarıyla cari defterdeki açık kalemleri gecikme gününe göre gösterir; tahsilat raporu dönemde cari hesaba yazılan tahsilatları yöntemine göre ayırır. Her rapor CSV olarak indirilebilir.',
    whenToUse:
      'Ay sonu bayi performansı, temsilci ve bölge karşılaştırması, vadesi geçen borç takibi ve tahsilat kontrolü için.',
    requiredPermission:
      'Satış, ürün, kategori: satış raporları. Vade ve tahsilat: cari hesap görme. Bayi kapsamı sınırlı temsilci yalnızca kendi bayilerini görür.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#bayi-raporlari',
  },
  'dealer_reports.report': {
    kind: 'field',
    title: 'Rapor',
    short:
      'Satış, Ürünler, Kategoriler, Vade dağılımı veya Tahsilat. Yetkiniz olmayan raporlar listede görünmez.',
  },
  'dealer_reports.period': {
    kind: 'field',
    title: 'Dönem',
    short:
      'Başlangıç ve bitiş günleri dahil (Türkiye saati); en çok bir yıl. Vade dağılımı her zaman bugün itibarıyladır.',
  },
  'dealer_reports.group_by': {
    kind: 'field',
    title: 'Kırılım',
    short:
      'Bayi, temsilci veya bölge bazında toplar. Satışta temsilci siparişteki temsilcidir; vade ve tahsilatta bayinin bugünkü temsilcisi. Bölge her zaman bayinin bugünkü bölgesidir.',
  },
  'dealer_reports.rep': {
    kind: 'field',
    title: 'Temsilci',
    short:
      'Yalnızca bu temsilcinin siparişleri (satış) veya bayileri (vade, tahsilat). "Temsilci atanmamış" atanmamışları gösterir.',
  },
  'dealer_reports.region': {
    kind: 'field',
    title: 'Bölge',
    short: 'Yalnızca bu bölgedeki bayiler. "Bölgesiz" bölgesi olmayan bayileri gösterir.',
  },
  'page.international_report': {
    kind: 'page',
    title: 'Ülke ve ihracat raporu',
    short:
      'Teslimat ülkesi ve para birimi bazında sipariş, ihracat, brüt, KDV, kargo, iade, net ve TL karşılığı.',
    whatItDoes:
      'Dönemde verilen siparişleri (taslak ve iptal hariç) teslimat adresinin ülkesine ve siparişin para birimine göre toplar. Brüt KDV dahildir ve iptal edilen ürünler düşülür; iade, siparişin tahsil edilmiş ödemelerinden yapılan iadedir. İhracat sütunları KDV istisnalı (ihracat) siparişleri gösterir. TL karşılığı her siparişe yazılan TCMB kuruyla hesaplanır; kuru olmayan döviz siparişi TL toplamına katılmaz ve ayrıca uyarılır.',
    whenToUse:
      'Ay sonunda pazar bazında satışları görmek, ihracat satışlarını mali müşavire vermek ve döviz satışlarının TL karşılığını kontrol etmek için.',
    requiredPermission:
      'Satış raporları. Mağaza kapsamı sınırlı kullanıcı yalnızca kendi mağazalarını görür.',
    guideUrl: 'docs/INTERNATIONAL_SALES_TR.md#ulke-raporu',
  },
  'international_report.period': {
    kind: 'field',
    title: 'Dönem',
    short: 'Siparişin verildiği gün (Türkiye saati); başlangıç ve bitiş dahil, en çok bir yıl.',
  },
  'international_report.store': {
    kind: 'field',
    title: 'Mağaza',
    short: 'Boş bırakılırsa yetkiniz olan tüm mağazaların siparişleri.',
  },
  'international_report.csv': {
    kind: 'action',
    title: 'CSV indir',
    short:
      'Ekrandaki raporu aynı süzgeçlerle Türkçe Excel biçiminde indirir (ülke ve para birimi satırları).',
  },
  'international_report.try_total': {
    kind: 'field',
    title: 'TL karşılığı',
    short:
      'Döviz siparişlerinin net tutarı, sipariş anında siparişe yazılan TCMB kuruyla Türk lirasına çevrilir. Muhasebe kaydı için mali müşavirinizin kullandığı kur farklı olabilir.',
  },
  'dealer_reports.csv': {
    kind: 'action',
    title: 'CSV indir',
    short: 'Ekrandaki raporu aynı süzgeçlerle, toplam satırıyla Türkçe Excel biçiminde indirir.',
  },
  'pricing.list_market': {
    kind: 'field',
    title: 'Pazar',
    short:
      'Seçilirse liste yalnızca o pazarda (ülke) geçerlidir ve genel listeden önce gelir. Boş: bu para birimindeki tüm pazarlar.',
    guideUrl: 'docs/PRICING_ENGINE_TR.md#pazar-fiyati',
  },
  'products.compliance': {
    kind: 'field',
    title: 'Ülke uygunluğu',
    short:
      'Ürünün ülke bazında satışa açık/kapalı durumu, kayıt/izin numarası ve teyit durumu. Kayıt yoksa ürün o ülkede satışa açıktır.',
    whatItDoes:
      'Satışa kapalı ülkenin pazarında (ziyaretçi üst çubuktan o ülkeyi seçtiğinde veya mağazanın varsayılan pazarıysa) ürün listelerde, aramada, site haritasında ve Merchant feed’inde görünmez, sepete eklenemez; ürün sayfası "bu ülkede satışta değil" yazar. Sepetteki ürün işaretlenir ve sipariş verilemez.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#ulke-uygunlugu',
  },
  'products.compliance_status': {
    kind: 'field',
    title: 'Satış durumu',
    short:
      'Satışa kapalıysa gerekçe zorunlu. Açık kayıt yalnızca kayıt/izin numarasını tutmak için kullanılır.',
  },
  'products.compliance_reason': {
    kind: 'field',
    title: 'Gerekçe',
    short:
      'Neden satılamadığı (iç bilgi; ziyaretçiye gösterilmez). Kayıt/izin bekleniyorsa "Kayıt/izin yok" seçin.',
  },
  'products.compliance_registration': {
    kind: 'field',
    title: 'Kayıt / izin numarası',
    short:
      'Ülkedeki kayıt veya izin numarası. Teyit edildiyse ürün sayfasında "Kayıt / izin numarası (ülke)" olarak görünür.',
  },
  'products.compliance_verification': {
    kind: 'field',
    title: 'Teyit durumu',
    short:
      'Numaranın resmî kaynaktan doğrulanıp doğrulanmadığı. "Teyit edildi" seçilince zaman ve kişi kaydedilir; numara değişince yeniden teyit edilir.',
  },
  'page.fx': {
    kind: 'page',
    title: 'Döviz kurları',
    short: "TCMB'nin günlük gösterge kurları, kur alımının durumu ve kurdan türetilmiş fiyat listeleri.",
    whatItDoes:
      "Kurlar iş günlerinde TCMB bülteni yayımlandıktan sonra (15:40'tan itibaren) kendiliğinden alınır ve bülten tarihi ve numarasıyla saklanır. TCMB'ye ulaşılamazsa son geçerli kur ve tarihi kullanılmaya devam eder; son bülten 4 günden eskiyse veya art arda 3 deneme başarısızsa uyarı görünür. Kur hiçbir zaman uydurulmaz.",
    whenToUse:
      'Yurt dışı mağazada (EUR, USD…) fiyatları TL listeden kurla türetirken veya dövizli siparişlerin kurunu kontrol ederken.',
    requiredPermission:
      'Görmek: fiyat görme. Kurları güncellemek ve listeyi yeniden hesaplamak: fiyat yazma.',
    guideUrl: 'docs/PRICING_ENGINE_TR.md#doviz-kurlari',
  },
  'fx.refresh': {
    kind: 'action',
    title: 'Kurları şimdi güncelle',
    short:
      "TCMB'den son bülteni hemen ister (dakikada en çok bir kez). Yeni bülten gelirse kendiliğinden güncellenen listeler yeniden hesaplanır.",
  },
  'fx.rates': {
    kind: 'field',
    title: 'Kurlar',
    short:
      'Son bültendeki döviz alış/satış ve efektif alış/satış kurları. Bazı para birimlerinde efektif kur yayımlanmaz; o tür seçilirse liste hesaplanmaz.',
  },
  'fx.derived': {
    kind: 'field',
    title: 'Kurdan türetilmiş listeler',
    short:
      'Fiyatları temel listeden kurla hesaplanan listeler. "Son bültenle hesaplanmadı" uyarısı, listenin eski kurla kaldığını gösterir.',
  },
  'fx.recompute': {
    kind: 'action',
    title: 'Şimdi hesapla',
    short:
      'Listeyi son kurla hemen yeniden hesaplar. Değişen her fiyat fiyat geçmişine yazılır; kur yoksa liste değişmez.',
    whenToUse:
      'Kurdan türetilen bir fiyat listesini (ör. Euro listesi) gece güncellemesini beklemeden son TCMB kuruyla yeniden hesaplamak istediğinizde.',
    dataChanged:
      'Listedeki fiyatlar temel listeden son kurla yeniden hesaplanır; değişen her fiyat fiyat geçmişine yazılır, temel listede fiyatı olmayan ürünlerin fiyatı bu listeden kaldırılır. Listenin son hesaplama bilgisi güncellenir.',
    requiredPermission: 'Fiyat düzenleme.',
    reversible:
      'Hayır, önceki kurla hesaplanan fiyatlara tek tıkla dönülmez; liste "Elle fiyatlıya döndür" ile kurdan ayrılıp elle düzeltilebilir.',
    commonErrors: [
      {
        problem: '"… için seçilen kur türünde TCMB kuru yok"',
        solution: 'Kur uydurulmaz: başka kur türü seçin veya kurlar gelince yeniden hesaplayın.',
      },
      { problem: '"Bu liste kurdan türetilmiyor"', solution: 'Önce listede "Kurdan türet" ayarını yapın.' },
      {
        problem: '"Kurdan türetilen listenin temel listesi bulunamadı"',
        solution: 'Temel listeyi yeniden seçin veya etkinleştirin.',
      },
    ],
  },
  'pricing.fx': {
    kind: 'action',
    title: 'Kurdan türet',
    short:
      'Listenin fiyatlarını başka para birimindeki temel listeden TCMB kuruyla hesaplar (ör. Euro listesi = TL perakende ÷ euro kuru).',
    whatItDoes:
      'Temel listedeki her fiyat (kademeli fiyatlar dahil) seçilen kur türüyle çevrilir, ek oran ve fiyat sonu uygulanır. Hesaplanan liste elle düzenlenemez. Kurun düşmesiyle inen fiyat vitrinde "indirim" (üstü çizili fiyat) olarak gösterilmez.',
    guideUrl: 'docs/PRICING_ENGINE_TR.md#doviz-kurlari',
  },
  'pricing.fx_base': {
    kind: 'field',
    title: 'Temel liste',
    short:
      'Fiyatların alınacağı, başka para birimindeki elle fiyatlı liste. Kendisi kurdan türetilmiş liste temel olamaz.',
  },
  'pricing.fx_rate_type': {
    kind: 'field',
    title: 'Kur türü',
    short:
      'TL fiyattan dövize geçerken genellikle döviz alış, dövizden TL fiyata geçerken döviz satış kullanılır (işletmeyi kur farkına karşı korur).',
  },
  'pricing.fx_markup': {
    kind: 'field',
    title: 'Ek oran',
    short: 'Çevrilen fiyata eklenen yüzde (ör. 5: kur farkı ve masraf payı). Eksi değer fiyatı düşürür.',
  },
  'pricing.fx_ending': {
    kind: 'field',
    title: 'Fiyat sonu',
    short: 'Hesaplanan fiyatı yukarı doğru tam sayıya, ,90 veya ,99 ile biten fiyata yuvarlar.',
  },
  'pricing.fx_auto': {
    kind: 'field',
    title: 'Kendiliğinden güncelle',
    short:
      'Açıkken liste her yeni TCMB bülteninde ve temel listede fiyat değişince yeniden hesaplanır. Kapalıyken yalnızca "Şimdi hesapla" ile.',
  },
  'pricing.fx_clear': {
    kind: 'action',
    title: 'Elle fiyatlıya döndür',
    short:
      'Kur bağlantısını kaldırır; mevcut fiyatlar kalır, artık kurla güncellenmez ve elle düzenlenebilir.',
  },
  'orders.fx': {
    kind: 'field',
    title: 'Kur',
    short:
      'Dövizli siparişte sipariş anındaki TCMB döviz alış kuru ve bülteni; fiyatı kurdan türetilmiş listeden gelen satırlarda o listenin hesaplandığı kur. Sonradan değişmez.',
    whatItDoes:
      'TL karşılığı bilgi amaçlıdır; faturada hangi kurun esas alınacağını mali müşavirinize danışın. Sipariş anında kur yoksa alan boş kalır (kur uydurulmaz).',
  },
  'payments.card_currencies': {
    kind: 'field',
    title: 'Kartla döviz tahsilatı',
    short:
      'TL dışı para birimindeki mağazada kart ödemesi yalnızca burada işaretli ve sağlayıcının desteklediği para biriminde sunulur. Kapıda ödeme yalnızca TL siparişte.',
    whatItDoes:
      'iyzico ödeme formu TRY, USD, EUR, GBP, NOK ve CHF; PayTR TL, EUR, USD, GBP ve RUB kabul eder. Döviz tahsilatı için sağlayıcıyla ayrıca anlaşma gerekir; anlaşma olmadan işaretlemeyin.',
    guideUrl: 'docs/PRICING_ENGINE_TR.md#doviz-kurlari',
  },
  'shipping.currency': {
    kind: 'field',
    title: 'Ücret para birimi',
    short:
      'Kargo ücreti ve ücretsiz kargo sınırının para birimi. Yöntem yalnızca aynı para birimindeki siparişlerde sunulur; varsayılan mağazanın para birimidir.',
  },
  'promotions.companies': {
    kind: 'field',
    title: 'Bayi firmaları',
    short:
      'Bayiye özel kampanya: yalnızca seçtiğiniz onaylı bayi firmalarının kullanıcıları yararlanır. Firma seçilince kitle "Bayiler" olur.',
    whatItDoes:
      'Sepette ve ürün sayfasında kampanya yalnızca bu firmaların Yetkili, Satın alma ve görüntüleme kullanıcılarına görünür. Firma askıya alınırsa veya kullanıcı firmadan çıkarılırsa uygulanmaz. Müşteri grubu ve segment seçimi ayrıca uygulanır.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#bayi-kampanyalari',
  },
  'promotions.groups': {
    kind: 'field',
    title: 'Müşteri grupları',
    short: 'Seçilirse yalnızca bu gruplar; perakende türündeki gruba misafir ziyaretçi de dahildir.',
  },
  'promotions.segments': {
    kind: 'field',
    title: 'Segmentler',
    short: 'Seçilirse yalnızca bu segmentlerdeki üyeler (giriş yapınca).',
  },
  'promotions.priority': {
    kind: 'field',
    title: 'Öncelik',
    short:
      'Yüksek olan önce denenir (−100 ile 100 arası). Aynı ürüne iki ürün indirimi binmez: öncelikli olan uygulanır.',
    guideUrl: 'docs/PROMOTIONS_TR.md#birlesme',
  },
  'promotions.stacking': {
    kind: 'field',
    title: 'Birleşme',
    short:
      'Tek başına kampanya öncelik sırasında ilk fayda sağlayansa yalnızca o uygulanır; değilse birleşebilir kampanyalar birlikte uygulanır.',
    guideUrl: 'docs/PROMOTIONS_TR.md#birlesme',
  },
  'promotions.allow_coupon': {
    kind: 'field',
    title: 'Kuponla birlikte',
    short: 'Kapalıysa kampanya uygulandığı sepette kupon kabul edilmez (kampanya geçerli kalır).',
  },
  'promotions.starts_at': {
    kind: 'field',
    title: 'Başlangıç',
    short: 'Boşsa yayına alındığı an. İleri tarihte yayına alınan kampanya o tarihte başlar.',
  },
  'promotions.ends_at': {
    kind: 'field',
    title: 'Bitiş',
    short: 'Boşsa süresiz. Bitiş tarihi ürün sayfasında yazar.',
  },
  'promotions.preview': {
    kind: 'field',
    title: 'Müşteri ne görür',
    short: 'Ürün sayfasındaki kampanya kutusunun metni: ad, koşul, bitiş tarihi.',
    guideUrl: 'docs/PROMOTIONS_TR.md#vitrin',
  },
  'promotions.excluded': {
    kind: 'field',
    title: 'İndirim almayan ürünler',
    short:
      'Fiyatı kampanya başlangıcından önceki 10 günde veya kampanya sırasında artırılan ürünler indirim almaz (indirimli satış kuralı).',
    guideUrl: 'docs/PROMOTIONS_TR.md#durust-indirim',
  },
  'promotions.usage': {
    kind: 'field',
    title: 'Kullanım',
    short:
      'Kampanyanın uygulandığı (iptal edilmemiş) siparişler, toplam indirim (kargo dahil) ve sipariş tutarı.',
    guideUrl: 'docs/PROMOTIONS_TR.md#rapor',
  },
  'page.gift_cards': {
    kind: 'page',
    title: 'Hediye kartları',
    short: 'Ödeme adımında kodla harcanan ön ödemeli kartlar: oluşturma, bakiye, durum ve son kullanma.',
    whatItDoes:
      'Oluşturulan kartları son dört karakteri, bakiyesi, durumu (kullanılabilir, kapatıldı, süresi doldu, bakiyesi bitti) ve son kullanma tarihiyle listeler. Kod yalnızca oluşturulurken bir kez gösterilir; sistemde kodun kendisi değil, özeti saklanır. Müşteri kodu ödeme adımında girer; bakiye yetmezse kalanı seçtiği yöntemle öder.',
    whenToUse:
      'Hediye kartı satarken, telafi olarak kart verirken veya bir kartın bakiyesini kontrol ederken.',
    dataChanged:
      'Oluşturma, kapatma, son kullanma değişikliği ve bakiye düzeltme denetim kaydına ve kartın hareketlerine düşer.',
    requiredPermission:
      'Görüntüleme: Hediye kartlarını görüntüleme. Oluşturma ve değiştirme: Hediye kartı oluşturma (hassas; iki adımlı doğrulama).',
    reversible: 'Kart kapatılıp yeniden açılabilir; bakiye gerekçeyle düzeltilebilir. Kart silinmez.',
    guideUrl: 'docs/GIFT_CARDS_TR.md#olusturma',
  },
  'page.gift_card_detail': {
    kind: 'page',
    title: 'Hediye kartı',
    short: 'Kartın bakiyesi, hareketleri (oluşturma, siparişte kullanım, iade, iptal, düzeltme) ve ayarları.',
    whatItDoes:
      'Her bakiye hareketi siparişiyle birlikte listelenir. Ödenmemiş sipariş iptal edilirse veya iade karta yapılırsa tutar karta geri yüklenir. Kart kapatılabilir, son kullanma tarihi ve iç not değiştirilebilir, bakiye gerekçeyle düzeltilebilir.',
    whenToUse:
      'Müşteri bakiyesini sorduğunda, kayıp/çalıntı kod bildirildiğinde (kartı kapatın) veya hatalı yüklemeyi düzeltirken.',
    dataChanged: 'Her değişiklik hareketlere ve denetim kaydına yazılır.',
    requiredPermission: 'Değiştirme: Hediye kartı oluşturma (hassas; iki adımlı doğrulama).',
    reversible: 'Kapatma geri alınabilir; düzeltme ters yönde yeni düzeltmeyle dengelenir.',
    guideUrl: 'docs/GIFT_CARDS_TR.md#bakiye',
  },
  'gift_cards.create': {
    kind: 'action',
    title: 'Hediye kartı oluştur',
    short:
      'Tutar ve isteğe bağlı son kullanma tarihiyle yeni kart oluşturur. Kod yalnızca bu pencerede bir kez gösterilir; müşteriye siz iletirsiniz.',
    whatItDoes:
      'Kod 16 karakterdir (karışmayan harf ve rakamlar, XXXX-XXXX-XXXX-XXXX). Sistem e-posta veya SMS göndermez. Satılan kartın muhasebe kaydı (KDV) mali müşavirinizle belirlenir.',
    whenToUse: 'Müşteriye hediye kartı sattığınızda, kampanya veya telafi için kart verdiğinizde.',
    dataChanged:
      'Yeni hediye kartı kaydı ve ilk "yükleme" hareketi oluşur; kodun yalnızca son dört karakteri saklanır. İşlem denetim kaydına yazılır.',
    requiredPermission: 'Hediye kartı oluşturma (hassas; iki adımlı doğrulama).',
    reversible: 'Kart silinmez; kapatılabilir.',
    commonErrors: [
      {
        problem: '"Tarih ileride olmalı"',
        solution: 'Son kullanma tarihini bugünden sonraki bir gün seçin veya boş bırakın.',
      },
      {
        problem: '"Bu işlem için doğrulama kodunuzu yeniden girmeniz gerekiyor"',
        solution: 'Hassas işlemdir; doğrulama uygulamanızdaki kodu girip tekrar deneyin.',
      },
    ],
    guideUrl: 'docs/GIFT_CARDS_TR.md#olusturma',
  },
  'gift_cards.search': {
    kind: 'field',
    title: 'Son dört karakter',
    short:
      'Kodun son dört karakterine göre arar. Tam kod sistemde saklanmadığı için tam kodla arama yapılamaz.',
    guideUrl: 'docs/GIFT_CARDS_TR.md#kod',
  },
  'gift_cards.state_filter': {
    kind: 'field',
    title: 'Durum',
    short:
      'Kullanılabilir: etkin, süresi dolmamış ve bakiyesi var. Kapatıldı: elle kapatıldı. Süresi doldu: son kullanma geçti. Bakiyesi bitti: tamamı harcandı.',
  },
  'gift_cards.amount': {
    kind: 'field',
    title: 'Tutar',
    short: 'Kartın ilk bakiyesi (en az 1,00). Ödeme adımında bu tutara kadar harcanır.',
    guideUrl: 'docs/GIFT_CARDS_TR.md#olusturma',
  },
  'gift_cards.currency': {
    kind: 'field',
    title: 'Para birimi',
    short: 'Kart yalnızca bu para birimiyle satış yapan mağazada kullanılabilir.',
  },
  'gift_cards.expires_at': {
    kind: 'field',
    title: 'Son kullanma tarihi',
    short:
      'Seçilen günün sonuna kadar geçerlidir; boşsa süresizdir. Süreli satış yapmadan önce avukatınıza danışın (tüketici mevzuatı).',
    guideUrl: 'docs/GIFT_CARDS_TR.md#son-kullanma',
  },
  'gift_cards.note': {
    kind: 'field',
    title: 'İç not',
    short: 'Yalnızca panelde görünür; müşteriye gösterilmez (ör. kimin için, hangi kampanya).',
  },
  'gift_cards.copy_code': {
    kind: 'action',
    title: 'Kodu kopyala',
    short:
      'Kodu panoya kopyalar. Pencere kapanınca kod bir daha gösterilmez; kaybolursa kartı kapatıp yenisini oluşturun.',
    guideUrl: 'docs/GIFT_CARDS_TR.md#kod',
  },
  'gift_cards.adjust': {
    kind: 'action',
    title: 'Bakiyeyi düzelt',
    short: 'Bakiyeye gerekçeyle ekler veya düşer (ör. hatalı yükleme). Bakiye eksiye düşemez.',
    whenToUse:
      'Karta yanlış tutar yüklendiğinde veya bakiyeyi gerekçeli olarak artırmanız/azaltmanız gerektiğinde.',
    dataChanged:
      'Kartın bakiyesi değişir ve kart geçmişine gerekçesiyle bir "düzeltme" hareketi eklenir; önceki ve yeni bakiye denetim kaydına yazılır.',
    requiredPermission: 'Hediye kartı oluşturma (hassas; iki adımlı doğrulama).',
    reversible: 'Ters yönde yeni düzeltmeyle.',
    commonErrors: [
      {
        problem: '"Bakiye sıfırın altına düşemez"',
        solution: 'Düşülecek tutarı kartın mevcut bakiyesi kadar veya daha az girin.',
      },
      { problem: '"Tutar sıfır olamaz"', solution: 'Eklemek için artı, düşmek için eksi bir tutar yazın.' },
    ],
    guideUrl: 'docs/GIFT_CARDS_TR.md#bakiye',
  },
  'gift_cards.toggle': {
    kind: 'action',
    title: 'Kartı kapat / yeniden aç',
    short:
      'Kapatılan kart ödeme adımında kabul edilmez (kayıp veya çalıntı kod). Önceki siparişler etkilenmez; kart yeniden açılabilir.',
    whenToUse:
      'Kod kaybolduğunda, çalındığında veya kartın kullanımını geçici olarak durdurmak istediğinizde.',
    dataChanged:
      'Kartın durumu "kapalı" veya "etkin" olur; bakiye ve geçmiş hareketler değişmez. Değişiklik denetim kaydına yazılır.',
    requiredPermission: 'Hediye kartı oluşturma (hassas; iki adımlı doğrulama).',
    reversible: 'Evet.',
    commonErrors: [
      {
        problem: '"Bu kayıt siz düzenlerken başka biri tarafından değiştirildi"',
        solution: 'Sayfayı yenileyip kartın güncel durumunu görün, sonra tekrar deneyin.',
      },
    ],
  },
  'gift_cards.save': {
    kind: 'action',
    title: 'Kaydet',
    short: 'Son kullanma tarihini ve iç notu kaydeder.',
  },
  'tenders.adjust_direction': {
    kind: 'field',
    title: 'İşlem',
    short: 'Bakiye ekle veya bakiyeden düş. Düşülen tutar mevcut bakiyeden fazla olamaz.',
  },
  'tenders.adjust_amount': {
    kind: 'field',
    title: 'Tutar',
    short: 'Eklenecek veya düşülecek tutar (pozitif yazın; yön "İşlem" alanından seçilir).',
  },
  'tenders.adjust_note': {
    kind: 'field',
    title: 'Gerekçe',
    short: 'Zorunlu. Hareketlere ve denetim kaydına yazılır; müşteriye gösterilmez.',
  },
  'customers.store_credit_adjust': {
    kind: 'action',
    title: 'Kredi ekle / düş',
    short:
      'Müşterinin mağaza kredisine gerekçeyle ekler (ör. telafi) veya düşer (düzeltme). Müşteri tutarı Hesabım sayfasında görür; gerekçeyi görmez.',
    whenToUse:
      'Müşteriye gecikme, eksik ürün gibi bir durum için telafi verirken veya yanlış girilen krediyi düzeltirken.',
    dataChanged:
      'Müşterinin seçilen para birimindeki mağaza kredisi bakiyesi değişir ve gerekçesiyle bir kredi hareketi eklenir; işlem denetim kaydına yazılır.',
    requiredPermission: 'Mağaza kredisi yönetimi (hassas; iki adımlı doğrulama).',
    reversible: 'Ters yönde yeni işlemle.',
    commonErrors: [
      {
        problem: '"Mağaza kredisi bakiyesi yetersiz"',
        solution: 'Düşülecek tutar müşterinin o para birimindeki bakiyesinden fazla olamaz.',
      },
      {
        problem: '"Bu müşterinin kişisel verileri … anonimleştirildi"',
        solution: 'KVKK silme başvurusuyla anonimleştirilen müşteriye kredi verilemez.',
      },
    ],
    guideUrl: 'docs/GIFT_CARDS_TR.md#magaza-kredisi',
  },
  'customers.store_credit_currency': {
    kind: 'field',
    title: 'Para birimi',
    short: 'Kredi para birimine göre ayrı tutulur ve yalnızca aynı para birimindeki siparişte kullanılır.',
  },
  'customers.gift_card_issue': {
    kind: 'action',
    title: 'Hediye kartı ver',
    short:
      'Bu müşteri adına kayıtlı hediye kartı oluşturur. Kod bir kez gösterilir; müşteriye siz iletirsiniz. Kart müşteri sayfasında listelenir.',
    whenToUse:
      'Belirli bir müşteriye (ör. telafi veya ödül olarak) adına kayıtlı hediye kartı vermek istediğinizde.',
    dataChanged:
      'Müşteriye bağlı yeni bir hediye kartı ve ilk yükleme hareketi oluşur; kart müşteri sayfasında listelenir ve denetim kaydına yazılır.',
    requiredPermission: 'Hediye kartı oluşturma (hassas; iki adımlı doğrulama).',
    reversible:
      'Kısmen: kart silinmez; Hediye Kartları sayfasından kapatılabilir veya bakiyesi düzeltilebilir.',
    commonErrors: [
      {
        problem: '"Tarih ileride olmalı"',
        solution: 'Son kullanma tarihini bugünden sonraki bir gün seçin veya boş bırakın.',
      },
      {
        problem: 'Pencereyi kapattım, kodu göremiyorum',
        solution: 'Kod bir daha gösterilmez; kartı kapatıp yeni kart oluşturun.',
      },
    ],
    guideUrl: 'docs/GIFT_CARDS_TR.md#olusturma',
  },
  'orders.refund_payment': {
    kind: 'field',
    title: 'İade edilecek ödeme',
    short:
      'Sipariş birden çok ödemeyle (ör. hediye kartı + kart) ödendiyse iadenin hangisine yapılacağını seçin. Hediye kartı veya krediye yapılan iade bakiyeye geri yüklenir.',
    guideUrl: 'docs/GIFT_CARDS_TR.md#iade',
  },
  'orders.refund_store_credit': {
    kind: 'field',
    title: 'Mağaza kredisi olarak iade',
    short:
      'Para iadesi yerine tutar müşterinin mağaza kredisine yazılır. Yalnızca müşterinin açık onayıyla; cayma hakkı iadesinde kullanılamaz (para iadesi zorunludur).',
    guideUrl: 'docs/GIFT_CARDS_TR.md#iade',
  },
  'orders.refund_consent': {
    kind: 'field',
    title: 'Müşteri onayı',
    short:
      'Müşterinin krediyi kabul ettiğini (ör. e-posta veya yazılı mesajla) teyit edin; onay olmadan kredi iadesi yapılamaz.',
    guideUrl: 'docs/GIFT_CARDS_TR.md#iade',
  },
  'page.loyalty': {
    kind: 'page',
    title: 'Sadakat programı',
    short:
      'Puan kazanma ve harcama oranları, bekleme ve geçerlilik süreleri, VIP seviyeleri ve program özeti.',
    whatItDoes:
      'Üyeler teslim edilen siparişlerden (bekleme süresi geçince) puan kazanır ve ödeme adımında "Puanlarımı kullan" ile öder; puan ödeme aracıdır, sipariş tutarı ve KDV değişmez. VIP seviyeleri son 12 aydaki net alışverişe göre her siparişte yeniden hesaplanır; seviye indirimi faturada indirim olarak görünür. Özette puanı olan üye sayısı, kullanılmamış puan ve değeri, son 30 gün hareketleri, seviyelere göre üye sayısı yer alır.',
    whenToUse:
      'Programı açarken, oranları veya seviyeleri değiştirirken ve puan borcunu (kullanılmamış puan değeri) izlerken.',
    dataChanged:
      'Ayar değişikliği denetim kaydına düşer; sepet ve ödeme adımında hemen geçerli olur, verilmiş siparişler değişmez.',
    requiredPermission:
      'Görüntüleme: Kampanyaları görüntüleme. Değiştirme: Sadakat programı yönetimi (hassas; iki adımlı doğrulama).',
    reversible: 'Program kapatılabilir; puanlar silinmez, kapalıyken kazanılmaz ve harcanmaz.',
    guideUrl: 'docs/LOYALTY_TR.md#ayarlar',
  },
  'loyalty.enabled': {
    kind: 'field',
    title: 'Sadakat programı açık',
    short:
      'Açıkken üyeler puan kazanır/harcar ve seviye ayrıcalıkları uygulanır. Kapatınca puanlar silinmez, donar. Müşterilere bildirim gönderilmez.',
    guideUrl: 'docs/LOYALTY_TR.md#ayarlar',
  },
  'loyalty.currency': {
    kind: 'field',
    title: 'Para birimi',
    short:
      'Puan yalnızca bu para birimindeki siparişlerde kazanılır ve harcanır; seviye harcaması da bu para biriminde.',
  },
  'loyalty.earn': {
    kind: 'field',
    title: 'Her 1 birime kazanılan puan',
    short:
      'Örn. 10: her 1 TL alışverişe 10 puan. Kargo, kapıda ödeme bedeli, iadeler ve puanla ödenen kısım hariç tutulur. 0: puan kazanılmaz (yalnızca seviyeler).',
    guideUrl: 'docs/LOYALTY_TR.md#kazanma',
  },
  'loyalty.value': {
    kind: 'field',
    title: '1 birim için gereken puan',
    short:
      'Örn. 100: 100 puan = 1 TL. Kazanma oranıyla birlikte geri dönüş oranını belirler (10 ve 100 → %10).',
    guideUrl: 'docs/LOYALTY_TR.md#harcama',
  },
  'loyalty.min_redeem': {
    kind: 'field',
    title: 'Kullanmak için en az puan',
    short: 'Müşterinin ödeme adımında puan kullanabilmesi için gereken en az bakiye. 0: sınır yok.',
  },
  'loyalty.hold_days': {
    kind: 'field',
    title: 'Teslimden sonra bekleme',
    short:
      'Puan, teslimden bu kadar gün sonra hesaba geçer (varsayılan 14: cayma süresi). Bu sürede iade edilen tutar puan kazandırmaz.',
    guideUrl: 'docs/LOYALTY_TR.md#kazanma',
  },
  'loyalty.expiry': {
    kind: 'field',
    title: 'Puan geçerliliği',
    short:
      'Kazanılan puan bu kadar ay sonra düşer; önce süresi dolacak puan harcanmış sayılır. 0: süresiz. Değişiklik yalnızca bundan sonra kazanılan puanlara uygulanır.',
    guideUrl: 'docs/LOYALTY_TR.md#son-kullanma',
  },
  'loyalty.tiers': {
    kind: 'field',
    title: 'VIP seviyeleri',
    short:
      'Son 12 aydaki net alışverişe göre seviye; seviye indirimi (kampanyalardan sonra, kupondan önce) ve ücretsiz kargo. En çok 5 seviye; seviye adı müşteriye görünür.',
    guideUrl: 'docs/LOYALTY_TR.md#seviyeler',
  },
  'loyalty.tier_name': {
    kind: 'field',
    title: 'Seviye adı',
    short: 'Müşteriye görünür (sepet, ödeme, Hesabım). Örn. Silver, Gold.',
  },
  'loyalty.tier_spend': {
    kind: 'field',
    title: 'Son 12 ay en az harcama',
    short: 'Bu tutar ve üzerinde net alışverişi olan üye bu seviyededir. 0: tüm üyeler (giriş seviyesi).',
    guideUrl: 'docs/LOYALTY_TR.md#seviyeler',
  },
  'loyalty.tier_discount': {
    kind: 'field',
    title: 'Seviye indirimi',
    short:
      'Ürün tutarına yüzde indirim (en çok %50); kampanyalardan sonra kalan tutara uygulanır, faturada indirim olarak görünür.',
  },
  'loyalty.tier_shipping': {
    kind: 'field',
    title: 'Ücretsiz kargo',
    short: 'Bu seviyedeki üye için kargo ücreti alınmaz; kapıda ödeme bedeli alınır.',
  },
  'loyalty.tier_add': {
    kind: 'action',
    title: 'Seviye ekle',
    short: 'Yeni bir seviye satırı ekler; kaydedince geçerli olur.',
  },
  'loyalty.tier_remove': {
    kind: 'action',
    title: 'Seviyeyi kaldır',
    short: 'Seviye satırını kaldırır; kaydedince o seviyedeki üyeler bir alt seviyeye geçer.',
  },
  'loyalty.save': {
    kind: 'action',
    title: 'Kaydet',
    short: 'Ayarları kaydeder (iki adımlı doğrulama). Programı açarken onay istenir.',
    requiredPermission: 'Sadakat programı yönetimi (hassas).',
  },
  'loyalty.adjust_points': {
    kind: 'field',
    title: 'Puan',
    short:
      'Eklenecek veya düşülecek puan (pozitif tam sayı; yön "İşlem" alanından). Eklenen puan programın geçerlilik süresine tabidir.',
  },
  'customers.loyalty_adjust': {
    kind: 'action',
    title: 'Puan ekle / düş',
    short:
      'Müşterinin sadakat puanına gerekçeyle ekler (ör. telafi) veya düşer (düzeltme). Bakiye eksiye düşmez; müşteri gerekçeyi görmez.',
    whenToUse: 'Müşteriye telafi olarak puan vermek veya hatalı yüklenen puanı düzeltmek istediğinizde.',
    dataChanged:
      'Müşterinin puan bakiyesi değişir ve gerekçesiyle bir puan hareketi eklenir; eklenen puan programın geçerlilik süresine tabidir. İşlem denetim kaydına yazılır.',
    requiredPermission: 'Mağaza kredisi yönetimi (hassas; iki adımlı doğrulama).',
    reversible: 'Evet, ters yönde yeni bir puan hareketiyle düzeltilir; hareket kaydı silinmez.',
    commonErrors: [
      {
        problem: '"Puan bakiyesi yetersiz"',
        solution: 'Düşülecek puan müşterinin mevcut puanından fazla olamaz.',
      },
      {
        problem: '"Bu müşterinin kişisel verileri … anonimleştirildi"',
        solution: 'Anonimleştirilen müşterinin puanı değiştirilemez.',
      },
    ],
    guideUrl: 'docs/LOYALTY_TR.md#ayarlar',
  },
  'page.referrals': {
    kind: 'page',
    title: 'Tavsiye programı',
    short:
      'Arkadaşını davet et: arkadaşın ilk sipariş indirimi, davet edenin ödül kuponu, bekleme süresi, sınır ve son davetler.',
    whatItDoes:
      'Üye Hesabım sayfasında kendi davet kodunu (DAVET-…) alır ve bağlantıyı kendisi paylaşır. Arkadaş kodu ilk siparişinde kullanır ve indirim alır; kod sahibinin kendisi, bayiler ve daha önce sipariş vermiş müşteriler kullanamaz. Sipariş teslim edilip bekleme süresi geçince davet edene tek kullanımlık, yalnızca onun hesabında geçerli ödül kuponu (ODUL-…) verilir. İptal veya tam iadede ödül verilmez.',
    whenToUse: 'Programı açarken, indirim ve ödülleri değiştirirken ve davetleri izlerken.',
    dataChanged:
      'Ayar değişikliği denetim kaydına düşer ve tüm davet kodlarına hemen uygulanır. Verilmiş ödül kuponları değişmez.',
    requiredPermission:
      'Görüntüleme: Kampanyaları görüntüleme. Değiştirme: Tavsiye programı yönetimi (hassas; iki adımlı doğrulama).',
    reversible: 'Program kapatılabilir; davet kodları çalışmaz, verilmiş ödül kuponları geçerli kalır.',
    guideUrl: 'docs/REFERRAL_AFFILIATE_TR.md#ayarlar',
  },
  'referrals.enabled': {
    kind: 'field',
    title: 'Tavsiye programı açık',
    short:
      'Açıkken üyeler davet kodu alabilir ve kodlar sepette çalışır. Kapatınca kodlar çalışmaz. Müşterilere bildirim gönderilmez.',
    guideUrl: 'docs/REFERRAL_AFFILIATE_TR.md#ayarlar',
  },
  'referrals.currency': {
    kind: 'field',
    title: 'Para birimi',
    short: 'Davet kodları ve ödül kuponları yalnızca bu para birimindeki sepetlerde geçerlidir.',
  },
  'referrals.friend': {
    kind: 'field',
    title: 'Arkadaşın indirimi',
    short: 'Davet koduyla ilk siparişini veren arkadaşa uygulanan kupon indirimi.',
    guideUrl: 'docs/REFERRAL_AFFILIATE_TR.md#davet',
  },
  'referrals.referrer': {
    kind: 'field',
    title: 'Davet edenin ödülü',
    short:
      'Arkadaşın siparişi teslim edilip bekleme süresi geçince davet edene verilen tek kullanımlık kupon.',
    guideUrl: 'docs/REFERRAL_AFFILIATE_TR.md#odul',
  },
  'referrals.reward_type': {
    kind: 'field',
    title: 'İndirim türü',
    short: 'Yüzde (en çok %50) ya da sabit tutar.',
  },
  'referrals.reward_value': {
    kind: 'field',
    title: 'İndirim',
    short: 'Yüzde türünde oran (ör. 10), sabit tutarda tutar (ör. 50,00).',
  },
  'referrals.reward_min': {
    kind: 'field',
    title: 'En az sepet tutarı',
    short: 'Kodun geçerli olması için gereken en az sepet tutarı. Boş: sınır yok.',
  },
  'referrals.hold_days': {
    kind: 'field',
    title: 'Teslimden sonra bekleme',
    short:
      'Ödül, arkadaşın siparişi teslim edildikten bu kadar gün sonra verilir (varsayılan 14: cayma süresi). Bu sürede iptal veya tam iade olursa ödül verilmez.',
    guideUrl: 'docs/REFERRAL_AFFILIATE_TR.md#odul',
  },
  'referrals.valid_days': {
    kind: 'field',
    title: 'Ödül kuponu geçerliliği',
    short: 'Ödül kuponu verildiği andan itibaren bu kadar gün geçerlidir (7–365).',
  },
  'referrals.max_rewards': {
    kind: 'field',
    title: 'Üye başına en çok ödül',
    short: 'Bir üyenin kazanabileceği en çok ödül. Sınır dolunca davet "Ödül sınırı doldu" olarak kapanır.',
  },
  'referrals.save': {
    kind: 'action',
    title: 'Kaydet',
    short:
      'Ayarları kaydeder ve tüm davet kodlarını günceller (iki adımlı doğrulama). Programı açarken onay istenir.',
    requiredPermission: 'Tavsiye programı yönetimi (hassas).',
  },
  'page.affiliates': {
    kind: 'page',
    title: 'İş ortakları',
    short: 'Affiliate ve influencer kayıtları, kupon veya bağlantı eşleşmesi, komisyonlar ve elle ödeme.',
    whatItDoes:
      'Sipariş iş ortağına önce kupon koduyla, kupon yoksa son ziyaretteki utm_source değeriyle bağlanır (yalnızca ziyaretçi ölçüm çerezine izin verdiyse). Komisyon KDV ve kargo hariç ürün tutarı üzerinden hesaplanır; iadelerde oranında düşer. Teslimden 14 gün sonra onaylanır, iptal veya tam iadede iptal olur. Ödemeyi siz yaparsınız: CSV indirip ödeme yaparsınız, sonra "ödendi" işaretlersiniz.',
    whenToUse: 'İş ortağı eklerken, oranı değiştirirken ve dönemsel komisyon ödemesi yaparken.',
    dataChanged: 'Ekleme, değişiklik, CSV indirme ve ödendi işareti denetim kaydına düşer.',
    requiredPermission:
      'Görüntüleme: Kampanyaları görüntüleme. Değiştirme ve ödendi işareti: İş ortağı yönetimi (hassas; iki adımlı doğrulama). E-posta, kişisel veri yetkisi olmadan maskelenir.',
    reversible: 'İş ortağı duraklatılabilir. "Ödendi" işareti geri alınamaz.',
    guideUrl: 'docs/REFERRAL_AFFILIATE_TR.md#is-ortaklari',
  },
  'affiliates.create': {
    kind: 'action',
    title: 'İş ortağı ekle',
    short: 'Yeni affiliate veya influencer kaydı açar.',
    requiredPermission: 'İş ortağı yönetimi (hassas).',
  },
  'affiliates.edit': {
    kind: 'action',
    title: 'Düzenle',
    short:
      'Oran, kupon, kaynak veya durumu değiştirir. Değişiklik yalnızca bundan sonraki siparişlere uygulanır.',
  },
  'affiliates.name': {
    kind: 'field',
    title: 'Ad',
    short: 'İş ortağının ya da kanalın adı. CSV dosyasında görünür.',
  },
  'affiliates.kind': {
    kind: 'field',
    title: 'Tür',
    short:
      'Affiliate (site, blog, karşılaştırma) veya influencer (sosyal medya). Yalnızca ayırt etmek içindir.',
  },
  'affiliates.email': {
    kind: 'field',
    title: 'E-posta',
    short:
      'İletişim için iç kayıt. Sistem iş ortağına e-posta göndermez. Kişisel veri yetkisi olmayanlara maskeli görünür.',
  },
  'affiliates.source': {
    kind: 'field',
    title: 'Bağlantı kaynağı (utm_source)',
    short:
      'İş ortağının bağlantılarına eklenecek değer: küçük harf, rakam, tire ve alt çizgi (2–40). Her iş ortağının kaynağı farklı olmalıdır.',
    guideUrl: 'docs/REFERRAL_AFFILIATE_TR.md#eslesme',
  },
  'affiliates.discount': {
    kind: 'field',
    title: 'Kupon',
    short:
      'İş ortağına özel kupon. Bu kuponla verilen sipariş, bağlantıdan önce bu iş ortağına yazılır. Bir kupon yalnızca bir iş ortağına bağlanabilir.',
    guideUrl: 'docs/REFERRAL_AFFILIATE_TR.md#eslesme',
  },
  'affiliates.rate': {
    kind: 'field',
    title: 'Komisyon oranı',
    short: 'KDV ve kargo hariç ürün tutarı üzerinden yüzde (en çok %50). Sipariş anındaki oran kullanılır.',
    guideUrl: 'docs/REFERRAL_AFFILIATE_TR.md#komisyon',
  },
  'affiliates.status': {
    kind: 'field',
    title: 'Durum',
    short: 'Duraklatılan iş ortağına yeni sipariş yazılmaz; mevcut komisyonları işlemeye devam eder.',
  },
  'affiliates.note': {
    kind: 'field',
    title: 'İç not',
    short: 'Sözleşme veya ödeme bilgisi gibi iç notlar. İş ortağı görmez.',
  },
  'affiliates.save': {
    kind: 'action',
    title: 'Kaydet',
    short: 'İş ortağını kaydeder (iki adımlı doğrulama).',
    requiredPermission: 'İş ortağı yönetimi (hassas).',
  },
  'commissions.filter_affiliate': {
    kind: 'field',
    title: 'İş ortağı süzgeci',
    short: 'Listeyi ve CSV dosyasını tek iş ortağıyla sınırlar.',
  },
  'commissions.filter_status': {
    kind: 'field',
    title: 'Durum süzgeci',
    short: 'Beklemede, onaylandı, ödendi veya iptal. CSV, durum seçilmezse onaylanmış komisyonları indirir.',
  },
  'commissions.export': {
    kind: 'action',
    title: 'CSV indir',
    short:
      'Ödeme için Excel uyumlu CSV (noktalı virgül ayraçlı). Durum seçilmezse onaylanmış ve ödenmemiş komisyonlar gelir.',
    guideUrl: 'docs/REFERRAL_AFFILIATE_TR.md#odeme',
  },
  'commissions.select': {
    kind: 'field',
    title: 'Seçim',
    short: 'Yalnızca onaylanmış komisyonlar seçilebilir ve ödendi işaretlenebilir.',
  },
  'commissions.mark_paid': {
    kind: 'action',
    title: 'Ödendi işaretle',
    short:
      'Seçili onaylanmış komisyonları ödendi yapar. Ödeme sistem dışında yapılır; işaret geri alınamaz ve açıklamasıyla denetim kaydına yazılır.',
    whenToUse: 'İş ortağına komisyon ödemesini banka veya başka bir yolla yaptıktan sonra.',
    dataChanged:
      'Seçili komisyonların durumu "ödendi" olur; ödeme tarihi ve açıklama kaydedilir, adet ve toplam tutar denetim kaydına yazılır.',
    requiredPermission: 'İş ortağı yönetimi (hassas; iki adımlı doğrulama).',
    reversible: 'Hayır, "ödendi" işareti geri alınamaz.',
    commonErrors: [
      {
        problem: '"Yalnızca onaylanmış komisyonlar ödendi olarak işaretlenebilir"',
        solution: 'Seçimden onay bekleyen veya zaten ödenmiş komisyonları çıkarın.',
      },
      {
        problem: '"Bu işlem için doğrulama kodunuzu yeniden girmeniz gerekiyor"',
        solution: 'Doğrulama uygulamanızdaki kodu girip tekrar deneyin.',
      },
    ],
    guideUrl: 'docs/REFERRAL_AFFILIATE_TR.md#odeme',
  },
  'commissions.paid_note': {
    kind: 'field',
    title: 'Ödeme açıklaması',
    short: 'Dekont numarası, tarih gibi ödeme bilgisi (en az 3 karakter). Komisyon satırında görünür.',
  },
  'page.support_tickets': {
    kind: 'page',
    title: 'Destek talepleri',
    short:
      'Müşteri talepleri: durum, atama, öncelik; hazır yanıtlar; destek, memnuniyet ve iade nedenleri raporu.',
    whatItDoes:
      "Müşterinin Hesabım'dan açtığı ve iletişim formundan dönüştürülen talepleri listeler. Liste önce acil, sonra en uzun süredir bekleyen talebi gösterir. Raporda seçilen dönemde açılan/çözülen talepler, ilk yanıt süresi (ortanca), memnuniyet puanları, konular ve (sipariş yetkisiyle) iade nedenleri ile en çok iade edilen ürünler yer alır.",
    whenToUse: 'Her gün yanıt bekleyen talepleri görmek, iş dağıtmak ve hizmet kalitesini izlemek için.',
    dataChanged: 'Bu sayfa yalnızca okur; hazır yanıt ekleme/düzenleme denetim kaydına düşer.',
    requiredPermission:
      'Görüntüleme: Destek taleplerini görüntüleme. Yanıt, atama ve hazır yanıtlar: Destek taleplerini yanıtlama ve yönetme. E-posta, kişisel veri yetkisi olmadan maskelenir.',
    reversible: 'Evet.',
    guideUrl: 'docs/SUPPORT_TR.md#talepler',
  },
  'page.support_ticket': {
    kind: 'page',
    title: 'Destek talebi',
    short: 'Talebin yazışması, müşteriye yanıt, iç not, hazır yanıt; durum, öncelik, konu ve atama.',
    whatItDoes:
      'Müşteriye yazdığınız yanıt talep sayfasında görünür ve e-postayla da gönderilir (e-posta altyapısı kurulu değilse yalnızca sayfada görünür). İç not yalnızca ekipte kalır. Yanıt veren çalışan, talep kimseye atanmamışsa talebi üstlenir. Müşteri yazınca talep "Yanıt bekliyor" olur; çözülen talep müşteri yazarsa yeniden açılır.',
    whenToUse: 'Talebi yanıtlarken, başka bir çalışana devrederken veya çözdüğünüzde.',
    dataChanged: 'Yanıt, iç not ve bilgi değişiklikleri denetim kaydına düşer.',
    requiredPermission: 'Destek taleplerini yanıtlama ve yönetme.',
    reversible: 'Gönderilen yanıt ve e-posta geri alınamaz; durum yeniden değiştirilebilir.',
    guideUrl: 'docs/SUPPORT_TR.md#yanit',
  },
  'support.filter_status': {
    kind: 'field',
    title: 'Durum süzgeci',
    short:
      '"Açık ve bekleyen": yanıt bekleyen ve müşteri yanıtı bekleyen talepler. Çözülen ve kapatılan talepleri ayrıca seçebilirsiniz.',
  },
  'support.filter_assigned': {
    kind: 'field',
    title: 'Atanan süzgeci',
    short: 'Size atanan, kimseye atanmamış veya belirli bir çalışana atanmış talepler.',
  },
  'support.filter_priority': {
    kind: 'field',
    title: 'Öncelik süzgeci',
    short: 'Yalnızca seçilen öncelikteki talepler.',
  },
  'support.search': {
    kind: 'field',
    title: 'Ara',
    short: 'Talep numarası (ör. 12 veya #12), müşterinin tam e-posta adresi ya da konudan bir kelime.',
  },
  'support.report_period': {
    kind: 'field',
    title: 'Rapor dönemi',
    short: 'Son 7, 30, 90 veya 365 gün. "Şu an açık" dönemden bağımsızdır.',
    guideUrl: 'docs/SUPPORT_TR.md#rapor',
  },
  'support.macro_add': {
    kind: 'action',
    title: 'Hazır yanıt ekle',
    short: 'Sık kullanılan bir yanıtı adıyla kaydeder.',
    guideUrl: 'docs/SUPPORT_TR.md#hazir-yanitlar',
  },
  'support.macro_edit': {
    kind: 'action',
    title: 'Düzenle',
    short: 'Hazır yanıtın adını veya metnini değiştirir.',
  },
  'support.macro_delete': {
    kind: 'action',
    title: 'Sil',
    short: 'Hazır yanıtı siler. Daha önce gönderilmiş yanıtlar etkilenmez.',
  },
  'support.macro_title': {
    kind: 'field',
    title: 'Ad',
    short: 'Listede görünen kısa ad (2–80 karakter, benzersiz).',
  },
  'support.macro_body': {
    kind: 'field',
    title: 'Yanıt metni',
    short: 'Eklerken {{name}} müşterinin adıyla değişir. Eklendikten sonra düzenleyebilirsiniz.',
  },
  'support.status': {
    kind: 'field',
    title: 'Durum',
    short:
      'Yanıt bekliyor: sıra sizde. Müşteri yanıtı bekleniyor: yanıt verdiniz. Çözüldü: müşteri yazarsa yeniden açılır, puan verebilir. Kapatıldı: müşteri yanıt yazamaz.',
    guideUrl: 'docs/SUPPORT_TR.md#durumlar',
  },
  'support.priority': {
    kind: 'field',
    title: 'Öncelik',
    short: 'Listede acil ve yüksek öncelikli talepler önce gelir. Müşteri önceliği görmez.',
  },
  'support.category': {
    kind: 'field',
    title: 'Konu',
    short:
      'Talebin konusu (sipariş, kargo, iade…); raporda konulara göre sayılır. Müşteri talep açarken seçer.',
  },
  'support.assignee': {
    kind: 'field',
    title: 'Atanan çalışan',
    short:
      'Talebi takip eden çalışan. Yalnızca destek taleplerini yanıtlama yetkisi olan etkin çalışanlar seçilebilir.',
  },
  'support.notify_resolved': {
    kind: 'field',
    title: 'Çözüldü e-postası',
    short:
      'İşaretliyse müşteriye "talebiniz çözüldü" e-postası ve puanlama bağlantısı gider. Talebin konusuyla ilgili hizmet e-postasıdır; pazarlama izni gerekmez (avukat teyidi bekliyor).',
    guideUrl: 'docs/SUPPORT_TR.md#memnuniyet',
  },
  'support.save_details': {
    kind: 'action',
    title: 'Değişiklikleri kaydet',
    short:
      'Durum, öncelik, konu ve atamayı kaydeder. Başka biri aynı anda değiştirdiyse sayfayı yenilemeniz istenir.',
  },
  'support.insert_macro': {
    kind: 'field',
    title: 'Hazır yanıt ekle',
    short: 'Seçilen hazır yanıt metin kutusuna eklenir; göndermeden önce düzenleyebilirsiniz.',
  },
  'support.reply_body': {
    kind: 'field',
    title: 'Yanıt veya iç not',
    short:
      'En çok 5000 karakter. Yanıt müşteriye gider; iç not gitmez. Müşteriden kart numarası, şifre gibi bilgiler istemeyin.',
  },
  'support.send_reply': {
    kind: 'action',
    title: 'Yanıtı gönder',
    short:
      'Yanıt talep sayfasında görünür ve müşteriye e-postayla gider; durum "Müşteri yanıtı bekleniyor" olur. E-posta altyapısı yoksa yalnızca sayfada görünür.',
    whenToUse:
      'Müşterinin destek talebine yanıt verdiğinizde ve talep henüz çözülmediğinde (müşteriden dönüş bekliyorsanız).',
    dataChanged:
      'Yanıt talebin yazışmasına eklenir, talebin durumu "Müşteri yanıtı bekleniyor" olur; e-posta kuruluysa müşteriye yanıt e-postası gider. İşlem denetim kaydına yazılır.',
    requiredPermission: 'Destek taleplerini yanıtlama ve yönetme.',
    reversible: 'Hayır, gönderilen yanıt ve e-posta geri alınamaz.',
    commonErrors: [
      {
        problem: '"Bu talep kapatıldı; yanıt yazılamaz"',
        solution: 'Kapanmış talebe yanıt yazılmaz; müşteriyle yeni talep üzerinden yazışın.',
      },
    ],
    guideUrl: 'docs/SUPPORT_TR.md#yanit',
  },
  'support.send_resolve': {
    kind: 'action',
    title: 'Gönder ve çözüldü yap',
    short: 'Yanıtı gönderir ve talebi çözüldü yapar; müşteri talep sayfasından puan verebilir.',
  },
  'support.add_note': {
    kind: 'action',
    title: 'İç not ekle',
    short: 'Yalnızca ekibin gördüğü not. Müşteriye gitmez; KVKK veri kopyasında yer alır.',
  },
  'support.convert_subject': {
    kind: 'field',
    title: 'Talep konusu',
    short: 'Talep listesinde ve müşteriye giden e-postada görünür (3–160 karakter).',
  },
  'messages.convert': {
    kind: 'action',
    title: 'Talebe dönüştür',
    short:
      'Mesajı destek talebine çevirir: yazışma, atama ve memnuniyet takibi talep ekranında sürer. Mesaj "işlendi" olur.',
    requiredPermission: 'Destek taleplerini yanıtlama ve yönetme.',
    guideUrl: 'docs/SUPPORT_TR.md#iletisim-formu',
  },
  'page.live_chat': {
    kind: 'page',
    title: 'Canlı sohbet',
    short:
      'Vitrindeki canlı destek sohbetleri: sohbete açık olma, bekleyen/süren sohbetler, yanıt, kapatma, talebe dönüştürme ve ayarlar.',
    whatItDoes:
      'Ziyaretçi sohbeti yalnızca en az bir çalışan "Sohbete açığım" iken (ve bu sayfa açıkken) başlatabilir; değilse pencere mesaj formuna düşer ve mesaj destek talebi olur. Bekleyen sohbeti üstlenen çalışan yanıtlar; ziyaretçi çalışan adını görmez. Hareketsiz sohbet ayarlanan sürede kapanır, kapanan sohbetler saklama süresi sonunda silinir.',
    whenToUse: 'Mesai saatlerinde ziyaretçilere anında yanıt vermek için.',
    dataChanged:
      'Mesajlar, üstlenme, kapatma ve ayar değişiklikleri kaydedilir; ayar ve üstlenme denetim kaydına düşer.',
    requiredPermission:
      'Görüntüleme: Canlı sohbet kuyruğunu görüntüleme. Yanıtlama ve ayarlar: Canlı sohbette yanıtlama. Talebe dönüştürme: Destek taleplerini yanıtlama.',
    reversible: 'Sohbet kapatılınca yeniden açılmaz; ziyaretçi yeni sohbet başlatır.',
    guideUrl: 'docs/LIVE_CHAT_TR.md#calisma',
  },
  'chat.available': {
    kind: 'field',
    title: 'Sohbete açığım',
    short:
      'Açıkken ve bu sayfa açık durdukça ziyaretçiler sohbet başlatabilir. Sayfadan çıkınca 90 saniye içinde çevrimdışı sayılırsınız.',
    guideUrl: 'docs/LIVE_CHAT_TR.md#calisma',
  },
  'chat.claim': {
    kind: 'action',
    title: 'Üstlen',
    short:
      'Bekleyen sohbeti size bağlar; ziyaretçiye "bir temsilcimiz katıldı" yazar. Başkasının sohbetine yazılamaz.',
  },
  'chat.reply': {
    kind: 'field',
    title: 'Yanıt',
    short: 'En çok 2000 karakter. Ziyaretçiden kart numarası, şifre veya doğrulama kodu istemeyin.',
  },
  'chat.send': {
    kind: 'action',
    title: 'Gönder',
    short: 'Mesajı ziyaretçiye gönderir (bekleyen sohbeti üstlenir).',
  },
  'chat.close': {
    kind: 'action',
    title: 'Sohbeti kapat',
    short: 'Sohbeti bitirir; ziyaretçi yeni sohbet başlatabilir. Konu sürecekse önce talebe dönüştürün.',
  },
  'chat.convert': {
    kind: 'action',
    title: 'Talebe dönüştür',
    short:
      'Sohbeti destek talebine taşır ve kapatır (ziyaretçinin e-postası gerekir). Takip ve e-postayla yanıt talep ekranında sürer.',
    requiredPermission: 'Destek taleplerini yanıtlama ve yönetme.',
    guideUrl: 'docs/LIVE_CHAT_TR.md#talep',
  },
  'chat.enabled': {
    kind: 'field',
    title: 'Vitrinde canlı destek penceresi',
    short:
      'Açıkken vitrinde "Canlı destek" düğmesi görünür. Varsayılan kapalı; KVKK aydınlatma metni yayımda olmalıdır.',
    guideUrl: 'docs/LIVE_CHAT_TR.md#ayarlar',
  },
  'chat.retention': {
    kind: 'field',
    title: 'Saklama süresi',
    short: 'Kapanan sohbetler bu kadar gün sonra mesajlarıyla birlikte silinir (30–730, varsayılan 180).',
    guideUrl: 'docs/LIVE_CHAT_TR.md#kvkk',
  },
  'chat.idle': {
    kind: 'field',
    title: 'Hareketsizlik süresi',
    short:
      'Bu kadar dakika mesaj gelmeyen bekleyen veya süren sohbet kendiliğinden kapanır (10–240, varsayılan 30).',
  },
  'chat.save': {
    kind: 'action',
    title: 'Ayarları kaydet',
    short: 'Sohbet ayarlarını kaydeder; denetim kaydına düşer.',
  },
  'page.google_ads_campaigns': {
    kind: 'page',
    title: 'Google Ads kampanyaları',
    short:
      'Ürünlerinizden Performance Max ve Alışveriş kampanyaları hazırlar, onaylatır ve Google Ads API ile uygular.',
    whatItDoes:
      'Kampanya taslağı sihirbazla hazırlanır ve onaya gönderilir. Onaylanınca sistem kampanyayı Google Ads’te DURAKLATILMIŞ oluşturur, Google’dan geri okuyup doğrular. Yayına alma, bütçe artırma, teklif değişikliği, hedeflemeyi genişletme, kaldırma ve Google önerileri onay ve iki adımlı doğrulama ister; duraklatma, bütçe azaltma ve ad değişikliği onaysızdır. Aylık reklam bütçesi tavanı tanımlanmadan harcatan işlem onaylanamaz.',
    requiredPermission:
      'Görüntüleme: Reklam raporlarını görüntüleme. Taslak, istek ve ürün: Reklam hesaplarını yönetme. Onay ve ayarlar: Reklam değişikliklerini onaylama (iki adımlı doğrulama). Acil durdurma: yalnızca işletme sahibi.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md',
  },
  'page.google_ads_campaign': {
    kind: 'page',
    title: 'Google Ads kampanyası',
    short: 'Kampanyanın değerleri, ürünleri ve Google’daki durumu; değişiklik istekleri ve geçmişi.',
    whatItDoes:
      'Buradan yayına alma, duraklatma, bütçe, teklif, hedefleme, ad ve kaldırma istenir. Google Ads’te elle yapılan bir değişiklik “Google Ads’te değiştirildi” olarak gösterilir; sistem Google’daki değerin üzerine yazmaz.',
    requiredPermission:
      'Görüntüleme: Reklam raporlarını görüntüleme. Taslak, istek ve ürün: Reklam hesaplarını yönetme. Onay ve ayarlar: Reklam değişikliklerini onaylama (iki adımlı doğrulama). Acil durdurma: yalnızca işletme sahibi.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md',
  },
  'gads.settings': {
    kind: 'action',
    title: 'Bütçe tavanı ve ayarlar',
    short: 'Aylık reklam bütçesi tavanı ve tavanda otomatik durdurma.',
    whatItDoes:
      'Tavan, yayına alma ve bütçe artırma onaylanırken denetlenir: tüm yayındaki kampanyaların günlük bütçeleri × 30,4 tavanı aşamaz. Otomatik durdurma varsayılan kapalıdır.',
    whenToUse:
      'Google Ads ile harcama yapmaya başlamadan önce aylık bütçe tavanını belirlemek veya değiştirmek istediğinizde.',
    dataChanged:
      'Aylık reklam bütçesi tavanı ve tavanda otomatik durdurma ayarı kaydedilir; değişiklik denetim kaydına yazılır. Sonraki onaylarda bu tavan denetlenir.',
    requiredPermission: 'Reklam bütçe ve yayın değişikliklerini onaylama (hassas; iki adımlı doğrulama).',
    reversible: 'Evet, ayar yeniden değiştirilebilir.',
    commonErrors: [
      {
        problem: '"Bu işlem için doğrulama kodunuzu yeniden girmeniz gerekiyor"',
        solution: 'Doğrulama uygulamanızdaki kodu girip tekrar deneyin.',
      },
    ],
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#aylik-tavan',
  },
  'gads.new_campaign': {
    kind: 'action',
    title: 'Yeni kampanya',
    short: 'Sihirbaz: mağaza, tür, ürünler, bütçe ve teklif, bölge/dil/tarih, özet.',
    whatItDoes:
      'Google bağlantıları eksikse (Google Ads hesabı, Merchant Center, Merchant ↔ Ads bağlantısı, satın alma dönüşümü) sihirbaz nedenini söyleyerek kilitli kalır.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#sihirbaz',
  },
  'gads.stop_all': {
    kind: 'action',
    title: 'Tüm Google kampanyalarını durdur',
    short: 'Acil durum: yayındaki tüm kampanyaları duraklatır, bekleyen harcama isteklerini iptal eder.',
    whatItDoes:
      'Yalnızca işletme sahibi kullanabilir ve iki adımlı doğrulama ister. Duraklatma işlemleri kuyruğun önüne girer.',
    whenToUse:
      'Reklam harcaması kontrolden çıktığında, yanlış bir kampanya yayına girdiğinde veya hesabın güvenliğinden şüphelendiğinizde.',
    dataChanged:
      'Yayındaki her Google kampanyası için duraklatma işlemi kuyruğun önüne eklenir; onay bekleyen veya sırada olan yayına alma, bütçe ve teklif istekleri iptal edilir. Duraklatılan ve iptal edilen sayılar denetim kaydına yazılır.',
    requiredPermission:
      'Yalnızca işletme sahibi; reklam bütçe ve yayın değişikliklerini onaylama (son 15 dakikada iki adımlı doğrulama).',
    reversible:
      'Kısmen: kampanyalar yeniden yayına alma isteğiyle (onayla) açılabilir; iptal edilen istekler yeniden oluşturulmalıdır.',
    commonErrors: [
      {
        problem: '"Bu işlem için yetkiniz yok"',
        solution: 'Acil durdurmayı yalnızca işletme sahibi kullanabilir.',
      },
      {
        problem: '"Bu işlem için doğrulama kodunuzu yeniden girmeniz gerekiyor"',
        solution: 'Doğrulama uygulamanızdaki kodu girip hemen tekrar deneyin.',
      },
    ],
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#aylik-tavan',
  },
  'gads.month': {
    kind: 'field',
    title: 'Bu ay',
    short: 'Ay içi harcama, tavan, tahmini aylık üst sınır ve bugünkü API işlemi.',
    whatItDoes:
      'Harcama Google Ads eşitlemesinden gelir (reklam merkezi). Tahmini aylık üst sınır = yayındaki kampanyaların günlük bütçeleri × 30,4.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#aylik-tavan',
  },
  'gads.campaigns': {
    kind: 'field',
    title: 'Kampanyalar',
    short: 'Tüm Google Ads kampanyaları: durum, bütçe, aylık en fazla, harcama, uyarılar.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#islemler-ve-onay',
  },
  'gads.approvals': {
    kind: 'field',
    title: 'Onay bekleyenler',
    short: 'Para harcatabilecek istekler ve para etkisi.',
    whatItDoes:
      'Her istekte günlük bütçe, Google’ın bir günde harcayabileceği en fazla tutar (2×), aylık en fazla (≈ günlük × 30,4) ve tüm yayındakilerle tavana göre durum gösterilir.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#islemler-ve-onay',
  },
  'gads.decide': {
    kind: 'action',
    title: 'Onayla / Reddet',
    short: 'Onay iki adımlı doğrulama ister; kendi isteğinizi yalnızca işletme sahibi onaylar.',
    whenToUse:
      'Bir ekip arkadaşınızın gönderdiği Google Ads isteğini (yayına alma, bütçe veya teklif artırma, metin değişikliği) inceledikten sonra.',
    dataChanged:
      'Onaylanan işlem "sırada" durumuna geçer ve arka plan işi tarafından Google Ads\'e uygulanır; reddedilen işlem kapanır. Karar ve not denetim kaydına yazılır.',
    requiredPermission: 'Reklam bütçe ve yayın değişikliklerini onaylama (hassas; iki adımlı doğrulama).',
    reversible:
      "Kısmen: onaylanan işlem Google'a uygulanmadan önce iptal edilebilir; uygulandıktan sonra ters yönde yeni bir istek gerekir.",
    commonErrors: [
      {
        problem: '"Kendi isteğinizi onaylayamazsınız"',
        solution: 'Başka bir onay yetkilisi veya işletme sahibi onaylamalı.',
      },
      {
        problem: '"Aylık reklam bütçesi tavanı tanımlı değil" veya "tavanı aşıyor"',
        solution: '"Bütçe tavanı ve ayarlar"dan tavanı belirleyin ya da kampanyanın bütçesini azaltın.',
      },
      {
        problem: '"Kampanyada ürün yok" veya "anahtar kelime yok"',
        solution: 'Yayına almadan önce kampanyaya ürün veya anahtar kelime ekleyin.',
      },
    ],
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#islemler-ve-onay',
  },
  'gads.decision_note': {
    kind: 'field',
    title: 'Not',
    short: 'Kararın gerekçesi; denetim kaydına yazılır.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#islemler-ve-onay',
  },
  'gads.monthly_cap': {
    kind: 'field',
    title: 'Aylık reklam bütçesi tavanı',
    short: 'Tüm Google Ads kampanyaları için aylık üst sınır.',
    whatItDoes: 'Boşsa yayına alma ve bütçe artırma onaylanamaz.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#aylik-tavan',
  },
  'gads.auto_stop': {
    kind: 'field',
    title: 'Otomatik durdurma',
    short: 'Varsayılan kapalı. Ay içi harcama tavana ulaşınca yayındaki kampanyalar onaysız duraklatılır.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#aylik-tavan',
  },
  'gads.daily_limit': {
    kind: 'field',
    title: 'Günlük API işlem sınırı',
    short: 'Explorer erişiminde Google gerçek hesapta günlük işlem sayısını sınırlar.',
    whatItDoes:
      'Sınır dolacaksa işlem ertesi sabah uygulanır; Google’ın kota hatasında artan beklemeyle yeniden denenir.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#isci',
  },
  'gads.submit': {
    kind: 'action',
    title: 'Taslak kaydet / Onaya gönder',
    short:
      'Taslak Google’a gitmez; onaya gönderilen kampanya onaylanınca Google’da duraklatılmış oluşturulur.',
    whenToUse:
      'Yeni Google kampanyası sihirbazının son adımında: üzerinde çalışmaya devam edecekseniz taslak olarak kaydetmek, hazırsa onaya göndermek için.',
    dataChanged:
      'Kampanya taslağı, ürünleri ve (arama kampanyasında) reklam metniyle anahtar kelimeleri kaydedilir; Google\'a henüz bir şey gitmez. "Onaya gönder" seçilirse oluşturma isteği onay bekleyenlere eklenir ve denetim kaydına yazılır.',
    requiredPermission: 'Reklam hesapları, veri yükleme ve değişiklik isteği.',
    reversible:
      "Evet, Google'a gitmeden önce taslak düzenlenebilir veya silinebilir, bekleyen istek iptal edilebilir.",
    commonErrors: [
      {
        problem: 'Bazı ürünler "uygun değil" olarak listelendi',
        solution: 'Listede yazan nedeni (ör. fiyatsız, yayında değil) giderip ürünü sonradan ekleyin.',
      },
      {
        problem: 'Metin uzman incelemesi bekliyor',
        solution:
          'Reklam metninde sağlık beyanı bulunduysa Veteriner Uzman İnceleyici onaylamadan kampanya ilerlemez.',
      },
    ],
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#sihirbaz',
  },
  'gads.store': {
    kind: 'field',
    title: 'Mağaza',
    short: 'Kampanyanın Google Ads ve Merchant Center hesapları mağazanın Google bağlantılarından gelir.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#sihirbaz',
  },
  'gads.kind': {
    kind: 'field',
    title: 'Kampanya türü',
    short: 'Performance Max tüm Google kanallarında; Alışveriş yalnızca Google Alışveriş’te.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#sihirbaz',
  },
  'gads.name': {
    kind: 'field',
    title: 'Kampanya adı',
    short: 'Google Ads’te görünen ad; hesapta benzersiz olmalı.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#sihirbaz',
  },
  'gads.daily_budget': {
    kind: 'field',
    title: 'Günlük bütçe',
    short: 'Google bir günde 2 katına kadar harcayabilir; aylık en fazla ≈ günlük × 30,4.',
    whatItDoes: 'Artırmak onay ister; azaltmak onaysızdır (onay kutusu ve denetim kaydı).',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#sihirbaz',
  },
  'gads.bidding': {
    kind: 'field',
    title: 'Teklif stratejisi',
    short: 'Performance Max: dönüşüm değeri veya dönüşüm; Alışveriş: dönüşüm değeri veya tıklama.',
    whatItDoes:
      'Kampanya yalnızca “Satın alma” dönüşümünü teklife esas alır. Teklif değişikliği her zaman onay ister.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#sihirbaz',
  },
  'gads.target_roas': {
    kind: 'field',
    title: 'Hedef ROAS',
    short: 'Harcanan her birime karşı hedeflenen dönüşüm değeri (yüzde). Düşürmek harcamayı artırabilir.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#sihirbaz',
  },
  'gads.target_cpa': {
    kind: 'field',
    title: 'Hedef dönüşüm başı maliyet',
    short: 'Bir satın alma için hedeflenen ortalama maliyet. Yükseltmek harcamayı artırabilir.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#sihirbaz',
  },
  'gads.request_note': {
    kind: 'field',
    title: 'Not',
    short: 'Onaylayana gerekçe; denetim kaydına yazılır.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#sihirbaz',
  },
  'gads.products': {
    kind: 'field',
    title: 'Ürünler',
    short: 'Kampanyaya yalnızca Google feed’ine giren ve başka kampanyada olmayan ürünler eklenir.',
    whatItDoes:
      'Feed’e girmeyen ürünün nedeni gösterilir (veteriner onayı yok, sağlık beyanı, görsel, fiyat…). Aynı ürün iki kampanyada olamaz.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#sihirbaz',
  },
  'gads.countries': {
    kind: 'field',
    title: 'Ülkeler',
    short: 'Reklamların gösterileceği ülkeler. Ülke eklemek onay ister; çıkarmak onaysızdır.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#sihirbaz',
  },
  'gads.languages': {
    kind: 'field',
    title: 'Diller',
    short: 'Hedeflenen kullanıcı dilleri. Dil eklemek onay ister.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#sihirbaz',
  },
  'gads.dates': {
    kind: 'field',
    title: 'Tarihler',
    short: 'Başlangıç ve bitiş (hesabın saat diliminde). Bitişi uzatmak veya kaldırmak onay ister.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#sihirbaz',
  },
  'gads.label': {
    kind: 'field',
    title: 'Ürün etiketi',
    short: 'Merchant’a custom_label_0 olarak giden kampanya etiketi; ürün filtresi bu etiketi içerir.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#urun-bazli-yonetim',
  },
  'gads.accept_google': {
    kind: 'action',
    title: 'Google’daki değerleri kabul et',
    short: 'Sistemdeki kaydı Google Ads’teki değerlere uyarlar; Google’a istek gitmez.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#uyusmazlik',
  },
  'gads.operations': {
    kind: 'action',
    title: 'Kampanya işlemleri',
    short: 'Onay gerektirenler onaya, gerektirmeyenler onay kutusuyla doğrudan kuyruğa girer.',
    whatItDoes:
      'Onaysız: duraklatma, bütçe azaltma, ad, hedeflemeyi daraltma. Onaylı: yayına alma, bütçe artırma, teklif, hedeflemeyi genişletme, kaldırma (geri döndürülemez).',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#islemler-ve-onay',
  },
  'gads.product_states': {
    kind: 'field',
    title: 'Ürün durumu',
    short:
      'Kuyrukta → Google’a iletildi — işleniyor → Uygun / Sınırlı / Uygun değil (Google’ın nedenleriyle).',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#urun-bazli-yonetim',
  },
  'gads.operation_history': {
    kind: 'field',
    title: 'İşlemler',
    short: 'Kim istedi, kim onayladı, Google’a uygulandı mı; hata varsa nedeni.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#islemler-ve-onay',
  },
  'gads.recommendations': {
    kind: 'action',
    title: 'Google önerileri',
    short: 'Google’dan istek anında okunur; uygulamak her zaman onay ister.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#google-okunanlar',
  },
  'gads.change_history': {
    kind: 'action',
    title: 'Değişiklik geçmişi',
    short: 'Google Ads’in son 14 günlük değişiklik kaydı; saklanmaz.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#google-okunanlar',
  },
  'gads.send_operation': {
    kind: 'action',
    title: 'Gönder',
    short:
      'Onaylı işlem onaya, onaysız işlem kuyruğa girer; işçi önce doğrulama isteği gönderir, sonra uygular ve geri okur.',
    whenToUse:
      "Google'da oluşturulmuş bir kampanyada yayına alma, duraklatma, bütçe, teklif veya hedefleme değişikliği istemek için.",
    dataChanged:
      'İşlem isteği kaydedilir: onay gerektirenler "onay bekliyor"a, gerektirmeyenler (duraklatma, bütçe azaltma gibi) onay kutusu işaretliyse doğrudan kuyruğa girer. Kuyruktaki işlem Google Ads\'e uygulanır ve sonucu geri okunur.',
    requiredPermission: 'Reklam hesapları, veri yükleme ve değişiklik isteği.',
    reversible:
      "Kısmen: onay bekleyen veya sıradaki işlem iptal edilebilir; Google'a uygulanmış değişiklik ters yönde yeni istekle düzeltilir.",
    commonErrors: [
      {
        problem: '"Bu kampanyada bekleyen bir işlem var"',
        solution: 'Önce o işlemin sonucunu bekleyin veya iptal edin (duraklatma her zaman istenebilir).',
      },
      { problem: '"Değer zaten aynı; değişiklik yok"', solution: 'Farklı bir değer girin.' },
      {
        problem: '"Kampanya henüz Google Ads\'te oluşturulmadı"',
        solution: 'Önce taslağı onaya gönderip oluşturulmasını bekleyin.',
      },
    ],
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#islemler-ve-onay',
  },
  'gads.product_box': {
    kind: 'field',
    title: 'Google reklamları',
    short: 'Ürünün Google Ads kampanyası, Google’daki durumu ve uygunluğu.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#urun-bazli-yonetim',
  },
  'gads.bulk': {
    kind: 'action',
    title: 'Google kampanyasına ekle / çıkar',
    short: 'Seçili ürünleri bir kampanyaya ekler veya çıkarır; uygun olmayanlar nedenleriyle listelenir.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#urun-bazli-yonetim',
  },
  'gads.filter': {
    kind: 'field',
    title: 'Google reklamları süzgeci',
    short: 'Ürünleri kampanyadaki durumlarına göre süzer.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#urun-bazli-yonetim',
  },
  'gads.search_source': {
    kind: 'field',
    title: 'Taslak kaynağı',
    short: 'Reklam taslağının üretileceği ürün veya kategori.',
    whatItDoes:
      'Metin seçilen kaydın adından, markasından, kategorisinden ve açıklamalarından çıkarılır; veride olmayan iddia yazılmaz. Ürün mağazada yayında olmalı; sağlık içerikli ürünün metni veteriner onaylı olmalı.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#arama-sihirbaz',
  },
  'gads.search_suggest': {
    kind: 'action',
    title: 'Veriden taslak oluştur',
    short: 'Başlık, açıklama, görünen yol ve anahtar kelime önerir; siz düzenleyip onaya gönderirsiniz.',
    whatItDoes: 'Google’a bir şey gitmez. Eksik başlık veya açıklama sayısı ayrıca belirtilir.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#arama-sihirbaz',
  },
  'gads.search_final_url': {
    kind: 'field',
    title: 'Son URL',
    short: 'Reklama tıklayan kişinin açacağı sayfa; mağazanın kendi alan adında olmalı.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#arama-sihirbaz',
  },
  'gads.search_path': {
    kind: 'field',
    title: 'Görünen yol',
    short: 'Reklamda alan adının arkasında görünen iki parça (her biri en çok 15 karakter).',
    whatItDoes: 'Yalnızca görünüştür; açılan sayfa son URL’dir. Harf, rakam ve tire kullanılır.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#arama-sihirbaz',
  },
  'gads.search_headlines': {
    kind: 'field',
    title: 'Başlıklar',
    short: '3–15 başlık, her biri en çok 30 karakter; Google birleşimleri kendisi dener.',
    whatItDoes:
      'Sabitleme bir başlığı belirli konuma kilitler; çok sabitleme reklamın performansını düşürür. Sağlık ürünlerinde “tedavi eder”, “önler” gibi ifadeler kullanılmaz; bulgu varsa uzman onayı gerekir.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#arama-sihirbaz',
  },
  'gads.search_descriptions': {
    kind: 'field',
    title: 'Açıklamalar',
    short: '2–4 açıklama, her biri en çok 90 karakter.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#arama-sihirbaz',
  },
  'gads.search_keywords': {
    kind: 'field',
    title: 'Anahtar kelimeler',
    short: 'Reklamın hangi aramalarda görünebileceği; eşleme türüyle (geniş, sıralı, tam).',
    whatItDoes: 'Anahtar kelime eklemek erişimi genişletir ve onay ister; yalnızca çıkarmak onaysızdır.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#arama-sihirbaz',
  },
  'gads.search_negatives': {
    kind: 'field',
    title: 'Negatif anahtar kelimeler',
    short: 'Reklamın görünmemesi gereken aramalar (ör. “ücretsiz”).',
    whatItDoes: 'Negatif eklemek erişimi daraltır (onaysız); çıkarmak genişletir ve onay ister.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#arama-sihirbaz',
  },
  'gads.search_ideas': {
    kind: 'action',
    title: 'Anahtar kelime öner',
    short: 'Google’ın planlama hizmetinden öneri ve aylık arama sayısı.',
    whatItDoes:
      'Google Ads API’de Basic erişim gerekir; Explorer erişiminde “Basic erişim gerekli” görünür ve Google’a istek gitmez. Öneriler saklanmaz.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#anahtar-kelime-onerisi',
  },
  'gads.text_review': {
    kind: 'field',
    title: 'Uzman incelemesi',
    short: 'Reklam metninde sağlık beyanı bulgusu varsa Veteriner Uzman İnceleyici onayı gerekir.',
    whatItDoes:
      'Karar metnin özetine bağlıdır; metin değişince yeniden incelenir. Uzman onayı olmadan oluşturma veya metin değişikliği onaylanamaz.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#uzman-onayi',
  },
  'gads.text_review_decide': {
    kind: 'action',
    title: 'Metni onayla / reddet',
    short: 'Uzman kararı; ret gerekçe ister.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#uzman-onayi',
  },
  'gads.search_edit_ad': {
    kind: 'action',
    title: 'Reklam metnini düzenle',
    short: 'Taslakta doğrudan kaydedilir; Google’daki kampanyada metin değişikliği onaylı istektir.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#arama-kampanya-sayfasi',
  },
  'gads.search_edit_keywords': {
    kind: 'action',
    title: 'Anahtar kelimeleri düzenle',
    short: 'Eklemek onay ister; yalnızca çıkarmak onay kutusuyla hemen uygulanır.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#arama-kampanya-sayfasi',
  },
  'gads.search_edit_negatives': {
    kind: 'action',
    title: 'Negatifleri düzenle',
    short: 'Eklemek onay kutusuyla hemen uygulanır; çıkarmak onay ister.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#arama-kampanya-sayfasi',
  },
  'gads.search_google_state': {
    kind: 'field',
    title: 'Google’daki durum',
    short: 'Google’ın politika onayı, inceleme durumu ve reklam gücü (saatte bir okunur).',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#arama-elle-degisiklik',
  },
  'gads.access_level': {
    kind: 'field',
    title: 'Google Ads API erişim düzeyi',
    short: 'Google Cloud projenizin Google’dan aldığı düzey: Explorer, Basic veya Standard.',
    whatItDoes:
      'Explorer’da anahtar kelime önerisi (planlama) kapalıdır. Google Basic onayını verdiğinde burada “Basic” seçin; sistem Google’a sormadan önce bu ayara bakar.',
    guideUrl: 'docs/GOOGLE_ADS_CAMPAIGNS_TR.md#anahtar-kelime-onerisi',
  },
  'page.needs_finder': {
    kind: 'page',
    title: 'İhtiyaç bulucu',
    short: 'Evcil Dostumun İhtiyacı soru setini düzenler, uzmana onaylatır ve vitrinde yayınlar.',
    whatItDoes:
      'Ziyaretçi türünü, temel bilgileri ve destek alanlarını seçer, birkaç soruyu cevaplar; sabit kurallar ona uygun ürünlerden bir bakım rutini önerir (yapay zekâ yok). Acil durum seçeneği işaretlenirse ürün önerilmez, veteriner hekime yönlendirilir. Cevaplar ziyaretçinin tarayıcısında kalır. Taslak, Veteriner Uzman İnceleyici onayı olmadan yayına alınamaz.',
    requiredPermission:
      'Görüntüleme: İçeriği görüntüleme. Düzenleme ve incelemeye gönderme: İçerik düzenleme. Onay: Uzman incelemesi (Veteriner Uzman İnceleyici). Yayın ve Dostumu kaydet ayarı: İçerik yayınlama.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md',
  },
  'needs_finder.generate': {
    kind: 'action',
    title: 'Ürün verisinden ilk taslak',
    short:
      'Kategorilerden destek alanları, ürünlerden öneri kuralları ve genel bir acil durum sorusu üretir.',
    whatItDoes:
      'Yalnızca vitrinde görünen ve hedef türü seçilmiş ürünler kullanılır. Ürünün uyarı metninde gebelik/emzirme geçiyorsa gebelikte hariç tutma eklenir. Üretilen metinler taslaktır; uzman incelemeden yayına çıkmaz.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#ilk-taslak',
  },
  'needs_finder.start_empty': {
    kind: 'action',
    title: 'Boş taslak',
    short: 'Alan, soru ve kural olmadan başlar; her şeyi siz eklersiniz.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#ilk-taslak',
  },
  'needs_finder.save': {
    kind: 'action',
    title: 'Taslağı kaydet',
    short: 'Düzenlemeleri kaydeder; içerik değiştiyse uzman onayı düşer.',
    whatItDoes:
      'Kayıt sırasında kimlikler, koşullardaki alan/soru başvuruları ve ürünler denetlenir; hata varsa yeriyle listelenir. Vitrin yayındaki onaylı hâli göstermeye devam eder.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.status': {
    kind: 'field',
    title: 'Durum ve yayın',
    short: 'İnceleme durumu, vitrindeki hâl ve kontrol listesi.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#onay-ve-yayin',
  },
  'needs_finder.problems': {
    kind: 'field',
    title: 'Kontrol listesi',
    short: 'Yayına engel olan (kırmızı) ve dikkat edilmesi gereken (sarı) noktalar.',
    whatItDoes:
      'Yayın için en az bir destek alanı, bir öneri kuralı ve bir acil durum seçeneği gerekir. Vitrinde görünmeyen veya türü uyuşmayan ürün önerilmez.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#onay-ve-yayin',
  },
  'needs_finder.submit': {
    kind: 'action',
    title: 'İncelemeye gönder',
    short: 'Kaydedilmiş taslağı Veteriner Uzman İnceleyici onayına gönderir.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#onay-ve-yayin',
  },
  'needs_finder.review': {
    kind: 'action',
    title: 'Uzman kararı',
    short: 'Veteriner Uzman İnceleyici taslağı onaylar veya gerekçeyle reddeder.',
    whatItDoes:
      'Karar, ekrandaki içeriğe (özetine) verilir; taslak sonradan değişirse onay düşer. Ret için not zorunludur.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#onay-ve-yayin',
  },
  'needs_finder.review_note': {
    kind: 'field',
    title: 'Uzman notu',
    short: 'Kararın gerekçesi; retta zorunlu, denetim kaydına yazılır.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#onay-ve-yayin',
  },
  'needs_finder.findings': {
    kind: 'field',
    title: 'Sağlık beyanı bulguları',
    short: 'Metinlerde hastalığı önleme/tedavi gibi ifadeler; kesin karar değildir, uzman değerlendirir.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#onay-ve-yayin',
  },
  'needs_finder.products': {
    kind: 'field',
    title: 'Önerilebilecek ürünler',
    short: 'Kurallarda ve alternatiflerde geçen tüm ürünler, gerekçeleri ve vitrindeki durumları.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#ilk-taslak',
  },
  'needs_finder.publish': {
    kind: 'action',
    title: 'Yayına al',
    short: 'Uzmanın onayladığı taslağı vitrinde /ihtiyac-bulucu sayfasında yayınlar.',
    whatItDoes:
      'Üst menü Menüler sayfasında tanımlanmamışsa varsayılan menüye "Evcil Dostumun İhtiyacı" eklenir; sayfa site haritasına girer.',
    whenToUse:
      'İhtiyaç bulucu taslağı Veteriner Uzman İnceleyici tarafından onaylandıktan sonra vitrinde açmak için.',
    dataChanged:
      'Onaylı taslak, vitrindeki /ihtiyac-bulucu sayfasının yayındaki içeriği olur; yayımlayan kişi ve tarih kaydedilir, işlem denetim kaydına yazılır.',
    requiredPermission: 'İçerik yayınlama.',
    reversible: 'Evet, "Yayından kaldır" ile vitrin sayfası kapatılır; taslak ve onay korunur.',
    commonErrors: [
      {
        problem: '"Sağlık içeriği veya sağlık beyanı var: … uzman onayı gerekir"',
        solution: 'Taslağı incelemeye gönderin; uzman onayladıktan sonra değiştirmeden yayına alın.',
      },
      {
        problem: '"Ürün bulunamadı (silinmiş olabilir)" veya "En az bir öneri kuralı ekleyin"',
        solution: 'Taslaktaki eksikleri düzeltip kaydedin; içerik değişince onay yeniden istenir.',
      },
    ],
    guideUrl: 'docs/NEEDS_FINDER_TR.md#onay-ve-yayin',
  },
  'needs_finder.unpublish': {
    kind: 'action',
    title: 'Yayından kaldır',
    short: 'Vitrin sayfasını kapatır; taslak ve onay korunur.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#onay-ve-yayin',
  },
  'needs_finder.regenerate': {
    kind: 'action',
    title: 'Taslağı yeniden üret',
    short: 'Mevcut taslağın yerine ürün verisinden yeni taslak üretir; düzenlemeler ve onay düşer.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#ilk-taslak',
  },
  'needs_finder.pet_profiles': {
    kind: 'field',
    title: 'Dostumu kaydet',
    short: 'Üye, dostunun temel bilgilerini açık rızayla hesabına kaydedebilir. Varsayılan kapalı.',
    whatItDoes:
      'Kaydedilenler: tür, yaş, kilo aralığı, kısırlaştırma, gebelik/emzirme ve seçilen alanlar; sağlık sorularının cevapları kaydedilmez. Kayıt KVKK verilerin kopyası ve silme taleplerine dahildir. Açmadan önce rıza metnini avukatınıza onaylatın.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#dostumu-kaydet',
  },
  'needs_finder.translations': {
    kind: 'field',
    title: 'Diğer diller',
    short: 'Metnin İngilizce, Almanca ve Arapça hâli; boşsa vitrinde Türkçe gösterilir.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.condition': {
    kind: 'field',
    title: 'Koşul',
    short:
      'Kural, soru veya hariç tutmanın ne zaman geçerli olduğu: tür, yaş, kilo, kısırlaştırma, gebelik, alan, cevap.',
    whatItDoes:
      'Doldurulan her bölüm tutmalı (VE); bir bölümdeki işaretlerden biri yeterli (VEYA). Boş koşul her zaman geçerlidir.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.row_actions': {
    kind: 'action',
    title: 'Sırala, düzenle, sil',
    short: 'Öğenin sırasını değiştirir, düzenler veya taslaktan çıkarır; kaydedene kadar geri alınabilir.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.areas': {
    kind: 'field',
    title: 'Destek alanları',
    short: 'Ziyaretçinin seçtiği konular; yalnızca işaretli türlerde gösterilir.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.area_label': {
    kind: 'field',
    title: 'Alan adı',
    short: 'Vitrinde gösterilen ad (ör. "Eklem").',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.area_description': {
    kind: 'field',
    title: 'Kısa açıklama',
    short: 'Alanın altında gösterilen tek cümle; isteğe bağlı.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.area_species': {
    kind: 'field',
    title: 'Gösterildiği türler',
    short: 'Alan yalnızca bu türler seçildiğinde listelenir.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.area_categories': {
    kind: 'field',
    title: 'İlgili kategoriler',
    short: 'Alanın hangi ürün kategorilerinden geldiği (taslak üretimi ve takip için).',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.id': {
    kind: 'field',
    title: 'Kimlik',
    short: 'Koşullarda kullanılan kısa ad; kaydettikten sonra değiştirmeyin.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.questions': {
    kind: 'field',
    title: 'Sorular',
    short: 'Sırayla sorulan sorular; alana veya önceki cevaba göre dallanır.',
    whatItDoes: 'En az bir soruda acil durum seçeneği olmalıdır. Görünmeyen sorunun cevabı hesaba katılmaz.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.question_text': {
    kind: 'field',
    title: 'Soru metni',
    short: 'Ziyaretçiye sorulan cümle. Dozaj veya teşhis sorusu yazmayın.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.question_help': {
    kind: 'field',
    title: 'Yardım metni',
    short: 'Sorunun altında gösterilen kısa açıklama; isteğe bağlı.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.question_area': {
    kind: 'field',
    title: 'Bağlı olduğu alan',
    short: 'Seçilirse soru yalnızca bu alan seçildiğinde sorulur; "Genel" her ziyaretçiye.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.question_multiple': {
    kind: 'field',
    title: 'Çoklu seçim',
    short: 'Ziyaretçi birden çok seçenek işaretleyebilir.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.options': {
    kind: 'field',
    title: 'Seçenekler',
    short: 'Sorunun cevapları (2–12).',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.option_label': {
    kind: 'field',
    title: 'Seçenek metni',
    short: 'Vitrinde cevap olarak gösterilir.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.option_emergency': {
    kind: 'field',
    title: 'Acil durum seçeneği',
    short: 'Seçilirse ürün önerilmez; "Lütfen önce bir veteriner hekime başvurun" gösterilir.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#acil-durum',
  },
  'needs_finder.option_exclusive': {
    kind: 'field',
    title: 'Tek başına seçilir',
    short: 'Çoklu soruda "Hiçbiri" gibi: seçilince diğerleri kalkar.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.rules': {
    kind: 'field',
    title: 'Öneri kuralları',
    short: 'Koşul tutarsa ürün onaylı gerekçesiyle önerilir; önceliğe göre sıralanır.',
    whatItDoes:
      'Ürün seçilen türe uygun değilse hiçbir zaman önerilmez. Stokta yoksa sıradaki uygun alternatif gelir; alternatif yoksa "stokta yok" olarak gösterilir.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.rule_product': {
    kind: 'field',
    title: 'Önerilen ürün',
    short: 'Koşul tutunca önerilen ürün.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.rule_reason': {
    kind: 'field',
    title: 'Neden önerildi',
    short: 'Vitrinde ürünün altında gösterilen onaylı gerekçe. Hastalığı önleme/tedavi iddiası kullanmayın.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.rule_priority': {
    kind: 'field',
    title: 'Öncelik',
    short: 'Yüksek öncelikli öneri listede önce gelir (0–100).',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.rule_alternatives': {
    kind: 'field',
    title: 'Alternatifler',
    short: 'Ürün stokta yoksa sırayla denenen onaylı alternatifler (en çok 5).',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.exclusions': {
    kind: 'field',
    title: 'Hariç tutmalar',
    short: 'Koşul tutarsa listelenen ürünler hiçbir kuraldan önerilmez; her zaman önceliklidir.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.exclusion_products': {
    kind: 'field',
    title: 'Önerilmeyecek ürünler',
    short: 'Koşul tutunca hiçbir kuraldan önerilmeyecek ürünler.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.exclusion_note': {
    kind: 'field',
    title: 'Not',
    short: 'Hariç tutmanın nedeni (panelde ve önizlemede).',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.texts': {
    kind: 'field',
    title: 'Metinler',
    short: 'Sayfanın giriş metni, acil durum metni ve paket kampanyası.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.intro': {
    kind: 'field',
    title: 'Giriş metni',
    short: 'Sayfanın başında gösterilir; boşsa varsayılan metin.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#panel',
  },
  'needs_finder.emergency_text': {
    kind: 'field',
    title: 'Acil durum metni',
    short: 'Acil durum seçilince "Lütfen önce bir veteriner hekime başvurun" başlığının altında gösterilir.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#acil-durum',
  },
  'needs_finder.bundle': {
    kind: 'field',
    title: 'İhtiyaç paketi kampanyası',
    short:
      'İsteğe bağlı otomatik kampanya (varsayılan kapalı); çalışıyorsa sonuçta adı ve koşulu gösterilir.',
    whatItDoes: 'İndirim sepette kampanya motoruyla hesaplanır; vitrinde üstü çizili fiyat gösterilmez.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#ihtiyac-paketi',
  },
  'needs_finder.preview': {
    kind: 'field',
    title: 'Önizleme',
    short: 'Vitrindeki kural motoruyla aynı hesap; stok dikkate alınmaz.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#onay-ve-yayin',
  },
  'needs_finder.report': {
    kind: 'field',
    title: 'Rapor',
    short: 'Yalnızca toplam sayılar; ziyaretçi kimliği veya cevap yok.',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#gizlilik-ve-olcum',
  },
  'needs_finder.report_days': {
    kind: 'field',
    title: 'Dönem',
    short: 'Son 7, 30 veya 90 gün (İstanbul saatine göre).',
    guideUrl: 'docs/NEEDS_FINDER_TR.md#gizlilik-ve-olcum',
  },
  'page_designs.needs_finder': {
    kind: 'field',
    title: 'Evcil Dostumun İhtiyacı tasarımı',
    short: 'Soru akışının görünümü: kartlar, sohbet veya tek sayfa + canlı özet.',
    whatItDoes:
      'Üç seçenek aynı soruları, kuralları ve sonucu kullanır; cevaplar ziyaretçinin tarayıcısında kalır.',
    guideUrl: 'docs/STOREFRONT_DESIGN_VARIANTS_TR.md#ihtiyac-bulucu',
  },
  'page.ads': {
    kind: 'page',
    title: 'Reklam merkezi',
    short:
      'Reklam harcamasını mağazanın gerçek siparişleriyle birlikte gösterir: kampanya performansı, ROAS, sipariş başı maliyet, kâr, uyarılar ve onaylı bütçe değişiklikleri.',
    whatItDoes:
      'Harcama, gösterim ve tıklama Meta/TikTok bağlantılarından her sabah okunur ya da platform raporu dosyayla yüklenir. Gelir; son ziyaret kaynağı hesabın kaynaklarından biri ve utm_campaign değeri kampanya adıyla aynı olan ödenmiş siparişlerden hesaplanır (KDV ve kargo hariç, iadeler düşülür). Bütçe ve yayın değişiklikleri istek → onay → platformda elle uygulama adımlarıyla izlenir; sistem reklam platformunda kendiliğinden değişiklik yapmaz.',
    whenToUse:
      'Hangi kampanyanın gerçekten satış getirdiğini görmek ve bütçe kararlarını kayıt altına almak için.',
    dataChanged:
      'Hesaplar, yüklenen günlük veriler ve değişiklik istekleri kaydedilir; hepsi denetim kaydına düşer.',
    requiredPermission:
      'Görüntüleme: Reklam raporlarını görüntüleme. Hesap, veri yükleme ve istek: Reklam hesaplarını yönetme. Onay: Reklam değişikliklerini onaylama (iki adımlı doğrulama). Kâr: Maliyet görüntüleme.',
    reversible:
      'Aynı gün ve satır yeniden yüklenirse üzerine yazılır. Uygulanan istek geri alınmaz; yeni istek açılır.',
    guideUrl: 'docs/ADS_MANAGER_TR.md#rapor',
  },
  'ads.connections': {
    kind: 'field',
    title: 'Reklam bağlantıları',
    short:
      'Meta ve TikTok bağlantısı Bağlantılar sayfasında kurulur (erişim anahtarı ve hesap kimliği). Bağlantı yalnızca okur; reklamlarınızı değiştirmez.',
    guideUrl: 'docs/ADS_MANAGER_TR.md#baglanti',
  },
  'ads.sync_now': {
    kind: 'action',
    title: 'Şimdi eşitle',
    short:
      'Canlı Meta/TikTok bağlantılarından son 7 günün (ilk seferde 30 günün) verisini hemen okur. Her sabah 06:40’ta kendiliğinden çalışır.',
    guideUrl: 'docs/ADS_MANAGER_TR.md#baglanti',
  },
  'ads.add_account': {
    kind: 'action',
    title: 'Hesap ekle',
    short:
      'Raporunu dosyayla yükleyeceğiniz reklam hesabını ekler (Google Ads, diğer platformlar veya bağlantı kurmadığınız Meta/TikTok hesabı).',
    guideUrl: 'docs/ADS_MANAGER_TR.md#hesaplar',
  },
  'ads.save_account': {
    kind: 'action',
    title: 'Kaydet',
    short: 'Hesabı kaydeder. Arşivlenen hesap raporda görünmez; verisi silinmez.',
  },
  'ads.account_platform': {
    kind: 'field',
    title: 'Platform',
    short: 'Reklamın yayınlandığı platform. Eşleşen kaynakların varsayılanı buna göre seçilir.',
  },
  'ads.account_name': {
    kind: 'field',
    title: 'Hesap adı',
    short: 'Raporda görünecek ad (2–80 karakter).',
  },
  'ads.account_external_id': {
    kind: 'field',
    title: 'Platformdaki hesap kimliği',
    short: 'İsteğe bağlı. Aynı platformda aynı kimlikle ikinci hesap açılamaz.',
  },
  'ads.account_currency': {
    kind: 'field',
    title: 'Para birimi',
    short:
      'Reklam hesabının para birimi (ör. TRY, USD). Yüklenen tutarlar bu para biriminde olmalı; sonradan değiştirilemez.',
    guideUrl: 'docs/ADS_MANAGER_TR.md#hesaplar',
  },
  'ads.account_utm_sources': {
    kind: 'field',
    title: 'Eşleşen kaynaklar (utm_source)',
    short:
      'Siparişin son ziyaret kaynağı bu değerlerden biriyse sipariş bu hesaba yazılır. Virgülle ayırın; küçük harf, rakam, nokta, tire, alt çizgi.',
    guideUrl: 'docs/ADS_MANAGER_TR.md#eslesme',
  },
  'ads.account_status': {
    kind: 'field',
    title: 'Durum',
    short: 'Arşivlenen hesap rapora ve eşleşmeye katılmaz; veri silinmez, yeniden etkinleştirilebilir.',
  },
  'ads.account_actions': {
    kind: 'action',
    title: 'Rapor yükle ve düzenle',
    short:
      'Rapor yükle: dosya hesabına platform raporu ekler. Kalem simgesi: ad, eşleşen kaynaklar ve durum.',
    guideUrl: 'docs/ADS_MANAGER_TR.md#dosya',
  },
  'ads.upload_file': {
    kind: 'field',
    title: 'Rapor dosyası',
    short:
      'CSV veya XLSX, en çok 10 MB. Tarih, kampanya ve harcama sütunları gerekli; reklam grubu, reklam, gösterim, tıklama ve dönüşüm isteğe bağlı. Önce önizlenir, kaydetmezseniz değişiklik olmaz.',
    guideUrl: 'docs/ADS_MANAGER_TR.md#dosya',
  },
  'ads.apply_import': {
    kind: 'action',
    title: 'Verileri kaydet',
    short:
      'Önizlenen geçerli satırları kaydeder. Aynı gün, kampanya, reklam grubu ve reklam zaten varsa üzerine yazılır.',
    guideUrl: 'docs/ADS_MANAGER_TR.md#dosya',
  },
  'ads.report': {
    kind: 'field',
    title: 'Kampanya performansı',
    short:
      'TO = tıklama / gösterim; TBM = harcama / tıklama; BGBM = 1000 gösterim başına harcama; sipariş başı maliyet = harcama / sipariş; CAC = harcama / yeni müşteri; ROAS = gelir / harcama.',
    guideUrl: 'docs/ADS_MANAGER_TR.md#rapor',
  },
  'ads.period': {
    kind: 'field',
    title: 'Dönem',
    short: 'Son 7, 30 veya 90 gün (bugün dahil, İstanbul saati).',
  },
  'ads.platform_filter': {
    kind: 'field',
    title: 'Platform',
    short: 'Raporu tek bir platformla sınırlar.',
  },
  'ads.compare': {
    kind: 'field',
    title: 'Karşılaştır',
    short: 'En çok 4 kampanya seçin; ölçütler yan yana tabloda gösterilir.',
    guideUrl: 'docs/ADS_MANAGER_TR.md#karsilastirma',
  },
  'ads.anomalies': {
    kind: 'field',
    title: 'Uyarılar',
    short:
      'Son veri günü önceki 7 günle karşılaştırılır: harcama 1,5 katı aştıysa, tıklama oranı yarıya düştüyse, tıklamasız harcama varsa veya eşitleme 2 günden eskiyse uyarı çıkar.',
    guideUrl: 'docs/ADS_MANAGER_TR.md#uyarilar',
  },
  'ads.product_ads': {
    kind: 'field',
    title: 'Alışveriş reklamı ürünleri',
    short:
      'Google alışveriş reklamlarında ürün başına harcama, tıklama ve Google dönüşümü; yanında aynı hesaptan gelen ödenmiş siparişlerde o ürünün net satışı ve ürün ROAS’ı.',
    guideUrl: 'docs/ADS_MANAGER_TR.md#alisveris-urunleri',
  },
  'ads.products': {
    kind: 'field',
    title: 'Ürün performansı',
    short:
      'Reklama yazılan siparişlerdeki ürünler: adet ve KDV hariç net satış (iptal edilen adetler düşülür).',
  },
  'ads.request_change': {
    kind: 'action',
    title: 'Değişiklik iste',
    short:
      'Kampanya için bütçe veya yayın durumu değişikliğini onaya gönderir. Onaysız değişiklik uygulanmaz.',
    guideUrl: 'docs/ADS_MANAGER_TR.md#degisiklik',
  },
  'ads.change_kind': {
    kind: 'field',
    title: 'Değişiklik',
    short: 'Günlük bütçe veya yayın durumu (durdur / yayına al).',
  },
  'ads.change_budget': {
    kind: 'field',
    title: 'Yeni günlük bütçe',
    short: 'Hesabın para biriminde, ör. 750 veya 750,50.',
  },
  'ads.change_status': {
    kind: 'field',
    title: 'Yeni durum',
    short: 'Kampanyanın yayını durdurulsun mu, yeniden mi başlasın.',
  },
  'ads.change_note': {
    kind: 'field',
    title: 'Gerekçe',
    short: 'Onaylayacak kişi için neden (3–500 karakter). Geçmişte kalır.',
  },
  'ads.send_request': {
    kind: 'action',
    title: 'Onaya gönder',
    short: 'İsteği "onay bekliyor" olarak kaydeder. Reklam platformunda hiçbir şey değişmez.',
    guideUrl: 'docs/ADS_MANAGER_TR.md#degisiklik',
  },
  'ads.history': {
    kind: 'field',
    title: 'Değişiklik geçmişi',
    short: 'Son 100 istek ve son 50 veri yüklemesi/eşitlemesi; kim istedi, kim onayladı, ne zaman uygulandı.',
    guideUrl: 'docs/ADS_MANAGER_TR.md#gecmis',
  },
  'ads.change_actions': {
    kind: 'action',
    title: 'Karar ver, uygulandı, iptal',
    short:
      'Karar ver: onay yetkilisi onaylar veya reddeder. Uygulandı: değişikliği platformda yaptıktan sonra işaretleyin. İptal: bekleyen isteği geri çeker.',
    guideUrl: 'docs/ADS_MANAGER_TR.md#degisiklik',
  },
  'ads.approve': {
    kind: 'action',
    title: 'Onayla',
    short:
      'İsteği onaylar (iki adımlı doğrulama istenir). Kendi isteğinizi yalnızca işletme sahibi onaylayabilir.',
    whenToUse:
      'Meta, TikTok veya başka bir reklam hesabı için gönderilen bütçe ya da yayın değişikliği isteğini inceledikten sonra.',
    dataChanged:
      'İsteğin durumu "onaylandı" olur ve karar notu kaydedilir; reklam platformunda kendiliğinden hiçbir şey değişmez, değişikliği platformda yapıp "Uygulandı" işaretlersiniz. Karar denetim kaydına yazılır.',
    requiredPermission: 'Reklam değişikliklerini onaylama.',
    reversible: 'Hayır, verilen karar değiştirilemez; gerekirse yeni bir istek açılır.',
    commonErrors: [
      {
        problem: '"Kendi isteğinizi onaylayamazsınız"',
        solution: 'Başka bir onay yetkilisi onaylamalı; kendi isteğini yalnızca işletme sahibi onaylar.',
      },
      {
        problem: '"Bu istek artık beklemede değil"',
        solution: 'Sayfayı yenileyin; istek başka biri tarafından karara bağlanmış veya iptal edilmiş.',
      },
    ],
    guideUrl: 'docs/ADS_MANAGER_TR.md#degisiklik',
  },
  'ads.reject': {
    kind: 'action',
    title: 'Reddet',
    short: 'İsteği reddeder; karar notu isteyene görünür.',
    requiredPermission: 'Reklam değişikliklerini onaylama.',
  },
  'ads.decision_note': {
    kind: 'field',
    title: 'Karar notu',
    short: 'İsteğe bağlı açıklama (en çok 500 karakter); geçmişte görünür.',
  },
  'payments.go_live_skip_sandbox': {
    kind: 'field',
    title: 'Test ödemesi olmadan canlıya geç',
    short:
      'Yalnızca işletme sahibi işaretleyebilir. Test ortamında başarılı ödeme yokken canlıya geçişe izin verir; iki adımlı doğrulama ister ve denetim kaydına "test ödemesi atlandı" olarak yazılır. İlk canlı siparişi kendi kartınızla küçük tutarla verip iade edin.',
    requiredPermission: 'İşletme sahibi (ödeme ayarlarını yönetme yetkisiyle).',
    guideUrl: 'docs/PAYMENTS_TR.md#test-odemesiz-canli',
  },
  'payments.go_live_confirm': {
    kind: 'action',
    title: 'Canlıya geç',
    short:
      'Kartla ödemeyi canlı ortama alır: bundan sonra gerçek kartlardan para çekilir. Canlı bağlantı testi başarılı olmalı; iki adımlı doğrulama ister, denetim kaydına yazılır.',
    whenToUse:
      'Ödeme kuruluşunun canlı anahtarlarını girip canlı bağlantı testini geçtikten ve test ortamında en az bir başarılı ödeme aldıktan sonra.',
    dataChanged:
      'Mağazanın ödeme ayarında ilgili ödeme yöntemi (TL kartı, yurt dışı kartı veya PayPal) canlı ortama alınır; işlem denetim kaydına yazılır.',
    requiredPermission:
      'Ödeme ayarları, banka hesapları ve sağlayıcı anahtarları; kartla ödemeyi canlıya alma (hassas; iki adımlı doğrulama).',
    reversible: '"Teste dön" ile geri alınır (mağaza yayında değilse).',
    commonErrors: [
      {
        problem: '"Kart sağlayıcısının bu ortam için bağlantı testi başarılı olmalı"',
        solution: 'Entegrasyonlar sayfasında canlı anahtarları girip bağlantıyı test edin.',
      },
      {
        problem: '"Canlıya geçmeden önce test ortamında en az bir başarılı ödeme alınmalı"',
        solution:
          'Test kartıyla bir sipariş ödeyin; test ödemesi olmadan geçişi yalnızca işletme sahibi onaylayabilir.',
      },
    ],
    guideUrl: 'docs/PAYMENTS_TR.md#canliya-gecis',
  },
  'payments.first_live_order': {
    kind: 'field',
    title: 'İlk canlı sipariş denemesi',
    short:
      'Test ödemesi atlanarak canlıya geçildi. Vitrinden kendi kartınızla küçük tutarlı bir sipariş verin, "Ödendi" olduğunu görün ve sipariş ayrıntısından iade edin. İade tamamlanınca bu uyarı kalkar.',
    guideUrl: 'docs/PAYMENTS_TR.md#test-odemesiz-canli',
  },
  'page.retention': {
    kind: 'page',
    title: 'Saklama ve imha',
    short:
      'Saklama süresi dolan kişisel verinin otomatik silinmesi (varsayılan kapalı), özelliklerin sabit saklama süreleri ve imha kaydı.',
    whatItDoes:
      'Açtığınız kurallar her gece 03:40’ta çalışır; süresi dolan sepet, onaylanmamış veya biten bülten kaydı ve entegrasyon günlüğü kalıcı olarak silinir. Destek talebi, form mesajı, kampanya kayıtları gibi verilerin sabit süreleri vardır. Her silme ve başvuru üzerine anonimleştirme imha kaydına gün, veri türü ve sayı olarak yazılır.',
    whenToUse:
      'Saklama sürelerini avukatınızla belirledikten sonra kuralları açmak ve imha kaydını (Kurul incelemesi için) görmek için.',
    dataChanged: 'Saklama ayarı; açık kurallarda süresi dolan kayıtlar silinir.',
    requiredPermission:
      'Görmek: saklama sürelerini ve imha kaydını görme. Değiştirmek: otomatik imha kurallarını açma (iki adımlı doğrulama).',
    reversible: 'Kural kapatılabilir; silinmiş kayıtlar geri getirilemez.',
    guideUrl: 'docs/PRIVACY_COMPLIANCE_TR.md#saklama',
  },
  'page.sales_regions': {
    kind: 'page',
    title: 'Satış bölgeleri',
    short:
      'İl/ilçe gruplarından oluşan bölgeler ve bölge sorumluları; bayiyi il/ilçesine göre bölgeye atama.',
    whatItDoes:
      'Bölge, il veya ilçe listesidir ve bir sorumlusu olabilir. Bayi kapsamı "yalnızca atanan bayiler" olan sorumlu, bölgesindeki bayileri görür. "İl/ilçeye göre ata" bayilerin kayıtlı il/ilçesini bölgelerle eşleştirir; önce önizleme gösterir.',
    whenToUse: 'Saha satış ekibini bölgelere ayırmak, temsilcilere yalnızca kendi bayilerini göstermek için.',
    requiredPermission:
      'Görmek: bayileri görüntüleme. Bölge tanımlamak ve atamak: satış bölgelerini yönetme.',
    reversible: 'Bölge silinirse bayilerin bölgesi boşalır; bayiler ve siparişler etkilenmez.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#temsilci',
  },
  'sales_regions.new': {
    kind: 'action',
    title: 'Bölge ekle',
    short: 'Ad, iller/ilçeler ve isteğe bağlı sorumlu ile yeni satış bölgesi.',
  },
  'sales_regions.auto_assign': {
    kind: 'action',
    title: 'İl/ilçeye göre ata',
    short:
      'Bayilerin il/ilçesini bölgelerle eşleştirir: önce kaç bayinin hangi bölgeye gideceğini gösterir, onaylarsanız uygular. Varsayılan olarak yalnızca bölgesi boş bayiler.',
  },
  'sales_regions.manager': {
    kind: 'field',
    title: 'Bölge sorumlusu',
    short:
      'Bölgedeki bütün bayileri görür (bayi kapsamı "yalnızca atanan bayiler" ise). Sorumlu, bayileri görebilen etkin bir panel kullanıcısı olmalı.',
  },
  'sales_regions.places': {
    kind: 'field',
    title: 'İller ve ilçeler',
    short: 'İl seçip ilçeyi boş bırakırsanız ilin tamamı bölgeye girer; ilçe seçerseniz yalnızca o ilçe.',
  },
  'dealers.sales_assignment': {
    kind: 'field',
    title: 'Satış temsilcisi ve bölge',
    short:
      'Bayinin temsilcisi ve bölgesi. Kapsamı "yalnızca atanan bayiler" olan temsilci ve bölge sorumlusu bu bayiyi görür; siparişlere sipariş anındaki temsilci yazılır.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#temsilci',
  },
  'dealers.sales_rep': {
    kind: 'field',
    title: 'Satış temsilcisi',
    short: 'Bayileri görebilen etkin panel kullanıcıları arasından seçilir. Boş: temsilci yok.',
  },
  'dealers.sales_region': {
    kind: 'field',
    title: 'Satış bölgesi',
    short: 'Elle seçilir veya Satış bölgeleri sayfasında il/ilçeye göre topluca atanır.',
  },
  'dealers.sales_filter': {
    kind: 'field',
    title: 'Temsilci ve bölge süzgeci',
    short: 'Belirli temsilcinin veya bölgenin bayileri; "Temsilci yok" / "Bölge yok" atanmamışları gösterir.',
  },
  'page.bizimhesap': {
    kind: 'page',
    title: 'BizimHesap',
    short:
      'Cari hesabın ana kaydı BizimHesap: kasa eşlemesi, bayi ↔ cari eşleştirmesi, BizimHesap’a yazma izinleri, kasasız faturaların düzeltmesi ve tahsilat kuyruğu.',
    whatItDoes:
      'Bayi siparişinin faturası bayinin BizimHesap cari koduna, ödenmiş siparişin faturası ödeme yönteminin kasasıyla gönderilir. Açık hesap (vadeli) siparişte kasa gönderilmez; tutar BizimHesap’ta cari borç olur. Tahsilat, cari ekleme ve fatura iptali BizimHesap’a yazar ve varsayılan kapalıdır.',
    whenToUse:
      'İlk kurulumda (kasa listesi, carileri içe aktar), yeni bayi eklendiğinde ve kasasız gönderilmiş eski faturaları düzeltirken.',
    dataChanged:
      'Kasa eşlemesi ve bayinin cari kodu bu sistemde; tahsilat/cari/iptal yalnızca yazma açıkken BizimHesap’ta.',
    requiredPermission:
      'Görmek: entegrasyonları görüntüleme. Kasa ve cari eşleştirme: entegrasyon yönetimi. Yazma izinleri: canlıya alma yetkisi (sahip/yönetici). Tahsilat gönderme: cari hesap yönetimi.',
    reversible:
      'Eşleme ve bağlantılar değiştirilebilir. BizimHesap’a giden tahsilat, cari ve iptal geri alınmaz (BizimHesap panelinden düzeltilir).',
    guideUrl: 'docs/B2B_GUIDE_TR.md#bizimhesap',
  },
  'dealers.bizimhesap_code': {
    kind: 'field',
    title: 'BizimHesap carisi',
    short:
      'Bayinin BizimHesap cari kodu. Bayi faturası ve tahsilatı bu cariye gider; bağlı değilse fatura gönderilmez (BizimHesap bilinmeyen kodla yeni cari açardı).',
    guideUrl: 'docs/B2B_GUIDE_TR.md#bizimhesap',
  },
  'dealers.bizimhesap_link': {
    kind: 'field',
    title: 'Cari kodu',
    short:
      'BizimHesap’taki cari kartının kodu. Kaydederken BizimHesap cari listesinde aranır; başka bayiye bağlı kod verilemez.',
  },
  'bizimhesap.statement': {
    kind: 'field',
    title: 'BizimHesap ekstresi',
    short:
      'BizimHesap’taki cari hareketleri ve bakiye. Ekstre 30 dakikada bir (hareketsiz bayide 6 saatte bir) çekilir; hatada aralık uzar. Fatura bağlantısı gelmeyen satır yalnızca bilgidir.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#bizimhesap',
  },
  'bizimhesap.refresh_one': {
    kind: 'action',
    title: 'Bu bayiyi güncelle',
    short: 'Bu bayinin ekstresini BizimHesap’tan hemen çeker (yalnızca okur).',
  },
  'bizimhesap.refresh_all': {
    kind: 'action',
    title: 'Şimdi güncelle',
    short:
      'BizimHesap’a bağlı bütün bayilerin ekstresini sıraya alır; zamanlanmış iş birkaç dakika içinde çeker.',
  },
  'bizimhesap.diff': {
    kind: 'field',
    title: 'Fark raporu',
    short:
      'BizimHesap bakiyesi + aktarılmamış siparişler ile bu sistemdeki cari defter bakiyesi arasındaki fark.',
  },
  'invoices.provider_cancel': {
    kind: 'action',
    title: 'BizimHesap iptali',
    short:
      'Sipariş tamamen iptal edilince BizimHesap’taki fatura kaydı iptal edilir (“Fatura iptali” anahtarı açıksa kendiliğinden). Resmî e-belge numarası olan faturada iptal yerine iade faturası gerekir (mali müşavir teyidi bekleniyor).',
    whenToUse:
      "Sipariş tamamen iptal edildiğinde BizimHesap'a daha önce gönderilmiş faturanın oradaki kaydını da iptal etmek için.",
    dataChanged:
      'BizimHesap\'a iptal isteği gönderilir; başarılıysa fatura sistemde "iptal edildi" olur. Sonuç (başarılı, başarısız veya belirsiz) denetim kaydına yazılır.',
    requiredPermission: 'Fatura oluşturma ve gönderme.',
    reversible: "Hayır, BizimHesap'ta iptal edilen fatura geri açılamaz.",
    commonErrors: [
      {
        problem: '"BizimHesap\'a yazma kapalı"',
        solution:
          'Sahip veya yönetici Entegrasyonlar → BizimHesap → BizimHesap\'a yazma bölümünden "Fatura iptali"ni açabilir.',
      },
      {
        problem: '"Bu fatura için bekleyen bir BizimHesap iptali yok"',
        solution:
          "İptal yalnızca siparişi iptal edilmiş ve BizimHesap'a gönderilmiş faturada yapılır; durumu sayfada kontrol edin.",
      },
    ],
    guideUrl: 'docs/B2B_GUIDE_TR.md#bizimhesap',
  },
  'invoices.provider_cancel_resolve': {
    kind: 'field',
    title: 'İptal sonucu',
    short:
      'BizimHesap panelinde kontrol ettiğiniz sonuç. “İptal edilmemiş” seçilirse yeniden gönderilebilir.',
  },
  'bizimhesap.cash_map': {
    kind: 'field',
    title: 'Kasa eşlemesi',
    short:
      'Her ödeme yöntemi için BizimHesap kasası. Ödenmiş siparişin faturası bu kasayla gider (BizimHesap’ın 16.10.2026 notu: kasa kimliği gönderilmeli).',
  },
  'bizimhesap.refresh_cashiers': {
    kind: 'action',
    title: 'Kasa listesini getir',
    short:
      'BizimHesap’taki kasaları çeker; seçimler bu listeden yapılır. İlk yanıt maskeli örnek olarak saklanır.',
  },
  'bizimhesap.cash_card': {
    kind: 'field',
    title: 'Kartla ödeme kasası',
    short: 'iyzico/PayTR ile ödenen siparişler (genellikle POS hesabı).',
  },
  'bizimhesap.cash_bank_transfer': {
    kind: 'field',
    title: 'Havale/EFT kasası',
    short: 'Havale ile ödenen siparişler (banka hesabı).',
  },
  'bizimhesap.cash_cash_on_delivery': {
    kind: 'field',
    title: 'Kapıda ödeme kasası',
    short: 'Kapıda tahsil edilen siparişler. Fatura tahsilattan önce gönderildiyse düzeltme listesine girer.',
  },
  'bizimhesap.cash_manual': {
    kind: 'field',
    title: 'Elle ödeme kasası',
    short: 'Panelde "Ödeme alındı" ile işaretlenen elle ödemeler.',
  },
  'bizimhesap.cash_cash': {
    kind: 'field',
    title: 'Nakit tahsilat kasası',
    short: 'Cari hesaba panelden girilen nakit tahsilatlar (BizimHesap’a tahsilat gönderirken).',
  },
  'bizimhesap.save_cash': {
    kind: 'action',
    title: 'Kasa eşlemesini kaydet',
    short: 'Seçimleri kaydeder; denetim kaydına yazılır.',
  },
  'bizimhesap.links': {
    kind: 'field',
    title: 'Bayi ↔ BizimHesap carisi',
    short:
      'Bayi faturası bu cari koduyla gider. Bağlı olmayan bayinin faturası gönderilmez: BizimHesap bilinmeyen kodla yeni cari açardı.',
  },
  'bizimhesap.import_customers': {
    kind: 'action',
    title: 'Carileri içe aktar',
    short:
      'BizimHesap cari listesini çekip bayilerle eşleştirir (bayi kodu = cari kodu, yoksa vergi no). Önce önizleme; kaydettiğiniz eşleşmeler yeniden doğrulanır.',
  },
  'bizimhesap.ambiguous': {
    kind: 'field',
    title: 'Belirsiz eşleşme',
    short:
      'Aynı vergi numarasıyla birden çok cari var veya aynı cari iki bayiye uyuyor; doğru cariyi seçin ya da bağlamayın.',
  },
  'bizimhesap.writes': {
    kind: 'field',
    title: 'BizimHesap’a yazma',
    short:
      'Gerçek muhasebe hesabınıza kayıt yazan adımlar. Varsayılan kapalı; açmak sahip/yönetici ve onay kutusu ister.',
  },
  'bizimhesap.write_collections': {
    kind: 'field',
    title: 'Tahsilat gönder',
    short:
      'Kuyruktaki tahsilatlar "Gönder" ile BizimHesap’a gider (nakit 1, kart 2, havale 3; eşlenen kasa).',
  },
  'bizimhesap.write_customers': {
    kind: 'field',
    title: 'Cari ekle',
    short:
      'BizimHesap’ta bulunmayan bayi için cari açılabilir (onaylı). Kapalıyken cari BizimHesap’ta elle açılır.',
  },
  'bizimhesap.write_cancel': {
    kind: 'field',
    title: 'Fatura iptali',
    short:
      'Tamamen iptal edilen siparişin BizimHesap kaydı iptal edilir. e-Fatura kesilmişse iptal yerine iade gerekir (mali müşavir teyidi bekleniyor).',
  },
  'bizimhesap.save_writes': {
    kind: 'action',
    title: 'Yazma ayarını kaydet',
    short: 'İki adımlı doğrulama ister; denetim kaydına yazılır.',
    whenToUse:
      "BizimHesap bağlantısını test edip kasa ve cari eşlemelerini tamamladıktan sonra, sistemin BizimHesap'a tahsilat, cari veya fatura iptali yazmasına izin vermek (ya da durdurmak) istediğinizde.",
    dataChanged:
      'Tahsilat gönderme, cari açma ve fatura iptali anahtarları açılır veya kapanır; kimin ne zaman değiştirdiği kaydedilir ve önceki/yeni değerler denetim kaydına yazılır.',
    requiredPermission: 'Entegrasyonu canlı ortama alma (hassas; iki adımlı doğrulama).',
    reversible:
      "Evet, anahtarlar yeniden kapatılabilir; açıkken BizimHesap'a yazılmış kayıtlar ise geri alınmaz.",
    commonErrors: [
      {
        problem: 'Onay kutusu işaretlenmeden kaydedilmiyor',
        solution: "Bir anahtarı açarken BizimHesap'a gerçek kayıt yazılacağını onaylayan kutuyu işaretleyin.",
      },
      {
        problem: '"Bu kayıt siz düzenlerken başka biri tarafından değiştirildi"',
        solution: 'Sayfayı yenileyip tekrar deneyin.',
      },
    ],
  },
  'bizimhesap.corrections': {
    kind: 'field',
    title: 'Kasasız gönderilmiş ödenmiş siparişler',
    short:
      'Kasa kimliği olmadan faturalanmış, ödemesi alınmış siparişler. Tahsilat kaydı açılıp onayla BizimHesap’a gönderilir.',
  },
  'bizimhesap.queue_corrections': {
    kind: 'action',
    title: 'Tahsilat kaydı aç',
    short: 'Seçilen siparişler için tahsilat kaydı açar; hiçbir şey BizimHesap’a gönderilmez.',
    whenToUse: "BizimHesap'ta tahsilatı eksik görünen ödenmiş siparişleri düzeltme listesinde gördüğünüzde.",
    dataChanged:
      'Seçilen her sipariş için "bekliyor" durumunda bir BizimHesap tahsilat kaydı açılır; denetim kaydına yazılır. BizimHesap\'a hiçbir şey gönderilmez.',
    requiredPermission:
      'Bayi cari hesabına tahsilat, düzeltme ve açılış bakiyesi girme (hassas; iki adımlı doğrulama).',
    reversible: 'Evet, gönderilmemiş tahsilat kaydı "Kaydı iptal et" ile iptal edilir.',
    commonErrors: [
      {
        problem: '"Ödenmiş siparişin ödeme yöntemi için BizimHesap kasası seçilmemiş"',
        solution: "Entegrasyonlar → BizimHesap → Kasa eşlemesi'nden kasayı seçin.",
      },
      {
        problem: '"Bayi BizimHesap carisine bağlı değil"',
        solution: 'Carileri içe aktar ile bayiyi BizimHesap carisine bağlayın.',
      },
    ],
  },
  'bizimhesap.collections': {
    kind: 'field',
    title: 'Tahsilat kuyruğu',
    short: 'Bekleyen, gönderilen, başarısız ve belirsiz tahsilatlar. Numara BizimHesap notuna yazılır.',
  },
  'bizimhesap.collection_actions': {
    kind: 'action',
    title: 'Gönder · Ekstreden kontrol et · Kaydı iptal et',
    short:
      'Gönder: yazma açıksa BizimHesap’a gider. Belirsizde ekstrede numara aranır; bulunursa gönderildi, bulunmazsa yeniden gönderilebilir. İptal: kayıt gönderilmez.',
    whenToUse:
      "Tahsilat kuyruğundaki kayıtları BizimHesap'a göndermek, bağlantı kopmasıyla belirsiz kalanları kontrol etmek veya BizimHesap'a elle girdiğiniz kaydı kuyruktan çıkarmak istediğinizde.",
    dataChanged:
      'Gönder: tahsilat BizimHesap\'a yazılır ve durumu "gönderildi", "başarısız" veya "belirsiz" olur; Kontrol belirsiz kaydı ekstreye bakarak sonuçlandırır, İptal kaydı "iptal" yapar. Her işlem denetim kaydına yazılır.',
    requiredPermission:
      'Bayi cari hesabına tahsilat, düzeltme ve açılış bakiyesi girme (hassas; iki adımlı doğrulama).',
    reversible:
      "Kısmen: BizimHesap'a gönderilen tahsilat buradan geri alınamaz (BizimHesap'ta düzeltilir); iptal edilen kayıt yeniden açılmaz.",
    commonErrors: [
      {
        problem: '"BizimHesap\'a yazma kapalı"',
        solution: 'Sahip veya yönetici BizimHesap\'a yazma bölümünden "Tahsilat gönder"i açmalı.',
      },
      {
        problem: '"Yalnızca bekleyen veya başarısız tahsilat gönderilebilir"',
        solution: 'Belirsiz kaydı önce "Ekstreden kontrol et" ile çözün.',
      },
      {
        problem: '"BizimHesap kasası seçilmemiş"',
        solution: "Kasa eşlemesi'nden ödeme yöntemine kasa seçin.",
      },
    ],
  },
  'bizimhesap.cancel_note': {
    kind: 'field',
    title: 'İptal gerekçesi',
    short: 'Ör. "BizimHesap’a elle girildi". Denetim kaydına yazılır.',
  },
  'bizimhesap.samples': {
    kind: 'field',
    title: 'Yanıt örnekleri',
    short:
      'Belgede alan yapısı olmayan uçların ilk gerçek yanıtı, kişisel veri maskelenerek. Belgeye işlemek için kopyalayın.',
  },
  'page.sales_commissions': {
    kind: 'page',
    title: 'Temsilci komisyonları',
    short: 'Satış temsilcisi komisyon kuralları ve aylık dökümler: hesaplama, onay, ödendi kaydı ve CSV.',
    whatItDoes:
      'Komisyon, siparişte yazılı temsilci için KDV ve kargo hariç net tutar üzerinden hesaplanır ve tahsil edilen oran kadar yazılır (kartla/havaleyle ödenen veya cari hesapta kapanan kısım). Dönemi hesapla taslak dökümleri yeniden kurar; sonraki ay iade, iptal veya geç tahsilat önceki tahakkuka göre düzeltme olarak gelir. Onaylanan döküm yeniden hesapta korunur; ödeme sistem dışında yapılır ve ödendi olarak işaretlenir.',
    whenToUse: 'Ay kapanışında temsilci primini hesaplamak, onaylamak ve muhasebeye CSV vermek için.',
    dataChanged: 'Komisyon kuralları ve dökümler; siparişler ve ödemeler değişmez.',
    requiredPermission:
      'Görmek: komisyonları görüntüleme (kapsamı sınırlı temsilci yalnızca kendisininkini görür). Kural, hesap, onay ve ödendi: komisyonları yönetme (iki adımlı doğrulama).',
    reversible:
      'Taslak döküm yeniden hesaplanabilir. Onaylı ve ödenmiş döküm değişmez; sonraki düzeltmeler yeni ayın dökümüne yazılır.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#komisyon',
  },
  'sales_commissions.rules': {
    kind: 'field',
    title: 'Komisyon kuralları',
    short:
      'Satıra en özel kural uyar: temsilciye özel kural genel kuraldan, ürün kuralı kategoriden, kategori kuralı tüm ürünlerden önce gelir; eşitlikte en yeni kural. Uyan kural yoksa o satıra komisyon yazılmaz.',
  },
  'sales_commissions.rate': {
    kind: 'field',
    title: 'Komisyon oranı',
    short:
      'Net tutarın yüzdesi (en çok %50). Oran siparişin ilk hesabında sabitlenir; kuralı sonradan değiştirmek o siparişin düzeltmelerini etkilemez.',
  },
  'sales_commissions.rule_rep': {
    kind: 'field',
    title: 'Temsilci',
    short: 'Boş bırakılırsa kural tüm temsilcilere uyar. Seçilirse yalnızca o temsilcinin siparişlerine.',
  },
  'sales_commissions.rule_scope': {
    kind: 'field',
    title: 'Kategori ve ürün kapsamı',
    short:
      'Kategori ve ürün seçmezseniz kural tüm ürünlere uyar. Ürünün herhangi bir kategorisi seçiliyse kategori kuralı uyar.',
  },
  'sales_commissions.period': {
    kind: 'field',
    title: 'Aylık dökümler',
    short:
      'Her temsilci için ay dökümü. Onayla dökümü kilitler (yeniden hesapta korunur); Ödendi işaretle sistem dışındaki ödemenin kaydını tutar.',
  },
  'sales_commissions.calculate': {
    kind: 'action',
    title: 'Dönemi hesapla',
    short:
      'Ayın siparişlerini ve önceki aylardaki siparişlerin tahsilat/iade değişimini hesaplar; taslak dökümleri yeniden kurar. Gelecek ay ve sonrasında döküm olan ay hesaplanamaz.',
  },
  'sales_commissions.csv': {
    kind: 'action',
    title: 'CSV indir',
    short: 'Dönemin bütün döküm satırları (sipariş, tür, tahsil oranı, taban, komisyon); Excel’de açılır.',
  },
  'sales_commissions.paid_note': {
    kind: 'field',
    title: 'Ödeme notu',
    short: 'Ödemenin nasıl yapıldığı (ör. "Ekim bordrosu" veya havale açıklaması). Denetim kaydına yazılır.',
  },
  'page.quotes': {
    kind: 'page',
    title: 'Teklifler',
    short: 'Bayilerin sepetten istediği ve sizin hazırladığınız teklifler; durum ve geçerlilik.',
    whatItDoes:
      'Bayi sepetten "Teklif iste" deyince istek buraya düşer. Teklifte satır fiyatını, geçerlilik tarihini ve notu girip gönderirsiniz; bayi Hesabım’da görür, kabul edince teklif fiyatıyla sipariş verir.',
    whenToUse: 'Toplu alımda özel fiyat vermek, bayiye yazılı fiyat teklifi sunmak için.',
    requiredPermission:
      'Görmek: bayi tekliflerini görüntüleme. Hazırlamak ve göndermek: bayi teklifi hazırlama.',
    reversible: 'Gönderilen sürüm değişmez; düzeltme yeni sürümle yapılır. İptal geri alınmaz.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#teklif',
  },
  'page.quote_detail': {
    kind: 'page',
    title: 'Teklif',
    short: 'Teklif satırları, fiyatlar, geçerlilik ve not; gönderme, iptal ve yazdırma.',
    whatItDoes:
      'Kaydet taslağı günceller; Gönder değiştirilemez bir sürüm oluşturur ve bayiye açar. Gönderilmiş teklifi değiştirip kaydederseniz teklif taslağa döner; bayinin sepetindeki eski sürüm geçersiz olur.',
    whenToUse: 'Bayiye özel fiyat vermek, istek üzerine teklif hazırlamak için.',
    requiredPermission: 'Bayi teklifi hazırlama.',
    reversible: 'Gönderilen sürümler silinmez.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#teklif',
  },
  'quotes.new': {
    kind: 'action',
    title: 'Yeni teklif',
    short: 'Onaylı bir bayi için boş teklif açar; ürünleri sonra eklersiniz.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#teklif',
  },
  'quotes.status_filter': {
    kind: 'field',
    title: 'Durum',
    short: 'İstek, taslak, gönderildi, siparişe dönüştü, reddedildi veya iptal.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#teklif',
  },
  'quotes.search': {
    kind: 'field',
    title: 'Arama',
    short: 'Teklif numarası veya bayi unvanının bir kısmı.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#teklif',
  },
  'quotes.dealer': {
    kind: 'field',
    title: 'Bayi',
    short: 'Yalnızca onaylı bayiler; fiyatlar bayinin grubuna göre gelir.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#teklif',
  },
  'quotes.print': {
    kind: 'action',
    title: 'Yazdır',
    short: 'Teklifi yazdırır; tarayıcının "PDF olarak kaydet" seçeneğiyle PDF alınır. İç not yazdırılmaz.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#teklif',
  },
  'quotes.save': {
    kind: 'action',
    title: 'Kaydet',
    short:
      'Satırları, fiyatları ve koşulları kaydeder; tutarlar yeniden hesaplanır. Gönderilmiş teklif taslağa döner.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#teklif',
  },
  'quotes.send': {
    kind: 'action',
    title: 'Gönder',
    short:
      'Değiştirilemez bir sürüm oluşturur; bayi Hesabım’da görür. E-posta altyapısı kuruluysa isteyene ve firma Yetkililerine e-posta gider.',
    whenToUse: 'Bayi için teklifin ürünlerini, fiyatlarını ve geçerlilik tarihini kesinleştirdiğinizde.',
    dataChanged:
      'Teklifin değiştirilemez yeni bir sürümü oluşur ve durumu "gönderildi" olur; bayi teklifi Hesabım\'da görür. E-posta kuruluysa isteyene ve firma yetkililerine bildirim gider; işlem denetim kaydına yazılır.',
    requiredPermission: 'Bayi teklifi hazırlama, gönderme ve iptal etme.',
    reversible:
      'Kısmen: teklif yeniden düzenlenip kaydedilince taslağa döner ve yeni sürüm gönderilebilir; giden e-posta geri alınmaz.',
    commonErrors: [
      { problem: '"Teklifte en az bir ürün olmalı"', solution: 'Göndermeden önce teklife ürün ekleyin.' },
      {
        problem: 'Geçerlilik tarihi hatası ("Tarih ileride olmalı")',
        solution: 'Geçerlilik tarihini bugün veya ileri bir gün olarak girin.',
      },
      {
        problem: '"Bu teklif kapandı"',
        solution: 'Siparişe dönüşmüş, reddedilmiş veya iptal edilmiş teklif gönderilemez; yeni teklif açın.',
      },
    ],
    guideUrl: 'docs/B2B_GUIDE_TR.md#teklif',
  },
  'quotes.cancel': {
    kind: 'action',
    title: 'İptal et',
    short: 'Teklif kabul edilemez olur; gerekçe zorunlu. Geri alınmaz.',
    whenToUse:
      'Teklifin artık geçerli olmaması gerektiğinde (fiyat değişti, bayi vazgeçti, yanlış hazırlandı).',
    dataChanged:
      'Teklifin durumu "iptal" olur ve gerekçe kaydedilir; bayi teklifi kabul edemez. İşlem denetim kaydına yazılır.',
    requiredPermission: 'Bayi teklifi hazırlama, gönderme ve iptal etme.',
    reversible: 'Hayır, iptal edilen teklif yeniden açılamaz; gerekirse yeni teklif hazırlanır.',
    commonErrors: [
      {
        problem: '"Bu teklif kapandı"',
        solution: 'Siparişe dönüşmüş veya reddedilmiş teklif iptal edilemez.',
      },
    ],
    guideUrl: 'docs/B2B_GUIDE_TR.md#teklif',
  },
  'quotes.valid_until': {
    kind: 'field',
    title: 'Geçerlilik',
    short:
      'Teklifin kabul edilebileceği son gün (Türkiye günü). Göndermek için zorunlu; geçmiş tarih olamaz.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#teklif',
  },
  'quotes.note': {
    kind: 'field',
    title: 'Bayiye not',
    short: 'Teslim süresi, ödeme koşulu gibi bilgiler; teklifte bayiye görünür.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#teklif',
  },
  'quotes.internal_note': {
    kind: 'field',
    title: 'İç not',
    short: 'Yalnızca panelde görünür; bayiye gösterilmez, yazdırılmaz.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#teklif',
  },
  'quotes.cancel_reason': {
    kind: 'field',
    title: 'İptal gerekçesi',
    short: 'En az 3 karakter; panelde ve denetim kaydında kalır.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#teklif',
  },
  'page.ledger': {
    kind: 'page',
    title: 'Cari hesaplar',
    short:
      'Bayilerin borç/alacak bakiyeleri, vadesi geçen borçları ve en eski vadeleri; açılış bakiyesi aktarımı.',
    whatItDoes:
      'Açık hesapla (vadeli) verilen siparişler bayinin cari hesabına kendiliğinden borç yazılır; iptal, kısmi iptal, düzenleme, iade ve "Ödeme alındı" fark olarak işlenir. Tahsilatlar en eski vadeli borca uygulanır (FIFO); vadesi bugünden önce olan kalan borç "vadesi geçmiş" görünür.',
    whenToUse:
      'Hangi bayinin ne kadar borcu olduğunu, kimin vadesinin geçtiğini görmek ve eski muhasebeden açılış bakiyesi aktarmak için.',
    requiredPermission:
      'Görmek: bayi cari hesabını görüntüleme. Tahsilat, düzeltme, açılış bakiyesi ve vade: cari hesap yönetimi (iki adımlı doğrulama).',
    reversible: 'Kayıtlar silinmez; yanlış kayıt ters kayıtla düzeltilir.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-hesap',
  },
  'page.company_ledger': {
    kind: 'page',
    title: 'Bayi cari hesabı',
    short:
      'Bayinin bakiyesi, yaşlandırması ve dönem ekstresi (devir ve yürüyen bakiyeyle); tahsilat ve düzeltme girişi.',
    whatItDoes:
      'Her satır bir borç (artı) veya alacaktır (eksi). Sipariş kayıtları siparişten gelir; tahsilat, düzeltme ve açılış bakiyesi elle girilir. Ekstre CSV olarak indirilebilir veya yazdırılabilir.',
    whenToUse: 'Bayiyle mutabakat yaparken, tahsilat girerken veya ekstre gönderirken.',
    requiredPermission:
      'Görmek: bayi cari hesabını görüntüleme. Kayıt girmek: cari hesap yönetimi (iki adımlı doğrulama).',
    reversible: 'Elle girilen kayıt ters kayıtla geri alınır; kayıt silinmez.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-hesap',
  },
  'ledger.search': {
    kind: 'field',
    title: 'Bayi ara',
    short: 'Firma adı veya bayi kodunun bir bölümü.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-hesap',
  },
  'ledger.only_overdue': {
    kind: 'field',
    title: 'Yalnızca vadesi geçenler',
    short: 'Vadesi bugünden önce olup henüz kapanmamış borcu olan bayileri gösterir.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-hesap',
  },
  'ledger.import': {
    kind: 'action',
    title: 'Açılış bakiyesi aktar',
    short:
      'Eski muhasebenizdeki bayi bakiyelerini CSV veya Excel dosyasıyla aktarır. Sütunlar: Bayi kodu veya Vergi no, Tutar (borç artı, alacak eksi), isteğe bağlı Para birimi, Tarih, Vade, Açıklama. Önce önizleme gösterilir; deftere ancak onaylayınca yazılır.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-hesap',
  },
  'page.ledger_bank_import': {
    kind: 'page',
    title: 'Banka hareketleri',
    short:
      'Bankanızın hesap hareketleri dökümünü yükleyip bayilerden gelen ödemeleri toplu olarak cari hesaplara tahsilat yazarsınız.',
    whatItDoes:
      'Gelen her hareket açıklama ve gönderen adına göre bayiyle eşleştirilir: sipariş numarası, bayi kodu, BizimHesap cari kodu, vergi numarası, en son unvan benzerliği. Siz satırları ve bayileri onaylarsınız; seçilenler havale tahsilatı olarak deftere yazılır. Bayi BizimHesap’a bağlıysa tahsilat BizimHesap tahsilat kuyruğuna da girer.',
    whenToUse: 'Gün veya hafta sonunda bankadan gelen bayi ödemelerini işlerken.',
    dataChanged: 'Bayinin cari defterine tahsilat kaydı (ve bağlı bayide BizimHesap tahsilat kuyruğu).',
    requiredPermission: 'Cari hesap yönetimi (iki adımlı doğrulama); bütün bayileri gören kullanıcı.',
    reversible:
      'Yanlış bayiye yazılan tahsilat cari ekstreden ters kayıtla kapatılır; ters kaydı yapılan hareket yeniden yüklenebilir.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#banka-hareketi',
  },
  'ledger.bank_import': {
    kind: 'action',
    title: 'Banka hareketi yükle',
    short:
      'Bankanın hesap hareketleri dökümüyle bayi ödemelerini toplu tahsilat olarak yazar. Önce önizleme; deftere onayınızla yazılır.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#banka-hareketi',
  },
  'ledger.bank_import_file': {
    kind: 'field',
    title: 'Banka dökümü',
    short:
      'CSV veya XLSX. Başlık satırı üstteki hesap bilgisi satırlarının altında olabilir. Gerekli: Tarih ve Tutar (ya da Alacak/Borç); Açıklama, Gönderen, Dekont No eşleştirmeye yardım eder. Giden hareketler atlanır.',
  },
  'ledger.bank_import_dealer': {
    kind: 'field',
    title: 'Bayi',
    short:
      'Önerilen bayiyi kontrol edin veya listeden seçin. Sipariş no, bayi kodu, BizimHesap kodu ve vergi no eşleşmeleri önceden seçili gelir; unvan benzerliği seçili gelmez.',
  },
  'ledger.bank_import_apply': {
    kind: 'action',
    title: 'Seçilenleri deftere yaz',
    short:
      'Seçilen hareketleri onayladığınız bayilere havale tahsilatı olarak (dekont no ve açıklamayla) yazar. Önizleme bir kez uygulanır; daha önce yazılmış hareket yeniden yazılmaz.',
    whenToUse: 'Banka hesap dökümünü yükleyip her hareketi doğru bayiyle eşleştirdikten sonra.',
    dataChanged:
      'Seçilen her hareket, eşleştirilen bayinin hesabına havale tahsilatı (dekont no ve açıklamayla) olarak yazılır. Bayi BizimHesap carisine bağlıysa tahsilatlar kuyruğa girer, "tahsilat gönder" açıksa gönderilir; işlem denetim kaydına yazılır.',
    requiredPermission:
      'Bayi cari hesabına tahsilat, düzeltme ve açılış bakiyesi girme (hassas; iki adımlı doğrulama).',
    reversible:
      'Kısmen: aktarım toplu geri alınmaz; yanlış tahsilat bayinin ekstresinden "Ters kayıt" ile kapatılır.',
    commonErrors: [
      {
        problem: '"Bu banka hareketi daha önce deftere yazılmış"',
        solution: 'O satırın seçimini kaldırın; aynı hareket iki kez yazılmaz.',
      },
      {
        problem: '"Seçilen bayi bulunamadı veya onaylı değil"',
        solution: 'Satırı onaylı bir bayiyle eşleştirin.',
      },
      {
        problem: '"Önizleme süresi doldu"',
        solution: 'Döküm dosyasını yeniden yükleyip önizlemeyi tekrar alın.',
      },
    ],
    guideUrl: 'docs/B2B_GUIDE_TR.md#banka-hareketi',
  },
  'ledger.balance_payments': {
    kind: 'field',
    title: 'Kartla bakiye ödemeleri',
    short:
      'Bayi firmasının Yetkilisi vitrinde Hesabım → Cari hesabım’dan bakiyesini, açık kalemlerini veya bir tutarı kartla öder. Ödeme kuruluşunun sonucu doğrulanınca deftere kart tahsilatı yazılır; bayi BizimHesap’a bağlıysa tahsilat kuyruğuna girer.',
    whatItDoes:
      'Tutar ödeme kuruluşunun bildirdiğiyle tutmazsa ödeme "İnceleniyor" olur ve deftere yazılmaz. Süresi dolan deneme ödeme kuruluşuna sorulur; geç gelen başarılı sonuç yine deftere yazılır. İade ödeme kuruluşunun panelinden yapılır; defterde ters kayıtla düzeltilir.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#kartla-bakiye-odemesi',
  },
  'dashboard.dealer_payments': {
    kind: 'field',
    title: 'Son bayi ödemeleri',
    short:
      'Bayilerin vitrinde Hesabım → Cari hesabım’dan kartla yaptığı ödemeler (son 30 gün, en yeni 10). Her ödeme bayinin cari hesabına kendiliğinden işlenir; para ödeme kuruluşunun (iyzico/PayTR) hesabınıza geçer.',
    whatItDoes:
      'Ödeme alınınca Android yönetim uygulamasına "Bayi ödemesi alındı" bildirimi gider (uygulamada Diğer → Anlık bildirimler’de veya panelde Hesabım → Mobil bildirimler’de açıksa ve cari hesapları görme yetkiniz varsa) ve uyarı alıcılarına e-posta gönderilir. Bildirim ve e-postada firma adı yoktur; tutar ve ödeme anahtarı vardır. Tutarı tutmayan ya da ödeme kuruluşunun incelediği ödeme deftere yazılmaz ve "Dikkat gerektirenler"de görünür.',
    requiredPermission: 'Cari hesapları görme',
    guideUrl: 'docs/B2B_GUIDE_TR.md#bayi-odemesi-bildirimi',
  },
  'dashboard.dealer_payment_email': {
    kind: 'field',
    title: 'Bayi ödemesinde e-posta',
    short:
      'Açıksa bir bayi kartla ödeme yaptığında Sistem Durumu’ndaki "Uyarı alıcıları"na (boşsa sahip ve yöneticilere) tutar ve ödeme anahtarıyla e-posta gider. E-posta servisi kurulu değilse gönderilmez. Android bildirimi bu düğmeden etkilenmez.',
    requiredPermission: 'İşletme ayarlarını değiştirme',
    guideUrl: 'docs/B2B_GUIDE_TR.md#bayi-odemesi-bildirimi',
  },
  'ledger.import_apply': {
    kind: 'action',
    title: 'Deftere yaz',
    short:
      'Önizlemedeki hatasız satırları açılış bakiyesi olarak deftere yazar. Hatalı satırlar atlanır. Aynı dosya iki kez uygulanamaz; daha önce açılış bakiyesi girilmiş bayiler önizlemede uyarı olarak sayılır.',
    whenToUse:
      'Eski muhasebe programınızdaki bayi bakiyelerini sisteme ilk kez aktarırken, önizlemeyi kontrol ettikten sonra.',
    dataChanged:
      'Önizlemedeki hatasız her satır, bayinin hesabına "açılış bakiyesi" kaydı olarak tek işlemde yazılır; aktarım "uygulandı" olur ve denetim kaydına düşer.',
    requiredPermission:
      'Bayi cari hesabına tahsilat, düzeltme ve açılış bakiyesi girme (hassas; iki adımlı doğrulama).',
    reversible:
      'Kısmen: aktarım toplu geri alınmaz; yanlış açılış kaydı bayinin ekstresinden tek tek "Ters kayıt" ile kapatılır.',
    commonErrors: [
      { problem: '"Önizleme süresi doldu"', solution: 'Dosyayı yeniden yükleyip önizlemeyi tekrar alın.' },
      {
        problem: '"Aktarılacak hatasız satır yok"',
        solution: 'Hata listesindeki satırları düzeltip dosyayı yeniden yükleyin.',
      },
      {
        problem: '"Bu aktarım önizleme aşamasında değil"',
        solution: 'Aynı önizleme ikinci kez uygulanamaz; ekstrelerde kayıtları kontrol edin.',
      },
    ],
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-hesap',
  },
  'ledger.currency': {
    kind: 'field',
    title: 'Para birimi',
    short: 'Bayinin farklı para birimlerinde hareketi varsa her para biriminin defteri ve bakiyesi ayrıdır.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-hesap',
  },
  'ledger.period': {
    kind: 'field',
    title: 'Dönem',
    short: 'Ekstrenin başlangıç ve bitiş tarihi. Başlangıçtan önceki hareketler "Devir" satırında toplanır.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-hesap',
  },
  'ledger.payment': {
    kind: 'action',
    title: 'Tahsilat gir',
    short:
      'Bayiden alınan ödemeyi alacak olarak yazar (siparişe bağlı değildir; en eski vadeli borca uygulanır). Siparişe bağlı tahsilat için sipariş ekranındaki "Ödeme alındı" da kullanılabilir.',
    whenToUse:
      'Bayi havale, nakit veya çekle borcunu ödediğinde ve ödeme belirli bir siparişe bağlı değilse.',
    dataChanged:
      'Bayinin cari hesabına alacak (tahsilat) kaydı eklenir ve bakiye azalır; işlem denetim kaydına yazılır. Bayi BizimHesap carisine bağlıysa kayıt tahsilat kuyruğuna girer, "tahsilat gönder" açıksa hemen gönderilir.',
    requiredPermission:
      'Bayi cari hesabına tahsilat, düzeltme ve açılış bakiyesi girme (hassas; iki adımlı doğrulama).',
    reversible:
      'Evet, "Ters kayıt" ile kapatılır; kayıt silinmez. BizimHesap\'a gönderilmişse orada elle düzeltilir.',
    commonErrors: [
      {
        problem: '"Tarih ileri bir tarih olamaz"',
        solution: 'Tahsilat tarihini bugün veya geçmiş bir gün seçin.',
      },
      {
        problem: 'Ödeme yöntemi alanı hatalı',
        solution: 'Tahsilatta ödeme yöntemi (havale, nakit vb.) seçmek zorunludur.',
      },
    ],
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-hesap',
  },
  'ledger.adjustment': {
    kind: 'action',
    title: 'Düzeltme gir',
    short:
      'Bayinin borcunu artıran (borç) veya azaltan (alacak) elle kayıt; ör. kargo farkı, fiyat farkı, iskonto. Açıklama zorunludur.',
    whenToUse:
      'Kargo farkı, fiyat farkı, iskonto gibi siparişe yansımayan bir tutarı bayinin hesabına işlemeniz gerektiğinde.',
    dataChanged:
      'Bayinin cari hesabına borç (bakiye artar, vadesiyle) veya alacak (bakiye azalır) yönlü düzeltme kaydı eklenir; işlem denetim kaydına yazılır.',
    requiredPermission:
      'Bayi cari hesabına tahsilat, düzeltme ve açılış bakiyesi girme (hassas; iki adımlı doğrulama).',
    reversible: 'Evet, "Ters kayıt" ile aynı tutarın tersi yazılarak kapatılır; kayıt silinmez.',
    commonErrors: [
      {
        problem: 'Yön veya açıklama alanı "zorunlu" uyarısı veriyor',
        solution: 'Düzeltmede borç/alacak yönünü seçin ve açıklama yazın.',
      },
      {
        problem: '"Tarih ileri bir tarih olamaz"',
        solution: 'Kayıt tarihini bugün veya geçmiş bir gün seçin.',
      },
    ],
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-hesap',
  },
  'ledger.reverse': {
    kind: 'action',
    title: 'Ters kayıt',
    short:
      'Elle girilen tahsilat, düzeltme veya açılış bakiyesi kaydını aynı tutarın tersiyle kapatır. Kayıt silinmez; ikisi ekstrede görünür. Sipariş kayıtları siparişten düzelir.',
    whenToUse: 'Yanlış girilen tahsilat, düzeltme veya açılış bakiyesi kaydını iptal etmek istediğinizde.',
    dataChanged:
      'Bayinin hesabına aynı tutarın tersiyle bir "ters kayıt" eklenir; asıl kayıt silinmez. Henüz BizimHesap\'a gönderilmemiş tahsilat kuyruktan iptal edilir; işlem gerekçesiyle denetim kaydına yazılır.',
    requiredPermission:
      'Bayi cari hesabına tahsilat, düzeltme ve açılış bakiyesi girme (hassas; iki adımlı doğrulama).',
    reversible: 'Hayır, ters kaydın tersi alınamaz; gerekirse doğru tutarla yeni kayıt girilir.',
    commonErrors: [
      {
        problem: '"Bu kaydın ters kaydı zaten yapılmış"',
        solution: 'Her kayıt yalnızca bir kez ters çevrilir; ekstrede ters kaydı görebilirsiniz.',
      },
      {
        problem: '"Bu kayıt ters çevrilemez"',
        solution: 'Sipariş kayıtları siparişten (iptal, iade, düzenleme) düzelir.',
      },
    ],
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-hesap',
  },
  'ledger.statement_csv': {
    kind: 'action',
    title: 'Ekstre indir (CSV)',
    short: 'Seçili dönemin ekstresini Türkçe Excel biçiminde indirir (devir, borç, alacak, bakiye).',
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-hesap',
  },
  'ledger.print': {
    kind: 'action',
    title: 'Yazdır',
    short: 'Ekstreyi yazdırır veya tarayıcının "PDF olarak kaydet" seçeneğiyle PDF yapar.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-hesap',
  },
  'ledger.amount': {
    kind: 'field',
    title: 'Tutar',
    short: 'Kuruşlu yazılabilir (ör. 1.250,50). Yön işaretle değil türle belirlenir.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-hesap',
  },
  'ledger.entry_date': {
    kind: 'field',
    title: 'Kayıt tarihi',
    short: 'Ödemenin alındığı veya düzeltmenin geçerli olduğu gün. İleri tarih girilemez.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-hesap',
  },
  'ledger.method': {
    kind: 'field',
    title: 'Ödeme şekli',
    short:
      'Havale/EFT, nakit, çek, senet, kart veya diğer. Çek ve senet için numarayı Belge no alanına yazın.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-hesap',
  },
  'ledger.reference': {
    kind: 'field',
    title: 'Belge no',
    short: 'Dekont, çek veya senet numarası (isteğe bağlı); ekstrede görünür.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-hesap',
  },
  'ledger.direction': {
    kind: 'field',
    title: 'Yön',
    short: 'Borç: bayinin borcunu artırır. Alacak: bayinin borcunu azaltır.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-hesap',
  },
  'ledger.due_date': {
    kind: 'field',
    title: 'Vade',
    short: 'Borç yönlü düzeltmenin ödeneceği gün; boşsa kayıt günü. Vadesi geçen borç listesinde kullanılır.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-hesap',
  },
  'ledger.open_items': {
    kind: 'field',
    title: 'Açık kalemler',
    short:
      'Henüz kapanmamış borçlar, en eski vade önce. Tahsilatlar ve iadeler en eski vadeli borçtan başlayarak düşülür; sipariş kayıtları sipariş başına netleşir. Bayi aynı listeyi vitrinde Hesabım sayfasında görür.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-hesap',
  },
  'ledger.reminders': {
    kind: 'field',
    title: 'Vade hatırlatması',
    short:
      'Açıkken her sabah 09:10’da, vadesi yaklaşan ve vadesi geçen açık kalemler için bayiye (firma e-postası ve firma Yetkilileri) tek e-posta gider. Her kalem her aşamada en çok bir kez hatırlatılır. Varsayılan kapalıdır.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#vade-hatirlatmasi',
  },
  'ledger.reminders_enabled': {
    kind: 'field',
    title: 'Hatırlatmayı aç',
    short:
      'Açmak gerçek bayilerinize e-posta gönderir; kaydetmeden önce onay kutusunu işaretlemeniz istenir. E-posta altyapısı kurulu değilse hatırlatma gönderilmez.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#vade-hatirlatmasi',
  },
  'ledger.reminders_days': {
    kind: 'field',
    title: 'Kaç gün önce',
    short:
      'Vadeden kaç gün önce hatırlatılsın (0–30). 0 yazarsanız yalnızca vadesi geçen kalemler için hatırlatma gider.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#vade-hatirlatmasi',
  },
  'ledger.reminders_save': {
    kind: 'action',
    title: 'Kaydet',
    short:
      'Hatırlatma ayarını kaydeder. Değişiklik denetim kaydına yazılır; ilk gönderim ertesi sabah 09:10’dadır.',
    whenToUse:
      'Bayilere vadesi yaklaşan veya geçen borçları için otomatik hatırlatma e-postası göndermeye başlamak, durdurmak ya da gün sayısını değiştirmek istediğinizde.',
    dataChanged:
      'Vade hatırlatma ayarı (açık/kapalı ve vadeden kaç gün önce) kaydedilir; açıkken her sabah ilgili bayilerin firma e-postasına ve yetkililerine hatırlatma gider. Değişiklik denetim kaydına yazılır.',
    requiredPermission:
      'Bayi cari hesabına tahsilat, düzeltme ve açılış bakiyesi girme (hassas; iki adımlı doğrulama; tüm bayilere yetki gerekir).',
    reversible: 'Evet, hatırlatma yeniden kapatılabilir; gönderilmiş e-postalar geri alınamaz.',
    commonErrors: [
      {
        problem: '"Vade hatırlatmasını açmak bayilerinize gerçek e-posta gönderir"',
        solution: 'Açarken onay kutusunu işaretleyin.',
      },
      {
        problem: '"Bu işlem için yetkiniz yok"',
        solution: 'Yalnızca tüm bayilere yetkili kullanıcı bu ayarı değiştirebilir; yöneticinize başvurun.',
      },
    ],
    guideUrl: 'docs/B2B_GUIDE_TR.md#vade-hatirlatmasi',
  },
  'dealers.member_role': {
    kind: 'field',
    title: 'Firma içi rol',
    short:
      'Yetkili: sipariş verir, firma siparişlerini, cari hesabı ve kullanıcıları görür, lokasyonları yönetir. Satın alma: sipariş verir, yalnızca kendi siparişlerini görür; eşik uygulanabilir. Yalnızca görüntüleme: fiyatları, firma siparişlerini ve cari hesabı görür, sipariş veremez. Firmada en az bir Yetkili kalır.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#firma-kullanicilari',
  },
  'dealers.order_limit': {
    kind: 'field',
    title: 'Sipariş eşiği',
    short:
      'Satın alma kullanıcısı bu tutarı (kargo dahil) aşan siparişi veremez; vitrinde "firma Yetkilisinin onayı gerekir" uyarısı görür. Siparişi Yetkili verebilir. Boş: eşik yok. Panelden verilen siparişlere uygulanmaz.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#firma-kullanicilari',
  },
  'dealers.locations': {
    kind: 'field',
    title: 'Lokasyonlar',
    short:
      'Bayinin şube, teslimat ve fatura adresleri. Firmanın sipariş verebilen kullanıcıları vitrinde ödeme adımında seçer; siparişe adresin o anki kopyası yazılır, lokasyon sonradan değişse de sipariş değişmez. Firma Yetkilisi vitrinde Hesabım’dan da ekleyebilir.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#lokasyonlar',
  },
  'dealers.location_label': {
    kind: 'field',
    title: 'Lokasyon adı',
    short: 'Listede ve ödeme adımında görünen kısa ad (ör. "Merkez", "Kadıköy şubesi"); en çok 40 karakter.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#lokasyonlar',
  },
  'orders.location_fill': {
    kind: 'field',
    title: 'Firma lokasyonundan doldur',
    short:
      'Seçilen bayi müşterisinin firma lokasyonlarından birini seçince teslimat adresi alanları dolar; sonra değiştirebilirsiniz.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#lokasyonlar',
  },
  'dealers.credit_limit': {
    kind: 'field',
    title: 'Kredi limiti',
    short:
      'Bayinin açık hesap borcu (cari bakiye + yeni sipariş) bu tutarı aşamaz; aşan sipariş vitrinde reddedilir, panelde yalnızca cari yönetimi yetkisi ve gerekçeyle verilebilir. Boş: limit yok.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#kredi-limiti',
  },
  'dealers.credit_currency': {
    kind: 'field',
    title: 'Limit para birimi',
    short:
      'Limit bu para birimindeki cari bakiyeye uygulanır. Limit tanımlıyken başka para biriminde açık hesapla sipariş verilemez.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#kredi-limiti',
  },
  'dealers.block_when_overdue': {
    kind: 'field',
    title: 'Vadesi geçmiş borçta açık hesabı durdur',
    short:
      'Açıkken bayinin vadesi geçmiş borcu varsa açık hesapla yeni sipariş verilemez (vitrinde seçenek kapalı görünür). Diğer ödeme yöntemleri açık kalır.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#kredi-limiti',
  },
  'orders.credit_override': {
    kind: 'field',
    title: 'Limit aşımı gerekçesi',
    short:
      'Sipariş bayinin kredi limitini aşıyor veya vadesi geçmiş borcu var. Gerekçe yazıp kaydederseniz sipariş yine de açılır; karar iki adımlı doğrulamayla ve denetim kaydına gerekçesiyle yazılır.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#kredi-limiti',
  },
  'dealers.payment_term': {
    kind: 'field',
    title: 'Vade (gün)',
    short:
      'Açık hesapla verilen siparişin borcu sipariş gününden bu kadar gün sonra vadesi gelir (0: sipariş günü). Değişiklik yeni siparişlerden itibaren geçerlidir; cari hesap yönetimi yetkisi ve iki adımlı doğrulama ister.',
    guideUrl: 'docs/B2B_GUIDE_TR.md#cari-hesap',
  },
  'retention.rules': {
    kind: 'field',
    title: 'Otomatik imha kuralları',
    short:
      'Her veri türü için saklama süresi ve otomatik silme. Hepsi varsayılan kapalı; açmak geri alınamaz silme onayı ister.',
    guideUrl: 'docs/PRIVACY_COMPLIANCE_TR.md#otomatik-imha',
  },
  'retention.days': {
    kind: 'field',
    title: 'Saklama süresi (gün)',
    short:
      'Kayıt bu kadar gün eski olunca silinir. Her veri türünün alt ve üst sınırı vardır; bülten çıkış kayıtları ispat için en az 3 yıl saklanır.',
  },
  'retention.due': {
    kind: 'field',
    title: 'Bugün silinecek',
    short: 'Kayıtlı süreyle bu gece silinecek kayıt sayısı (kural açıksa).',
  },
  'retention.enabled': {
    kind: 'field',
    title: 'Otomatik imha',
    short: 'Açıkken süresi dolan kayıtlar her gece kalıcı olarak silinir ve imha kaydına yazılır.',
    reversible: 'Kapatılabilir; silinmiş kayıtlar geri getirilemez.',
  },
  'retention.save': {
    kind: 'action',
    title: 'Kaydet',
    short:
      'Süreleri ve açık/kapalı durumunu kaydeder. Kapalı bir kural açılıyorsa önce silinecek kayıt sayısı gösterilir ve onay istenir.',
    requiredPermission: 'Otomatik imha kurallarını açma ve değiştirme (iki adımlı doğrulama)',
  },
  'retention.confirm': {
    kind: 'action',
    title: 'Aç ve kaydet',
    short: 'Açılan kurallar bu geceden başlayarak süresi dolan kayıtları kalıcı olarak siler.',
    whenToUse:
      'Saklama sürelerini mali müşavir ve avukatınızla belirledikten sonra, süresi dolan kişisel verilerin otomatik silinmesini başlatmak için.',
    dataChanged:
      'Seçilen imha kuralları açılır ve süreleri kaydedilir; o geceden itibaren süresi dolan kayıtlar silinir ve imha kaydına yazılır. Değişiklik denetim kaydına yazılır.',
    requiredPermission: 'Otomatik imha kurallarını açma ve değiştirme (hassas; iki adımlı doğrulama).',
    reversible: 'Silinen kayıtlar geri getirilemez.',
    commonErrors: [
      {
        problem: '"Otomatik imhayı açmak için … onaylayın"',
        solution: 'Silinecek kayıtların geri alınamayacağını onaylayan kutuyu işaretleyin.',
      },
    ],
  },
  'retention.fixed': {
    kind: 'field',
    title: 'Sabit saklama süreleri',
    short:
      'Özelliklerin kendi temizlik süreleri (ör. destek talebi 2 yıl, kampanya alıcı kayıtları 180 gün). Bunlar da imha kaydına yazılır.',
  },
  'retention.log': {
    kind: 'field',
    title: 'İmha kaydı',
    short:
      'Hangi gün hangi veri türünden kaç kaydın silindiği veya anonimleştirildiği. Kişisel veri içermez ve silinmez.',
    guideUrl: 'docs/PRIVACY_COMPLIANCE_TR.md#imha-kaydi',
  },
  'retention.log_period': {
    kind: 'field',
    title: 'Dönem',
    short: 'Son 30, 90, 365 veya 1095 gün (3 yıl).',
  },
  'page.google_reports': {
    kind: 'page',
    title: 'Google raporları',
    short:
      'Mağazaya bağlı GA4 mülkünün kanal/gün raporu ve Google Business Profile konum bilgisi ile yorumlar.',
    whatItDoes:
      'GA4 Data API ile oturum, kullanıcı, temel etkinlik ve satın alma gelirini kanal ve güne göre gösterir; Business Profile’dan konum bilgisini ve son 50 yorumu okur. Veriler istek anında Google’dan çekilir, saklanmaz; hiçbir şey Google’a yazılmaz.',
    whenToUse: 'Trafik kaynaklarını ve yerel işletme yorumlarını panelden izlemek için.',
    requiredPermission:
      'GA4: Ölçümleme ayarlarını görüntüleme. Business Profile: SEO ayarlarını görüntüleme.',
    guideUrl: 'docs/GOOGLE_INTEGRATIONS_TR.md#raporlar',
  },
  'google_reports.ga4': {
    kind: 'field',
    title: 'Analytics (GA4) raporu',
    short:
      'Google bağlantılarında mağazaya seçilen GA4 mülkünden okunur. Gelir mülkün para biriminde; iade ve iptaller düşülmez.',
    guideUrl: 'docs/GOOGLE_INTEGRATIONS_TR.md#raporlar',
  },
  'google_reports.period': {
    kind: 'field',
    title: 'Dönem',
    short: 'Son 7, 28 veya 90 gün (dün dahil, bugün hariç).',
  },
  'google_reports.business_profile': {
    kind: 'field',
    title: 'Google Business Profile',
    short: 'Mağazaya seçilen konumun bilgileri ve son 50 yorumu. Salt okuma: yorum yanıtı Google’da verilir.',
    guideUrl: 'docs/GOOGLE_INTEGRATIONS_TR.md#business-profile',
  },
  'google_reports.reply': {
    kind: 'action',
    title: 'Yorumları yanıtla',
    short: 'Konumu Google Haritalar’da yeni sekmede açar; yanıtı orada işletme hesabınızla verirsiniz.',
  },
  'ads.google_conversions': {
    kind: 'field',
    title: 'Google Ads dönüşüm yükleme',
    short:
      'Pazarlama izni veren ziyaretçilerin reklamdan gelen ödenmiş siparişlerini (gclid, sipariş no, tutar) Google Ads’e bildirir. Varsayılan kapalı; kişisel verinin yurt dışına aktarımıdır.',
    guideUrl: 'docs/ADS_MANAGER_TR.md#google-donusum',
  },
  'ads.google_conversions_enabled': {
    kind: 'field',
    title: 'Dönüşüm yükle',
    short:
      'Açıkken her sabah son 60 günün yüklenmemiş siparişleri bir kez gönderilir. Açmak onay yetkisi ve iki adımlı doğrulama ister.',
    requiredPermission: 'Reklam değişikliklerini onaylama.',
    guideUrl: 'docs/ADS_MANAGER_TR.md#google-donusum',
  },
  'ads.google_conversion_action': {
    kind: 'field',
    title: 'Dönüşüm işlemi',
    short:
      'Google Ads’te "Tıklama içe aktarma" türünde oluşturulan dönüşüm işleminin kaynak adı: customers/<10 hane>/conversionActions/<numara>.',
    guideUrl: 'docs/ADS_MANAGER_TR.md#google-donusum',
  },
  'ads.google_conversions_save': {
    kind: 'action',
    title: 'Kaydet',
    short:
      'Ayarı kaydeder ve denetim kaydına yazar. Kapatınca gönderim durur; daha önce gönderilenler Google’da kalır.',
  },
  'blog.title': {
    kind: 'field',
    title: 'Yazı Başlığı',
    short: 'Vitrinde ve arama sonuçlarında görünen başlık (en fazla 160 karakter).',
  },
  'blog.slug': {
    kind: 'field',
    title: 'Kısa Ad (adres)',
    short:
      'Yazının adresi: /blog/<kısa-ad>. Yayındaki yazının kısa adı kayıtla hemen değişir ve eski adres kalıcı olarak yönlendirilir; bunun için İçerik yayınlama yetkisi gerekir.',
  },
  'blog.excerpt': {
    kind: 'field',
    title: 'Özet',
    short:
      'Blog listesinde ve başlığın altında görünen kısa metin (en fazla 300 karakter). SEO açıklaması boşsa bu kullanılır.',
  },
  'blog.category': {
    kind: 'field',
    title: 'Kategori',
    short: 'Yazının blog kategorisi (isteğe bağlı). Kategoriler Blog ekranının altında yönetilir.',
  },
  'blog.tags': {
    kind: 'field',
    title: 'Etiketler',
    short: 'Virgülle ayırın (en fazla 10). Küçük harfe çevrilir, tekrar edenler birleştirilir.',
  },
  'blog.author': {
    kind: 'field',
    title: 'Yazar',
    short:
      'Yazının künyesinde görünen ad ve unvan (ör. "Veteriner Hekim"). Boş bırakılırsa yazar gösterilmez.',
  },
  'blog.cover': {
    kind: 'action',
    title: 'Kapak Görseli',
    short: 'Listede ve yazının başında görünen görsel (isteğe bağlı). Alternatif metin zorunludur.',
  },
  'blog.health_content': {
    kind: 'field',
    title: 'Sağlık İçeriği',
    short:
      'Yazı evcil hayvan sağlığıyla ilgiliyse işaretleyin: Veteriner Uzman İnceleyici onayı olmadan yayımlanmaz ve vitrinde bilgilendirme notu gösterilir.',
  },
  'blog.references': {
    kind: 'field',
    title: 'Kaynaklar',
    short:
      'Yazının dayandığı kaynaklar (en fazla 30): başlık ve isteğe bağlı bağlantı. Vitrinde numaralı liste olarak görünür.',
  },
  'blog.related': {
    kind: 'field',
    title: 'İlgili Ürünler',
    short: 'Yazının sonunda gösterilecek ürünler (en fazla 8). Vitrinde görünmeyen ürünler atlanır.',
  },
  'blog.preview': {
    kind: 'action',
    title: 'Önizle',
    short:
      'Kaydedilmemiş değişiklikleri kaydeder ve taslağı yeni sekmede açar. Bağlantı imzalıdır, 2 saat geçerlidir.',
  },
  'blog.save': {
    kind: 'action',
    title: 'Taslağı Kaydet',
    short: 'Değişiklikleri taslak olarak saklar; vitrindeki yazı yeniden yayımlanana kadar değişmez.',
  },
  'blog.feature': {
    kind: 'action',
    title: 'Öne çıkar',
    short: 'Yazıyı Makaleler sayfasında öne çıkan yazı yapar.',
    whatItDoes:
      'Yayın sürümünü değiştirmez; yeniden yayın veya uzman onayı gerekmez. Birden çok yazı öne çıkarılmışsa en son çıkarılan gösterilir. Yalnızca yayındaki yazı vitrinde öne çıkar.',
    requiredPermission: 'İçerik yayınlama',
  },
  'blog.publish': {
    kind: 'action',
    title: 'Yayımla',
    short: 'Taslağı yeni sürüm olarak vitrine çıkarır. Yayın tarihi verilirse o zamana kadar görünmez.',
    whenToUse: 'Yazının metnini, kapak görselini ve SEO alanlarını kontrol edip önizledikten sonra.',
    dataChanged:
      'Taslak yeni bir sürüm olarak saklanır ve yazı "yayında" olur; Makaleler sayfasında ve site haritasında görünür. İşlem denetim kaydına yazılır.',
    requiredPermission: 'İçerik yayınlama (sağlık içeriğinde ayrıca uzman onayı)',
    reversible: 'Evet, "Yayından Kaldır" ile vitrinden kaldırılır; sürümler saklanır.',
    commonErrors: [
      { problem: '"Yayımlamak için yazının metnini girin"', solution: 'Yazı metni boş olamaz.' },
      {
        problem: '"Sağlık içeriği veya sağlık beyanı var: … uzman onayı gerekir"',
        solution: 'Veteriner Uzman İnceleyici onayından sonra yayımlayın.',
      },
    ],
  },
  'blog.schedule': {
    kind: 'field',
    title: 'Yayın Tarihi',
    short: 'Boş bırakılırsa yazı hemen yayına girer. Vitrinde gösterilen tarih budur.',
  },
  'blog.unpublish': {
    kind: 'action',
    title: 'Yayından Kaldır',
    short: 'Yazı vitrinden hemen kalkar; taslak ve sürümler saklanır.',
    whenToUse: 'Yazı güncelliğini yitirdiğinde veya düzeltilene kadar görünmemesi gerektiğinde.',
    dataChanged:
      'Yazının durumu "yayından kaldırıldı" olur ve vitrinden kalkar; taslak ve sürümler korunur. İşlem denetim kaydına yazılır.',
    requiredPermission: 'İçerik yayınlama',
    reversible: 'Evet. Yeniden yayımlayabilirsiniz.',
    commonErrors: [
      {
        problem: '"Bu kayıt siz düzenlerken başka biri tarafından değiştirildi"',
        solution: 'Sayfayı yenileyip tekrar deneyin.',
      },
    ],
  },
  'blog.delete': {
    kind: 'action',
    title: 'Yazıyı Sil',
    short: 'Hiç yayımlanmamış yazıyı kalıcı olarak siler. Yayımlanmış yazılar silinmez, yayından kaldırılır.',
    whenToUse: 'Hiç yayımlanmamış ve artık gerekmeyen bir yazı taslağını kaldırmak için.',
    dataChanged: 'Taslak yazı kalıcı olarak silinir; işlem denetim kaydına yazılır.',
    requiredPermission: 'İçerik yayınlama',
    reversible: 'Hayır.',
    commonErrors: [
      {
        problem: '"Yayımlanmış yazı silinemez"',
        solution: 'Yayımlanmış yazıyı "Yayından Kaldır" ile vitrinden kaldırın.',
      },
    ],
  },
  'blog.category_add': {
    kind: 'action',
    title: 'Kategori Ekle',
    short:
      'Yeni blog kategorisi ekler; kısa ad addan üretilir. Kategori, içinde yayındaki yazı olunca vitrinde listelenir.',
    requiredPermission: 'İçerik düzenleme',
  },
  'blog.category_edit': {
    kind: 'action',
    title: 'Kategoriyi Düzenle veya Sil',
    short:
      'Ad ve kısa ad değişikliği vitrine hemen yansır; eski adres yönlendirilir. Silinen kategorinin yazıları kategorisiz kalır, silinmez.',
    requiredPermission: 'İçerik yayınlama',
  },
  'menus.post': {
    kind: 'field',
    title: 'Blog Yazısı',
    short:
      'Bağlanacak blog yazısı. Yazı yalnızca yayındayken menüde görünür; kısa adı değişse de bağlantı doğru adrese gider.',
  },
  // ------------------------------------------------------------------ Ürün soruları (Faz 4)
  'page.product_bulk': {
    kind: 'page',
    title: 'Toplu İşlem Geçmişi',
    short: 'Ürünlerde yapılan toplu değişiklikleri, sonuçlarını ve atlanan satırları gösterir.',
    whatItDoes:
      'Ürünler ekranında seçilen ürünlere uygulanan toplu işlemler (durum, kategori, etiket, koleksiyon, stok, SEO, Google alışveriş) burada listelenir. Her işlemin kaç satırı değiştirdiği, kaçının neden atlandığı ve büyük işlemlerde ilerleme görünür. Uygulanan işlem geri alınabilir: yalnızca o günden beri değişmemiş satırlar eski değerine döner.',
    whenToUse:
      'Bir toplu değişikliğin sonucunu kontrol etmek veya yanlış yapılan bir işlemi geri almak için.',
    requiredPermission:
      'Görüntüleme: Ürünleri görme. Uygulama ve geri alma: Toplu ürün işlemi uygulama (ayrıca işleme göre ürün düzenleme veya stok değiştirme) ve iki adımlı doğrulama.',
    reversible:
      'Evet. Uygulanan işlem geri alınabilir; sonradan elle değiştirilmiş satırlar korunur. Uygulama ve geri alma denetim kaydına yazılır.',
    commonErrors: [
      {
        problem: '"Önizleme 30 dakikadan eski."',
        solution:
          'Ürünler ekranında aynı seçimle yeniden önizleyip uygulayın; değerler arada değişmiş olabilir.',
      },
      {
        problem: 'Bazı satırlar "Önizlemeden sonra değişti" notuyla atlandı.',
        solution:
          'Önizleme ile uygulama arasında o ürün başka biri veya sipariş tarafından değiştirildi. Gerekirse o ürünü yeniden seçip işlemi tekrarlayın.',
      },
    ],
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#toplu-islemler',
  },
  'page.product_grid': {
    kind: 'page',
    title: 'Tabloda Düzenle',
    short: 'Ürün ve varyantları tabloda görüp SKU, barkod, durum, fiyat ve stoku Excel gibi düzenlersiniz.',
    whatItDoes:
      'Her satır bir varyanttır. Hücreye gelip Enter’a basarak, çift tıklayarak veya yazmaya başlayarak düzenlersiniz; ok tuşlarıyla gezinilir. Değişen hücreler renklenir ve hemen kaydedilmez. "Değişiklikleri kaydet" önizleme gösterir: siz düzenlerken başkası tarafından (veya bir siparişle) değiştirilmiş hücreler çakışma olarak ayrılır ve kaydedilmez; geçersiz hücreler (ör. kullanılan SKU) nedeniyle listelenir. Kaydedilenler toplu işlem olarak kaydedilir ve geri alınabilir.',
    whenToUse:
      'Birçok ürünün fiyatını, stokunu veya kodlarını tek tek ürün ekranına girmeden düzeltmek için.',
    requiredPermission:
      'Görüntüleme: Ürünleri görme (fiyat için fiyat görme, stok için stok görme). Kaydetme: Toplu ürün işlemi uygulama ve düzenlenen alana göre ürün düzenleme, fiyat değiştirme veya stok hareketi girme; iki adımlı doğrulama.',
    reversible:
      'Evet. Her kayıt Toplu işlem geçmişinde görünür ve geri alınabilir; fiyat geçmişi ve stok hareketleri silinmez.',
    commonErrors: [
      {
        problem: '"Siz düzenlerken değişti" listesinde hücreler var.',
        solution:
          'Bu hücreler kaydedilmedi. Tablo yenilenince güncel değeri görün ve gerekiyorsa yeniden düzenleyip kaydedin.',
      },
      {
        problem: 'Stok hücresi düzenlenemiyor.',
        solution:
          'Varyant parti/SKT ile takip ediliyorsa stok, Stok ekranından parti seçilerek girilir. Depo seçili değilse veya pasifse de düzenlenemez.',
      },
    ],
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#tablo-duzenleme',
  },
  'page.reviews': {
    kind: 'page',
    title: 'Ürün Değerlendirmeleri',
    short:
      'Ürünü satın alıp teslim alan müşterilerin değerlendirmelerini onaylar, yanıtlar veya reddedersiniz.',
    whatItDoes:
      'Yalnızca ürünü bu mağazadan satın alıp teslim almış (sipariş durumu "Teslim edildi" veya "Tamamlandı") müşteri değerlendirme yazabilir; her müşteri bir ürüne bir kez. Değerlendirme önce burada "Onay bekleyen" listesine düşer; onaylayınca ürün sayfasında yayımlanır ve ortalama puana katılır. Vitrinde yazar olarak ad ve soyadın baş harfi, "Doğrulanmış alışveriş" etiketiyle gösterilir. Metinde veya mağaza yanıtında hastalığı önleme/tedavi gibi bir ifade varsa yayın için Veteriner Uzman İnceleyici onayı gerekir. Olumsuz değerlendirme yalnızca olumsuz olduğu için reddedilmez; kural dışı içerik (kişisel veri, hakaret, sağlık iddiası, ürünle ilgisiz metin) reddedilir.',
    whenToUse: 'Onay bekleyen değerlendirmeleri her gün kontrol etmek için.',
    requiredPermission:
      'Görüntüleme: Ürün değerlendirmelerini görme. Onay, ret ve yanıt: Ürün değerlendirmelerini onaylama, reddetme ve yanıtlama. Sağlık beyanı onayı: Uzman (veteriner) onayı.',
    reversible: 'Evet. Yayımlanan değerlendirme yayından kaldırılabilir; her işlem denetim kaydına yazılır.',
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#degerlendirmeler',
  },
  'page.review_detail': {
    kind: 'page',
    title: 'Değerlendirme',
    short: 'Değerlendirmeyi okuyup onaylarsınız, mağaza yanıtı yazarsınız veya reddedersiniz.',
    whatItDoes:
      'Onayla ve yayımla ile değerlendirme ürün sayfasında görünür. Mağaza yanıtı değerlendirmenin altında mağaza adıyla görünür; boş bırakılıp kaydedilirse kaldırılır. Reddetme gerekçesi yalnızca panelde görünür; müşteriye bildirim gitmez.',
    requiredPermission:
      'Ürün değerlendirmelerini onaylama, reddetme ve yanıtlama (sağlık beyanında ayrıca uzman onayı)',
    commonErrors: [
      {
        problem:
          '"Sağlık içeriği veya sağlık beyanı var: yayımlamak için Veteriner Uzman İnceleyici onayı gerekir."',
        solution:
          'Değerlendirme metni değiştirilemez; Veteriner Uzman İnceleyiciden onay isteyin veya değerlendirmeyi gerekçeyle reddedin. İfade mağaza yanıtındaysa yanıtı düzeltin.',
      },
    ],
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#degerlendirmeler',
  },
  'reviews.enabled': {
    kind: 'field',
    title: 'Değerlendirmeler vitrinde açık',
    short:
      'Kapalıyken ürün sayfalarında değerlendirme bölümü ve puan gösterilmez, yeni değerlendirme yazılamaz. Mevcut değerlendirmeler silinmez; açınca geri gelir.',
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#degerlendirmeler',
  },
  'reviews.filter': {
    kind: 'field',
    title: 'Durum',
    short: 'Onay bekleyen, yayındaki veya reddedilen değerlendirmeler.',
  },
  'reviews.reply': {
    kind: 'field',
    title: 'Mağaza yanıtı',
    short:
      'Değerlendirmenin altında mağaza adıyla görünür (en çok 2000 karakter). Kişisel veri ve sağlık iddiası yazmayın.',
  },
  'reviews.save_reply': {
    kind: 'action',
    title: 'Yanıtı kaydet',
    short: 'Yanıtı kaydeder; değerlendirme yayındaysa vitrinde hemen değişir. Boş yanıt, yanıtı kaldırır.',
  },
  'reviews.publish': {
    kind: 'action',
    title: 'Onayla ve yayımla',
    short: 'Değerlendirme ürün sayfasında yayımlanır ve ortalama puana katılır.',
    whenToUse: 'Müşteri değerlendirmesini okuyup uygunsuz içerik olmadığını kontrol ettikten sonra.',
    dataChanged:
      'Değerlendirmenin durumu "yayında" olur; ürün sayfasında görünür ve ürünün ortalama puanına katılır. İşlem denetim kaydına yazılır.',
    requiredPermission: 'Ürün değerlendirmelerini onaylama, reddetme ve yanıtlama.',
    reversible: 'Evet, "Reddet" ile vitrinden kaldırılır.',
    commonErrors: [
      {
        problem: '"Sağlık içeriği veya sağlık beyanı var: … uzman onayı gerekir"',
        solution:
          'Değerlendirmede sağlık beyanı bulunduysa Veteriner Uzman İnceleyici onayından sonra yayımlanır.',
      },
    ],
  },
  'reviews.reject': {
    kind: 'field',
    title: 'Reddetme gerekçesi',
    short: 'Yalnızca panelde görünür. Değerlendirme vitrinde gösterilmez ve ortalamaya katılmaz.',
  },
  'page.questions': {
    kind: 'page',
    title: 'Ürün Soruları',
    short: 'Müşterilerin ürün sayfasından sorduğu soruları yanıtlar ve ürün sayfasında yayımlarsınız.',
    whatItDoes:
      'Giriş yapmış müşteri, vitrinde görebildiği bir ürüne soru sorar (24 saatte en fazla 5). Soru önce burada "Yanıt bekleyen" listesine düşer; yanıtlayıp yayımlayınca ürün sayfasının "Soru ve cevaplar" bölümünde görünür. Vitrinde yazar olarak yalnızca ad ve soyadın baş harfi gösterilir. Soru veya yanıtta hastalığı önleme/tedavi gibi bir ifade varsa yayın için Veteriner Uzman İnceleyici onayı gerekir. Yayımlanınca müşteriye (e-posta altyapısı kuruluysa) bir kez yanıt e-postası gider.',
    whenToUse: 'Her gün yanıt bekleyen soruları kontrol etmek için.',
    requiredPermission:
      'Görüntüleme: Ürün sorularını görüntüleme. Yanıtlama, yayımlama, reddetme: Ürün sorularını yanıtlama ve yayımlama. Sağlık beyanı onayı: Uzman (veteriner) onayı.',
    reversible: 'Evet. Yayımlanan soru yayından kaldırılabilir (reddet); her işlem denetim kaydına yazılır.',
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#soru-cevap',
  },
  'page.question_detail': {
    kind: 'page',
    title: 'Soru',
    short: 'Soruyu okuyup yanıtlarsınız; yanıtı yayımlar veya soruyu reddedersiniz.',
    whatItDoes:
      'Yanıtı kaydedin, sonra yayımlayın. Yayındaki yanıtı değiştirirseniz vitrinde hemen değişir; değişiklik sağlık beyanı içeriyorsa soru uzman onayına kadar vitrinden kalkar. Reddetme gerekçesi yalnızca panelde görünür.',
    requiredPermission: 'Ürün sorularını yanıtlama ve yayımlama (sağlık beyanında ayrıca uzman onayı)',
    commonErrors: [
      {
        problem: '"Yayımlamak için önce yanıt yazın."',
        solution: 'Yanıt alanını doldurup kaydedin, sonra yayımlayın.',
      },
      {
        problem:
          '"Sağlık içeriği veya sağlık beyanı var: yayımlamak için Veteriner Uzman İnceleyici onayı gerekir."',
        solution: 'Yanıttaki ifadeyi düzeltin veya Veteriner Uzman İnceleyiciden onay isteyin.',
      },
    ],
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#soru-cevap',
  },
  'questions.filter': {
    kind: 'field',
    title: 'Durum',
    short: 'Yanıt bekleyen, yayındaki veya reddedilen sorular.',
  },
  'questions.answer': {
    kind: 'field',
    title: 'Yanıt',
    short:
      'Ürün sayfasında soruyla birlikte mağaza adıyla görünür (en fazla 2000 karakter). Hastalığı önleme veya tedavi etme iddiası kullanmayın.',
  },
  'questions.save': {
    kind: 'action',
    title: 'Yanıtı Kaydet',
    short: 'Yanıtı saklar. Soru yayındaysa vitrinde hemen değişir.',
  },
  'questions.publish': {
    kind: 'action',
    title: 'Yayımla',
    short:
      'Soru ve yanıtı ürün sayfasında gösterir; müşteriye bir kez yanıt e-postası gönderilir (e-posta kuruluysa).',
    whenToUse: 'Müşterinin ürün sorusunu yanıtladıktan ve yanıtı kontrol ettikten sonra.',
    dataChanged:
      'Soru ve yanıt ürün sayfasında görünür ("yayında" olur); soruyu soran üye müşteriye bir kez yanıt e-postası gider. İşlem denetim kaydına yazılır.',
    requiredPermission: 'Ürün sorularını yanıtlama ve yayımlama.',
    reversible: 'Kısmen: "Reddet / Yayından Kaldır" ile vitrinden kaldırılır; giden e-posta geri alınamaz.',
    commonErrors: [
      { problem: '"Yayımlamak için önce yanıt yazın"', solution: 'Yanıtı yazıp kaydedin, sonra yayımlayın.' },
      {
        problem: '"Sağlık içeriği veya sağlık beyanı var"',
        solution: 'Yanıtta sağlık beyanı bulunduysa Veteriner Uzman İnceleyici onayından sonra yayımlanır.',
      },
    ],
  },
  'questions.reject': {
    kind: 'action',
    title: 'Reddet / Yayından Kaldır',
    short:
      'Soru vitrinde gösterilmez. Gerekçe isteğe bağlıdır ve yalnızca panelde görünür; müşteriye bildirim gitmez.',
  },
  // ------------------------------------------------------------------ Çok dilli içerik (F4-11)
  'content.locale': {
    kind: 'field',
    title: 'İçerik dili',
    short:
      'Listeyi seçilen dildeki içerikle gösterir. Yeni sayfa, yazı, kategori veya banner bu dilde oluşturulur.',
    whatItDoes:
      'Mağazanın dilleri, Mağazalar ekranındaki pazarlardan gelir (ör. Türkiye → Türkçe, Birleşik Krallık → İngilizce). Mağazanın tek dili varsa bu seçici görünmez. Vitrin, mağazanın varsayılan pazarının dilindeki içeriği gösterir; ziyaretçinin dil değiştirmesi Faz 7 ile gelir.',
    dataChanged: 'Hiçbir veriyi değiştirmez; yalnızca listeyi süzer.',
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#cok-dilli-icerik',
  },
  'content.translate': {
    kind: 'action',
    title: 'Çeviri Ekle',
    short: 'İçeriği seçtiğiniz dilde taslak olarak kopyalar ve düzenleyicisini açar.',
    whatItDoes:
      'Kopya, kaynakla aynı çeviri grubuna bağlanır; düzenleyicide "Diğer diller" bağlantılarıyla birbirine geçebilirsiniz. Metinler kaynak dilde kopyalanır: çevirip kaydedin. Çeviri yayımlanana (banner etkinleştirilene) kadar vitrinde görünmez. Blog yazısı bölümündeki ve yazıdaki kategori, varsa hedef dildeki kategori çevirisine bağlanır.',
    whenToUse: 'Başka dilde pazar açtığınızda, mevcut içeriği o dilde hazırlamak için.',
    dataChanged: 'Hedef dilde yeni bir taslak oluşturur; kaynak içerik değişmez.',
    requiredPermission: 'İçerik düzenleme.',
    reversible: 'Yayımlanmamış çeviri silinebilir.',
    commonErrors: [
      {
        problem: 'Sağlık içeriği olan çeviri yayımlanamıyor.',
        solution:
          'Uzman onayı çeviriye kopyalanmaz. Çeviriyi kaydedin; Veteriner Uzman İnceleyici çeviriyi ayrıca onaylar.',
      },
      {
        problem: '"Bu dil mağazanın pazarlarında yok" hatası.',
        solution: 'Mağazalar ekranından bu dilde bir pazar ekleyin.',
      },
    ],
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#cok-dilli-icerik',
  },
  'content.translate_target': {
    kind: 'field',
    title: 'Hedef dil',
    short: 'Çevirinin dili. Yalnızca mağazanın henüz çevirisi olmayan dilleri listelenir.',
  },
  'blog.category_translation_name': {
    kind: 'field',
    title: 'Kategori adı (hedef dil)',
    short:
      'Kategorinin hedef dildeki adı. Adres bu addan üretilir. Kategoriler taslaksızdır: çeviri vitrinde hemen kullanılabilir.',
    requiredPermission: 'İçerik düzenleme.',
  },
  'menus.translation_draft': {
    kind: 'action',
    title: 'Başka Dildeki Menüden Başla',
    short:
      'Seçilen dildeki menüyü bu dil için taslak olarak yükler. Sayfa ve yazı bağlantıları bu dildeki çevirilerine bağlanır; çevirisi olmayan bağlantılar çıkarılır.',
    whatItDoes:
      'Taslak kaydedilmez: etiketleri çevirin, gerekirse bağlantıları düzeltin ve "Menüyü kaydet" ile yayımlayın. Çıkarılan bağlantıların adları bildirimde listelenir.',
    requiredPermission: 'İçerik yayınlama (kaydetmek için).',
  },
  'pages.hero_text': {
    kind: 'field',
    title: 'Başlık altı metni',
    short: 'Büyük başlığın altındaki kısa açıklama. Sağlık beyanı denetiminden geçer.',
  },
  'pages.grid_category': {
    kind: 'field',
    title: 'Kategori',
    short:
      'Ürün ızgarası bu kategorideki, vitrinde görünen ürünlerden oluşur. Kategori pasifleşirse bölüm vitrinde gösterilmez.',
  },
  'pages.post_limit': {
    kind: 'field',
    title: 'Yazı sayısı',
    short: 'Bölümde gösterilecek en yeni yayındaki yazı sayısı (1–12).',
  },
  'pages.add_section': {
    kind: 'action',
    title: 'Bölüm Ekle',
    short:
      'Seçilen türde yeni bir bölümü sayfanın sonuna ekler. Değişiklik "Taslağı kaydet" ile saklanır; yayımlanana kadar vitrin değişmez.',
  },
  'pages.faq_items': {
    kind: 'action',
    title: 'Soru Ekle / Kaldır',
    short:
      'Sıkça sorulan sorular bölümüne soru-cevap çifti ekler veya çıkarır. Cevaplar sağlık beyanı denetiminden geçer.',
  },
  'pages.review_decision': {
    kind: 'action',
    title: 'Onayla / Reddet',
    short:
      'Veteriner Uzman İnceleyici kaydedilmiş içeriği onaylar ya da gerekçe yazarak reddeder. Karar içerik özetine bağlıdır: içerik değişirse onay düşer. Kaydedilmemiş değişiklik varken düğmeler kapalıdır.',
  },
  'blog.category_name': {
    kind: 'field',
    title: 'Kategori adı',
    short: 'Vitrinde blog kategorisinin başlığı olarak görünür. Değişiklik vitrine hemen yansır.',
  },
  'blog.category_slug': {
    kind: 'field',
    title: 'Kısa ad',
    short:
      'Kategori adresi: /blog/kategori/kisa-ad. Değiştirilirse eski adres yeni adrese kalıcı olarak yönlendirilir.',
  },
  'blog.category_description': {
    kind: 'field',
    title: 'Kategori açıklaması',
    short: 'Kategori sayfasının üstünde görünen kısa açıklama (en fazla 300 karakter).',
  },
  'editor.link_url': {
    kind: 'field',
    title: 'Bağlantı adresi',
    short:
      'Site içi adres (/urunler), http:// veya https:// ile başlayan adres, e-posta (mailto:) veya telefon (tel:). Diğer adres türleri güvenlik nedeniyle kabul edilmez.',
  },
  'editor.image_alt': {
    kind: 'field',
    title: 'Alternatif metin',
    short:
      'Görseli göremeyen ziyaretçiler ve arama motorları için kısa açıklama. Zorunludur; görselde ne olduğunu yazın.',
  },
  'editor.image_caption': {
    kind: 'field',
    title: 'Görsel alt yazısı',
    short: 'Görselin altında görünen isteğe bağlı açıklama.',
  },
  'editor.table': {
    kind: 'action',
    title: 'Tablo',
    short:
      'İmleç tablodayken satır/sütun ekleyip silebilirsiniz. İlk satır başlık satırıdır. Hücre birleştirme yoktur; en çok 100 satır, 12 sütun.',
    whatItDoes:
      'Vitrinde tablo dar ekranda yatay kaydırılır. Hücrelerde yalnızca metin, kalın/italik ve bağlantı kullanılır.',
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#tablo-video',
  },
  'editor.video': {
    kind: 'field',
    title: 'Video adresi',
    short:
      'YouTube (youtube.com, youtu.be, shorts) veya Vimeo adresi. Başka sitelerin videoları güvenlik nedeniyle eklenmez.',
    whatItDoes:
      'Adres değil, video kimliği saklanır. Vitrinde ziyaretçi "oynat" diyene kadar video hizmetine istek gitmez; YouTube çerezsiz alan adından, Vimeo izlemesiz açılır.',
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#tablo-video',
  },
  'editor.import': {
    kind: 'action',
    title: 'Markdown veya HTML içe al',
    short:
      'Başka bir editörde veya eski sitede yazılmış metni dönüştürür: başlık, liste, tablo, alıntı, kalın/italik, bağlantı ve YouTube/Vimeo videoları alınır.',
    whatItDoes:
      'Betik, stil, form, izin dışı çerçeveler ve dış görseller atılır (sayıları bildirilir); görselleri "Görsel ekle" ile yükleyin. Markdown içindeki HTML etiketleri metin olarak kalır. 1. düzey başlık 2. düzeye çevrilir (sayfa başlığı tektir).',
    guideUrl: 'docs/CONTENT_STUDIO_TR.md#ice-alma',
  },
  'menus.translation_source': {
    kind: 'field',
    title: 'Kaynak dil',
    short: 'Taslağın alınacağı menünün dili. Yalnızca mağazanın diğer dilleri listelenir.',
  },
  'categories.name': {
    kind: 'field',
    title: 'Kategori adı',
    short: 'Vitrinde menüde, kategori sayfasının başlığında ve ürün sayfasının konum satırında görünür.',
  },
  'categories.slug': {
    kind: 'field',
    title: 'Kısa ad (adres)',
    short:
      'Kategori sayfasının adresi: /kategori/<kısa-ad>. Yalnızca küçük harf, rakam ve tire. Değiştirilirse eski adres yeni adrese kalıcı olarak (301) yönlendirilir.',
  },
  'categories.description': {
    kind: 'field',
    title: 'Kategori açıklaması',
    short:
      'Kategori sayfasının üstünde görünür. Arama sonuçları açıklaması boşsa bu metnin başı kullanılır. Sağlık beyanı (önler, tedavi eder gibi) içermemelidir.',
  },
  'categories.seo_title': {
    kind: 'field',
    title: 'Arama sonuçlarında başlık',
    short:
      'Google sonuçlarında ve sekme başlığında görünen başlık (en fazla 70 karakter). Boşsa kategori adı kullanılır; sonuna mağaza adı eklenir.',
  },
  'categories.seo_description': {
    kind: 'field',
    title: 'Arama sonuçlarında açıklama',
    short:
      'Google sonuçlarında başlığın altında görünebilecek kısa açıklama (en fazla 170 karakter). Boşsa kategori açıklamasının başı kullanılır. Google başka bir metin seçebilir.',
  },
  'categories.edit': {
    kind: 'action',
    title: 'Kategoriyi Düzenle',
    short: 'Ad, kısa ad, açıklama ve arama sonuçları alanlarını değiştirir. Değişiklik vitrine hemen yansır.',
  },
  'redirects.not_found': {
    kind: 'page',
    title: 'Bulunamayan adresler',
    short: 'Vitrinde 404 veren adresleri, kaç kez görüldükleriyle listeler.',
    whatItDoes:
      'Vitrin sunucusu bulunamayan her adresi sayar ve topluca kaydeder. Yalnızca adresin yolu tutulur; sorgu dizesi, IP adresi ve tarayıcı bilgisi saklanmaz. Mağaza başına en fazla 5.000 farklı adres tutulur, 180 gündür görülmeyenler silinir. Bir adrese yönlendirme veya 410 verildiğinde listeden kendiliğinden düşer.',
    whenToUse:
      'Eski siteden geçişten sonraki haftalarda düzenli bakın: çok görülen eski adresleri doğru sayfaya yönlendirin.',
  },
  'redirects.not_found_filter': {
    kind: 'field',
    title: 'Göster',
    short: 'Bekleyen veya yok sayılan adresleri gösterir.',
  },
  'redirects.not_found_actions': {
    kind: 'action',
    title: 'Yönlendir / 410 ver / Yok say',
    short:
      'Yönlendir: eski adres hazır olarak yönlendirme penceresini açar. 410 ver: adresi kalıcı olarak kaldırıldı işaretler. Yok say: listeden çıkarır, sayım sürer.',
    requiredPermission: 'SEO düzenleme.',
  },
  'redirects.filter_source': {
    kind: 'field',
    title: 'Kaynak',
    short:
      'Kuralları nereden geldiğine göre süzer: Elle (panelden), İçe aktarım (dosyadan), Kendiliğinden (ürün/kategori adresi değişince), Eşleştirme (eski adres gelince sistemin emin olduğu karşılık).',
  },
  'redirects.filter_host': {
    kind: 'field',
    title: 'Alan adı',
    short:
      '"Tüm alan adları" vitrinin kendi alan adına ve eski alan adlarına birlikte uygulanan kurallardır; bir eski alan adı seçilirse yalnızca ona özel kurallar görünür.',
  },
  'redirects.host': {
    kind: 'field',
    title: 'Kaynak alan adı',
    short:
      'Boş bırakın: kural vitrinin kendi alan adında ve tüm eski alan adlarında geçerli olur (önerilen). Yalnızca bir eski alan adına özel kural için o alan adını yazın (ör. zootopiaglobal.com; "www." olmadan).',
    whatItDoes:
      'Eski alan adına gelen istekte önce o alan adına özel kurala, yoksa tüm alan adlarına uygulanan kurala bakılır. Mağazanın kendi alan adı yazılırsa kural tüm alan adlarına uygulanır.',
  },
  'redirects.shadowed': {
    kind: 'field',
    title: 'Sayfaları gölgeleyen kurallar',
    short:
      'Bu kuralların eski adresi vitrinde gerçek bir sayfa (ör. Satış Noktaları, Makaleler, İhtiyaç Bulucu, yayındaki ürün veya kategori). Kural yönlendirme yaptığı için ziyaretçi sayfayı göremez.',
    whatItDoes:
      'Genellikle eski siteden aktarılan ve yeni sitede aynı adreste sayfa açılınca anlamını yitiren kurallardır. Sayfanın görünmesi için kuralı silin; kural bilinçli ise (sayfayı başka adrese taşımak) olduğu gibi bırakabilirsiniz.',
    reversible: 'Silinen kural yeniden eklenebilir.',
    requiredPermission: 'Silme: SEO düzenleme.',
  },
  'page.broken_links': {
    kind: 'page',
    title: 'Kırık linkler',
    short:
      'Vitrinde 404 veren adresler ve eski alan adından gelip karşılığı bulunamadığı için güvenli sayfaya gönderilen eski adresler.',
    whatItDoes:
      'Eski alan adına (ör. zootopiaglobal.com) veya vitrine eski site biçiminde (/product-page/…, /category/…) gelen adres tabloda yoksa sistem karşılığını arar: emin olursa kuralı "Eşleştirme" olarak ekler; emin değilse ziyaretçiyi türün kategorisine, tüm ürünlere veya ana sayfaya 301 ile gönderir ve adresi buraya yazar. Vitrinde 404 veren adresler de burada görünür. Yalnızca adres yolu ve alan adı saklanır (IP, sorgu dizesi ve tarayıcı bilgisi yok); mağaza başına en çok 5.000 adres, 180 gündür görülmeyenler silinir.',
    whenToUse:
      'Geçişten sonraki haftalarda düzenli bakın: çok görülen adreslere doğru karşılığı yönlendirme olarak ekleyin.',
    dataChanged: 'Yönlendir ve 410 ver yönlendirme listesine kural ekler; Yok say yalnızca listeden çıkarır.',
    requiredPermission: 'Görüntüleme: SEO görüntüleme. İşlemler: SEO düzenleme.',
    guideUrl: 'docs/SEO_GUIDE_TR.md#eski-alan-adi',
  },
  'broken_links.collect': {
    kind: 'action',
    title: 'Arşivden eski adresleri topla',
    short:
      'Eski alan adlarının ve vitrin alan adının önceki sitesinin Internet Archive (Wayback Machine) arşivindeki sayfa adreslerini getirip eşleştirir.',
    whatItDoes:
      'Emin olunan karşılıklar yönlendirme listesine "Eşleştirme" olarak eklenir; karşılığı bulunamayanlar bu listeye "Arşivden" etiketiyle yazılır. Arşive yalnızca alan adı gönderilir. Sistem bunu her gün kendiliğinden de yapar.',
    reversible: 'Eklenen kurallar Yönlendirmeler sayfasından düzenlenebilir veya silinebilir.',
    requiredPermission: 'SEO düzenleme.',
  },
  'broken_links.host': {
    kind: 'field',
    title: 'Alan adı',
    short: '"Vitrin alan adı" mağazanın kendi alan adıdır; diğerleri eski alan adlarıdır.',
  },
  'broken_links.found_via': {
    kind: 'field',
    title: 'Nereden',
    short:
      "Ziyaret: adres gerçekten açıldı. Arşivden: Wayback Machine listesinden toplandı (henüz ziyaret yok). Search Console: Google'da görülmüş eski sayfa.",
  },
  'sc_setup.connect': {
    kind: 'page',
    title: "Google'a bağlan ve kur",
    short:
      "Search Console kurulumunu sistem yapar: vitrin alan adı ve eski alan adları (www'lu ve www'suz) için mülkler doğrulanır ve eklenir, site haritası gönderilir, eski sitenin Google'da görünen sayfaları yeni adreslere eşlenir.",
    whatItDoes:
      "Doğrulama dosya yöntemiyle yapılır: Google'ın verdiği dosyayı (google….html) uygulama vitrinde ve eski alan adında yönlendirmeden sunar. Google hesabı bağlı değilse veya site doğrulama izni yoksa düğme Google'a götürür (mevcut Google izinleriniz korunur); dönüşte kurulum kendiliğinden başlar. Indexing API kullanılmaz (Google buna yalnızca iş ilanı ve canlı yayın sayfaları için izin verir).",
    whenToUse: 'Eski alan adından geçişten sonra bir kez; alan adı eklenince yeniden.',
    dataChanged:
      'Search Console mülkleri eklenir, mağaza vitrin mülküne bağlanır, site haritası gönderilir; eşlenen eski adresler Yönlendirmeler listesine, karşılıksızlar Kırık linkler listesine yazılır.',
    requiredPermission: 'Entegrasyon yönetimi.',
    guideUrl: 'docs/SEO_GUIDE_TR.md#search-console-kurulumu',
  },
  'sc_setup.run': {
    kind: 'action',
    title: "Google'a bağlan / Kurulumu yeniden çalıştır",
    short:
      'Bağlantı ve izinler tamsa kurulumu hemen çalıştırır; değilse Google onay ekranına götürür. Tekrar çalıştırmak güvenlidir.',
    reversible: "Mülkler Search Console'dan elle kaldırılabilir; eşleşen yönlendirmeler düzenlenebilir.",
    requiredPermission: 'Entegrasyon yönetimi.',
  },
  'sc_setup.enable_api': {
    kind: 'action',
    title: "Google Cloud'da API'yi etkinleştir",
    short:
      "Kurulum Google'ın iki ücretsiz API'sini kullanır: doğrulama adımları Site Verification API'yi, mülk ekleme, site haritası ve eski sayfalar Search Console API'yi. Panelde bağlandığınız OAuth istemcisinin bulunduğu Google Cloud projesinde bağlantıyı açıp Etkinleştir'e basın; 1–2 dakika sonra Kurulumu yeniden çalıştır.",
    whatItDoes: "Yalnızca Google Cloud'daki sayfayı yeni sekmede açar; panelde hiçbir şey değişmez.",
    guideUrl: 'docs/GOOGLE_INTEGRATIONS_TR.md',
  },
  'sc_setup.inspections': {
    kind: 'field',
    title: 'Google dizin durumu',
    short:
      'Her sabah yayındaki ürün sayfaları ve en çok kullanılan eski adresler Google\'ın URL denetimiyle kontrol edilir. Ürün sayfası için beklenen "dizinde", eski adres için "yönlendirmeli sayfa"dır.',
  },
  'indexnow.section': {
    kind: 'page',
    title: 'IndexNow (Bing, Yandex)',
    short:
      "Değişen adresleri Bing ve Yandex'e bildirir. Sistem on dakikada bir kendiliğinden çalışır; ilk çalışmada tüm adresler bir kez gönderilir.",
    whatItDoes:
      'Anahtar dosyası (/<anahtar>.txt) vitrinde ve eski alan adında yönlendirmeden sunulur. Yalnızca mağaza yayındayken ve sunucuda arama motorlarına açma açıkken gönderilir; dışarı yalnızca sitenin herkese açık adresleri gider. Google IndexNow kullanmaz; Google için site haritası ve Search Console yeterlidir.',
  },
  'indexnow.submit': {
    kind: 'action',
    title: 'Tüm adresleri şimdi gönder',
    short:
      "Mağazanın dizine açık tüm adreslerini (ürün, kategori, marka, sayfa, makale, yasal metin) IndexNow'a gönderir.",
    whenToUse:
      'Mağaza yayına alındıktan sonra veya çok sayıda ürün/sayfa değiştirdiğinizde arama motorlarına (Bing, Yandex vb.) hemen haber vermek istediğinizde.',
    dataChanged:
      'Mağazanın dizine açık adresleri IndexNow hizmetine gönderilir; son bildirimin tarihi, adres sayısı ve sonucu kaydedilir. İşlem denetim kaydına yazılır.',
    requiredPermission: 'SEO düzenleme.',
    reversible:
      'Hayır, gönderilen bildirim geri alınamaz; arama motorları adresleri kendi takvimleriyle tarar.',
    commonErrors: [
      {
        problem: '"Mağaza yayında değil" nedeniyle gönderilmedi',
        solution: 'Önizlemedeki mağaza bildirilmez; önce mağazayı yayına alın.',
      },
      {
        problem: '"Arama motorlarına açma kapalı"',
        solution: 'Mağazanın arama motorlarına açık olduğunu SEO ayarlarından kontrol edin.',
      },
      { problem: '"Mağazanın alan adı yok"', solution: 'Mağazalar ekranından vitrin alan adını ekleyin.' },
    ],
  },
  'system.staging_banner': {
    kind: 'field',
    title: 'Staging ortamı',
    short:
      'Bu panel deneme (staging) sunucusundadır. Gerçek müşteri ve bayilere e-posta gitmemesi için yalnızca izin listesindeki adreslere gönderilir; canlı sunucuda bu kısıtlama yoktur.',
    guideUrl: 'DEPLOYMENT_TR.md#staging-eposta',
  },
  'system.mail_allowlist': {
    kind: 'field',
    title: 'E-posta izin listesi',
    short:
      "Staging'de e-posta gönderilebilecek adresler. Her satıra tam adres (ad@ornek.com) veya alan adı (@ornek.com) yazın; en çok 20. Sunucudaki MAIL_ALLOWLIST ile birleşir. Liste boşsa hiçbir e-posta gönderilmez. Örnek: @zootopia.com.tr",
    commonErrors: [
      {
        problem: 'Sipariş e-postası gelmedi.',
        solution:
          'Alıcı listede değilse e-posta gönderilmez; Entegrasyonlar → E-posta (SMTP) → Bağlantı günlüğünde "Staging\'de engellendi" görünür.',
      },
    ],
    guideUrl: 'DEPLOYMENT_TR.md#staging-eposta',
  },
  'system.mail_allowlist_save': {
    kind: 'action',
    title: 'İzin listesini kaydet',
    short: 'Listeyi kaydeder; bir sonraki e-postadan itibaren geçerlidir. Denetim kaydına yazılır.',
    reversible: 'Evet, listeyi yeniden düzenleyerek.',
    requiredPermission: 'İşletme ayarlarını düzenleme.',
  },
  'products.media_retry': {
    kind: 'action',
    title: 'Görseli yeniden dene',
    short:
      'İndirilemeyen içe aktarma görselini yeniden kuyruğa alır; arka plan işi yaklaşık 30 sn içinde tekrar indirir. Neden "Görsel kaynakta yok" veya "Dosya görsel değil" ise önce kaynak adresi düzeltin (dosyayı yeniden içe aktarın).',
    reversible: 'Evet; görsel yine indirilemezse durum "İndirilemedi" olarak kalır.',
    requiredPermission: 'Ürün düzenleme.',
    guideUrl: 'docs/BULK_IMPORT_EXPORT_TR.md#gorsel-indirme',
  },
  'imports.sku_generate': {
    kind: 'action',
    title: "Önerilen SKU'larla yeniden önizle",
    short:
      "SKU'su boş varyantlara öneri verir: barkod varsa barkod, yoksa ürün kodu ve seçenek değeri (ör. TUY-BAKIM-250-ML). Öneriler önizlemede listelenir; uygulamadan önce kontrol edin.",
    reversible:
      "Uygulanmadan hiçbir şey kaydedilmez; uygulandıktan sonra SKU'lar ürün sayfasından değiştirilebilir.",
    guideUrl: 'docs/BULK_IMPORT_EXPORT_TR.md#shopify',
  },
  'imports.media_retry_all': {
    kind: 'action',
    title: 'İndirilemeyenleri yeniden dene',
    short:
      'İndirilemeyen tüm içe aktarma görsellerini yeniden kuyruğa alır. Nedenler listesi sorunun kaynakta mı sunucuda mı olduğunu gösterir.',
    requiredPermission: 'Ürün düzenleme.',
    guideUrl: 'docs/BULK_IMPORT_EXPORT_TR.md#gorsel-indirme',
  },
  'imports.categories_file': {
    kind: 'action',
    title: 'Kategori dosyası seç ve önizle',
    short:
      'Sütunlar: Kategori Adı, Üst Kategori (adı veya kısa adı), Açıklama, Sıra, Kısa Ad, Durum (etkin/gizli), SEO Başlık, SEO Açıklama. Önce önizlenir; hiçbir şey değişmez. Boş hücre mevcut değeri silmez.',
    guideUrl: 'docs/BULK_IMPORT_EXPORT_TR.md#kategori-ice-aktarma',
  },
  'imports.categories_apply': {
    kind: 'action',
    title: 'Kategorileri uygula',
    short:
      'Önizlemedeki eklemeleri ve güncellemeleri tek işlemde yazar (hepsi ya da hiçbiri); önce üst kategoriler. Kısa adı değişen kategorinin eski adresi yeni adrese yönlendirilir.',
    whenToUse:
      'Kategori dosyasının önizlemesinde eklenecek ve güncellenecek kategorileri kontrol ettikten sonra.',
    dataChanged:
      'Önizlemedeki yeni kategoriler eklenir, mevcutlar güncellenir (önce üst kategoriler); kısa adı değişen kategorinin eski adresi için yönlendirme açılır. Hepsi tek işlemde yazılır ve denetim kaydına düşer.',
    reversible: 'Tek tıkla geri alınmaz; önce "Kategorileri indir" ile yedek alın.',
    requiredPermission: 'İçe aktarma ve ürün düzenleme.',
    commonErrors: [
      { problem: '"Önizleme süresi doldu (1 saat)"', solution: 'Dosyayı yeniden yükleyip önizleyin.' },
      {
        problem: '"Bu kısa ad zaten kullanılıyor" veya "Kategori kendi alt kategorisinin altına taşınamaz"',
        solution: 'Dosyada çakışan kısa adı veya hatalı üst kategoriyi düzeltip yeniden yükleyin.',
      },
      {
        problem: '"Bu içe aktarma zaten uygulandı"',
        solution: 'Aynı önizleme ikinci kez uygulanmaz; değişiklik için dosyayı yeniden yükleyin.',
      },
    ],
  },
  'imports.categories_export': {
    kind: 'action',
    title: 'Şablon / Kategorileri indir',
    short:
      'Boş şablonu veya mevcut kategori ağacını aynı sütunlarla indirir; düzenleyip geri yükleyebilirsiniz.',
  },
  'imports.create_missing_categories': {
    kind: 'field',
    title: 'Eksik kategorileri oluştur',
    short:
      'Açıksa "Kategori" sütununda bulunamayan kategoriler uygulamada oluşturulur; "Kedi > Takviye" yazımında üst kategori de oluşturulur. Kapalıysa bulunamayan kategori uyarı verir, ürün kategorisiz eklenir.',
    guideUrl: 'docs/BULK_IMPORT_EXPORT_TR.md#urun-ice-aktarma',
  },
  'imports.category_mode': {
    kind: 'field',
    title: 'Var olan ürünlerin kategorileri',
    short:
      '"Ekle": dosyadaki kategoriler ürünün mevcut kategorilerine eklenir. "Değiştir": ürünün kategorileri dosyadakilerle değiştirilir. Kategori hücresi boş satırda ürünün kategorileri değişmez.',
  },
  'stock.transfer_receipt': {
    kind: 'action',
    title: 'Mal kabul gir',
    short:
      'Transfer yerine ilk stok girişini açar: tedarikçiden gelen malı lot ve son kullanma tarihiyle depoya ekler.',
    whenToUse:
      'Depoda henüz stok yokken tedarikçiden ilk mal geldiğinde (transfer edilecek stok olmadığında).',
    dataChanged:
      'Seçilen depoya "mal kabul" hareketiyle stok eklenir; lot ve son kullanma tarihi girildiyse yeni lot açılır. İşlem denetim kaydına yazılır.',
    requiredPermission: 'Stok hareketi ve sayım.',
    reversible:
      'Kısmen: hareket silinmez; fazla girilen adet "Düzeltme" veya "Hasar/fire" hareketiyle düşülür.',
    commonErrors: [
      {
        problem: 'Lot alanı "zorunlu" uyarısı veriyor',
        solution: 'Lot takibi yapılan üründe lot numarası ve son kullanma tarihini girin.',
      },
      {
        problem: 'Depo "etkin değil" uyarısı',
        solution:
          'Pasif depoya giriş yapılmaz; Depolar sayfasından depoyu etkinleştirin veya başka depo seçin.',
      },
    ],
  },
  'stores.archive': {
    kind: 'action',
    title: 'Arşivle',
    short:
      'Kullanılmayan mağazanın vitrinini kapatır ve listenin sonuna alır; sipariş, ürün ve ayarlar silinmez. Yayındaki mağaza önce bakıma alınır veya önizlemeye döndürülür.',
    whenToUse:
      'Artık kullanmadığınız ama siparişleri ve kayıtları saklanması gereken bir mağazayı kapatmak istediğinizde.',
    dataChanged:
      'Mağazanın durumu "arşiv" olur; vitrin kapanır (alan adı "mağaza yok" der) ve mağaza panel listesinin sonuna gider. Sipariş, ürün ve ayarlar silinmez; işlem denetim kaydına yazılır.',
    reversible: 'Evet, "Arşivden çıkar" ile (önizlemeye döner).',
    requiredPermission: 'Mağazayı yayına alma (iki adımlı doğrulama).',
    commonErrors: [
      {
        problem: '"Yayındaki mağaza doğrudan arşivlenemez"',
        solution: 'Önce "Bakıma Al" veya "Önizlemeye Döndür" kullanın, sonra arşivleyin.',
      },
    ],
  },
  'stores.delete': {
    kind: 'action',
    title: 'Mağazayı sil',
    short:
      'Yalnızca önizlemedeki/arşivdeki ve hiç siparişi olmayan mağaza silinir; alan adları, pazarlar, fiyat listeleri, ürün yayınları ve mağazaya ait içerik birlikte silinir (ürünler kalır).',
    whenToUse:
      'Deneme için açılmış veya hiç kullanılmamış, siparişi olmayan bir mağazadan tamamen kurtulmak istediğinizde.',
    dataChanged:
      'Mağaza kaydı; alan adları, pazarlar, fiyat listeleri, ürün yayınları, içerik ve tema kayıtlarıyla birlikte kalıcı olarak silinir. Ürünler kalır; silme denetim kaydına yazılır.',
    reversible: 'Hayır. Emin değilseniz arşivleyin.',
    requiredPermission: 'Mağazayı yayına alma (iki adımlı doğrulama).',
    commonErrors: [
      {
        problem: '"Bu mağazanın siparişleri var; silinemez"',
        solution: 'Siparişi olan mağazayı silmek yerine arşivleyin.',
      },
      {
        problem: '"Yayındaki veya bakımdaki mağaza silinemez"',
        solution: 'Önce mağazayı önizlemeye döndürün veya arşivleyin.',
      },
      {
        problem:
          '"Yazılan kod mağaza koduyla aynı değil" veya "yalnızca bu mağazaya yetkili kullanıcı … var"',
        solution:
          'Onay alanına mağaza kodunu aynen yazın; yalnızca bu mağazaya yetkili kullanıcı, davet ve API anahtarlarının kapsamını önce değiştirin.',
      },
    ],
  },
  'stores.delete_code': {
    kind: 'field',
    title: 'Mağaza kodu',
    short: 'Yanlış mağazayı silmemek için mağazanın kodunu aynen yazın.',
  },
  'products.price_list_missing': {
    kind: 'action',
    title: 'Fiyatlar sayfasına git',
    short:
      'Vitrin fiyatı mağazanın etkin, grubu boş (temel) fiyat listesinden gelir. Liste yoksa, etkin değilse, para birimi pazarla uyuşmuyorsa veya tarih dışındaysa ürün o mağazada fiyatsız kalır ve listelenmez.',
    guideUrl: 'docs/PRICING_ENGINE_TR.md',
  },
  'payments.card_status': {
    kind: 'field',
    title: 'Vitrinde kartla ödeme',
    short:
      "Kapalı: vitrinde kart seçeneği yok. Test: sandbox anahtarıyla ödeme alınır, para çekilmez. Canlı: gerçek ödeme. Entegrasyonlar'daki rozet yalnızca anahtarların bağlantı testidir.",
    guideUrl: 'docs/PAYMENTS_TR.md',
  },
  'migration.export': {
    kind: 'action',
    title: 'Taşıma paketini indir',
    short:
      'Seçilen mağazanın paketini ZIP olarak indirir. Dosyada kişisel veri ve anahtar yoktur; yine de güvenli bir yerde saklayın.',
    requiredPermission: 'Yalnızca işletme sahibi (iki adımlı doğrulama).',
    guideUrl: 'docs/GO_LIVE_TR.md#tasima-paketi',
  },
  'migration.target_store': {
    kind: 'field',
    title: 'Hedef mağaza',
    short:
      'Paketin uygulanacağı mağaza. Boşsa paketteki mağaza koduyla eşleşir; bu işletmede yoksa önizleme durumunda oluşturulur.',
  },
  'migration.include_stock': {
    kind: 'field',
    title: 'Açılış stoku',
    short:
      'Açıkken her ürünün depo, lot ve son kullanma tarihli güncel bakiyesi "Açılış stoku" hareketiyle yazılır. Rezervasyonlar ve hareket geçmişi taşınmaz. Depoda o ürün/lot için zaten stok hareketi varsa (daha önce taşınmış ya da mal kabul girilmiş) yazılmaz; bakiye iki kez sayılmaz.',
  },
  'migration.overwrite': {
    kind: 'field',
    title: 'Üzerine yaz',
    short:
      'Kapalıyken yalnızca eksik kayıtlar eklenir. Açıkken canlıda zaten olan ama paketteki hâlinden farklı kayıtlar paketteki hâliyle güncellenir.',
  },
  'migration.legal_reviewed': {
    kind: 'field',
    title: 'Avukat incelemesi',
    short:
      'İşaretlerseniz yasal metinler "avukat inceledi" işaretiyle yayımlanır ve onay sizin adınıza kaydedilir. İşaret otomatik verilmez.',
  },
  'migration.carry_approvals': {
    kind: 'field',
    title: 'Veteriner onaylarını taşı',
    short:
      "Staging'de onaylanmış sağlık içerikli ürün, sayfa, yazı ve bannerların onayı sizin adınıza kaydedilir. İşaretlemezseniz bu içerikler canlıda yeniden onay bekler.",
    requiredPermission: 'İşletme sahibi (veteriner uzman onay yetkisi).',
  },
  'migration.file': {
    kind: 'action',
    title: 'Paket dosyası seç ve önizle',
    short:
      "Staging'den indirilen ZIP dosyasını yükler ve önizler; hiçbir şey yazılmaz. Önizleme 1 saat geçerlidir.",
  },
  'migration.refresh': {
    kind: 'action',
    title: 'Önizlemeyi yenile',
    short: 'Seçenekleri değiştirdikten sonra aynı paketle önizlemeyi yeniden hesaplar.',
  },
  'migration.apply': {
    kind: 'action',
    title: 'İçe aktar',
    short:
      'Önizlenen paketi tek işlemde uygular (hepsi ya da hiçbiri) ve denetim kaydına yazar. Aynı önizleme ikinci kez uygulanamaz.',
    whenToUse:
      'Hazırlık (staging) ortamından indirdiğiniz taşıma paketinin önizlemesini kontrol ettikten sonra, canlı ortama ilk kurulumda.',
    dataChanged:
      'Paketteki markalar, kategoriler, ürünler, fiyat listeleri, içerik, menü, tema ve ayarlar tek işlemde yazılır: eşleşen kayıtlar yerinde kalır ("üzerine yaz" seçiliyse güncellenir), eşleşmeyenler eklenir. Müşteri, sipariş, ödeme ve anahtarlar taşınmaz, kart ödemesi kapalı gelir; işlem denetim kaydına yazılır.',
    reversible: 'Hayır; önizlemeyi kontrol edin.',
    requiredPermission: 'Yalnızca işletme sahibi (iki adımlı doğrulama).',
    commonErrors: [
      { problem: '"Önizleme süresi doldu (1 saat)"', solution: 'Paket dosyasını yeniden seçip önizleyin.' },
      {
        problem: '"Bu içe aktarma zaten uygulandı"',
        solution: 'Aynı önizleme ikinci kez uygulanamaz; gerekirse paketi yeniden yükleyin.',
      },
    ],
  },
  'privacy.create': {
    kind: 'action',
    title: 'Başvuru kaydet',
    short:
      'E-posta, KEP, posta veya elden gelen başvuruyu kaydeder. Aynı e-postayla müşteri hesabı varsa bağlanır; başvurana "başvurunuz alındı" e-postası gider.',
    requiredPermission: 'KVKK başvurusu kaydetme ve sonuçlandırma',
  },
  'privacy.requester_email': {
    kind: 'field',
    title: 'Başvuranın e-postası',
    short:
      'Sonuç bu adrese gönderilir; müşteri hesabı ve misafir siparişleri bu adresle eşleştirilir. Başvuranın kimliğini (ör. kayıtlı e-postadan yazması) doğrulayın.',
  },
  'privacy.received_at': {
    kind: 'field',
    title: 'Başvuru tarihi',
    short:
      'Başvurunun işletmeye ulaştığı gün. 30 günlük yanıt süresi bu tarihten sayılır; ileri tarih girilemez.',
  },
  'privacy.export': {
    kind: 'action',
    title: 'Verilerin kopyasını indir',
    short:
      'Kişinin hesap, adres, sipariş, izin ve diğer kayıtlarını JSON dosyası olarak indirir. Şifre özeti ve şifreli alanlar dosyada yoktur. Dosyayı yalnızca başvurana iletin.',
    requiredPermission: 'KVKK: verilerin kopyası (sahip, yönetici; iki adımlı doğrulama)',
  },
  'privacy.note': {
    kind: 'field',
    title: 'Başvurana yanıt',
    short:
      "Sonuçlandırma veya retle başvurana e-postayla giden metin. Retle gerekçe zorunlu; e-postaya Kurul'a şikâyet hakkı (KVKK m.14) kendiliğinden eklenir.",
  },
  'privacy.start_review': {
    kind: 'action',
    title: 'İncelemeye al',
    short: 'Başvurunun ele alındığını gösterir; süre işlemeye devam eder.',
  },
  'privacy.complete': {
    kind: 'action',
    title: 'Sonuçlandır',
    short:
      'Yanıt metniyle başvuruyu kapatır ve başvurana bildirir. Silme başvurusu yalnızca anonimleştirmeyle sonuçlanır.',
    whenToUse:
      'KVKK başvurusundaki talebi yerine getirdikten sonra (ör. veri kopyasını ilettiniz, bilgiyi düzelttiniz, silme başvurusunda anonimleştirmeyi yaptınız).',
    dataChanged:
      'Başvuru yanıt metniyle "sonuçlandı" olur; e-posta kuruluysa başvurana sonuç e-postası gider. İşlem denetim kaydına yazılır.',
    requiredPermission: 'KVKK başvurusu kaydetme ve sonuçlandırma.',
    reversible: 'Hayır, sonuçlanan başvuru yeniden açılamaz.',
    commonErrors: [
      {
        problem: '"Silme başvurusu ancak anonimleştirmeyle sonuçlanır"',
        solution:
          'Önce "Anonimleştir"i çalıştırın; yasal nedenle silinemiyorsa başvuruyu gerekçesiyle reddedin.',
      },
      { problem: 'Yanıt metni "zorunlu" uyarısı', solution: 'Başvurana gidecek yanıt metnini yazın.' },
    ],
  },
  'privacy.reject': {
    kind: 'action',
    title: 'Reddet',
    short:
      'Gerekçeyle başvuruyu kapatır (ör. kimlik doğrulanamadı, yasal saklama yükümlülüğü). Gerekçe başvurana e-postayla gider.',
    whenToUse:
      'Başvuranın kimliği doğrulanamadığında veya veriler yasal saklama yükümlülüğü nedeniyle silinemediğinde.',
    dataChanged:
      'Başvuru gerekçesiyle "reddedildi" olur; e-posta kuruluysa gerekçe başvurana e-postayla gider. İşlem denetim kaydına yazılır.',
    requiredPermission: 'KVKK başvurusu kaydetme ve sonuçlandırma.',
    reversible: 'Hayır, reddedilen başvuru yeniden açılamaz; kişi yeni başvuru yapabilir.',
    commonErrors: [
      {
        problem: 'Gerekçe "zorunlu" uyarısı',
        solution: 'Reddetme nedenini yazın; bu metin başvurana gönderilir.',
      },
      {
        problem: '"Bu durumdan bu duruma geçilemez"',
        solution: 'Başvuru zaten sonuçlanmış veya reddedilmiş; sayfayı yenileyin.',
      },
    ],
  },
  'privacy.anonymize': {
    kind: 'action',
    title: 'Anonimleştir',
    short:
      'Silme başvurusunda kişisel verileri kalıcı olarak anonimleştirir. Önce önizlemedeki silinecek/saklanacak listesini ve engelleri kontrol edin; açık sipariş veya iade varsa yapılamaz.',
    whenToUse:
      'Kişinin KVKK silme başvurusunu doğruladıktan, açık siparişi ve iade talebi kalmadığından emin olduktan sonra.',
    dataChanged:
      'Kişinin hesabındaki ad, e-posta, telefon ve şifre silinir (giriş kapanır); adres defteri, oturumlar, sepet ve favoriler silinir, siparişlerdeki iletişim ve teslimat bilgileri anonimleşir. Yasal saklama gereken sipariş tutarları ve fatura kayıtları kalır; imha kaydı ve denetim kaydı yazılır.',
    reversible: 'Hayır. Hesap kapanır ve geri doldurulamaz.',
    requiredPermission: 'KVKK: anonimleştirme (sahip, yönetici; iki adımlı doğrulama)',
    commonErrors: [
      {
        problem: '"Kapanmamış … sipariş var" veya "Sonuçlanmamış … iade talebi var"',
        solution:
          'Siparişler teslim edilip kapanmadan veya iptal edilmeden ve iadeler sonuçlanmadan anonimleştirme yapılamaz.',
      },
      {
        problem: '"Yazılan e-posta başvuranın e-postasıyla aynı değil"',
        solution: 'Onay alanına başvurandaki e-posta adresini aynen yazın.',
      },
      {
        problem: '"Anonimleştirme yalnızca silme başvurusunda yapılır"',
        solution: 'Başvurunun türünü kontrol edin; diğer başvurular "Sonuçlandır" ile kapatılır.',
      },
    ],
  },
  'privacy.confirm_email': {
    kind: 'field',
    title: 'Onay',
    short:
      'Yanlış kişinin verilerinin silinmemesi için başvuranın e-postasını aynen yazın; düğme ancak o zaman açılır.',
  },
  'system.error_tracking': {
    kind: 'field',
    title: 'Dış hata takibi',
    short:
      'Beklenmeyen sunucu hataları Sentry uyumlu bir servise (ör. Sentry AB bölgesi, GlitchTip) gönderilir. Entegrasyonlar → Hata takibi ile DSN girin. Kişisel veri gönderilmez (istek gövdesi, IP, kullanıcı yok; e-posta ve uzun sayılar maskelenir).',
    guideUrl: 'TROUBLESHOOTING_TR.md#uyarilar',
  },
  'system.alert_recipients': {
    kind: 'field',
    title: 'Uyarı alıcıları',
    short:
      'Kritik durum uyarılarının gideceği adresler. Boşsa işletme sahiplerine gider. Staging sunucusunda adresin e-posta izin listesinde olması gerekir.',
    guideUrl: 'TROUBLESHOOTING_TR.md#uyarilar',
  },
  'system.mail_dns': {
    kind: 'field',
    title: 'E-posta alan adı denetimi',
    short:
      "SPF (hangi sunucular e-posta gönderebilir), DKIM (e-posta imzası) ve DMARC (imzasız e-postaya ne yapılacağı) DNS'ten okunur. Kayıtları e-posta sağlayıcınızın talimatıyla alan adı panelinize eklersiniz; sonuç 10 dakika önbellekte tutulur.",
    guideUrl: 'TROUBLESHOOTING_TR.md#e-posta-alan-adi',
  },
  'system.observability': {
    kind: 'field',
    title: 'Gözlemlenebilirlik (OpenTelemetry)',
    short:
      'İstek ve arka plan işi süreleri, hata oranları ve izler bir toplayıcıya (Grafana Cloud, Honeycomb, New Relic veya kendi OpenTelemetry Collector) gönderilir; yavaşlayan uç veya biriken iş oradan görülür. Entegrasyonlar → Gözlemlenebilirlik ile açılır.',
    whatItDoes:
      'Kişisel veri gönderilmez: yalnızca yöntem, rota şablonu (ör. /v1/admin/orders/:id), durum kodu ve iş adı. Toplayıcı girilene kadar hiçbir şey kaydedilmez ve gönderilmez.',
    requiredPermission: 'Görüntüleme: sistem durumu. Açma: entegrasyon yönetimi (iki adımlı doğrulama).',
    guideUrl: 'TROUBLESHOOTING_TR.md#gozlemlenebilirlik',
  },
  'system.csp_reports': {
    kind: 'field',
    title: 'Vitrin içerik güvenliği ihlalleri',
    short:
      'Vitrinin güvenlik politikası izin verilmeyen bir betiği, görseli, çerçeveyi veya bağlantıyı engellediğinde ziyaretçinin tarayıcısı bunu bildirir. Yeni eklenen bir etiket veya video çalışmıyorsa ya da sayfaya izinsiz kod eklenmeye çalışılıyorsa burada görünür.',
    whatItDoes:
      'Yalnızca özet tutulur: kural, engellenen kaynağın alan adı, sayfanın yolu, sayı ve tarih. Kişisel veri, IP ve tarayıcı eklentilerinin bildirimleri tutulmaz; 30 gün görülmeyen kayıt kendiliğinden silinir.',
    dataChanged: 'Hiçbir veriyi değiştirmez; yalnızca okur.',
    requiredPermission: 'Sistem durumunu görüntüleme',
    guideUrl: 'TROUBLESHOOTING_TR.md#csp-ihlalleri',
  },
  'system.dkim_selector': {
    kind: 'field',
    title: 'DKIM seçicisi',
    short:
      'DKIM kaydının adındaki ilk parça ("seçici._domainkey.alanadi"). Yaygın seçiciler kendiliğinden denenir; sağlayıcınız farklı bir ad verdiyse buraya yazın.',
  },
  'page.exports': {
    kind: 'page',
    title: 'Dışa aktarma',
    short:
      'Sipariş, sipariş satırı, müşteri, stok, fatura ve ödeme listelerini Excel (XLSX) veya CSV olarak indirir; mali müşavire gönderilecek dosyalar buradan alınır.',
    whatItDoes:
      'Önce dönemi, mağazayı ve dosya biçimini seçersiniz; sonra istediğiniz listenin "indir" düğmesine basarsınız. Tutarlar Excel\'de toplanabilir sayı olarak gelir. Kişisel veriler (e-posta, telefon, fatura adı ve adresi, VKN/TCKN) varsayılan olarak maskelidir. Her indirme, kimin hangi listeyi kaç satırla indirdiği denetim kaydına yazılır.',
    whenToUse:
      'Ay sonunda muhasebeye sipariş, fatura ve ödeme listesi göndermek; stok sayımı veya son kullanma tarihi kontrolü yapmak; müşteri listesini kendi programınıza almak için.',
    dataChanged: 'Hiçbir kayıt değişmez; yalnızca denetim kaydına "dışa aktarma" satırı eklenir.',
    requiredPermission:
      'Her liste kendi görüntüleme yetkisini ister (ör. siparişler için "Siparişleri görüntüleme"). Maskesiz kişisel veri için "Müşteri kişisel verilerini maskesiz görme" yetkisi ve iki adımlı doğrulama gerekir.',
    reversible:
      'İndirilen dosya bilgisayarınızdadır; paylaştığınız kişiden geri alınamaz. Gereğinden fazla veri paylaşmayın.',
    guideUrl: 'docs/BULK_IMPORT_EXPORT_TR.md#operasyon-disa-aktarma',
  },
  'exports.period': {
    kind: 'field',
    title: 'Dönem',
    short:
      'Hangi tarihler arasındaki kayıtların indirileceği. Tarihler Türkiye saatine göre gün olarak sayılır, bitiş günü dahildir. Stok listesi dönemden bağımsızdır (bugünkü durum). Muhasebeye aylık dosya için "Geçen ay" seçin.',
    guideUrl: 'docs/BULK_IMPORT_EXPORT_TR.md#operasyon-disa-aktarma',
  },
  'exports.from': {
    kind: 'field',
    title: 'Başlangıç tarihi',
    short: "Bu günün 00:00'ından itibaren (Türkiye saati) olan kayıtlar alınır.",
  },
  'exports.to': {
    kind: 'field',
    title: 'Bitiş tarihi',
    short: "Bu gün dahil (23:59'a kadar) olan kayıtlar alınır. Başlangıçtan önce olamaz.",
  },
  'exports.store': {
    kind: 'field',
    title: 'Mağaza',
    short:
      'Sipariş, fatura ve ödeme listelerini tek mağazayla sınırlar. Müşteri ve stok listeleri işletme geneli olduğu için etkilenmez.',
  },
  'exports.format': {
    kind: 'field',
    title: 'Dosya biçimi',
    short:
      'Excel (XLSX): tutarlar sayı olarak gelir, doğrudan toplanabilir. CSV: noktalı virgülle ayrılmış, Türkçe karakterli; muhasebe programına aktarmak için.',
  },
  'exports.personal_data': {
    kind: 'field',
    title: 'Kişisel veriler',
    short:
      'Maskeli (önerilen): e-posta, telefon, fatura adı/adresi gizlenir, VKN/TCKN\'nin yalnızca son 3 hanesi görünür. Açık: tüm bilgiler görünür; iki adımlı doğrulama ister ve denetim kaydında "maskesiz" olarak işaretlenir.',
    commonErrors: [
      {
        problem: "Mali müşavir faturadaki VKN/TCKN'nin tamamını istiyor.",
        solution:
          'Yalnızca bu durumda "Açık" seçin, iki adımlı doğrulamayı yapın ve dosyayı güvenli yoldan iletin (e-posta eki yerine şifreli paylaşım).',
      },
    ],
    requiredPermission: 'Açık için: Müşteri kişisel verilerini maskesiz görme.',
    guideUrl: 'docs/PRIVACY_COMPLIANCE_TR.md#disa-aktarma',
  },
  'exports.orders': {
    kind: 'action',
    title: 'Siparişleri indir',
    short:
      'Her sipariş bir satır: tarih, durum, ödeme yöntemi, müşteri, fatura bilgileri, ara toplam, indirim, kargo, KDV ve toplam. Taslak siparişler alınmaz.',
    requiredPermission: 'Siparişleri görüntüleme',
  },
  'exports.order_lines': {
    kind: 'action',
    title: 'Sipariş satırlarını indir',
    short:
      'Her ürün satırı bir satır: SKU, adet, birim fiyat, KDV oranı, KDV, satır toplamı ve hangi lottan gönderildiği. KDV oranına göre toplam almak için.',
    requiredPermission: 'Siparişleri görüntüleme',
  },
  'exports.customers': {
    kind: 'action',
    title: 'Müşterileri indir',
    short:
      'Kayıt tarihi seçilen döneme düşen müşteriler: tür (perakende/bayi), bayi firma, e-posta ve SMS izni, sipariş sayısı, son sipariş. Dönem "Tüm zamanlar" ise hepsi.',
    requiredPermission: 'Müşterileri görüntüleme',
  },
  'exports.stock': {
    kind: 'action',
    title: 'Stoğu indir',
    short:
      'Bugünkü stok, depo ve lot bazında: son kullanma tarihi, SKT durumu (geçti / 90 gün içinde / uygun), eldeki, ayrılmış ve satılabilir adet. Maliyet yetkiniz varsa birim maliyet ve stok maliyeti de gelir.',
    requiredPermission: 'Stoku görüntüleme (maliyet sütunları için ayrıca maliyet görme)',
  },
  'exports.invoices': {
    kind: 'action',
    title: 'Faturaları indir',
    short:
      'Fatura tarihi seçilen döneme düşen faturalar: numara, tür (e-Arşiv/e-Fatura), durum, sipariş, fatura bilgileri, KDV hariç tutar, KDV ve toplam.',
    requiredPermission: 'Faturaları görüntüleme',
  },
  'exports.payments': {
    kind: 'action',
    title: 'Ödemeleri indir',
    short:
      'Ödeme ve iade hareketleri tarih sırasıyla: yöntem, durum, tutar, iade edilen, net tahsilat, taksit, sağlayıcı işlem numarası. İadeler ayrı satırda eksi tutarla gelir.',
    requiredPermission: 'Ödemeleri görüntüleme',
  },
  'stock.critical': {
    kind: 'field',
    title: 'Kritik stok',
    short:
      "Satılabilir adedi (eldeki − ayrılmış, SKT'si geçmemiş) eşiğe eşit veya altına düşen ürünler. Eşiğin en çok altında olan en üsttedir; günlük e-posta özeti de bu listeden hazırlanır.",
    whatItDoes:
      'Depo eşiği, tüm depolar eşiği ve varsayılan eşik birlikte değerlendirilir. "Kural" sütunu satırın hangi eşikten geldiğini gösterir.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#kritik-stok',
  },
  'stock.default_threshold': {
    kind: 'field',
    title: 'Varsayılan eşik',
    short:
      'Kendi eşiği olmayan ürünlerde tüm depoların toplam satılabilir adedi bu sayıya eşit veya altına düşünce kritik sayılır. Yalnızca en az bir kez stok girişi yapılmış ürünlere uygulanır. Boş bırakılırsa uygulanmaz.',
    requiredPermission: 'Stok değiştirme',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#kritik-stok',
  },
  'stock.daily_digest': {
    kind: 'field',
    title: 'Günlük e-posta özeti',
    short:
      'Açıksa kritik stok olduğu günlerde her sabah 08:00\'de (Türkiye saati) tek e-posta gider. Alıcılar Sistem Durumu\'ndaki "Uyarı alıcıları"; boşsa sahip ve yöneticiler.',
    requiredPermission: 'İşletme ayarlarını değiştirme',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#kritik-stok',
  },
  'stock.thresholds': {
    kind: 'field',
    title: 'Kritik stok eşikleri',
    short:
      'Bu ürün için uyarı eşiği. "Tüm depolar" toplam satılabilir adede, depo kutuları o depoya bakar. Boş kutu eşik yok demektir; hiç eşik yoksa varsayılan eşik uygulanır.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#kritik-stok',
  },
  'stock.thresholds_save': {
    kind: 'action',
    title: 'Eşikleri kaydet',
    short:
      'Bu ürünün eşiklerini kaydeder; kritik stok listesi hemen güncellenir. Değişiklik denetim kaydına yazılır.',
    requiredPermission: 'Stok değiştirme',
  },
  'page.seo': {
    kind: 'page',
    title: 'SEO merkezi',
    short:
      'Vitrinde yayında olan ürün, kategori, sayfa ve blog yazılarının arama motoru sorunlarını tek listede gösterir; her satırdan düzenleme ekranına gidilir.',
    whatItDoes:
      'Başlık ve açıklama uzunluğu, eksik açıklama, yinelenen başlık, görselsiz ürün, alternatif metni olmayan görsel, geçersiz barkod (GTIN) ve zayıf içerik denetlenir. Mağazanın arama motorlarına açık olup olmadığı ve SEO alanlarında yapılan son değişiklikler de burada görünür. Veriler doğrudan kayıtlardan hesaplanır; dış hizmete bağlanmaz.',
    whenToUse: 'Yayına almadan önce ve düzenli olarak (ör. her hafta) eksikleri gidermek için.',
    dataChanged: 'Hiçbir kayıt değişmez; düzeltmeler ilgili düzenleme ekranında yapılır.',
    requiredPermission: 'SEO görüntüleme',
    guideUrl: 'docs/SEO_GUIDE_TR.md#seo-merkezi',
  },
  'seo.indexing': {
    kind: 'field',
    title: 'Dizine açıklık',
    short:
      'Mağaza yayında ve sunucuda dizine açma (SITE_INDEXING) açıksa arama motorlarına açıktır. Biri kapalıysa her sayfa "noindex" döner ve robots.txt siteyi kapatır.',
    guideUrl: 'docs/GO_LIVE_TR.md#yayina-alma',
  },
  'seo.issues': {
    kind: 'field',
    title: 'SEO sorunları',
    short:
      "Yalnızca vitrinde yayında olan içerik denetlenir. Sorun sayısı çok olan en üsttedir; parantez içindeki sayı uzunluk, adet, görsel boyutu veya ilgili SKU'dur. Ana görsel kısa kenarı 500 px altındaysa küçük, 1500 px altındaysa düşük çözünürlüklü sayılır.",
    guideUrl: 'docs/SEO_GUIDE_TR.md#seo-merkezi',
  },
  'seo.issue_filter': {
    kind: 'field',
    title: 'Sorun türü',
    short: 'Listeyi tek bir sorun türüne göre süzer (ör. yalnızca açıklaması eksik olanlar).',
  },
  'seo.history': {
    kind: 'field',
    title: 'SEO değişiklik geçmişi',
    short:
      'Ürün, kategori, sayfa ve yazılarda SEO başlığı, açıklaması ve kısa ad (adres) değişiklikleri; kim ve ne zaman yaptı. Kısa ad değişince eski adres otomatik yönlendirilir.',
    guideUrl: 'docs/SEO_GUIDE_TR.md#seo-merkezi',
  },
  'seo.crawl': {
    kind: 'field',
    title: 'Site tarayıcısı',
    short:
      'Vitrini bir ziyaretçi gibi gezer (yalnızca kendi alan adınız, en fazla 150 sayfa): kırık bağlantı, yönlendirme zinciri, sunucu hatası, başlık/açıklama/H1 eksikleri, alternatif metin, canonical uyuşmazlığı, site haritasında "noindex" sayfa ve hiçbir yerden bağlantı verilmeyen (yetim) sayfaları bulur.',
    whatItDoes:
      'Ana sayfadan ve site haritasından başlar, iç bağlantıları izler. Hesap, sepet, ödeme ve önizleme sayfalarına girmez. Yayındaki mağazalar her pazartesi kendiliğinden taranır.',
    guideUrl: 'docs/SEO_GUIDE_TR.md#site-tarayicisi',
  },
  'seo.crawl_start': {
    kind: 'action',
    title: 'Taramayı başlat',
    short:
      'Taramayı sıraya alır; sunucuyu yormamak için sayfalar saniyede bir gezilir, 150 sayfa birkaç dakika sürer. Bir tarama sürerken ikincisi başlatılamaz.',
    requiredPermission: 'SEO düzenleme',
    guideUrl: 'docs/SEO_GUIDE_TR.md#site-tarayicisi',
  },
  'seo.crawl_filter': {
    kind: 'field',
    title: 'Sorun türü (tarama)',
    short: 'Son taramanın sorunlarını tek bir türe göre süzer.',
  },
  'page.google': {
    kind: 'page',
    title: 'Google bağlantıları',
    short:
      'Google hesabınızı bağlar; her mağaza için Search Console mülkünü, GA4 mülkünü ve Merchant Center hesabını seçtirir.',
    whatItDoes:
      'Bağlantı Google’ın izin ekranından yapılır (parolanız bize gelmez). Verilen erişim yenileme jetonu olarak şifreli saklanır; istediğiniz zaman "Bağlantıyı kaldır" ile Google’da iptal edilir. Raporlar ve ürün gönderimi sonraki adımlarda bu bağlantıyı kullanır.',
    whenToUse: 'OAuth istemcisini Entegrasyonlar ekranında doğruladıktan sonra.',
    dataChanged:
      'Google bağlantısı ve mağaza kaynak seçimleri; her işlem denetim kaydına ve günlüğe yazılır.',
    requiredPermission:
      'Entegrasyonları görüntüleme (bağlamak/kaldırmak için yönetme yetkisi ve iki adımlı doğrulama)',
    guideUrl: 'docs/GOOGLE_INTEGRATIONS_TR.md#baglanti',
  },
  'google.client': {
    kind: 'field',
    title: 'OAuth istemcisi',
    short:
      'Google Cloud Console → API’ler ve Hizmetler → Kimlik bilgileri → OAuth istemci kimliği (Web uygulaması). Kimlik ve gizli anahtar Entegrasyonlar ekranına girilir.',
    guideUrl: 'docs/GOOGLE_INTEGRATIONS_TR.md#oauth-istemcisi',
  },
  'google.redirect_uri': {
    kind: 'field',
    title: 'Yetkili yönlendirme adresi',
    short:
      'Bu adresi Google Cloud’daki OAuth istemcisinin "Yetkili yönlendirme URI’leri" listesine aynen ekleyin.',
    commonErrors: [
      {
        problem: 'Google "redirect_uri_mismatch" hatası veriyor',
        solution:
          'Adres Google Cloud’a eksik veya farklı (http/https, sondaki /) girilmiş; buradan kopyalayıp yapıştırın.',
      },
    ],
    guideUrl: 'docs/GOOGLE_INTEGRATIONS_TR.md#oauth-istemcisi',
  },
  'google.connect': {
    kind: 'action',
    title: 'Google ile bağlan',
    short:
      'Google’ın izin ekranını açar. Onaydan sonra panele dönülür; yalnızca seçtiğiniz hizmetlere erişim istenir. Bağlantı 10 dakika içinde tamamlanmalı.',
    requiredPermission: 'Entegrasyonları yönetme (iki adımlı doğrulama)',
    reversible: 'Evet: "Bağlantıyı kaldır".',
    guideUrl: 'docs/GOOGLE_INTEGRATIONS_TR.md#baglanti',
  },
  'google.services': {
    kind: 'field',
    title: 'Hizmetler ve izinler',
    short:
      'Search Console (tam erişim: site haritası gönderimi için), Analytics (salt okuma), Merchant Center (ürün verisi). Google ekranında bir izni kaldırırsanız o hizmet kullanılamaz.',
    guideUrl: 'docs/GOOGLE_INTEGRATIONS_TR.md#izinler',
  },
  'google.test': {
    kind: 'action',
    title: 'Bağlantıyı test et',
    short:
      'Erişim jetonu yenilenir, bağlı hesap okunur ve mağazalara seçilen kaynaklara hâlâ erişilebildiği denetlenir.',
    requiredPermission: 'Entegrasyonları yönetme',
  },
  'google.disconnect': {
    kind: 'action',
    title: 'Bağlantıyı kaldır',
    short: 'Google’da erişim iptal edilir, şifreli jeton ve mağaza kaynak seçimleri silinir.',
    whenToUse:
      'Google hesabını değiştirmek istediğinizde veya Google hizmetlerine erişimi tamamen kesmek gerektiğinde.',
    dataChanged:
      "Google'daki erişim izni iptal edilir; saklanan şifreli jeton ve mağazalar için seçilen Search Console, Merchant Center, Analytics gibi kaynak seçimleri silinir. İşlem denetim kaydına yazılır.",
    requiredPermission: 'Entegrasyonları yönetme (iki adımlı doğrulama)',
    reversible: 'Hayır; yeniden bağlanıp kaynakları yeniden seçmek gerekir.',
    commonErrors: [
      { problem: '"Kayıt bulunamadı"', solution: 'Google bağlantısı zaten kaldırılmış; sayfayı yenileyin.' },
      {
        problem: '"Bu işlem için doğrulama kodunuzu yeniden girmeniz gerekiyor"',
        solution: 'Doğrulama uygulamanızdaki kodu girip tekrar deneyin.',
      },
    ],
  },
  'google.resources': {
    kind: 'field',
    title: 'Mağaza kaynakları',
    short: 'Liste, bağlı Google hesabının erişebildiği mülk ve hesaplardan gelir; elle kimlik girilmez.',
    guideUrl: 'docs/GOOGLE_INTEGRATIONS_TR.md#kaynaklar',
  },
  'google.logs': {
    kind: 'field',
    title: 'Günlük',
    short: 'Bağlantı, jeton yenileme, kaynak listesi, test ve iptal işlemleri; hata kodlarıyla.',
  },
  'page.search_console': {
    kind: 'page',
    title: 'Arama performansı',
    short:
      'Google aramada mağazanızın tıklama, gösterim, tıklama oranı ve ortalama konumu; sorgu, sayfa, ülke ve cihaza göre.',
    whatItDoes:
      'Veriler bağlı Search Console mülkünden her sabah çekilir (Google verisi yaklaşık 2 gün gecikmelidir). Yükselen/düşen sayfalar, site haritası gönderimi ve URL denetimi de buradadır. Rakamlar yalnızca Google’dan gelen gerçek verilerdir.',
    whenToUse:
      'Haftalık SEO takibi, içerik değişikliklerinin etkisini görmek ve yeni sayfaları Google’a bildirmek için.',
    requiredPermission: 'SEO görüntüleme (senkron, gönderim ve denetim için SEO düzenleme)',
    guideUrl: 'docs/GOOGLE_INTEGRATIONS_TR.md#search-console',
  },
  'sc.sync': {
    kind: 'action',
    title: 'Şimdi senkronize et',
    short:
      'İlk seferde son 28 günü, sonra son 5 günü Google’dan yeniden çeker. Otomatik senkron her sabah 06:15’te.',
    requiredPermission: 'SEO düzenleme',
  },
  'sc.metrics': {
    kind: 'field',
    title: 'Ölçüler',
    short:
      'Tıklama: aramadan siteye geçiş. Gösterim: sonuçlarda görünme. Tıklama oranı: tıklama ÷ gösterim. Ortalama konum: gösterimle ağırlıklı ortalama sıra (küçük daha iyi).',
  },
  'sc.dimension': {
    kind: 'field',
    title: 'Ayrıntı tablosu',
    short:
      'Sorgu, sayfa, ülke veya cihaza göre en çok tıklanandan başlayarak ilk 100 satır; "Ara" ile süzülür.',
  },
  'sc.movers': {
    kind: 'field',
    title: 'Yükselen ve düşen sayfalar',
    short:
      'Son 7 veya 28 günün tıklamaları önceki eşit dönemle karşılaştırılır; her yönde en fazla 10 sayfa.',
  },
  'sc.sitemaps': {
    kind: 'field',
    title: 'Site haritaları',
    short: 'Search Console’daki site haritaları; Google işledikçe durum ve adres sayısı güncellenir.',
    guideUrl: 'docs/SEO_GUIDE_TR.md#site-haritasi',
  },
  'sc.sitemap_submit': {
    kind: 'action',
    title: 'Site haritasını gönder',
    short:
      'Mağazanın site haritası dizinini (https://alan-adı/sitemap.xml) Search Console’a bildirir. Mağaza yayına alındıktan sonra bir kez yeterli.',
    whenToUse: 'Mağazayı yayına aldıktan sonra ilk kez veya alan adı değiştikten sonra.',
    dataChanged:
      "Search Console'daki mülkünüze site haritası adresi eklenir; işlem denetim kaydına yazılır. Paneldeki veriler değişmez.",
    requiredPermission: 'SEO düzenleme',
    reversible: "Hayır, bu panelden geri alınamaz; gerekirse site haritası Search Console'dan kaldırılır.",
    commonErrors: [
      {
        problem: '"Bu mağaza için Search Console mülkü seçilmedi"',
        solution: "Google bağlantıları → Mağaza kaynakları'ndan mülkü seçin.",
      },
      {
        problem: '"Mağazanın alan adı seçilen Search Console mülkünün kapsamında değil"',
        solution: 'Vitrin alan adını kapsayan mülkü seçin (ör. alan adı mülkü).',
      },
      {
        problem: '"Google hizmeti isteği reddetti veya yanıt vermedi"',
        solution: 'Biraz sonra tekrar deneyin; sürerse Google bağlantısını test edin.',
      },
    ],
  },
  'sc.inspect': {
    kind: 'field',
    title: 'URL denetimi',
    short:
      'Sayfanın Google dizininde olup olmadığı, son tarama ve Google’ın seçtiği canonical. Google mülk başına günde 2.000 denetime izin verir.',
    requiredPermission: 'SEO düzenleme',
  },
  'sc.digest': {
    kind: 'field',
    title: 'Haftalık e-posta özeti',
    short:
      'Pazartesi sabahı uyarı alıcılarına (Sistem Durumu → Uyarı alıcıları; boşsa sahip ve yöneticiler) gönderilir. E-posta kurulu değilse gönderilmez.',
  },
  'page.merchant': {
    kind: 'page',
    title: 'Google alışveriş',
    short:
      'Ürünlerinizi Google Merchant Center’a gönderir: feed öncesi denetim, feed dosyası adresi ve Merchant API ile otomatik gönderim; Google’daki ret nedenleri.',
    whatItDoes:
      'İki yol vardır: (1) feed dosyası — Merchant Center adresi her gün kendisi alır, Google bağlantısı gerekmez; (2) Merchant API — Google bağlantısıyla değişen ürünler her sabah gönderilir ve onay durumları geri gelir. Sağlık beyanı sorunu, görseli veya fiyatı olmayan ürün hiçbir yolla gönderilmez.',
    whenToUse: 'Google alışveriş sekmesinde ve ücretsiz listelemelerde görünmek için.',
    requiredPermission: 'SEO görüntüleme (açmak, göndermek için SEO düzenleme)',
    guideUrl: 'docs/MERCHANT_CENTER_TR.md#genel',
  },
  'merchant.preview': {
    kind: 'field',
    title: 'Feed öncesi denetim',
    short:
      'Veteriner onayı olmayan veya içeriği onaydan sonra değişen sağlık ürünleri, metninde hastalık/tedavi iddiası olanlar, görseli veya fiyatı olmayanlar gönderilmez. Google’ın en küçük boyutunun altındaki görseller (bugün 100×100, giyimde 250×250; 31 Ocak 2027’den itibaren 500×500 px) atlanır; uygun görseli kalmayan ürün gönderilmez. Uyarılı ürünler gönderilir ama Google’da daha az görünebilir; en iyi sonuç için 1500×1500 px ve üstü görsel yükleyin.',
    guideUrl: 'docs/MERCHANT_CENTER_TR.md#denetim',
  },
  'merchant.feed': {
    kind: 'field',
    title: 'Feed dosyası',
    short:
      'Açınca gizli anahtarlı bir adres oluşur. Bu adresi Merchant Center’da "Zamanlanmış getirme" olarak girin. Adres paylaşılmamalı; sızarsa "Adresi yenile".',
    guideUrl: 'docs/MERCHANT_CENTER_TR.md#feed-dosyasi',
  },
  'merchant.feed_rotate': {
    kind: 'action',
    title: 'Adresi yenile',
    short: 'Yeni anahtarlı adres üretir; eskisi hemen çalışmaz. Merchant Center’daki adresi güncelleyin.',
    whenToUse: 'Ürün akışı adresinin yetkisiz kişilerle paylaşıldığından şüphelendiğinizde.',
    dataChanged:
      'Mağazanın ürün akışı adresi için yeni bir gizli anahtar üretilir ve eski adres hemen çalışmaz; işlem denetim kaydına yazılır.',
    requiredPermission: 'SEO düzenleme',
    reversible: "Hayır, eski adres geri gelmez; Merchant Center'daki akış adresini yenisiyle değiştirin.",
    commonErrors: [
      {
        problem: 'Yenilemeden sonra Merchant Center ürünleri çekemiyor',
        solution: "Eski adres hemen çalışmaz; yeni akış adresini Merchant Center'a girin.",
      },
    ],
  },
  'merchant.api': {
    kind: 'field',
    title: 'Merchant API',
    short:
      'Google bağlantılarında Merchant Center izni verilip hesap seçildiyse ürünler her sabah 05:30’da gönderilir.',
    guideUrl: 'docs/MERCHANT_CENTER_TR.md#merchant-api',
  },
  'merchant.sync': {
    kind: 'action',
    title: 'Şimdi gönder',
    short:
      'Değişen ürünler gönderilir, artık gönderilmeyenler Google’dan silinir, onay durumları güncellenir.',
    whenToUse:
      "Ürünlerde fiyat, stok veya görsel değişikliği yaptıktan sonra Google Alışveriş'e gece senkronunu beklemeden göndermek istediğinizde.",
    dataChanged:
      "Değişen ürünler Google Merchant Center'a yazılır, artık gönderilmeyen ürünler oradan silinir ve ürünlerin Google onay durumları güncellenir; son senkron sonucu kaydedilir ve işlem denetim kaydına yazılır.",
    requiredPermission: 'SEO düzenleme',
    reversible: 'Hayır, gönderilen değişiklikler geri alınamaz; ürün düzeltilip yeniden gönderilir.',
    commonErrors: [
      {
        problem: '"Bu mağaza için Merchant Center hesabı seçilmedi"',
        solution: "Google bağlantıları → Mağaza kaynakları'ndan Merchant Center hesabını seçin.",
      },
      {
        problem: '"Bu hizmet için Google izni verilmedi"',
        solution: 'Google ile yeniden bağlanırken Merchant Center hizmetini de seçin.',
      },
      { problem: '"Mağazanın vitrin alan adı yok"', solution: 'Mağazalar ekranından alan adı ekleyin.' },
    ],
  },
  'merchant.performance': {
    kind: 'field',
    title: 'Ürün performansı',
    short:
      'Merchant Center raporu: her ürünün Google’daki ücretsiz listeleme ve alışveriş reklamı gösterim ve tıklamaları. Saklanmaz, her açılışta Google’dan okunur.',
    guideUrl: 'docs/MERCHANT_CENTER_TR.md#urun-performansi',
  },
  'merchant.performance_period': {
    kind: 'field',
    title: 'Dönem',
    short: 'Son 7, 28 veya 90 gün (dün dahil). Google verisi 1–2 gün gecikebilir.',
  },
  'merchant.issues': {
    kind: 'field',
    title: 'Google’daki sorunlar',
    short:
      'Google’ın reddettiği veya uyarı verdiği ürünler. Yeni reddedilen ürün olduğunda uyarı alıcılarına günde en fazla bir e-posta gider.',
    guideUrl: 'docs/MERCHANT_CENTER_TR.md#ret-nedenleri',
  },
  'products.merchant': {
    kind: 'field',
    title: 'Google alışveriş',
    short: 'Ürünün Merchant Center’a gönderilip gönderilmeyeceği ve Google’a özel alanlar.',
    guideUrl: 'docs/MERCHANT_CENTER_TR.md#urun-alanlari',
  },
  'products.google_category': {
    kind: 'field',
    title: 'Google ürün kategorisi',
    short:
      'Google’ın ürün taksonomisindeki numara (ör. 5082 = Evcil Hayvan Malzemeleri > Kedi Malzemeleri) veya tam yol. Boşsa Google tahmin eder.',
    guideUrl: 'docs/MERCHANT_CENTER_TR.md#urun-alanlari',
  },
  'products.identifier_exists': {
    kind: 'field',
    title: 'Üretici barkodu',
    short:
      'Varyantlarda geçerli barkod (GTIN) varsa Google’a gönderilir. Ürünün hiç barkodu yoksa "Bu ürünün barkodu yok" seçin; yanlış seçim ürünün reddedilmesine yol açabilir.',
  },
  'products.sku_is_mpn': {
    kind: 'field',
    title: 'Stok kodu = MPN',
    short:
      'Ürünü kendiniz üretiyorsanız stok kodu üreticinin parça numarasıdır; açınca Google’a MPN olarak gönderilir ve barkodu olmayan ürün de marka + MPN ile tanınır. Başka üreticinin ürününde açmayın.',
  },
  'products.custom_labels': {
    kind: 'field',
    title: 'Özel etiketler',
    short:
      'Google Ads’te ürünleri gruplamak için serbest etiketler (ör. kampanya, sezon, kâr marjı grubu). Müşteri görmez.',
  },
  'page.attribution': {
    kind: 'page',
    title: 'Kampanyalar ve kaynaklar',
    short:
      'Kampanya bağlantısı (UTM) oluşturur ve siparişleri geldikleri kaynağa göre (Google reklamı, e-posta bülteni, Instagram, yönlendiren site…) raporlar.',
    whatItDoes:
      'Vitrin, ziyaretçi çerez izni verdiyse ilk ve son gelişin kaynağını 90 gün saklar; sipariş verilince bu bilgi siparişe yazılır. Reklam tıklama kimlikleri (gclid, fbclid, ttclid) yalnızca pazarlama izniyle saklanır ve sunucu olaylarında eşleştirme için kullanılır.',
    whenToUse:
      'Hangi kampanyanın ve kanalın satış getirdiğini görmek, reklam ve e-posta bağlantılarını hazırlamak için.',
    requiredPermission: 'Ölçümleme görüntüleme',
    guideUrl: 'docs/MEASUREMENT_TR.md#kaynak-bilgisi',
  },
  'attribution.builder': {
    kind: 'field',
    title: 'Kampanya bağlantısı',
    short:
      'Kaynak: trafiğin geldiği yer (google, instagram, newsletter). Ortam: türü (cpc, social, email). Kampanya: adı (ekim-indirimi). Bağlantı yalnızca ekranda oluşturulur, kaydedilmez.',
    guideUrl: 'docs/MEASUREMENT_TR.md#kaynak-bilgisi',
  },
  'attribution.url': {
    kind: 'field',
    title: 'Sayfa adresi',
    short: 'Ziyaretçinin açılacağı vitrin sayfası (ana sayfa, ürün, kategori).',
  },
  'attribution.source': {
    kind: 'field',
    title: 'Kaynak',
    short: 'Trafiğin geldiği yer: google, facebook, instagram, tiktok, newsletter…',
  },
  'attribution.medium': {
    kind: 'field',
    title: 'Ortam',
    short: 'Trafiğin türü: cpc (ücretli tıklama), social, email, sms, qr…',
  },
  'attribution.campaign': {
    kind: 'field',
    title: 'Kampanya',
    short: 'Kampanyanın adı; raporda bu adla gruplanır.',
  },
  'attribution.term': {
    kind: 'field',
    title: 'Anahtar kelime',
    short: 'İsteğe bağlı: ücretli aramada anahtar kelime.',
  },
  'attribution.content': {
    kind: 'field',
    title: 'İçerik',
    short: 'İsteğe bağlı: aynı kampanyada farklı bağlantıları ayırmak için (ör. ust-banner, alt-buton).',
  },
  'attribution.report': {
    kind: 'field',
    title: 'Kaynağa göre siparişler',
    short:
      'Sipariş sayısı, ödenen sipariş, ödenen ciro, iade ve net tutar kaynağa göre. "Bilinmiyor": ziyaretçi çerez izni vermemişti. "Doğrudan": izin vardı ama doğrudan veya site içinden gelmişti.',
    guideUrl: 'docs/MEASUREMENT_TR.md#kaynak-bilgisi',
  },
  'attribution.model': {
    kind: 'field',
    title: 'Temas',
    short:
      'Son temas: siparişten önceki son doğrudan olmayan kaynak (ör. son tıklanan reklam). İlk temas: ziyaretçinin ilk geldiği kaynak (90 gün içinde).',
  },
  'page.web_vitals': {
    kind: 'page',
    title: 'Sayfa hızı',
    short:
      'Vitrinin hızını Google PageSpeed Insights ile ölçer: Core Web Vitals (LCP, INP, CLS) gerçek ziyaretçi verisi ve Lighthouse puanı.',
    whatItDoes:
      'Ana sayfa, ilk kategori, ilk ürün ve son blog yazısı mobil ve masaüstünde ölçülür. Yayındaki mağazalar her pazartesi 04:30’da kendiliğinden ölçülür; "Şimdi ölç" ile elle de başlatılır.',
    whenToUse: 'Tasarım veya içerik değişikliğinden sonra hızın düşüp düşmediğini görmek için.',
    requiredPermission: 'SEO görüntüleme (ölçüm başlatmak için SEO düzenleme)',
    guideUrl: 'docs/SEO_GUIDE_TR.md#sayfa-hizi',
  },
  'web_vitals.run': {
    kind: 'action',
    title: 'Şimdi ölç',
    short:
      'Sekiz ölçüm yapılır (dört sayfa × mobil/masaüstü); birkaç dakika sürebilir. Staging vitrini parolalı olduğu için orada sayfalar açılamaz; ölçüm canlı vitrinde anlamlıdır.',
    requiredPermission: 'SEO düzenleme',
    guideUrl: 'docs/SEO_GUIDE_TR.md#sayfa-hizi',
  },
  'web_vitals.results': {
    kind: 'field',
    title: 'Sonuçlar',
    short:
      'LCP: en büyük içeriğin görünme süresi. INP: tıklamaya tepki süresi. CLS: sayfa kayması. Saha verisi gerçek ziyaretçilerden gelir; yeni veya az ziyaret edilen sayfalarda yoktur.',
    guideUrl: 'docs/SEO_GUIDE_TR.md#sayfa-hizi',
  },
  'page.attributes': {
    kind: 'page',
    title: 'Ürün özellikleri',
    short: 'Ürünlerin teknik özellik tanımları (sayı, seçenek, evet/hayır, metin) ve kullanılan etiketler.',
    whatItDoes:
      'Tanımladığınız özelliklerin değerleri ürün ekranında girilir. Görünür özellikler ürün sayfasındaki "Teknik özellikler" tablosunda, süzgeç işaretliler vitrin süzgeçlerinde kullanılır.',
    whenToUse: 'Ürünleri karşılaştırılabilir kılmak, süzgeç ve koleksiyon kuralı kurmak istediğinizde.',
    requiredPermission: 'Ürünleri görüntüleme (düzenlemek için Ürün ekleme ve düzenleme)',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#ozellikler',
  },
  'attributes.list': {
    kind: 'field',
    title: 'Özellik listesi',
    short:
      'Her özelliğin türü, seçenekleri, nerede göründüğü ve kaç üründe değeri olduğu. Silinen özelliğin ürünlerdeki değerleri de silinir.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#ozellikler',
  },
  'attributes.code': {
    kind: 'field',
    title: 'Kısa kod',
    short:
      'İçe aktarma sütununda ve vitrin süzgeç adresinde kullanılır. Küçük harf, rakam ve tire. Boşsa addan üretilir.',
  },
  'attributes.type': {
    kind: 'field',
    title: 'Özellik türü',
    short:
      'Metin, sayı (birimiyle), tek seçenek, birden çok seçenek veya evet/hayır. Ürünlerde değeri girilmiş özelliğin türü sonradan değiştirilemez.',
  },
  'attributes.options': {
    kind: 'field',
    title: 'Seçenekler',
    short:
      'Her satıra bir seçenek; vitrinde bu sırayla gösterilir. Ürünlerde kullanılan seçenek kaldırılamaz; yeni seçenek eklemek serbest.',
  },
  'attributes.visible': {
    kind: 'field',
    title: 'Ürün sayfasında göster',
    short:
      'Açıksa değer ürün sayfasının "Teknik özellikler" tablosunda ve arama motorlarına giden ürün bilgisinde görünür. Kapalıysa yalnızca panelde kalır.',
  },
  'attributes.filterable': {
    kind: 'field',
    title: 'Vitrin süzgeçlerinde göster',
    short:
      'Ürün listesinde müşterinin bu özelliğe göre süzmesini sağlar (sayılarda aralık, seçeneklerde işaretleme).',
  },
  'attributes.position': {
    kind: 'field',
    title: 'Sıra',
    short: 'Küçük sayı önce gelir; ürün sayfasındaki tabloda ve süzgeçlerde bu sıra kullanılır.',
  },
  'products.tags': {
    kind: 'field',
    title: 'Etiketler',
    short:
      'Virgülle ayırın (ör. yavru kedi, tahılsız). Küçük harfe çevrilir; vitrinde görünmez. Koleksiyon kuralları ve ürün listesi süzgeci için kullanılır.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#ozellikler',
  },
  'products.copy': {
    kind: 'action',
    title: 'Kopyala',
    short:
      'Ürünün taslak kopyasını açar: içerik, varyantlar (SKU sonuna -K eklenir, barkod boş), kategoriler, özellikler, görseller ve fiyatlar kopyalanır. Mağaza yayını, stok, SEO başlığı ve veteriner onayı kopyalanmaz.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#urun-araclari',
  },
  'products.save_template': {
    kind: 'action',
    title: 'Şablon olarak kaydet',
    short:
      'Bu ürünün marka, kategori, tür, seçenek, özellik, etiket ve açıklama metinlerini adlandırılmış şablon olarak kaydeder. Yeni üründe "Şablondan başla" ile kullanılır.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#urun-araclari',
  },
  'products.template': {
    kind: 'field',
    title: 'Şablon',
    short:
      'Seçip "Şablonu uygula" deyince form şablondaki değerlerle dolar; ad, SKU ve fiyatı siz girersiniz.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#urun-araclari',
  },
  'products.sku_suggest': {
    kind: 'action',
    title: 'SKU öner',
    short:
      'Boş SKU alanlarını işletmenin SKU kalıbına göre doldurur (ör. ZG-OMEGA-3-BALIK-60-ML). Öneri işletmede benzersizdir; dolu SKU değiştirilmez.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#urun-araclari',
  },
  'products.sku_pattern': {
    kind: 'field',
    title: 'SKU kalıbı',
    short:
      'Jetonlar: {marka}, {kategori}, {urun}, {secenek}, {sira}. Örnek: {marka}-{urun}-{secenek}. Değişiklik yalnızca yeni önerileri etkiler.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#urun-araclari',
  },
  'products.schedule': {
    kind: 'action',
    title: 'Yayını planla',
    short:
      'Ürünü bu mağazada ileri bir tarihte yayına alır (dakikada bir denetlenir). O anda ürün etkin, onaylı ve fiyatlı değilse yayınlanmaz; nedeni burada görünür. Elle yayın veya kaldırma planı iptal eder.',
    whenToUse: 'Ürünü belirli bir tarihte (ör. lansman günü) satışa açmak istediğinizde.',
    dataChanged:
      'Ürünün o mağazadaki yayın kaydına planlanan tarih ve planlayan kişi yazılır; tarih gelince ürün şartları sağlıyorsa yayına alınır, sağlamıyorsa neden kaydedilir. İşlem denetim kaydına yazılır.',
    requiredPermission: 'Ürün yayınlama.',
    reversible:
      'Evet, plan tarih boşaltılarak iptal edilir; elle yayınlama veya kaldırma da planı iptal eder.',
    commonErrors: [
      { problem: '"Ürün bu mağazada zaten yayında"', solution: 'Yayındaki ürün için plan gerekmez.' },
      {
        problem: '"Yayın zamanı en erken 1 dakika sonrası olabilir" veya "en fazla 1 yıl sonrasına"',
        solution: 'Tarihi bu aralıkta seçin.',
      },
    ],
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#urun-araclari',
  },
  'products.bulk': {
    kind: 'action',
    title: 'Toplu işlem',
    short:
      'Seçili ürünlerde (veya süzgece uyan tüm ürünlerde) durum, kategori, etiket, koleksiyon, stok, SEO kalıbı, Google alışveriş ayarını veya mağazadaki yayın durumunu tek seferde değiştirir. Önce önizleme gösterilir; onaylamadan hiçbir şey değişmez.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#toplu-islemler',
  },
  'products.bulk_select_all': {
    kind: 'action',
    title: 'Süzgece uyan tüm ürünleri seç',
    short:
      'Yalnızca bu sayfadakileri değil, arama ve süzgeçlere uyan bütün ürünleri seçer (en çok 5.000). Süzgeci değiştirirseniz seçim temizlenir.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#toplu-islemler',
  },
  'products.bulk_kind': {
    kind: 'field',
    title: 'İşlem',
    short:
      'Yapılacak değişiklik. Stok işlemleri için stok değiştirme yetkisi, mağazada yayınla/yayından kaldır için ürün yayınlama yetkisi, diğerleri için ürün düzenleme yetkisi gerekir; uygulamak için ayrıca "Toplu ürün işlemi uygulama" yetkisi ve iki adımlı doğrulama istenir.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#toplu-islemler',
  },
  'products.bulk_store': {
    kind: 'field',
    title: 'Mağaza',
    short:
      'Ürünlerin yayınlanacağı veya yayından kaldırılacağı mağaza. Yayınlamada yalnızca etkin, veteriner onayı gereken içerikte onaylı ve bu mağazanın perakende listesinde fiyatı olan ürünler yayına girer; diğerleri önizlemede gerekçesiyle atlanır. Veteriner onayı toplu verilmez; ürün sayfasından tek tek verilir.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#toplu-yayin',
  },
  'products.bulk_stock': {
    kind: 'field',
    title: 'Stok adedi',
    short:
      '"Sayıma göre ayarla" her etkin varyantın stokunu bu sayıya getirir; "Ekle veya çıkar" mevcut stoka ekler (eksi sayı çıkarır). Her değişiklik stok hareketi olarak "Toplu işlem" nedeniyle kaydedilir.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#toplu-islemler',
  },
  'products.bulk_seo': {
    kind: 'field',
    title: 'SEO kalıbı',
    short:
      'Jetonlar ürün bilgisiyle doldurulur: {urun} ürün adı, {marka} marka, {kategori} ilk kategori. "Yalnızca boş olanları doldur" açıkken elle yazılmış SEO başlığı ve açıklaması korunur.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#toplu-islemler',
  },
  'products.bulk_preview': {
    kind: 'action',
    title: 'Önizle',
    short:
      'Hangi ürünün hangi değerden hangi değere geçeceğini ve atlanacak ürünleri nedeniyle gösterir. Hiçbir ürün değişmez; önizleme 30 dakika geçerlidir.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#toplu-islemler',
  },
  'products.bulk_apply': {
    kind: 'action',
    title: 'Uygula',
    short:
      'Önizlenen değişiklikleri yapar. Önizlemeden sonra başkası tarafından değiştirilmiş satırlara dokunulmaz. 200 satırdan büyük işlemler arka planda uygulanır; ilerleme geçmişte görünür.',
    whenToUse:
      'Toplu işlem önizlemesinde hangi ürünün hangi değere geçeceğini ve atlanacak ürünleri kontrol ettikten sonra, 30 dakika dolmadan.',
    dataChanged:
      'Seçili ürünlerde durum, kategori, etiket, koleksiyon, stok, SEO, Google ayarı veya mağaza yayını gibi seçtiğiniz alan değişir; her satırın eski ve yeni değeri toplu işlem geçmişine yazılır. Stok değişikliği stok hareketi olarak kaydedilir; işlem denetim kaydına yazılır.',
    requiredPermission:
      'Toplu ürün işlemi uygulama ve geri alma (hassas; iki adımlı doğrulama); işlemin türüne göre ayrıca ürün ekleme ve düzenleme, stok hareketi ve sayım veya ürün yayınlama.',
    reversible: 'Evet, Toplu işlem geçmişinden "Geri al" ile; sonradan elle değiştirilmiş satırlar atlanır.',
    commonErrors: [
      { problem: '"Önizleme süresi doldu (30 dk)"', solution: 'Yeniden önizleyip uygulayın.' },
      {
        problem: '"Bu toplu işlem önizleme aşamasında değil"',
        solution: 'İşlem zaten uygulanmış veya iptal edilmiş; geçmişten durumunu kontrol edin.',
      },
    ],
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#toplu-islemler',
  },
  'products.bulk_history': {
    kind: 'action',
    title: 'Toplu işlem geçmişi',
    short:
      'Son 50 toplu işlemi, sonuçlarını ve atlanan satırları gösterir; uygulanan işlemi buradan geri alabilirsiniz.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#toplu-islemler',
  },
  'products.bulk_revert': {
    kind: 'action',
    title: 'Geri al',
    short:
      'Bu işlemle değişen değerleri eski hâline döndürür. İşlemden sonra elle değiştirilmiş satırlar atlanır; stok ters hareketle düzeltilir. Geri alma da denetim kaydına yazılır.',
    whenToUse:
      'Uygulanan toplu ürün işleminin yanlış olduğunu fark ettiğinizde (yanlış kategori, yanlış durum, yanlış stok).',
    dataChanged:
      'Hâlâ işlemin yazdığı değerde olan satırlar eski değerlerine döner, stok ters hareketle düzeltilir; işlem "geri alındı" olur ve denetim kaydına yazılır.',
    requiredPermission:
      'Toplu ürün işlemi uygulama ve geri alma (hassas; iki adımlı doğrulama); işlemin türüne göre ayrıca ürün ekleme ve düzenleme, stok hareketi ve sayım veya ürün yayınlama.',
    reversible: 'Hayır, geri alınan işlem yeniden uygulanamaz; gerekirse yeni bir toplu işlem yapılır.',
    commonErrors: [
      {
        problem: '"Bu toplu işlem uygulanmamış; geri alınamaz"',
        solution: 'Yalnızca uygulanmış ve daha önce geri alınmamış işlem geri alınır.',
      },
    ],
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#toplu-islemler',
  },
  'products.grid': {
    kind: 'action',
    title: 'Tabloda düzenle',
    short:
      'Ürünleri varyant satırlarıyla tabloda açar; SKU, barkod, durum, fiyat ve stok hücrelerini Excel gibi düzenleyip tek seferde kaydedersiniz.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#tablo-duzenleme',
  },
  'products.grid_price_list': {
    kind: 'field',
    title: 'Fiyat listesi',
    short:
      'Fiyat sütunu bu listenin 1 adet fiyatını gösterir ve düzenler. Kaydedilmemiş değişiklik varken değiştirilemez.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#tablo-duzenleme',
  },
  'products.grid_warehouse': {
    kind: 'field',
    title: 'Depo',
    short:
      'Stok sütunu bu depodaki eldeki adedi gösterir ve düzenler (fark stok hareketi olarak kaydedilir). Parti/SKT takipli varyantlar burada değiştirilemez.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#tablo-duzenleme',
  },
  'products.grid_save': {
    kind: 'action',
    title: 'Değişiklikleri kaydet',
    short:
      'Önce önizleme açılır: kaydedilecek değişiklikler, siz düzenlerken başkasının değiştirdiği hücreler (kaydedilmez) ve geçersiz hücreler. "Kaydet" ile uygulanır; toplu işlem geçmişinden geri alınabilir.',
    whenToUse:
      'Ürün tablosunda SKU, barkod, durum, fiyat veya stok hücrelerini düzenledikten sonra değişiklikleri topluca yazmak için.',
    dataChanged:
      'Önizlemede onaylanan hücreler ürünlere, fiyat listelerine ve stoğa yazılır; değişiklikler toplu işlem geçmişine ve denetim kaydına düşer. Siz düzenlerken başkasının değiştirdiği hücreler yazılmaz.',
    requiredPermission:
      'Toplu ürün işlemi uygulama ve geri alma (hassas; iki adımlı doğrulama); düzenlenen hücreye göre ayrıca ürün ekleme ve düzenleme, fiyat düzenleme veya stok hareketi ve sayım.',
    reversible: 'Evet, Toplu işlem geçmişinden "Geri al" ile; sonradan elle değiştirilmiş satırlar atlanır.',
    commonErrors: [
      {
        problem: 'Önizlemede "başkası değiştirdi" olarak işaretlenen hücreler',
        solution: 'Tabloyu yenileyip güncel değerlerin üzerine yeniden düzenleyin.',
      },
      {
        problem: '"Önizleme süresi doldu (30 dk)"',
        solution: 'Değişiklikleri yeniden kaydedip önizlemeyi tekrar açın.',
      },
    ],
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#tablo-duzenleme',
  },
  'products.grid_discard': {
    kind: 'action',
    title: 'Vazgeç',
    short: 'Kaydedilmemiş tüm hücre değişikliklerini siler; kayıtlı veriler değişmez.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#tablo-duzenleme',
  },
  'stock.lot_pick': {
    kind: 'field',
    title: 'Lot',
    short:
      'Bu depoda stok lotlarda tutuluyorsa sayım, düzeltme ve hasar hangi lota yazılacaksa o lot seçilir. Lotsuz bakiye için "Lotsuz stok". Sayımda girilen adet yalnızca seçilen lotun yeni miktarıdır.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#skt',
  },
  'imports.column_map': {
    kind: 'field',
    title: 'Sütun eşleştirme',
    short:
      'Dosyadaki sütunun hangi alana aktarılacağı. "Yok say" sütunu aktarmaz. Uygulanan içe aktarmadaki elle eşleştirme kaydedilir ve aynı başlıklı sonraki dosyalarda kendiliğinden kullanılır (her zaman değiştirilebilir).',
    guideUrl: 'docs/BULK_IMPORT_EXPORT_TR.md#sutun-eslestirme',
  },
  'imports.retry': {
    kind: 'action',
    title: 'Hatalıları yeniden dene',
    short:
      'Yalnızca hata alan ürünleri yeniden uygular; başarılı olanlar tekrarlanmaz. Önceki denemede oluşmuş ürün yeniden oluşturulmaz, güncellenir.',
    whenToUse:
      'Ürün içe aktarması bittiğinde bazı ürünler hata aldıysa ve hatanın nedenini (ör. eksik kategori, bağlantı kesintisi) giderdiyseniz.',
    dataChanged:
      'Yalnızca hata alan veya yarım kalan ürünler yeniden uygulanır; daha önce oluşmuş ürün güncellenir, yeniden oluşturulmaz. İşlem denetim kaydına yazılır.',
    requiredPermission: 'Ürün içe aktarma.',
    reversible:
      'Hayır, uygulanan ürün değişiklikleri tek tıkla geri alınmaz; gerekirse ürünler tek tek düzeltilir.',
    commonErrors: [
      {
        problem: '"İçe aktarma henüz bitmedi"',
        solution: 'İş bitene kadar bekleyin, sonra yeniden deneyin.',
      },
      { problem: '"Yeniden denenecek ürün yok"', solution: 'Tüm ürünler başarıyla uygulanmış.' },
    ],
    guideUrl: 'docs/BULK_IMPORT_EXPORT_TR.md#buyuk-dosyalar',
  },
  'pricing.cost_based': {
    kind: 'field',
    title: 'Maliyet bazlı fiyat',
    short:
      '"Maliyetten" kâr oranıyla, "Hedef brüt marj" marjla fiyat üretir: KDV hariç fiyat maliyetten hesaplanır, KDV dahil listede ürünün KDV oranı eklenir. Maliyeti girilmemiş varyant atlanır. Maliyet görme yetkisi gerekir.',
    guideUrl: 'docs/PRICING_ENGINE_TR.md#maliyet-ve-marj',
  },
  'pricing.min_margin': {
    kind: 'field',
    title: 'En düşük marj',
    short:
      'Toplu fiyat sonucunda brüt marjı bu oranın altına düşen ürünler önizlemede "Düşük marj" olarak işaretlenir; "Uygulama" seçilirse bu ürünlere yeni fiyat yazılmaz.',
    guideUrl: 'docs/PRICING_ENGINE_TR.md#maliyet-ve-marj',
  },
  'pricing.fx_rate': {
    kind: 'field',
    title: 'Kur',
    short:
      'Başka para birimindeki listenin fiyatı bu kurla çevrilir (kaynak birimin 1 biriminin karşılığı). Kur elle girilir; otomatik kur çekilmez.',
    guideUrl: 'docs/PRICING_ENGINE_TR.md#maliyet-ve-marj',
  },
  'pricing.campaign_dates': {
    kind: 'field',
    title: 'Geçerlilik tarihleri',
    short:
      'Liste yalnızca bu aralıkta fiyat verir (kampanya). Aynı türde birden çok liste geçerliyse önceliği yüksek olan kazanır. İndirimli görünüm için önceki fiyat yine fiyat geçmişinden hesaplanır.',
    guideUrl: 'docs/PRICING_ENGINE_TR.md#kampanya-listeleri',
  },
  'products.price_tiers': {
    kind: 'field',
    title: 'Adet bazlı fiyatlar',
    short:
      'Belirli adetten itibaren geçerli birim fiyat (ör. 6 adet ve üzeri). Sepette adede uyan en yüksek eşik uygulanır.',
    guideUrl: 'docs/PRICING_ENGINE_TR.md#kademeli-fiyat',
  },
  'products.extras': {
    kind: 'field',
    title: 'Video, belge ve tamamlayıcı ürünler',
    short:
      'Ürün sayfasında gösterilecek videolar, PDF belgeler ve "Birlikte iyi gider" ürünleri. Sağlık içeriği olan üründe video veya belge değişirse Veteriner Uzman İnceleyici onayı yenilenir.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#urun-sayfasi-ekleri',
  },
  'products.videos': {
    kind: 'field',
    title: 'Videolar',
    short:
      'YouTube veya Vimeo video adresini yapıştırın ve bir başlık yazın (en çok 5). Vitrinde ziyaretçi "oynat" demeden video sitesine bağlanılmaz.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#urun-sayfasi-ekleri',
  },
  'products.video_add': {
    kind: 'action',
    title: 'Video ekle',
    short: 'Yeni bir video satırı ekler. Adres ve başlık girip ürünü kaydedin.',
  },
  'products.documents': {
    kind: 'field',
    title: 'Belgeler',
    short:
      'Analiz sertifikası, kullanma kılavuzu gibi PDF belgeler (en çok 10). Vitrinde "Belgeler" sekmesinde herkese açık bağlantı olarak görünür; kişisel veri içeren belge yüklemeyin.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#urun-sayfasi-ekleri',
  },
  'products.document_upload': {
    kind: 'action',
    title: 'PDF belge yükle',
    short:
      'En çok 10 MB PDF. JavaScript, gömülü dosya veya program açan PDF reddedilir; böyle bir belgeyi "PDF olarak yazdır" ile yeniden kaydedip yükleyin.',
  },
  'products.complementary': {
    kind: 'field',
    title: 'Tamamlayıcı ürünler',
    short:
      'Bu ürünle birlikte önerdiğiniz ürünler (en çok 12, seçim sırasıyla). Vitrinde "Birlikte iyi gider" başlığıyla gösterilir; vitrinde görünmeyen ürün atlanır.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#urun-sayfasi-ekleri',
  },
  'products.attributes': {
    kind: 'field',
    title: 'Ürün özellikleri',
    short:
      'Tanımlı özelliklerin bu üründeki değerleri. Boş bırakılan özellik ürüne yazılmaz. Yeni özellik Katalog → Ürün özellikleri ekranında tanımlanır.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#ozellikler',
  },
  'page.collections': {
    kind: 'page',
    title: 'Koleksiyonlar',
    short: 'Elle seçilen veya kurala uyan ürün grupları (ör. "Yavru kedi ürünleri").',
    whatItDoes:
      'Koleksiyonlar vitrinde koleksiyon sayfası ve ana sayfa bölümü olarak kullanılır. Kurallı koleksiyon ürünler değiştikçe kendiliğinden güncellenir.',
    whenToUse: 'Kampanya, mevsim veya ihtiyaca göre ürünleri bir araya getirmek istediğinizde.',
    requiredPermission: 'Ürünleri görüntüleme (düzenlemek için Ürün ekleme ve düzenleme)',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#koleksiyonlar',
  },
  'page.collection_editor': {
    kind: 'page',
    title: 'Koleksiyon',
    short: 'Koleksiyonun adı, adresi, durumu ve ürünleri (elle seçim veya kural).',
    whatItDoes:
      'Elle seçimde ürünleri arayıp eklersiniz. Kuralda kategori, marka, etiket, tür ve özellik koşullarını birleştirirsiniz; "Eşleşenleri göster" kaydetmeden sonucu gösterir.',
    requiredPermission: 'Ürün ekleme ve düzenleme',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#koleksiyonlar',
  },
  'collections.slug': {
    kind: 'field',
    title: 'Kısa ad',
    short:
      'Vitrin adresi: /koleksiyon/<kısa-ad>. Değiştirilirse eski adres yenisine kendiliğinden yönlendirilir.',
  },
  'collections.status': {
    kind: 'field',
    title: 'Durum',
    short: 'Gizli koleksiyon vitrinde görünmez; panelde düzenlenmeye devam eder.',
  },
  'collections.kind': {
    kind: 'field',
    title: 'Elle seçim veya kural',
    short:
      'Elle seçimde ürünler ve sıraları sizdedir. Kuralda ürünler koşullara göre her seferinde yeniden belirlenir; ürüne etiket eklemek koleksiyonu günceller.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#koleksiyonlar',
  },
  'collections.manual': {
    kind: 'field',
    title: 'Ürün ekle',
    short: 'Ad, SKU veya barkodla arayın; en fazla 500 ürün. Vitrinde yalnızca yayındaki ürünler görünür.',
  },
  'collections.match': {
    kind: 'field',
    title: 'Koşulların birleşimi',
    short:
      '"Tüm koşullar": ürün her koşulu sağlamalı (ör. kedi VE tahılsız). "Biri yeterli": koşullardan birini sağlayan ürün girer.',
  },
  'collections.preview': {
    kind: 'action',
    title: 'Eşleşenleri göster',
    short: 'Kuralı kaydetmeden eşleşen ürün sayısını ve ilk ürünleri gösterir.',
    reversible: 'Evet: hiçbir şey kaydetmez.',
  },
  'page.site_search': {
    kind: 'page',
    title: 'Site içi arama',
    short: 'Vitrinde en çok yapılan ve sonuçsuz kalan aramalar; eş anlamlı kelime grupları.',
    whatItDoes:
      'Arama Türkçe karakterlere duyarsızdır (kopek = köpek), kelime başını eşler (kedi → kediler) ve küçük yazım hatalarını tolere eder. Sonuçsuz kalan aramaları görüp eş anlamlı ekleyebilir veya ürün adlarını düzenleyebilirsiniz.',
    whenToUse: 'Müşterilerin ne aradığını ve bulamadığını görmek için; ayda bir göz atmak yeterli.',
    requiredPermission: 'SEO görüntüleme (eş anlamlılar için SEO düzenleme)',
    guideUrl: 'docs/SEO_GUIDE_TR.md#site-ici-arama',
  },
  'site_search.report': {
    kind: 'field',
    title: 'Arama raporu',
    short:
      'Arama sayfasının ilk görüntülenmesi bir arama sayılır; yazarken çıkan öneriler sayılmaz. Arama metni sadeleştirilmiş tutulur (küçük harf, Türkçe karakterler ç→c gibi). E-posta veya telefon numarası içeren aramalar kaydedilmez. 90 günden eski kayıtlar silinir.',
    guideUrl: 'docs/SEO_GUIDE_TR.md#site-ici-arama',
  },
  'site_search.zero': {
    kind: 'field',
    title: 'Sonuçsuz kalan aramalar',
    short:
      'Son aramada hiç ürün bulunamayanlar. Ürün satıyorsanız eş anlamlı ekleyin (ör. "yem" → "mama") veya ürün adına/kısa açıklamasına bu kelimeyi ekleyin.',
  },
  'site_search.synonyms': {
    kind: 'field',
    title: 'Eş anlamlılar',
    short:
      'Gruptaki her kelime aranınca diğerleri de aranır. Bir kelime yalnızca bir grupta olabilir; en fazla 500 grup.',
    guideUrl: 'docs/SEO_GUIDE_TR.md#site-ici-arama',
  },
  'site_search.terms': {
    kind: 'field',
    title: 'Kelimeler',
    short:
      'Virgülle ayrılmış en az iki, en çok 20 tek kelime. Büyük/küçük harf ve Türkçe karakter fark etmez.',
  },
  'page.keywords': {
    kind: 'page',
    title: 'Anahtar kelimeler',
    short:
      'Mağazanın hedeflediği aramaların havuzu: arama niyeti, küme, hedef sayfa; Search Console’dan tıklama, gösterim ve konum; kanibalizasyon ve içerik boşluğu uyarıları.',
    whatItDoes:
      'Kelimeleri elle veya Search Console önerilerinden eklersiniz. Her kelimenin hedef sayfasının yayında olup olmadığı ve son 28 günde hangi sayfanın gösterim aldığı denetlenir.',
    whenToUse: 'İçerik planlarken ve SEO önceliklerini belirlerken.',
    requiredPermission: 'SEO görüntüleme (düzenlemek için SEO düzenleme)',
    guideUrl: 'docs/SEO_GUIDE_TR.md#anahtar-kelimeler',
  },
  'keywords.pool': {
    kind: 'field',
    title: 'Anahtar kelime havuzu',
    short:
      'Kelime küçük harfle saklanır; aynı kelime bir kez eklenir. Değerler Search Console senkronundan (son 28 gün).',
    guideUrl: 'docs/SEO_GUIDE_TR.md#anahtar-kelimeler',
  },
  'keywords.alerts': {
    kind: 'field',
    title: 'Uyarılar',
    short:
      'Kanibalizasyon: aynı aramada iki veya daha fazla sayfa gösterimlerin en az %20’sini alıyor; Google hangisini göstereceğini seçemiyor olabilir. İçerik boşluğu: kelimenin hedef sayfası yok veya yayında değil.',
    guideUrl: 'docs/SEO_GUIDE_TR.md#anahtar-kelimeler',
  },
  'keywords.intent': {
    kind: 'field',
    title: 'Arama niyeti',
    short:
      'Bilgi (ör. "kedilerde omega 3 ne işe yarar"), araştırma (ör. "en iyi kedi omega 3"), satın alma (ör. "kedi omega 3 satın al"), marka/yön bulma (ör. "zootopia").',
  },
  'keywords.cluster': {
    kind: 'field',
    title: 'Küme',
    short: 'Aynı konudaki kelimeleri gruplar (ör. "kedi takviyeleri"). Havuzu kümeye göre süzebilirsiniz.',
  },
  'keywords.target': {
    kind: 'field',
    title: 'Hedef sayfa',
    short:
      'Bu kelimede görünmesini istediğiniz vitrin sayfasının yolu (ör. /urun/omega-3-balik-yagi). Tam adres de yapıştırılabilir.',
  },
  'keywords.candidates': {
    kind: 'field',
    title: 'Search Console önerileri',
    short: 'Havuzda olmayan ve son 28 günde en çok gösterim alan 100 arama.',
    guideUrl: 'docs/SEO_GUIDE_TR.md#anahtar-kelimeler',
  },
  'keywords.rank_tracking': {
    kind: 'field',
    title: 'Sıralama takibi',
    short: 'Günlük sıralama verisi lisanslı (ücretli) sağlayıcı ister; sağlayıcı seçimi sahibin kararıdır.',
  },
  'page.tracking': {
    kind: 'page',
    title: 'Ölçümleme',
    short:
      'Vitrine Google Tag Manager, Google Analytics 4, Google Ads, Meta ve TikTok etiketlerini ekler; çerez onayı bandını ve onay istatistiklerini yönetir.',
    whatItDoes:
      'Etiketler vitrinde yalnızca çerez politikası yayımlanmışsa ve ziyaretçi ilgili çerez türüne (analitik veya pazarlama) izin verdiyse yüklenir. İzin vermeyen ziyaretçide hiçbir dış betik çalışmaz. Etiket eklenince vitrinde "Tümünü kabul et / Reddet / Tercihler" bandı çıkar.',
    whenToUse: 'Reklam ve analitik hesaplarınızı açtıktan sonra kimlikleri girmek için.',
    dataChanged: 'Mağazanın etiket ayarları; her değişiklik denetim kaydına yazılır.',
    requiredPermission:
      'Ölçümleme ayarlarını görüntüleme (düzenleme için ayrı yetki ve iki adımlı doğrulama)',
    guideUrl: 'docs/MEASUREMENT_TR.md#etiketler',
  },
  'tracking.status': {
    kind: 'field',
    title: 'Vitrinde durum',
    short:
      'Etkin: etiket var ve çerez politikası yayımda. Etiket yoksa bant da çıkmaz. Çerez politikası yayımlanmadan etiketler vitrine eklenmez.',
    guideUrl: 'docs/MEASUREMENT_TR.md#cerez-onayi',
  },
  'tracking.gtm': {
    kind: 'field',
    title: 'Google Tag Manager kimliği',
    short:
      'GTM-XXXXXXX biçiminde. Ziyaretçi analitik veya pazarlamadan birine izin verince yüklenir; konteynerdeki Google etiketleri Consent Mode sinyaline uyar.',
    commonErrors: [
      {
        problem: 'GA4 hem GTM içinde hem aşağıdaki alanda tanımlı',
        solution: 'Ziyaretler iki kez sayılır. GA4 GTM içindeyse GA4 ölçüm kimliği alanını boş bırakın.',
      },
    ],
    guideUrl: 'docs/MEASUREMENT_TR.md#etiketler',
  },
  'tracking.ga4': {
    kind: 'field',
    title: 'GA4 ölçüm kimliği',
    short:
      'G-XXXXXXXXXX biçiminde (Google Analytics → Yönetici → Veri akışları). Yalnızca analitik izniyle yüklenir.',
    guideUrl: 'docs/MEASUREMENT_TR.md#etiketler',
  },
  'tracking.google_ads': {
    kind: 'field',
    title: 'Google Ads kimliği',
    short: 'AW-123456789 biçiminde. Yalnızca pazarlama izniyle yüklenir.',
    guideUrl: 'docs/MEASUREMENT_TR.md#etiketler',
  },
  'tracking.google_ads_label': {
    kind: 'field',
    title: 'Satın alma dönüşüm etiketi',
    short:
      'Google Ads → Hedefler → Dönüşümler → etiket ayarında "AW-…/" sonrasındaki bölüm. Doluysa başarılı kartlı ödemede dönüşüm gönderilir.',
    guideUrl: 'docs/MEASUREMENT_TR.md#olaylar',
  },
  'tracking.meta': {
    kind: 'field',
    title: 'Meta piksel kimliği',
    short: 'Yalnızca rakam (Meta Olay Yöneticisi → Veri kaynakları). Yalnızca pazarlama izniyle yüklenir.',
    guideUrl: 'docs/MEASUREMENT_TR.md#etiketler',
  },
  'tracking.tiktok': {
    kind: 'field',
    title: 'TikTok piksel kimliği',
    short: 'TikTok Reklam Yöneticisi → Olaylar → Web olayları. Yalnızca pazarlama izniyle yüklenir.',
    guideUrl: 'docs/MEASUREMENT_TR.md#etiketler',
  },
  'tracking.server_events': {
    kind: 'field',
    title: 'Sunucu taraflı olaylar',
    short:
      'Ödemesi alınan sipariş (satın alma) ve iade, sunucudan GA4, Meta ve TikTok’a gönderilir. Yalnızca sipariş anında ilgili çerez türüne onay veren ziyaretçilerin siparişleri; olay kimliği tarayıcı olayıyla aynı olduğu için çift sayılmaz.',
    whatItDoes:
      'GA4’e analitik onayıyla (GA çerezindeki istemci kimliği ile), Meta ve TikTok’a pazarlama onayıyla (piksel çerezi ve tarayıcı bilgisi ile) gönderilir. IP adresi gönderilmez. Hatalı gönderim 6 kez, artan aralıklarla yeniden denenir.',
    requiredPermission:
      'Ölçümleme görüntüleme (ayar için vitrin etiketlerini düzenleme, iki adımlı doğrulama)',
    guideUrl: 'docs/MEASUREMENT_TR.md#sunucu-olaylari',
  },
  'tracking.server_ga4': {
    kind: 'field',
    title: 'GA4 Measurement Protocol',
    short:
      'GA4 → Yönetici → Veri akışları → (web akışı) → Measurement Protocol API gizli anahtarları → Oluştur. Oluşan "Gizli anahtar değeri"ni buraya girin.',
    guideUrl: 'docs/MEASUREMENT_TR.md#sunucu-olaylari',
  },
  'tracking.server_meta': {
    kind: 'field',
    title: 'Meta Conversions API',
    short:
      'Meta Olay Yöneticisi → piksel → Ayarlar → Conversions API → "Erişim jetonu oluştur". Jetonu buraya girin; Meta’da gösterilen jeton bir daha görünmez.',
    guideUrl: 'docs/MEASUREMENT_TR.md#sunucu-olaylari',
  },
  'tracking.server_tiktok': {
    kind: 'field',
    title: 'TikTok Events API',
    short: 'TikTok Ads Manager → Olaylar → Web olayları → piksel → Ayarlar → "Erişim jetonu oluştur".',
    guideUrl: 'docs/MEASUREMENT_TR.md#sunucu-olaylari',
  },
  'tracking.server_test_code': {
    kind: 'field',
    title: 'Test olayı kodu',
    short:
      'Meta/TikTok "Test olayları" ekranında gösterilen kod. Yalnızca "Test olayı gönder" düğmesinde kullanılır; gerçek satışlar kodsuz gönderilir.',
  },
  'tracking.server_test': {
    kind: 'action',
    title: 'Test olayı gönder',
    short:
      'GA4: örnek satın alma Google’ın doğrulama ucuna gider (rapora yazılmaz, yalnızca biçim denetlenir). Meta/TikTok: test koduyla örnek ziyaret olayı; sağlayıcının Test olayları ekranında görünür. Satın alma gönderilmez.',
    requiredPermission: 'Vitrin etiketlerini düzenleme',
  },
  'tracking.server_user_data': {
    kind: 'field',
    title: 'Kişisel veri eşleştirme',
    short:
      'Açıkken e-posta ve telefon, gönderilmeden önce SHA-256 ile özetlenir (düz metin gitmez). Yine de kişisel veri aktarımıdır: aydınlatma metni ve çerez politikasında yazılı olmalı. Varsayılan kapalı.',
    guideUrl: 'docs/MEASUREMENT_TR.md#sunucu-olaylari',
  },
  'tracking.server_log': {
    kind: 'field',
    title: 'Sunucu olayı günlüğü',
    short:
      'Her olayın gönderilen verisi, durumu ve sağlayıcının hata mesajı. "Gönderilmedi": onay var ama eşleştirme çerezi yoktu ya da gönderim kapatılmıştı. Başarısız olay yeniden denenebilir.',
    guideUrl: 'docs/MEASUREMENT_TR.md#sunucu-olaylari',
  },
  'tracking.events': {
    kind: 'field',
    title: 'Olay yöneticisi',
    short:
      'Standart e-ticaret olaylarının hangi ölçüm hizmetine gideceğini seçer ve özel olay tanımlar. Onay kuralları değişmez: izin yoksa hiçbir olay gitmez.',
    requiredPermission:
      'Görmek: ölçümleme ayarlarını görme. Değiştirmek: ölçümleme etiketlerini yönetme (iki adımlı doğrulama).',
    guideUrl: 'docs/MEASUREMENT_TR.md#olay-yoneticisi',
  },
  'tracking.events_standard': {
    kind: 'field',
    title: 'Standart olaylar',
    short:
      'İşaret kaldırılırsa o olay o hizmete gönderilmez (ör. Meta’ya ürün listesi görüntüleme gitmesin). Meta ve TikTok’ta karşılığı olmayan olaylar zaten gönderilmez (—).',
  },
  'tracking.custom_events': {
    kind: 'field',
    title: 'Özel olaylar',
    short:
      'En çok 20 özel olay: belirli sayfa görüntüleme veya telefon, e-posta, WhatsApp, dış site bağlantısına tıklama. Kişisel veri gönderilmez.',
  },
  'tracking.custom_event_name': {
    kind: 'field',
    title: 'Olay adı',
    short:
      'Ölçüm hizmetinde görünecek ad: küçük harfle başlar; a–z, rakam ve alt çizgi, 3–40 karakter. Standart olay adları ve google_, ga_, firebase_ önekleri kullanılamaz.',
  },
  'tracking.custom_event_trigger': {
    kind: 'field',
    title: 'Ne zaman',
    short: 'Olayın gönderileceği an: sayfa görüntüleme veya bağlantı türüne göre tıklama.',
  },
  'tracking.custom_event_path': {
    kind: 'field',
    title: 'Sayfa yolu',
    short: 'Alan adı olmadan yol: /kampanya/ekim yalnızca o sayfa; /kampanya/* ile başlayan tüm sayfalar.',
  },
  'tracking.custom_event_destinations': {
    kind: 'field',
    title: 'Gönderilecek hizmetler',
    short:
      'Olayın gideceği hizmetler. Hizmetin etiketi girilmemişse veya ziyaretçi izin vermediyse gönderilmez.',
  },
  'tracking.custom_event_add': {
    kind: 'action',
    title: 'Listeye ekle',
    short: 'Olayı listeye ekler; vitrine gitmesi için “Olay ayarlarını kaydet”e basın.',
  },
  'tracking.custom_event_remove': {
    kind: 'action',
    title: 'Olayı kaldır',
    short: 'Olayı listeden çıkarır; kaydedince vitrinde gönderilmez.',
  },
  'tracking.events_save': {
    kind: 'action',
    title: 'Olay ayarlarını kaydet',
    short: 'Olay seçimini ve özel olayları vitrine uygular; denetim kaydına yazılır.',
    requiredPermission: 'Ölçümleme etiketlerini yönetme (iki adımlı doğrulama)',
  },
  'tracking.save': {
    kind: 'action',
    title: 'Etiketleri kaydet',
    short:
      'Kimlikleri kaydeder. Vitrinde birkaç dakika içinde geçerli olur. Boş bırakılan alan o etiketin kaldırılması demektir.',
    requiredPermission: 'Vitrin etiketlerini düzenleme (iki adımlı doğrulama)',
    reversible: 'Evet: alanı boşaltıp yeniden kaydedin.',
    guideUrl: 'docs/MEASUREMENT_TR.md#etiketler',
  },
  'tracking.legal': {
    kind: 'field',
    title: 'Yasal metin etkisi',
    short:
      'Eklenen etiketlerin çerezleri ve verinin aktarıldığı kuruluşlar. Yayımdaki çerez politikası ve aydınlatma metninde geçmeyenler işaretlenir; metinleri avukatınıza güncelletin.',
    whatItDoes:
      'Sistem yasal metin üretmez; yalnızca metinde çerez adının ve sağlayıcı adının geçip geçmediğine bakar. Çerez adları ve süreler sağlayıcıların belgelerine göredir; sağlayıcı değiştirebilir.',
    guideUrl: 'docs/MEASUREMENT_TR.md#yasal-metin-etkisi',
  },
  'tracking.stats': {
    kind: 'field',
    title: 'Çerez onayı istatistikleri',
    short:
      'Son 30 günde seçim yapan tarayıcı sayısı ve seçimleri (aynı tarayıcının son seçimi sayılır). Kişiyi tanımlayan bilgi tutulmaz.',
    guideUrl: 'docs/MEASUREMENT_TR.md#istatistik',
  },
  // ---------------------------------------------------------------- F7-13: vergi kipi, ülke KDV, gümrük, proforma
  'stores.market_tax_mode': {
    kind: 'field',
    title: 'Vergi kipi',
    short:
      'Pazardaki siparişlere hangi KDV’nin uygulanacağı: yurt içi KDV, ihracat istisnası (KDV’siz) veya varış ülkesinin KDV’si.',
    whatItDoes:
      '"Yurt içi KDV" ürünün KDV sınıfının oranını uygular. "İhracat (KDV istisnası)" yalnızca yurt dışı pazarda seçilebilir; siparişler KDV’siz kaydedilir ve "İhracat — KDV istisnası" olarak işaretlenir (gerekçe mali müşavirce teyit edilmelidir). "Varış ülkesi KDV" Fiyatlandırma sayfasındaki ülke oranını uygular; oranı olmayan ürün o pazarda satılamaz. Fiyatlar değişmez: ihracat pazarında KDV hariç fiyat listesi kullanın.',
    guideUrl: 'docs/PRICING_ENGINE_TR.md#vergi-kipi',
  },
  'pricing.tax_country_rate': {
    kind: 'field',
    title: 'Ülke KDV oranları',
    short: 'KDV sınıfının bir ülkedeki oranı; vergi kipi "Varış ülkesi KDV" olan pazarlarda uygulanır.',
    whatItDoes:
      'Sınıf ve ülke başına bir oran tutulur (ör. Almanya, Gıda: %7). "Varış ülkesi KDV" pazarında ürünün sınıfının (sınıfı yoksa varsayılan sınıfın) o ülke oranı yoksa ürün yanlış vergiyle satılmasın diye satışa kapatılır.',
    guideUrl: 'docs/PRICING_ENGINE_TR.md#vergi-kipi',
  },
  'shipping.countries': {
    kind: 'field',
    title: 'Gönderilen ülkeler',
    short: 'Yöntemin sunulduğu pazar ülkeleri; hiçbiri seçilmezse tüm pazarlarda sunulur.',
    whatItDoes:
      'Ödeme adımında yalnızca ziyaretçinin seçtiği pazarın ülkesine uygun yöntemler listelenir. Ağırlığa göre ücretle ülke/bölge başına ayrı yöntem tanımlayabilirsiniz (ör. "Avrupa — ağırlığa göre").',
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#ulke-kargo',
  },
  'products.customs': {
    kind: 'field',
    title: 'Gümrük ve ihracat',
    short: 'GTİP/HS kodu, menşe ülke ve gümrük tanımı; proforma faturada ve gümrük beyanında kullanılır.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#gumruk',
  },
  'products.hs_code': {
    kind: 'field',
    title: 'GTİP / HS kodu',
    short: 'Malın gümrük tarife pozisyonu (6–12 hane). İlk 6 hane uluslararası HS kodudur.',
    whatItDoes:
      'Nokta ve boşluklar kaydedilirken atılır. Doğru pozisyonu gümrük müşaviriniz veya Ticaret Bakanlığı tarife cetveliyle teyit edin.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#gumruk',
  },
  'products.origin_country': {
    kind: 'field',
    title: 'Menşe ülke',
    short: 'Malın üretildiği ülke; proforma faturada ve gümrük beyanında yazılır.',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#gumruk',
  },
  'products.customs_description': {
    kind: 'field',
    title: 'Gümrük tanımı',
    short: 'Beyanda geçecek kısa ve açık mal tanımı (pazarlama dili olmadan).',
    guideUrl: 'docs/PRODUCT_MANAGEMENT_TR.md#gumruk',
  },
  'orders.tax_exemption': {
    kind: 'field',
    title: 'İhracat — KDV istisnası',
    short: 'Sipariş, vergi kipi "İhracat" olan pazardan verildi; KDV hesaplanmadı.',
    whatItDoes:
      'Resmî fatura kesilirken istisna kodu ve gümrük beyannamesi bilgisi muhasebede tamamlanmalıdır. İstisnanın uygulanabilirliği mali müşavirce teyit edilmelidir.',
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#proforma',
  },
  'orders.proforma': {
    kind: 'action',
    title: 'Proforma fatura',
    short: 'Gümrük ve alıcı için yazdırılabilir sipariş belgesi; ticari fatura değildir.',
    whatItDoes:
      'Satıcı bilgileri (işletme ayarları), alıcı ve teslim adresi, GTİP/menşe/ağırlıklı satırlar, toplamlar, kur ve istisna notu içerir. Kişisel veri içerdiği için görüntüleme kayda geçer.',
    requiredPermission: 'Siparişleri ve kişisel verileri görüntüleme.',
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#proforma',
  },
  'payments.bank_account_currency': {
    kind: 'field',
    title: 'Hesabın para birimi',
    short:
      'Havale/EFT seçeneği yalnızca bu para birimindeki siparişlerde bu hesapla sunulur (ör. euro pazarı için EUR IBAN).',
    guideUrl: 'docs/PAYMENTS_TR.md#banka-hesaplari',
  },
  'page.order_proforma': {
    kind: 'page',
    title: 'Proforma Fatura',
    short: 'Siparişin proforma faturası; "Yazdır / PDF kaydet" ile basılır.',
    whatItDoes:
      'GTİP veya menşe ülkesi eksik ürünler sayfanın üstünde uyarılır (belgeye basılmaz). Kısmen iptal edilen ürünler kalan adetle yazılır.',
    requiredPermission: 'Siparişleri ve kişisel verileri görüntüleme.',
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#proforma',
  },
  // ---------------------------------------------------------------- F7-14: çok dilli vitrin
  'products.translations': {
    kind: 'field',
    title: 'Çeviriler',
    short:
      'Ürünün diğer dillerdeki adı, açıklaması ve SEO alanları. Çevirisi olan dil vitrinde /en/… gibi adreste arama motorlarına açılır.',
    whatItDoes:
      'Çevirisi olmayan dilde ürün sayfası açılır ama dizine eklenmez ve hreflang’de yer almaz. Sağlık içerikli ürünün çevirisi Veteriner Uzman İnceleyici onaylayınca yayınlanır; metin değişince onay düşer.',
    guideUrl: 'docs/SEO_GUIDE_TR.md#cok-dilli',
  },
  'translations.seo': {
    kind: 'field',
    title: 'Çeviride SEO alanları',
    short:
      'O dildeki arama sonucunda görünen başlık (70 karakter) ve açıklama (170 karakter); boşsa ad ve açıklamadan.',
    guideUrl: 'docs/SEO_GUIDE_TR.md#cok-dilli',
  },
  'keywords.language': {
    kind: 'field',
    title: 'Anahtar kelimenin dili',
    short:
      'Anahtar kelimenin arandığı dil; havuz dile göre süzülür. Hedef sayfa dil önekiyle yazılabilir (/en/urun/x).',
    guideUrl: 'docs/SEO_GUIDE_TR.md#cok-dilli',
  },
  // ---------------------------------------------------------------- F7-15: pazar başına Merchant feed
  'merchant.markets': {
    kind: 'field',
    title: 'Google’a gönderilen pazarlar',
    short:
      'Her pazar (ülke + dil + para birimi) ayrı feed ve Merchant API veri kaynağıdır; işaretli pazarların ürünleri Google’a gönderilir.',
    whatItDoes:
      'Fiyat pazarın listesinden ve ziyaretçinin ödediği tutar olarak (KDV hariç listede pazarın KDV’si eklenir, ihracat istisnasında eklenmez); ad ve açıklama pazarın dilinde (ana dil dışında çevirisi olmayan ürün gönderilmez); bağlantı o dilin adresi; kargo o ülkenin yöntemleri; ülkede satışa kapalı ürün gönderilmez. İşareti kaldırılan pazarın ürünleri sonraki senkronda Google’dan silinir.',
    guideUrl: 'docs/MERCHANT_CENTER_TR.md#pazarlar',
  },
  // ---------------------------------------------------------------- F7-16: yabancı ödeme kuruluşları
  'payments.intl': {
    kind: 'field',
    title: 'Yurt dışı ödemeler (Stripe, PayPal)',
    short:
      'Döviz pazarlarında kart ödemesini Stripe’ın, PayPal ödemesini PayPal’ın güvenli sayfasında alır. TL ödemeleri yurt içi kart sağlayıcısıyla alınmaya devam eder.',
    whatItDoes:
      'Müşteri sağlayıcının sayfasına yönlendirilir; kart bilgisi sisteme gelmez. Ödemenin sonucu sağlayıcıdan sunucu sorgusuyla okunur, tutar ve para birimi siparişle karşılaştırılır. İade siparişten yapılır ve sağlayıcıya gönderilir.',
    guideUrl: 'docs/PAYMENTS_TR.md#yurt-disi-odemeler',
  },
  'payments.intl_entity': {
    kind: 'field',
    title: 'Yurt dışı şirket gereksinimi',
    short:
      'Stripe ve PayPal, Türkiye’de kurulu işletmelere hesap açmıyor; hesap desteklenen bir ülkedeki şirketiniz adına açılmalı.',
    whatItDoes:
      'Tahsilat o şirketin Stripe/PayPal hesabına geçer. Faturalama, vergi ve muhasebe kaydını mali müşavirinizle netleştirmeden canlıya geçmeyin.',
    guideUrl: 'docs/PAYMENTS_TR.md#yurt-disi-odemeler',
  },
  'payments.intl_card_provider': {
    kind: 'field',
    title: 'Döviz kart ödemesi',
    short:
      'Stripe seçiliyse TL dışı kart ödemeleri (Kartla döviz tahsilatında işaretli para birimleri) Stripe ile alınır; TL ödemeleri yukarıdaki sağlayıcıyla.',
    whatItDoes:
      'Stripe ödeme sayfası kartı ve Stripe hesabınızda açık cüzdanları (Apple Pay, Google Pay) gösterir. Taksit ve ön provizyon yoktur. Önce Entegrasyonlar → Stripe’ta test anahtarıyla bağlantı kurun.',
    guideUrl: 'docs/PAYMENTS_TR.md#yurt-disi-odemeler',
  },
  'payments.paypal': {
    kind: 'field',
    title: 'PayPal ile ödeme',
    short:
      'Açıkken ödeme adımında PayPal seçeneği görünür; yalnızca EUR, USD ve GBP pazarlarında (PayPal TL, AED, SAR ve AZN kabul etmez).',
    whatItDoes:
      'Müşteri PayPal’da onaylar; mağazaya dönünce ödeme sunucudan tahsil edilir. Müşteri onaylayıp dönmezse PayPal bildirimi veya süre denetimi tahsil eder. Süresi dolmuş siparişe sonradan gelen onay tahsil edilmez.',
    guideUrl: 'docs/PAYMENTS_TR.md#yurt-disi-odemeler',
  },
  'payments.intl_notify_urls': {
    kind: 'field',
    title: 'Stripe ve PayPal bildirim adresleri',
    short: 'Stripe Dashboard → Webhooks ve PayPal Developer → uygulama → Webhooks’a eklenecek adresler.',
    whatItDoes:
      'Stripe’ta checkout.session.completed, checkout.session.async_payment_succeeded, async_payment_failed ve expired olaylarını seçin; imza anahtarını (whsec_…) Entegrasyonlar → Stripe’a girin. PayPal’da CHECKOUT.ORDER.APPROVED ve PAYMENT.CAPTURE.* olaylarını seçin; bildirim kimliğini Entegrasyonlar → PayPal’a girin.',
    guideUrl: 'docs/PAYMENTS_TR.md#yurt-disi-odemeler',
  },
  // ---------------------------------------------------------------- F7-17: çeviriler
  'page.ui_translations': {
    kind: 'page',
    title: 'Çeviriler',
    short: 'Arayüz ve yardım metinlerinin dil başına çeviri durumu.',
    whatItDoes:
      'Türkçe, İngilizce, Almanca ve Arapça için arayüz (panel, vitrin, mobil) ve yardım metinlerinin toplam ve eksik sayısını, eksik anahtarları ve yazı yönünü gösterir. Kaynak dil Türkçedir; eksik metin İngilizceye, o da yoksa Türkçeye düşer.',
    whenToUse:
      'Yazılım güncellemesinden sonra veya yeni bir dilde vitrin açmadan önce çevirilerin tam olduğunu görmek için.',
    requiredPermission: 'Yardım metinlerini yönetme',
    guideUrl: 'docs/ADMIN_GUIDE_TR.md#ceviriler',
  },
  'ui_translations.coverage': {
    kind: 'field',
    title: 'Çeviri kapsamı',
    short: 'Her dilde arayüz ve yardım metinlerinin kaçının çevrildiği; eksik 0 ise dil tamdır.',
    whatItDoes:
      'Arayüz metinleri paketle gelen kataloglardan sayılır (CI’daki eksik anahtar testiyle aynı). Yardım için her kaydın başlığı ve kısa açıklaması sayılır; ayrıntı alanları Türkçe dışındaki dillerde Türkçe kayıttan gelir.',
    guideUrl: 'docs/ADMIN_GUIDE_TR.md#ceviriler',
  },
  // ---------------------------------------------------------------- F7-19: düzenli sipariş
  'page.subscriptions': {
    kind: 'page',
    title: 'Düzenli siparişler',
    short:
      'Müşterinin "her N haftada bir" başlattığı düzenli gönderimler: ayarlar, hazırlık ve abonelik listesi.',
    whatItDoes:
      'Mağaza başına düzenli gönderimi açar; aralıkları, abonelik indirimini ve ödeme bağlantısı süresini belirler. Her dönemde (Türkiye günüyle) güncel fiyattan, abonelik indirimiyle ve en uygun kargo yöntemiyle sipariş açılır, stok ayrılır ve müşteriye kartla ödeme bağlantısı gönderilir. Kart saklanmaz ve otomatik çekim yapılmaz; müşteri her siparişi sözleşme metinlerini onaylayarak kendisi öder. Süresinde ödenmeyen sipariş iptal edilir ve stok geri döner; üst üste iki dönem ödenmezse abonelik duraklatılır.',
    whenToUse:
      'Mama ve kum gibi düzenli tüketilen ürünlerde tekrar eden siparişleri müşteri için kolaylaştırmak istediğinizde.',
    requiredPermission:
      'Siparişleri görüntüleme. Ayarlar: İşletme ayarlarını değiştirme. İptal: Sipariş düzenleme.',
    guideUrl: 'docs/SUBSCRIPTIONS_TR.md',
  },
  'subscriptions.settings': {
    kind: 'field',
    title: 'Düzenli sipariş ayarları',
    short:
      'Mağaza başına; varsayılan kapalı. Açmak için kartla ödeme sağlayıcısı ve sözleşme metinleri gerekir.',
    guideUrl: 'docs/SUBSCRIPTIONS_TR.md#ayarlar',
  },
  'subscriptions.enabled': {
    kind: 'field',
    title: 'Düzenli gönderimi aç',
    short:
      'Açıkken uygun ürünlerin sayfasında "Düzenli gönder" kutusu görünür. Kapatınca yeni dönem siparişi açılmaz; abonelikler bekler.',
    whatItDoes:
      'Açmak için kartla ödeme sağlayıcısının (iyzico, PayTR veya Sipay) bağlı, ön bilgilendirme formu ile mesafeli satış sözleşmesinin yayımlanmış olması gerekir. E-posta gönderimi kapalıysa müşteri ödeme bağlantısını yalnızca Hesabım → Düzenli siparişlerim’de görür.',
    guideUrl: 'docs/SUBSCRIPTIONS_TR.md#ayarlar',
  },
  'subscriptions.intervals': {
    kind: 'field',
    title: 'Aralıklar',
    short: 'Müşterinin seçebileceği gönderim sıklıkları (hafta). En az bir aralık seçin.',
  },
  'subscriptions.discount': {
    kind: 'field',
    title: 'Abonelik indirimi',
    short: 'Düzenli siparişlerde yüzde indirim (0–30). Abonelik başladığındaki oran o abonelikte değişmez.',
    whatItDoes:
      'Otomatik kampanyalardan sonra ürün tutarına kupon yerine uygulanır; kargo ücreti indirimden etkilenmez. Oranı değiştirmek yalnızca bundan sonra başlayan abonelikleri etkiler.',
    guideUrl: 'docs/SUBSCRIPTIONS_TR.md#ayarlar',
  },
  'subscriptions.link_hours': {
    kind: 'field',
    title: 'Ödeme bağlantısı süresi',
    short:
      'Dönem siparişinin ödenmesi için süre (24–168 saat). Süre dolunca sipariş iptal edilir ve stok geri döner.',
  },
  'subscriptions.save': {
    kind: 'action',
    title: 'Ayarları kaydet',
    short: 'Ayarları kaydeder; açarken onay ister. Değişiklik denetim kaydına düşer.',
  },
  'subscriptions.list': {
    kind: 'field',
    title: 'Abonelikler',
    short: 'Müşteri, ürün, adet, aralık, sonraki sipariş günü, durum ve ödeme bekleyen sipariş.',
    whatItDoes:
      'E-posta adresi müşteri kişisel verilerini görme yetkisi yoksa maskelenir. Duraklatılmış aboneliklerde neden de görünür (müşteri isteği, üst üste iki ödenmeyen sipariş, ürünün düzenli gönderimden çıkması).',
    guideUrl: 'docs/SUBSCRIPTIONS_TR.md#panel',
  },
  'subscriptions.runs': {
    kind: 'action',
    title: 'Dönemler',
    short: 'Aboneliğin her dönemi: sipariş açıldı, ödendi, atlandı, stok yoktu, ödenmedi.',
  },
  'subscriptions.cancel': {
    kind: 'field',
    title: 'Aboneliği iptal et',
    short:
      'Gerekçe en az 3 karakter; denetim kaydına yazılır. Müşteriye e-posta gitmez; Hesabım’da "İptal edildi" görür.',
  },
  'products.subscribable': {
    kind: 'field',
    title: 'Düzenli Gönderime Uygun',
    short: 'Açıkken, mağazada düzenli gönderim açıksa ürün sayfasında "Düzenli gönder" kutusu görünür.',
    whatItDoes:
      'Kapatırsanız yeni abonelik başlatılamaz; mevcut abonelikler sonraki dönemde "ürün artık uygun değil" nedeniyle duraklatılır.',
    guideUrl: 'docs/SUBSCRIPTIONS_TR.md#urunler',
  },
  // ---------------------------------------------------------------- F7-21: alanlar arası izleme
  'tracking.cross_domain': {
    kind: 'field',
    title: 'Alanlar arası izleme',
    short:
      'Birden çok vitrin alan adı varsa GA4 bağlayıcısı ve kaynak bilgisi alan adları arasında taşınır; ikinci alan adı eklenince kendiliğinden açılır.',
    whatItDoes:
      'Listeye mağazanın vitrin alan adları ve aynı GA4 ölçüm kimliğini veya GTM konteynerini kullanan diğer mağazaların alan adları girer. Vitrin bu alan adlarına giden bağlantılara Google bağlayıcı parametresini ve kaynak bilgisini (2 dakika geçerli) ekler; bu alan adlarından gelmek yönlendiren site sayılmaz. GA4 yönetiminde alan adı listesi ayrıca girilmelidir.',
    guideUrl: 'docs/MEASUREMENT_TR.md#alanlar-arasi',
  },
  'shipping.geliver': {
    kind: 'field',
    title: 'Geliver ile kargo',
    short:
      'Geliver hesabınızla siparişten gönderi açma, kargo firmalarının fiyatlarını karşılaştırma ve etiketi panelden alma. Bağlantı Entegrasyonlar → Kargo → Geliver ile kurulur.',
    whatItDoes:
      'Test ortamında gönderiler Geliver\'e test gönderisi olarak açılır; canlıda etiket ücreti Geliver bakiyesinden düşer. Durum ve takip numarası 30 dakikada bir Geliver\'den okunur; sipariş sayfasında "Durumu yenile" ile hemen okunur. Ayarlar işletme düzeyindedir (tüm mağazalar).',
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#geliver',
  },
  'shipping.geliver_sender': {
    kind: 'field',
    title: 'Gönderici adresi',
    short:
      "Paketin alınacağı adres. Geliver'de tanımlı gönderici adreslerinden seçilir; liste Geliver'den okunur.",
    whatItDoes:
      'Liste boşsa Geliver panelinde gönderici adresi ekleyin. Gönderici adresi seçilmeden "Geliver ile kargola" kullanılamaz.',
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#geliver',
  },
  'shipping.geliver_parcel': {
    kind: 'field',
    title: 'Varsayılan koli ölçüleri',
    short:
      'Gönderi penceresinde önerilen uzunluk, genişlik ve yükseklik (cm, 1–300). Her gönderide değiştirilebilir.',
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#geliver',
  },
  'shipping.geliver_weight': {
    kind: 'field',
    title: 'Varsayılan ağırlık',
    short:
      'Ürün ağırlığı girilmemiş satırlar için kullanılan ağırlık (gram). Ürünlerde ağırlık girmek teklifleri doğru yapar.',
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#geliver',
  },
  'shipping.geliver_save': {
    kind: 'action',
    title: 'Geliver ayarlarını kaydet',
    short:
      'Gönderici adresini ve varsayılan koliyi kaydeder; gönderici adresi Geliver listesinde yoksa kaydedilmez. Değişiklik denetim kaydına düşer.',
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#geliver',
  },
  'orders.ship_geliver': {
    kind: 'action',
    title: 'Geliver ile kargola',
    short:
      "Paketteki ürünleri, koli ölçülerini ve ağırlığı seçip Geliver'den kargo firmalarının tekliflerini alır; seçilen teklifle etiket satın alınır.",
    whatItDoes:
      'Etiket alınınca gönderi kaydedilir, paketteki adetler stoktan düşer ve sipariş kargoda (veya kısmen gönderildi) olur. Müşteriye "kargoya verildi" e-postası takip numarası oluşunca gider. Kapıda ödemeli siparişler şimdilik elle kargolanır. Teslimat adresinde il, ilçe ve telefon olmalı; alıcının e-postası Geliver\'e gönderilmez.',
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#geliver',
  },
  'orders.geliver_parcel': {
    kind: 'field',
    title: 'Koli ölçüleri ve ağırlık',
    short:
      'Kargo ücretini belirleyen ölçüler (cm) ve ağırlık (gram). Ağırlık ürün ağırlıklarından önerilir; paketi tartıp düzeltin.',
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#geliver',
  },
  'orders.geliver_offers': {
    kind: 'action',
    title: 'Teklifleri getir',
    short:
      "Geliver'de gönderi açar ve kargo firmalarının fiyatlarını getirir; ücret doğmaz. Ölçü veya ürün değişirse yeniden getirin.",
    whatItDoes:
      'Teklifler birkaç saniyede gelir; tamamlanmadıysa "Yenile" ile okunur. Satın alınmayan gönderiler Geliver\'de taslak olarak kalır.',
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#geliver',
  },
  'orders.geliver_offer': {
    kind: 'field',
    title: 'Kargo teklifi',
    short: "Firma, hizmet, tahmini süre ve Geliver'in bildirdiği ücret. En ucuz ve en hızlı işaretlidir.",
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#geliver',
  },
  'orders.geliver_buy': {
    kind: 'action',
    title: 'Etiketi satın al',
    short:
      'Seçilen teklifle etiketi satın alır; onaydan sonra ücret Geliver bakiyesinden düşer (test ortamında test gönderisi). Aynı teklif iki kez satın alınmaz.',
    whenToUse:
      'Geliver tekliflerini aldıktan sonra uygun kargo firmasını seçip etiketi basmak istediğinizde.',
    dataChanged:
      "Geliver'de etiket satın alınır ve ücret Geliver bakiyenizden düşer. Siparişe gönderi kaydı eklenir, paketteki adetler stoktan düşer; takip numarası oluşunca müşteriye e-posta gider.",
    requiredPermission: 'Kargo işlemleri.',
    reversible:
      'Kısmen: kargo firması paketi almadan önce "Geliver\'de iptal et" ile iptal edilebilir ve ürünler stoğa döner. Ücret iadesi Geliver\'in kurallarına bağlıdır.',
    commonErrors: [
      {
        problem: '"Geliver bağlı değil"',
        solution: "Entegrasyonlar → Kargo → Geliver'de API anahtarını girip bağlantıyı test edin.",
      },
      {
        problem: '"Seçilen teklif bu gönderide yok" veya "gönderi iptal edilmiş"',
        solution: 'Teklifleri yeniden getirip yeni bir teklif seçin.',
      },
      {
        problem: '"Kapıda ödemeli siparişler şimdilik Geliver ile gönderilemez"',
        solution: 'Bu siparişi takip numarasıyla "Kargoya Ver" üzerinden elle kargolayın.',
      },
    ],
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#geliver',
  },
  'orders.geliver_label': {
    kind: 'action',
    title: 'Etiketi aç',
    short: "Geliver'in ürettiği kargo etiketini (PDF) yeni sekmede açar; yazdırıp pakete yapıştırın.",
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#geliver',
  },
  'orders.geliver_sync': {
    kind: 'action',
    title: 'Durumu yenile',
    short:
      "Gönderinin durumunu ve takip numarasını Geliver'den şimdi okur (kendiliğinden 30 dakikada bir okunur). Takip numarası ilk kez gelince müşteriye e-posta gider.",
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#geliver',
  },
  'orders.geliver_cancel': {
    kind: 'action',
    title: "Geliver'de iptal et",
    short:
      "Kargo firması paketi almadan önce gönderiyi Geliver'de iptal eder; paketteki ürünler stoğa döner ve sipariş yeniden gönderilebilir. Etiket ücretinin iadesi Geliver'in kurallarına göre yapılır.",
    whenToUse:
      'Etiket alındıktan sonra paket gönderilmeyecekse veya yanlış ölçü/ürünle etiket alındıysa, kargo firması paketi almadan önce.',
    dataChanged:
      'Gönderi Geliver\'de iptal edilir ve paneldeki gönderi "İptal" olur; paketteki ürünler stoğa döner, sipariş yeniden gönderilebilir.',
    requiredPermission: 'Kargo işlemleri.',
    reversible:
      'Hayır, iptal edilen gönderi geri açılamaz; gerekirse teklifleri yeniden alıp yeni etiket satın alınır.',
    commonErrors: [
      {
        problem: '"Kargo firması paketi teslim aldıktan sonra iptal buradan yapılamaz"',
        solution: 'Geliver veya kargo firmasıyla doğrudan görüşün.',
      },
      {
        problem: '"Bu gönderi kapanmış"',
        solution: 'Teslim edilmiş veya zaten iptal edilmiş gönderi iptal edilemez.',
      },
    ],
    guideUrl: 'docs/SHIPPING_INVOICES_TR.md#geliver',
  },
  'stores.customer_auth': {
    kind: 'field',
    title: 'Müşteri girişi',
    short:
      'Vitrinde "Google ile devam et": giriş, kayıt ve ödeme adımında. Mağaza başına açılır; varsayılan kapalı.',
    whatItDoes:
      "Yalnızca vitrin müşterileri içindir: bayi firmasına üye hesaplar Google ile giremez ve bayilik başvurusu Google oturumuyla yapılamaz. Google'dan yalnızca kalıcı kimlik (sub), e-posta ve ad alınır; Google erişim jetonları saklanmaz. Açmadan önce aydınlatma metni ve yurt dışı aktarım envanteri avukat onayıyla güncellenmelidir.",
    guideUrl: 'docs/GOOGLE_INTEGRATIONS_TR.md#musteri-girisi',
  },
  'stores.customer_auth_toggle': {
    kind: 'action',
    title: 'Google ile girişi aç/kapat',
    short:
      'Açmak yalnızca işletme sahibi tarafından ve iki adımlı doğrulamayla yapılır; Entegrasyonlar → Google ile giriş istemcisi kurulu olmalıdır. Kapatmak yeni Google girişlerini durdurur.',
    whenToUse:
      'Müşterilerin vitrine Google hesaplarıyla üye olmasını ve giriş yapmasını başlatmak veya durdurmak istediğinizde.',
    dataChanged:
      'Mağazanın müşteri girişi ayarında "Google ile giriş" açılır veya kapanır; değişiklik denetim kaydına yazılır.',
    requiredPermission:
      'Açmak: yalnızca işletme sahibi (son 15 dakikada iki adımlı doğrulama). Kapatmak: İşletme bilgilerini ve ayarlarını değiştirme.',
    reversible: 'Evet, ayar yeniden açılıp kapatılabilir.',
    commonErrors: [
      {
        problem: '"Google ile girişi yalnızca işletme sahibi açabilir"',
        solution: 'Açma işlemini işletme sahibi yapmalıdır.',
      },
      {
        problem: '"Önce Entegrasyonlar → Google ile giriş bölümünde OAuth istemcisini kaydedip test edin"',
        solution: 'Google ile giriş istemcisini kurup test ettikten sonra tekrar deneyin.',
      },
    ],
    guideUrl: 'docs/GOOGLE_INTEGRATIONS_TR.md#musteri-girisi',
  },
  'stores.customer_auth_redirects': {
    kind: 'field',
    title: 'Yönlendirme adresleri',
    short:
      "Google Cloud → API'ler ve Hizmetler → Kimlik bilgileri → OAuth istemcisi → Yetkili yönlendirme URI'leri alanına her vitrin alan adı için bu adresleri girin.",
    guideUrl: 'docs/GOOGLE_INTEGRATIONS_TR.md#musteri-girisi',
  },
} satisfies Record<string, HelpContent>;

export type HelpKey = keyof typeof HELP_TR;
